"use client";
var bl = Object.defineProperty;
var El = (e, t, n) => t in e ? bl(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var N = (e, t, n) => El(e, typeof t != "symbol" ? t + "" : t, n);
import * as ne from "react";
import ce, { createContext as ln, useMemo as Qn, useState as pe, useRef as he, useEffect as le, useCallback as Te, useId as vl, useContext as Me, createElement as Zn, useSyncExternalStore as us, StrictMode as ds, useLayoutEffect as wl, forwardRef as Xa } from "react";
import { A as Pe, T as Ps, S as Rl, E as gn, N as Sl, d as ht } from "./server-tk39xLe_.mjs";
import { a as Jy } from "./server-tk39xLe_.mjs";
import { createPortal as Tl } from "react-dom";
const Al = /* @__PURE__ */ new Set(["Alt", "Control", "Meta", "Mod", "Shift"]), Cl = /* @__PURE__ */ new Set(["ArrowDown", "ArrowLeft", "ArrowRight", "ArrowUp", "Backspace", "Delete", "End", "Enter", "Escape", "Home", "PageDown", "PageUp", "Space", "Tab"]), Ol = /* @__PURE__ */ new Set(["!", '"', "#", "$", "%", "&", "'", "(", ")", "*", "+", ",", "-", ".", "/", ":", ";", "<", "=", ">", "?", "@", "[", "\\", "]", "^", "_", "`", "{", "|", "}", "~", "£"]), kl = /* @__PURE__ */ new Set(["!", '"', "#", "$", "%", "&", "(", ")", "*", "+", ":", "<", ">", "?", "@", "^", "_", "{", "|", "}", "~", "£"]), jt = {
  /**
   * Renders a parsed shortcut as a non-glyph string for accessible help text.
   * eg: `{ modifiers: ['Mod','Shift'], key: 'K' }` → `'Mod+Shift+K'`.
   * Glyph rendering (⌘/⇧/⌥/⌃) lives in the menu surface.
   * @param parsed - The parsed shortcut.
   */
  format(e) {
    return e.modifiers.length === 0 ? e.key : `${e.modifiers.join("+")}+${e.key}`;
  },
  /**
   * Returns true when the keyboard event matches the parsed shortcut.
   * Rules:
   * - `Mod` resolves to Meta on macOS and Control elsewhere at match time.
   * - The event's modifier set must EXACTLY equal the parsed modifier set
   *   (extra modifiers held → no match), with one exception: when the parsed key
   *   is a symbol that requires Shift to produce on the standard layout
   *   (`?`, `!`, `@`, etc.), the matcher does NOT require Shift to appear in
   *   `parsed.modifiers` — the printable-character check on `event.key` is
   *   sufficient.
   * - Letter comparison is case-insensitive (`event.key` may be lower- or
   *   upper-case depending on Shift state).
   * @param parsed - The parsed shortcut to test against.
   * @param event - The DOM keyboard event.
   */
  matches(e, t) {
    const n = Pe.isMacOS(), r = {
      alt: !1,
      control: !1,
      meta: !1,
      shift: !1
    };
    for (const a of e.modifiers)
      a === "Alt" ? r.alt = !0 : a === "Shift" ? r.shift = !0 : a === "Meta" ? r.meta = !0 : a === "Control" ? r.control = !0 : a === "Mod" && (n ? r.meta = !0 : r.control = !0);
    const o = e.key, s = kl.has(o);
    if (t.altKey !== r.alt || t.ctrlKey !== r.control || t.metaKey !== r.meta || !s && t.shiftKey !== r.shift) return !1;
    const i = t.key;
    return i === void 0 ? !1 : e.key.length === 1 && /[A-Za-z]/.test(e.key) ? i.toLowerCase() === e.key.toLowerCase() : e.key === "Space" ? i === " " || i === "Space" : i === e.key;
  },
  /**
   * Parses a strictly-typed shortcut string into its modifier set + key. Returns
   * `null` for unsupported tokens — meaning the binding never matches. The strict
   * `Shortcut` template-literal type is the primary contract; this parser exists
   * as defense-in-depth against `as Shortcut` casts and dynamic strings.
   * @param shortcut - The shortcut string.
   */
  parse(e) {
    if (typeof e != "string" || e.length === 0) return null;
    const t = e.split("+");
    if (t.length === 0) return null;
    const n = t[t.length - 1], r = t.slice(0, -1), o = [], s = /* @__PURE__ */ new Set();
    for (const a of r) {
      if (!Al.has(a)) return null;
      const c = a;
      if (s.has(c)) return null;
      s.add(c), o.push(c);
    }
    if (!Pl(n)) return null;
    const i = ["Control", "Alt", "Shift", "Meta", "Mod"];
    return o.sort((a, c) => i.indexOf(a) - i.indexOf(c)), {
      key: n,
      modifiers: o
    };
  }
}, Pl = (e) => e.length === 0 ? !1 : e.length === 1 ? /^[A-Za-z0-9]$/.test(e) ? !0 : Ol.has(e) : !!(Cl.has(e) || /^F([1-9]|1[0-2])$/.test(e)), yn = /* @__PURE__ */ new Map(), en = /* @__PURE__ */ new Map(), xs = /* @__PURE__ */ new Map();
let Is = null;
const xl = () => null, Fo = /* @__PURE__ */ new Set(), Ae = {
  /**
   * Test-only helper. Resets all registry maps so tests can register fresh scope types
   * without leaking state between cases.
   */
  _clear() {
    yn.clear(), en.clear(), xs.clear(), Fo.clear();
  },
  /**
   * Internal: installs the React component factory used by `defineScope` to mint the typed
   * wrapper component. Phase 2's scope wrapper module calls this once at module load.
   * @param factory - The wrapper factory to install, or null to clear it.
   */
  _setScopeWrapperFactory(e) {
    Is = e;
  },
  actionsById: en,
  contextScopes: xs,
  /**
   * Registers a scope type and all its actions. Throws if any action id is already
   * registered (global uniqueness invariant). Returns the typed wrapper component
   * for this scope type; until Phase 2 installs the wrapper factory, the returned
   * component is a no-op placeholder (sufficient for unit tests against the registry).
   * @param spec - The scope type definition.
   */
  defineScope(e) {
    if (yn.has(e.id)) throw new Error(`ActionRegistry: scope type '${e.id}' is already registered. Each scope type must have a unique id.`);
    const t = Va(e.actions);
    for (const r of t) {
      const o = en.get(r.id);
      if (o) throw new Error(`ActionRegistry: action id '${r.id}' is already registered (by scope type '${o.scopeTypeId}'). Action ids must be globally unique.`);
    }
    yn.set(e.id, e);
    for (const r of t)
      en.set(r.id, {
        action: r,
        scopeTypeId: e.id
      });
    process.env.NODE_ENV !== "production" && Il(e.id, t);
    const n = Is;
    return n ? n(e) : xl;
  },
  scopeTypes: yn
}, Va = (e) => {
  const t = [];
  for (const n of e)
    t.push(n), n.children && n.children.length > 0 && t.push(...Va(n.children));
  return t;
}, Il = (e, t) => {
  for (const n of t) {
    if (!n.shortcut) continue;
    const r = jt.parse(n.shortcut);
    if (!r) continue;
    const o = jt.format(r);
    en.forEach((s) => {
      if (s.scopeTypeId === e || s.action.id === n.id || !s.action.shortcut) return;
      const i = jt.parse(s.action.shortcut);
      if (!i || i.key !== r.key || i.modifiers.length !== r.modifiers.length) return;
      for (let c = 0; c < i.modifiers.length; c++)
        if (i.modifiers[c] !== r.modifiers[c]) return;
      const a = `${o}::${e}::${s.scopeTypeId}`;
      Fo.has(a) || (Fo.add(a), console.warn(`[actions] shortcut ${o} on scope '${e}' shadows scope '${s.scopeTypeId}'`));
    });
  }
}, Ns = /* @__PURE__ */ new Set(), tt = {
  /**
   * Walks `composedPath()` outermost → innermost and produces the resolved scope chain.
   * Reads `data-scope` (high-volume scopes) and `data-context-scope-id` (low-volume
   * scopes registered via `<ContextScope>`). Returns root → current order.
   * @param path - The result of `event.composedPath()`.
   */
  resolveChain(e) {
    const t = [...e].reverse(), n = [];
    for (const r of t) {
      if (!Nl(r)) continue;
      const o = r, s = o.getAttribute("data-scope");
      if (s !== null) {
        const a = Ae.scopeTypes.get(s);
        if (!a) continue;
        const c = a.payloadFromDom(o);
        n.push({
          element: o,
          payload: c,
          scopeTypeId: s
        });
        continue;
      }
      const i = o.getAttribute("data-context-scope-id");
      if (i !== null) {
        const a = Ae.contextScopes.get(i);
        if (!a) continue;
        n.push({
          element: o,
          payload: a.payload,
          scopeTypeId: a.scopeTypeId ?? `__context:${i}`
        });
      }
    }
    return n;
  },
  /**
   * Looks up every selected payload of a given scope type via
   * `document.querySelectorAll('[data-scope=X][data-selected]')` and maps each
   * matching element through the scope type's `payloadFromDom`.
   * @param scopeTypeId - The scope type id whose selection to read.
   */
  resolveSelection(e) {
    const t = Ae.scopeTypes.get(e);
    if (!t) return [];
    if (typeof document > "u") return [];
    const n = jl(e), r = document.querySelectorAll(`[data-scope="${n}"][data-selected]`), o = [];
    return r.forEach((s) => {
      o.push(t.payloadFromDom(s));
    }), o;
  },
  /**
   * Computes a stable string key for a payload, used by the in-flight Map. Uses the
   * action's `key(payload)` if provided, otherwise a deterministic JSON serialization
   * with alphabetized keys (via `Objects.orderProperties`).
   * Non-serializable fallback (cycles, functions, Date, Map/Set, class instances):
   * - In dev (`process.env.NODE_ENV !== 'production'`): throws — surfaces the bug at
   *   first dispatch, before in-flight tracking silently collapses entries.
   * - In prod: emits `console.warn` once per actionId, falls back to
   *   `crypto.randomUUID()`. In-flight tracking degrades gracefully.
   * @param actionId - The action id (used for diagnostic messages and warn de-duping).
   * @param payload - The payload to key.
   * @param keyFn - Optional `Action.key` function.
   */
  stableKey(e, t, n) {
    if (n) return n(t);
    if (t == null) return String(t);
    if (typeof t != "object") return JSON.stringify(t);
    try {
      const r = Bo(t), o = JSON.stringify(r, Ml);
      if (o === void 0) throw new Error("serialization yielded undefined");
      return o;
    } catch (r) {
      if (!(process.env.NODE_ENV === "production"))
        throw new Error(`Action '${e}' received a non-serializable payload. Declare key(payload) on the action definition. (cause: ${r.message})`);
      return Ns.has(e) || (Ns.add(e), console.warn(`[actions] Action '${e}' received a non-serializable payload. In-flight tracking falls back to a per-dispatch random id. Declare key(payload) to fix.`)), Dl();
    }
  }
}, Nl = (e) => typeof HTMLElement < "u" && e instanceof HTMLElement ? !0 : e !== null && typeof e == "object" && "getAttribute" in e && "nodeType" in e && e.nodeType === 1, Ml = (e, t) => {
  if (typeof t == "function") throw new Error("payload contains a function");
  if (typeof t == "symbol") throw new Error("payload contains a symbol");
  if (typeof t == "bigint") return t.toString();
  if (t instanceof Map) throw new Error("payload contains a Map");
  if (t instanceof Set) throw new Error("payload contains a Set");
  return t;
}, Dl = () => typeof crypto < "u" && typeof crypto.randomUUID == "function" ? crypto.randomUUID() : `__rand:${Math.random().toString(36).slice(2)}:${Date.now()}`, jl = (e) => e.replace(/\\/g, "\\\\").replace(/"/g, '\\"'), Bo = (e) => {
  const t = {};
  return Object.keys(e).sort().forEach((n) => {
    const r = e[n];
    Ms(r) ? t[n] = Bo(r) : Array.isArray(r) ? t[n] = r.map((o) => Ms(o) ? Bo(o) : o) : t[n] = r;
  }), t;
}, Ms = (e) => {
  if (e === null || typeof e != "object" || Array.isArray(e)) return !1;
  const t = Object.getPrototypeOf(e);
  return t === Object.prototype || t === null;
};
var _n = { exports: {} }, Bt = {};
var Ds;
function Ll() {
  if (Ds) return Bt;
  Ds = 1;
  var e = /* @__PURE__ */ Symbol.for("react.transitional.element"), t = /* @__PURE__ */ Symbol.for("react.fragment");
  function n(r, o, s) {
    var i = null;
    if (s !== void 0 && (i = "" + s), o.key !== void 0 && (i = "" + o.key), "key" in o) {
      s = {};
      for (var a in o)
        a !== "key" && (s[a] = o[a]);
    } else s = o;
    return o = s.ref, {
      $$typeof: e,
      type: r,
      key: i,
      ref: o !== void 0 ? o : null,
      props: s
    };
  }
  return Bt.Fragment = t, Bt.jsx = n, Bt.jsxs = n, Bt;
}
var $t = {};
var js;
function Hl() {
  return js || (js = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(T) {
      if (T == null) return null;
      if (typeof T == "function")
        return T.$$typeof === x ? null : T.displayName || T.name || null;
      if (typeof T == "string") return T;
      switch (T) {
        case b:
          return "Fragment";
        case k:
          return "Profiler";
        case _:
          return "StrictMode";
        case g:
          return "Suspense";
        case y:
          return "SuspenseList";
        case H:
          return "Activity";
      }
      if (typeof T == "object")
        switch (typeof T.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), T.$$typeof) {
          case R:
            return "Portal";
          case w:
            return T.displayName || "Context";
          case S:
            return (T._context.displayName || "Context") + ".Consumer";
          case h:
            var q = T.render;
            return T = T.displayName, T || (T = q.displayName || q.name || "", T = T !== "" ? "ForwardRef(" + T + ")" : "ForwardRef"), T;
          case E:
            return q = T.displayName || null, q !== null ? q : e(T.type) || "Memo";
          case A:
            q = T._payload, T = T._init;
            try {
              return e(T(q));
            } catch {
            }
        }
      return null;
    }
    function t(T) {
      return "" + T;
    }
    function n(T) {
      try {
        t(T);
        var q = !1;
      } catch {
        q = !0;
      }
      if (q) {
        q = console;
        var I = q.error, j = typeof Symbol == "function" && Symbol.toStringTag && T[Symbol.toStringTag] || T.constructor.name || "Object";
        return I.call(
          q,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          j
        ), t(T);
      }
    }
    function r(T) {
      if (T === b) return "<>";
      if (typeof T == "object" && T !== null && T.$$typeof === A)
        return "<...>";
      try {
        var q = e(T);
        return q ? "<" + q + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function o() {
      var T = M.A;
      return T === null ? null : T.getOwner();
    }
    function s() {
      return Error("react-stack-top-frame");
    }
    function i(T) {
      if (L.call(T, "key")) {
        var q = Object.getOwnPropertyDescriptor(T, "key").get;
        if (q && q.isReactWarning) return !1;
      }
      return T.key !== void 0;
    }
    function a(T, q) {
      function I() {
        z || (z = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          q
        ));
      }
      I.isReactWarning = !0, Object.defineProperty(T, "key", {
        get: I,
        configurable: !0
      });
    }
    function c() {
      var T = e(this.type);
      return V[T] || (V[T] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), T = this.props.ref, T !== void 0 ? T : null;
    }
    function l(T, q, I, j, Q, K) {
      var W = I.ref;
      return T = {
        $$typeof: m,
        type: T,
        key: q,
        props: I,
        _owner: j
      }, (W !== void 0 ? W : null) !== null ? Object.defineProperty(T, "ref", {
        enumerable: !1,
        get: c
      }) : Object.defineProperty(T, "ref", { enumerable: !1, value: null }), T._store = {}, Object.defineProperty(T._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(T, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(T, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: Q
      }), Object.defineProperty(T, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: K
      }), Object.freeze && (Object.freeze(T.props), Object.freeze(T)), T;
    }
    function u(T, q, I, j, Q, K) {
      var W = q.children;
      if (W !== void 0)
        if (j)
          if ($(W)) {
            for (j = 0; j < W.length; j++)
              d(W[j]);
            Object.freeze && Object.freeze(W);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else d(W);
      if (L.call(q, "key")) {
        W = e(T);
        var ae = Object.keys(q).filter(function(ue) {
          return ue !== "key";
        });
        j = 0 < ae.length ? "{key: someKey, " + ae.join(": ..., ") + ": ...}" : "{key: someKey}", ie[W + j] || (ae = 0 < ae.length ? "{" + ae.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          j,
          W,
          ae,
          W
        ), ie[W + j] = !0);
      }
      if (W = null, I !== void 0 && (n(I), W = "" + I), i(q) && (n(q.key), W = "" + q.key), "key" in q) {
        I = {};
        for (var oe in q)
          oe !== "key" && (I[oe] = q[oe]);
      } else I = q;
      return W && a(
        I,
        typeof T == "function" ? T.displayName || T.name || "Unknown" : T
      ), l(
        T,
        W,
        I,
        o(),
        Q,
        K
      );
    }
    function d(T) {
      f(T) ? T._store && (T._store.validated = 1) : typeof T == "object" && T !== null && T.$$typeof === A && (T._payload.status === "fulfilled" ? f(T._payload.value) && T._payload.value._store && (T._payload.value._store.validated = 1) : T._store && (T._store.validated = 1));
    }
    function f(T) {
      return typeof T == "object" && T !== null && T.$$typeof === m;
    }
    var p = ce, m = /* @__PURE__ */ Symbol.for("react.transitional.element"), R = /* @__PURE__ */ Symbol.for("react.portal"), b = /* @__PURE__ */ Symbol.for("react.fragment"), _ = /* @__PURE__ */ Symbol.for("react.strict_mode"), k = /* @__PURE__ */ Symbol.for("react.profiler"), S = /* @__PURE__ */ Symbol.for("react.consumer"), w = /* @__PURE__ */ Symbol.for("react.context"), h = /* @__PURE__ */ Symbol.for("react.forward_ref"), g = /* @__PURE__ */ Symbol.for("react.suspense"), y = /* @__PURE__ */ Symbol.for("react.suspense_list"), E = /* @__PURE__ */ Symbol.for("react.memo"), A = /* @__PURE__ */ Symbol.for("react.lazy"), H = /* @__PURE__ */ Symbol.for("react.activity"), x = /* @__PURE__ */ Symbol.for("react.client.reference"), M = p.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, L = Object.prototype.hasOwnProperty, $ = Array.isArray, U = console.createTask ? console.createTask : function() {
      return null;
    };
    p = {
      react_stack_bottom_frame: function(T) {
        return T();
      }
    };
    var z, V = {}, D = p.react_stack_bottom_frame.bind(
      p,
      s
    )(), Z = U(r(s)), ie = {};
    $t.Fragment = b, $t.jsx = function(T, q, I) {
      var j = 1e4 > M.recentlyCreatedOwnerStacks++;
      return u(
        T,
        q,
        I,
        !1,
        j ? Error("react-stack-top-frame") : D,
        j ? U(r(T)) : Z
      );
    }, $t.jsxs = function(T, q, I) {
      var j = 1e4 > M.recentlyCreatedOwnerStacks++;
      return u(
        T,
        q,
        I,
        !0,
        j ? Error("react-stack-top-frame") : D,
        j ? U(r(T)) : Z
      );
    };
  })()), $t;
}
var Ls;
function Ul() {
  return Ls || (Ls = 1, process.env.NODE_ENV === "production" ? _n.exports = Ll() : _n.exports = Hl()), _n.exports;
}
var C = Ul();
const pt = ln(null);
class ql {
  constructor() {
    N(this, "_listeners", /* @__PURE__ */ new Set());
    N(this, "_map", /* @__PURE__ */ new Map());
    /**
     * Removes the entry at `key`, replaces the snapshot Map, and notifies subscribers.
     * No-op if the key is not present.
     * @param key - The in-flight key to remove.
     */
    N(this, "delete", (t) => {
      if (!this._map.has(t)) return;
      const n = new Map(this._map);
      n.delete(t), this._map = n, this._emit();
    });
    /** Returns the current snapshot Map (identity is stable until a mutation occurs). */
    N(this, "getSnapshot", () => this._map);
    /**
     * Sets the entry at `key`, replaces the snapshot Map, and notifies subscribers.
     * @param key - The in-flight key to set.
     * @param entry - The in-flight entry.
     */
    N(this, "set", (t, n) => {
      const r = new Map(this._map);
      r.set(t, n), this._map = r, this._emit();
    });
    /**
     * Registers a subscriber. Returns an unsubscribe function.
     * @param listener - The subscriber callback.
     */
    N(this, "subscribe", (t) => (this._listeners.add(t), () => {
      this._listeners.delete(t);
    }));
    N(this, "_emit", () => {
      this._listeners.forEach((t) => t());
    });
  }
}
const Sr = {
  body: "",
  destructive: !1,
  open: !1,
  resolve: null
}, Fl = {
  items: [],
  open: !1,
  position: {
    x: 0,
    y: 0
  }
}, Wt = "__app", Bl = (e) => {
  if (!e || !(e instanceof HTMLElement)) return !1;
  if (e.isContentEditable) return !0;
  const t = e.tagName;
  return t === "INPUT" || t === "TEXTAREA" || t === "SELECT";
}, uy = (e) => {
  const {
    ConfirmDialog: t,
    Menu: n,
    children: r,
    commandPalette: o = !0,
    onError: s,
    shortcutHelp: i = !0,
    toast: a
  } = e, c = Qn(() => new ql(), []), [l, u] = pe(!1), [d, f] = pe(!1), [p, m] = pe(Sr), [R, b] = pe(Fl), _ = he([]), k = he([]), S = he(!1), w = he(/* @__PURE__ */ new Set()), h = he([]), g = he(s);
  g.current = s;
  const y = he(a);
  y.current = a;
  const E = he({});
  le(() => {
    if (!o && !i) return;
    const I = [];
    if (o) {
      const j = {
        id: "app.openCommandPalette",
        label: "Open command palette",
        /** Built-in: opens the command palette overlay. */
        run: () => u(!0),
        shortcut: "Mod+K"
      };
      I.push(j), E.current.palette = j;
    }
    if (i) {
      const j = {
        id: "app.openShortcutHelp",
        label: "Open shortcut help",
        /** Built-in: opens the shortcut help overlay. */
        run: () => f(!0),
        shortcut: "?"
      };
      I.push(j), E.current.help = j;
    }
    return Ae.scopeTypes.has(Wt) || Ae.defineScope({
      actions: I,
      /** Synthetic scope: emits no DOM attributes (lives at the chain root). */
      attrs: () => ({}),
      id: Wt,
      /** Synthetic scope: payload is always the empty object. */
      payloadFromDom: () => ({})
    }), () => {
      Ae.scopeTypes.delete(Wt);
      for (const j of I) Ae.actionsById.delete(j.id);
      E.current = {};
    };
  }, [o, i]);
  const A = Te(() => {
    if (typeof document > "u") return [];
    const I = document.activeElement;
    if (I && I !== document.body && I instanceof HTMLElement) {
      const Q = [];
      let K = I;
      for (; K; )
        Q.push(K), K = K.parentElement;
      const W = tt.resolveChain(Q);
      if (W.length > 0) return W;
    }
    return tt.resolveChain(_.current);
  }, []), H = Te((I) => {
    h.current = I, w.current.forEach((j) => j());
  }, []), x = Te((I) => new Promise((j) => {
    m({
      body: I.body,
      cancelLabel: I.cancelLabel,
      confirmLabel: I.confirmLabel,
      destructive: I.destructive ?? !1,
      open: !0,
      resolve: j,
      title: I.title
    });
  }), []), M = Te((I, j) => {
    if (y.current) {
      y.current(I, j);
      return;
    }
    process.env.NODE_ENV !== "production" && console.warn(`[actions] toast('${I}') called but no toast prop was provided to <ActionRootBase>.`);
  }, []), L = Te(() => {
    m((I) => (I.resolve?.(!0), Sr));
  }, []), $ = Te(() => {
    m((I) => (I.resolve?.(!1), Sr));
  }, []), U = Te(async (I, j, Q, K, W) => {
    const ae = `${I.id}::${tt.stableKey(I.id, j, I.key)}`, oe = new AbortController();
    c.set(ae, {
      abort: oe,
      startedAt: Date.now()
    });
    const ue = {
      chain: Q,
      confirm: x,
      dispatch: ((ve, ge) => V.current(ve, ge)),
      selection: W,
      signal: oe.signal,
      toast: M
    };
    try {
      await I.run(j, ue);
    } catch (ve) {
      throw g.current && g.current(ve, {
        action: I,
        payload: j,
        surface: K
      }), ve;
    } finally {
      c.delete(ae);
    }
  }, [x, M, c]), z = Te(async (I, j, Q = "dispatch") => {
    const K = Ae.actionsById.get(I);
    if (!K) {
      const oe = new Error(`Action '${I}' is not registered.`);
      throw g.current && g.current(oe, {
        action: {
          id: I,
          label: I,
          /** Stub action used solely to populate the onError ctx for unregistered ids. */
          run: () => {
          }
        },
        payload: j,
        surface: Q
      }), oe;
    }
    const W = A(), ae = bn(W, K.scopeTypeId);
    await U(K.action, j, W, Q, ae);
  }, [A, U]), V = he(z);
  V.current = z, le(() => {
    if (typeof document > "u") return;
    const I = (j) => {
      if (!S.current) return;
      const Q = j.composedPath();
      let K = tt.resolveChain(Q);
      K.length === 0 && (K = A()), H(K);
      const W = Bl(j.target), ae = j.metaKey || j.ctrlKey || j.altKey, ue = [...[...K].reverse()];
      Ae.scopeTypes.get(Wt) && ue.push({
        element: document.documentElement,
        payload: {},
        scopeTypeId: Wt
      });
      for (const ge of ue) {
        const He = Ae.scopeTypes.get(ge.scopeTypeId);
        if (He)
          for (const Ce of Ka(He.actions)) {
            if (!Ce.shortcut) continue;
            const Fe = jt.parse(Ce.shortcut);
            if (!Fe || !jt.matches(Fe, j) || W && !ae && Fe.modifiers.length === 0) continue;
            const Be = bn(K, ge.scopeTypeId), We = Hs(K, Be, x, M, V);
            if (!(Ce.hidden && Ce.hidden(ge.payload, We)) && !(Ce.disabled && Ce.disabled(ge.payload, We))) {
              j.preventDefault(), j.stopPropagation(), U(Ce, ge.payload, K, "keyboard", Be).catch(() => {
              });
              return;
            }
          }
      }
    };
    return document.addEventListener("keydown", I), () => {
      document.removeEventListener("keydown", I);
    };
  }, [x, H, A, U, M]), le(() => {
    if (typeof document > "u") return;
    const I = (j) => {
      if (!S.current) return;
      const Q = j.composedPath(), K = tt.resolveChain(Q);
      if (k.current = K, H(K), K.length === 0) return;
      const W = [], ae = [...K].reverse();
      for (const oe of ae) {
        const ue = Ae.scopeTypes.get(oe.scopeTypeId);
        if (!ue) continue;
        const ve = bn(K, oe.scopeTypeId), ge = Hs(K, ve, x, M, V);
        for (const He of ue.actions) {
          const Ce = Ya(He, oe.scopeTypeId, oe.payload, ge);
          Ce && W.push(Ce);
        }
      }
      W.length !== 0 && (j.preventDefault(), b({
        items: W,
        open: !0,
        position: {
          x: j.clientX,
          y: j.clientY
        }
      }));
    };
    return document.addEventListener("contextmenu", I), () => {
      document.removeEventListener("contextmenu", I);
    };
  }, [x, H, M]), le(() => {
    if (typeof document > "u") return;
    const I = (j) => {
      const Q = j.composedPath();
      _.current = Q, H(tt.resolveChain(Q));
    };
    return document.addEventListener("pointerdown", I), () => {
      document.removeEventListener("pointerdown", I);
    };
  }, [H]), le(() => (S.current = !0, () => {
    S.current = !1;
  }), []);
  const D = Te((I) => {
    b((K) => ({
      ...K,
      open: !1
    }));
    const j = k.current, Q = bn(j, I.scopeTypeId);
    U(I.action, I.payload, j, "menu", Q).catch(() => {
    });
  }, [U]), Z = Te(() => {
    b((I) => ({
      ...I,
      open: !1
    }));
  }, []), ie = Te((I) => (w.current.add(I), () => {
    w.current.delete(I);
  }), []), T = Te(() => h.current, []), q = Qn(() => ({
    confirm: x,
    dispatch: z,
    getActiveChain: T,
    helpOpen: d,
    inFlightStore: c,
    onError: s,
    paletteOpen: l,
    setHelpOpen: f,
    setPaletteOpen: u,
    subscribeToChain: ie,
    toast: M
  }), [x, z, M, T, d, c, s, l, ie]);
  return /* @__PURE__ */ C.jsxs(pt.Provider, { value: q, children: [
    r,
    /* @__PURE__ */ C.jsx(t, { body: p.body, cancelLabel: p.cancelLabel, confirmLabel: p.confirmLabel, destructive: p.destructive, onCancel: $, onConfirm: L, open: p.open, title: p.title }),
    n ? /* @__PURE__ */ C.jsx(n, { items: R.items, onClose: Z, onSelect: D, open: R.open, position: R.position }) : null
  ] });
}, Ka = (e) => {
  const t = [];
  for (const n of e)
    t.push(n), n.children && n.children.length > 0 && t.push(...Ka(n.children));
  return t;
}, bn = (e, t) => Ae.scopeTypes.get(t)?.selectable ? e.some((r) => r.scopeTypeId === t) ? tt.resolveSelection(t) : [] : [], Ya = (e, t, n, r) => {
  if (e.hidden && e.hidden(n, r)) return null;
  const o = typeof e.label == "function" ? e.label(n, r) : e.label;
  let s = e.icon;
  typeof e.icon == "function" && e.icon.length === 2 && (s = e.icon(n, r));
  const i = {
    action: e,
    icon: s,
    iconColor: e.iconColor,
    label: o,
    payload: n,
    scopeTypeId: t,
    shortcut: e.shortcut
  };
  if (e.children && e.children.length > 0) {
    const c = [];
    for (const l of e.children) {
      const u = Ya(l, t, n, r);
      u && c.push(u);
    }
    if (c.length > 0) return {
      ...i,
      children: c
    };
  }
  const a = e.disabled ? e.disabled(n, r) : !1;
  return e.destructive === !0 ? {
    ...i,
    destructive: !0,
    disabled: a
  } : {
    ...i,
    disabled: a,
    selected: !1
  };
}, Hs = (e, t, n, r, o) => ({
  chain: e,
  confirm: n,
  dispatch: ((s, i) => o.current(s, i)),
  selection: t,
  signal: new AbortController().signal,
  toast: r
});
var En = { exports: {} }, Tr = {};
var Us;
function $l() {
  if (Us) return Tr;
  Us = 1;
  var e = ce.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  return Tr.c = function(t) {
    return e.H.useMemoCache(t);
  }, Tr;
}
var Ar = {};
var qs;
function Wl() {
  return qs || (qs = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = ce.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
    Ar.c = function(t) {
      var n = e.H;
      return n === null && console.error(
        `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
      ), n.useMemoCache(t);
    };
  })()), Ar;
}
var Fs;
function zl() {
  return Fs || (Fs = 1, process.env.NODE_ENV === "production" ? En.exports = $l() : En.exports = Wl()), En.exports;
}
var re = zl();
const Bs = (e) => {
  const t = he(e);
  return $o(t.current, e) || (t.current = e), t.current;
}, $o = (e, t) => {
  if (Object.is(e, t)) return !0;
  if (e === null || t === null || typeof e != "object" || typeof t != "object") return !1;
  if (Array.isArray(e)) {
    if (!Array.isArray(t) || e.length !== t.length) return !1;
    for (let o = 0; o < e.length; o++) if (!$o(e[o], t[o])) return !1;
    return !0;
  }
  if (Array.isArray(t)) return !1;
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  for (const o of n)
    if (!Object.prototype.hasOwnProperty.call(t, o) || !$o(e[o], t[o])) return !1;
  return !0;
}, $s = /* @__PURE__ */ new Set(), dy = (e) => {
  const t = re.c(14), n = vl(), r = Bs(e.actions), o = Bs(e.payload), s = Me(pt), i = he(!1);
  let a, c;
  t[0] !== s || t[1] !== n || t[2] !== e.scopeTypeId ? (a = () => {
    i.current || (i.current = !0, process.env.NODE_ENV !== "production" && (s || $s.has(n) || ($s.add(n), console.warn(`[actions] <ContextScope> '${e.scopeTypeId ?? n}' rendered without an <ActionRoot> ancestor — keyboard shortcuts and right-click menus will not work.`))));
  }, c = [s, n, e.scopeTypeId], t[0] = s, t[1] = n, t[2] = e.scopeTypeId, t[3] = a, t[4] = c) : (a = t[3], c = t[4]), le(a, c);
  let l, u;
  t[5] !== n || t[6] !== e.scopeTypeId || t[7] !== r || t[8] !== o ? (l = () => (Ae.contextScopes.set(n, {
    actions: r,
    payload: o,
    scopeTypeId: e.scopeTypeId
  }), () => {
    Ae.contextScopes.delete(n);
  }), u = [n, r, o, e.scopeTypeId], t[5] = n, t[6] = e.scopeTypeId, t[7] = r, t[8] = o, t[9] = l, t[10] = u) : (l = t[9], u = t[10]), le(l, u);
  let d;
  return t[11] !== n || t[12] !== e.children ? (d = /* @__PURE__ */ C.jsx("div", { "data-context-scope-id": n, children: e.children }), t[11] = n, t[12] = e.children, t[13] = d) : d = t[13], d;
}, Ws = /* @__PURE__ */ new Set(), Gl = (e) => {
  const t = (n) => {
    const r = re.c(3), {
      children: o,
      className: s,
      style: i,
      ...a
    } = n, c = Me(pt), l = he(!1);
    let u, d;
    r[0] !== c ? (u = () => {
      l.current || (l.current = !0, process.env.NODE_ENV !== "production" && (c || Ws.has(e.id) || (Ws.add(e.id), console.warn(`[actions] Scope '${e.id}' rendered without an <ActionRoot> ancestor — keyboard shortcuts and right-click menus will not work.`))));
    }, d = [c], r[0] = c, r[1] = u, r[2] = d) : (u = r[1], d = r[2]), le(u, d);
    const {
      selected: f,
      ...p
    } = a, m = f === !0, b = {
      ...e.attrs(p),
      "data-scope": e.id
    };
    return e.selectable && m && (b["data-selected"] = ""), s !== void 0 && (b.className = s), i !== void 0 && (b.style = i), Zn("div", b, o);
  };
  return t.displayName = `Scope(${e.id})`, t;
};
Ae._setScopeWrapperFactory(Gl);
const Xl = [], Vl = () => {
  const e = Me(pt);
  return us(e ? e.subscribeToChain : Kl, e ? e.getActiveChain : zs, zs);
}, Kl = () => () => {
}, zs = () => Xl, Gs = /* @__PURE__ */ new Set(), Xs = /* @__PURE__ */ new Set(), fy = (e, t) => {
  const n = Me(pt), o = Ae.actionsById.get(e)?.action, s = Qn(() => o ? tt.stableKey(o.id, t, o.key) : "", [o, t]), i = `${e}::${s}`, a = n ? n.inFlightStore.subscribe : eu, l = us(a, n ? () => n.inFlightStore.getSnapshot().has(i) : Vs, Vs), u = Vl(), d = Qn(() => o?.shortcut ? jt.parse(o.shortcut) ?? void 0 : void 0, [o?.shortcut]), f = Te(async () => {
    if (o) {
      if (!n) {
        process.env.NODE_ENV !== "production" && !Xs.has(e) && (Xs.add(e), console.warn(`[useAction] '${e}' run() called outside an <ActionRoot>; ignoring.`));
        return;
      }
      try {
        await n.dispatch(e, t, "button");
      } catch {
      }
    }
  }, [o, n, e, t]);
  if (!o)
    return process.env.NODE_ENV !== "production" && !Gs.has(e) && (Gs.add(e), console.warn(`[useAction] action '${e}' is not registered.`)), {
      destructive: !1,
      disabled: !1,
      exists: !1,
      hidden: !0,
      icon: null,
      inFlight: !1,
      label: "",
      run: f
    };
  const p = {
    chain: u,
    confirm: n ? n.confirm : Ql,
    dispatch: n ? n.dispatch : Zl,
    selection: [],
    signal: Yl,
    toast: n ? n.toast : tu
  }, m = o.hidden ? o.hidden(t, p) : !1, R = o.disabled ? o.disabled(t, p) : !1, b = typeof o.label == "function" ? o.label(t, p) : o.label;
  let _ = o.icon;
  typeof o.icon == "function" && o.icon.length === 2 && (_ = o.icon(t, p));
  const k = Jl(_) ? _ : null;
  return {
    destructive: o.destructive === !0,
    disabled: R,
    exists: !0,
    hidden: m,
    icon: k,
    inFlight: l,
    label: b,
    run: f,
    shortcut: d
  };
}, Yl = AbortSignal.abort(), Vs = () => !1, Jl = (e) => typeof e == "object" && e !== null && typeof e.body == "string", Ql = () => Promise.resolve(!1), Zl = () => Promise.resolve(), eu = () => () => {
}, tu = () => {
}, nu = () => {
  throw new Error("useActions() called without an <ActionRoot> ancestor.");
}, hy = () => {
  const e = re.c(4), t = Me(pt);
  let n;
  e[0] !== t ? (n = (s, i) => t ? t.dispatch(s, i) : nu(), e[0] = t, e[1] = n) : n = e[1];
  const r = n;
  let o;
  return e[2] !== r ? (o = {
    dispatch: r,
    getDefinition: ru,
    listShortcuts: ou
  }, e[2] = r, e[3] = o) : o = e[3], o;
};
function ru(e) {
  return Ae.actionsById.get(e)?.action;
}
function ou() {
  const e = [];
  return Ae.actionsById.forEach((t, n) => {
    t.action.shortcut && e.push({
      actionId: n,
      scopeTypeId: t.scopeTypeId,
      shortcut: t.action.shortcut
    });
  }), e;
}
const py = () => {
  const e = Me(pt);
  if (!e)
    throw new Error("useConfirm() called without an <ActionRoot> ancestor.");
  return e.confirm;
}, su = "_overlay_fuq4r_2", iu = "_card_fuq4r_13", au = "_icon_fuq4r_28", cu = "_title_fuq4r_35", lu = "_description_fuq4r_43", uu = "_errorDetails_fuq4r_50", du = "_button_fuq4r_69", lt = {
  overlay: su,
  card: iu,
  icon: au,
  title: cu,
  description: lu,
  errorDetails: uu,
  button: du
}, tn = {
  /**
   * Base64 decode a string using browser's atob function.
   * @param str - The string to decode.
   */
  decode(e) {
    const t = atob(e);
    let n = "";
    for (let r = 0; r < t.length; r++) {
      const o = ("00" + t.charCodeAt(r).toString(16)).slice(-2);
      n += "%" + o;
    }
    return decodeURIComponent(n);
  },
  /**
   * Base64 encode a string using browser's btoa function.
   * @param str - The string to encode.
   */
  encode(e) {
    return btoa(encodeURIComponent(e).replace(/%([0-9A-F]{2})/g, (t, n) => String.fromCharCode(parseInt(n, 16))));
  }
};
var Wo = /* @__PURE__ */ ((e) => (e.REQUEST = "request", e.RESPONSE = "response", e))(Wo || {});
const er = {
  /**
   * Decrypts a string using XOR cipher.
   * See: https://stackoverflow.com/a/66938952/886279
   * @param salt - The secret key required to decrypt.
   * @param encoded - The encoded String.
   */
  decrypt(e, t) {
    if (!t) return "";
    let n = 0;
    for (let o = 0; o < e.length; o++)
      n ^= e.charCodeAt(o);
    let r = "";
    for (let o = 0; o < t.length; o += 2) {
      const s = parseInt(t.slice(o, o + 2), 16) ^ n;
      r += String.fromCharCode(s);
    }
    return r;
  },
  /**
   * Decrypts a payload. Accepts encrypted string.
   * @param hmac - The HMAC secret required to decrypt.
   * @param context - The context (request or response) for key derivation.
   * @param encoded - The encrypted string you want to decode.
   */
  decryptPayload(e, t, n) {
    try {
      const r = Ks(e, t), o = er.decrypt(r, n);
      return JSON.parse(o);
    } catch {
      throw new Error("Failed to decrypt payload: invalid format or corrupted data");
    }
  },
  /**
   * Encrypts a string using XOR cipher.
   * See: https://stackoverflow.com/a/66938952/886279
   * @param salt - The secret key required to encrypt.
   * @param plaintext - The plaintext String you want to encode.
   */
  encrypt(e, t) {
    let n = 0;
    for (let o = 0; o < e.length; o++)
      n ^= e.charCodeAt(o);
    let r = "";
    for (let o = 0; o < t.length; o++) {
      const s = t.charCodeAt(o) ^ n;
      r += ("0" + s.toString(16)).slice(-2);
    }
    return r;
  },
  /**
   * Encrypts a payload. Returns encrypted string.
   * @template T
   * @param hmac - The HMAC secret required to encrypt.
   * @param context - The context (request or response) for key derivation.
   * @param unencoded - The object you want to encode.
   */
  encryptPayload(e, t, n) {
    const r = JSON.stringify(n), o = Ks(e, t);
    return er.encrypt(o, r);
  }
}, Ks = (e, t) => e + ":" + t;
function Ys(e) {
  return e instanceof Uint8Array || ArrayBuffer.isView(e) && e.constructor.name === "Uint8Array" && "BYTES_PER_ELEMENT" in e && e.BYTES_PER_ELEMENT === 1;
}
const zo = (e) => e ? `"${e}" ` : "";
function Js(e, t = "") {
  if (typeof e != "number")
    throw new TypeError(zo(t) + "expected number, got " + typeof e);
  if (!Number.isSafeInteger(e) || e < 0)
    throw new RangeError(zo(t) + "expected integer >= 0, got " + e);
  return e;
}
function ar(e, t, n = "") {
  if (Ys(e) && t === void 0)
    return e;
  const r = Ys(e), o = "", s = r ? `length=${e.length}` : `type=${typeof e}`, i = zo(n) + "expected Uint8Array" + o + ", got " + s;
  throw r ? new RangeError(i) : new TypeError(i);
}
function fu(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new TypeError("expected hash wrapped by utils.createHasher");
  if (Js(e.outputLen), Js(e.blockLen), e.outputLen < 1 || e.blockLen < 1)
    throw new Error("hash blockLen / outputLen must be >= 1");
}
const Qs = (e, t) => {
  if (e === null || typeof e != "object" || Array.isArray(e))
    throw new TypeError((t === "object" ? "" : `"${t}" `) + "expected object, got type=" + typeof e);
};
function tr(e, t = !0) {
  if (e.destroyed)
    throw new Error("hash was destroyed");
  if (t && e.finished)
    throw new Error("digest() was already called");
}
function Ja(e, t) {
  ar(e, void 0, "output");
  const n = t.outputLen;
  if (!(e.length >= n))
    throw new RangeError('"output" expected length >= ' + n);
}
function Go(...e) {
  for (let t = 0; t < e.length; t++)
    e[t].fill(0);
}
function Cr(e) {
  return new DataView(e.buffer, e.byteOffset, e.byteLength);
}
function Ue(e, t) {
  return e << 32 - t | e >>> t;
}
const hu = /* @ts-ignore */ typeof Uint8Array.from([]).toHex == "function" && typeof Uint8Array.fromHex == "function", pu = /* @__PURE__ */ Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function Zs(e) {
  if (ar(e), hu)
    return e.toHex();
  let t = "";
  for (let n = 0; n < e.length; n++)
    t += pu[e[n]];
  return t;
}
function Or(e) {
  if (typeof e != "string")
    throw new TypeError("string expected");
  return new Uint8Array(new TextEncoder().encode(e));
}
function mu(e, t, n = "opts") {
  return Qs(e, "defaults"), t !== void 0 && Qs(t, n), Object.assign(e, t);
}
function gu(e, t = {}) {
  if (typeof e != "function")
    throw new TypeError('"hashCons" expected function, got type=' + typeof e);
  t = mu({}, t, "info");
  const n = (o, s) => e(s).update(o).digest(), r = e(void 0);
  return n.outputLen = r.outputLen, n.blockLen = r.blockLen, n.canXOF = r.canXOF, n.create = (o) => e(o), Object.assign(n, t), Object.freeze(n);
}
const yu = (e) => ({
  // Current NIST hashAlgs suffixes used here fit in one DER subidentifier octet.
  // Larger suffix values would need base-128 OID encoding and a different length byte.
  oid: Uint8Array.from([6, 9, 96, 134, 72, 1, 101, 3, 4, 2, e])
});
class ei {
  constructor(t, n) {
    N(this, "oHash");
    N(this, "iHash");
    N(this, "blockLen");
    N(this, "outputLen");
    N(this, "canXOF", !1);
    N(this, "finished", !1);
    N(this, "destroyed", !1);
    if (fu(t), ar(n, void 0, "key"), this.iHash = t.create(), typeof this.iHash.update != "function")
      throw new Error("expected Hash instance");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const r = this.blockLen, o = new Uint8Array(r);
    o.set(n.length > r ? t.create().update(n).digest() : n);
    for (let s = 0; s < o.length; s++)
      o[s] ^= 54;
    this.iHash.update(o), this.oHash = t.create();
    for (let s = 0; s < o.length; s++)
      o[s] ^= 106;
    this.oHash.update(o), Go(o);
  }
  update(t) {
    return tr(this), this.iHash.update(t), this;
  }
  digestInto(t) {
    tr(this), Ja(t, this), this.finished = !0;
    const n = t.subarray(0, this.outputLen);
    this.iHash.digestInto(n), this.oHash.update(n), this.oHash.digestInto(n), this.destroy();
  }
  digest() {
    const t = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(t), t;
  }
  _cloneInto(t) {
    t || (t = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: n, iHash: r, finished: o, destroyed: s, blockLen: i, outputLen: a, canXOF: c } = this;
    return t = t, t.finished = o, t.destroyed = s, t.blockLen = i, t.outputLen = a, t.canXOF = c, t.oHash = n._cloneInto(t.oHash), t.iHash = r._cloneInto(t.iHash), t;
  }
  clone() {
    return this._cloneInto();
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
}
const _u = /* @__PURE__ */ (() => {
  const e = ((t, n, r) => new ei(t, n).update(r).digest());
  return e.create = (t, n) => new ei(t, n), e;
})(), bu = (e) => e / 2 ** 32 | 0, Eu = (e) => e >>> 0;
function vu(e, t, n, r) {
  const o = bu(n), s = Eu(n);
  e.setUint32(t, r ? s : o, r), e.setUint32(t + 4, r ? o : s, r);
}
function wu(e, t, n) {
  return e & t ^ ~e & n;
}
function Ru(e, t, n) {
  return e & t ^ e & n ^ t & n;
}
class Su {
  constructor(t, n, r, o) {
    N(this, "blockLen");
    N(this, "outputLen");
    N(this, "canXOF", !1);
    N(this, "padOffset");
    N(this, "isLE");
    // For partial updates less than block size
    N(this, "buffer");
    N(this, "view");
    N(this, "finished", !1);
    N(this, "length", 0);
    N(this, "pos", 0);
    N(this, "destroyed", !1);
    this.blockLen = t, this.outputLen = n, this.padOffset = r, this.isLE = o, this.buffer = new Uint8Array(t), this.view = Cr(this.buffer);
  }
  update(t) {
    tr(this), ar(t);
    const { view: n, buffer: r, blockLen: o } = this, s = t.length;
    let i = !1;
    for (let a = 0; a < s; ) {
      const c = Math.min(o - this.pos, s - a);
      if (c === o) {
        const l = Cr(t);
        for (; o <= s - a; a += o)
          this.process(l, a);
        i = !0;
        continue;
      }
      r.set(a === 0 && c === s ? t : t.subarray(a, a + c), this.pos), this.pos += c, a += c, this.pos === o && (this.process(n, 0), this.pos = 0, i = !0);
    }
    return this.length += t.length, i && this.roundClean(), this;
  }
  digestInto(t) {
    tr(this), Ja(t, this), this.finished = !0;
    const { buffer: n, view: r, blockLen: o, isLE: s } = this;
    let { pos: i } = this;
    n[i++] = 128, n.fill(0, i), this.padOffset > o - i && (this.process(r, 0), n.fill(0)), vu(r, o - 8, this.length * 8, s), this.process(r, 0), this.roundClean();
    const a = t === n ? r : Cr(t), c = this.outputLen, l = c / 4, u = this.get();
    if (c % 4 || l > u.length)
      throw new Error("invalid outputLen");
    for (let d = 0; d < l; d++)
      a.setUint32(4 * d, u[d], s);
  }
  digest() {
    const { buffer: t, outputLen: n } = this;
    this.digestInto(t);
    const r = t.slice(0, n);
    return this.destroy(), r;
  }
  _cloneIntoMeta(t) {
    const { buffer: n, length: r, finished: o, destroyed: s, pos: i } = this;
    return t.destroyed = s, t.finished = o, t.length = r, t.pos = i, i && t.buffer.set(n), t;
  }
  clone() {
    return this._cloneInto();
  }
}
const Tu = /* @__PURE__ */ Uint32Array.from([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), Au = /* @__PURE__ */ Uint32Array.from([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), Ye = /* @__PURE__ */ new Uint32Array(64);
class Cu extends Su {
  constructor(n, r) {
    super(64, n, 8, !1);
    // We cannot use array here since array allows indexing by variable
    // which means optimizer/compiler cannot use registers.
    // Numeric initializers matter: starting the fields as `undefined` changes
    // V8's field representation and makes sha256 3x slower (measured).
    N(this, "A", 0);
    N(this, "B", 0);
    N(this, "C", 0);
    N(this, "D", 0);
    N(this, "E", 0);
    N(this, "F", 0);
    N(this, "G", 0);
    N(this, "H", 0);
    this.A = r[0] | 0, this.B = r[1] | 0, this.C = r[2] | 0, this.D = r[3] | 0, this.E = r[4] | 0, this.F = r[5] | 0, this.G = r[6] | 0, this.H = r[7] | 0;
  }
  get() {
    const { A: n, B: r, C: o, D: s, E: i, F: a, G: c, H: l } = this;
    return [n, r, o, s, i, a, c, l];
  }
  // prettier-ignore
  set(n, r, o, s, i, a, c, l) {
    this.A = n | 0, this.B = r | 0, this.C = o | 0, this.D = s | 0, this.E = i | 0, this.F = a | 0, this.G = c | 0, this.H = l | 0;
  }
  _cloneInto(n) {
    return (n || (n = new this.constructor())).set(...this.get()), this._cloneIntoMeta(n);
  }
  process(n, r) {
    for (let f = 0; f < 16; f++, r += 4)
      Ye[f] = n.getUint32(r, !1);
    for (let f = 16; f < 64; f++) {
      const p = Ye[f - 15], m = Ye[f - 2], R = Ue(p, 7) ^ Ue(p, 18) ^ p >>> 3, b = Ue(m, 17) ^ Ue(m, 19) ^ m >>> 10;
      Ye[f] = b + Ye[f - 7] + R + Ye[f - 16] | 0;
    }
    let { A: o, B: s, C: i, D: a, E: c, F: l, G: u, H: d } = this;
    for (let f = 0; f < 64; f++) {
      const p = Ue(c, 6) ^ Ue(c, 11) ^ Ue(c, 25), m = d + p + wu(c, l, u) + Au[f] + Ye[f] | 0, b = (Ue(o, 2) ^ Ue(o, 13) ^ Ue(o, 22)) + Ru(o, s, i) | 0;
      d = u, u = l, l = c, c = a + m | 0, a = i, i = s, s = o, o = m + b | 0;
    }
    o = o + this.A | 0, s = s + this.B | 0, i = i + this.C | 0, a = a + this.D | 0, c = c + this.E | 0, l = l + this.F | 0, u = u + this.G | 0, d = d + this.H | 0, this.set(o, s, i, a, c, l, u, d);
  }
  roundClean() {
    Go(Ye);
  }
  destroy() {
    this.destroyed = !0, this.set(0, 0, 0, 0, 0, 0, 0, 0), Go(this.buffer);
  }
}
class Ou extends Cu {
  constructor() {
    super(32, Tu);
  }
}
const ti = /* @__PURE__ */ gu(
  () => new Ou(),
  /* @__PURE__ */ yu(1)
), rn = {
  /**
   * Computes the SHA-256 hex digest of the given input.
   * @param input - The string or raw bytes to hash.
   * @returns The lowercase hex SHA-256 digest.
   */
  hash(e) {
    return Zs(ti(typeof e == "string" ? Or(e) : e));
  },
  /**
   * Computes the HMAC-SHA256 hex digest of the given message.
   * @param secret - The secret key; a string is read as UTF-8.
   * @param message - The message to sign.
   * @returns The lowercase hex HMAC-SHA256 digest.
   */
  hmac(e, t) {
    return Zs(rn.hmacBytes(e, t));
  },
  /**
   * Computes the HMAC-SHA256 of the given message as raw bytes. Needed by key-derivation chains that feed
   * one HMAC's raw output in as the next one's key — notably AWS SigV4, where re-hexing each intermediate
   * would produce a different (wrong) signing key.
   * @param secret - The secret key; a string is read as UTF-8.
   * @param message - The message to sign.
   * @returns The 32-byte HMAC-SHA256 digest.
   */
  hmacBytes(e, t) {
    return _u(ti, typeof e == "string" ? Or(e) : e, Or(t));
  }
}, rt = {
  /**
   * Calculates the content length of the given body.
   * Uses TextEncoder for browsers and Buffer.byteLength for Node.js.
   * @param body - The body whose content length is to be calculated.
   */
  getContentLength(e) {
    if (e == null || typeof e == "function") return 0;
    const t = JSON.stringify(e);
    if (typeof TextEncoder < "u") return new TextEncoder().encode(t).length;
    if (typeof Buffer < "u") return Buffer.byteLength(t, "utf8");
    let n = 0;
    for (let r = 0; r < t.length; r++) {
      const o = t.charCodeAt(r);
      if (o < 128) n += 1;
      else if (o < 2048) n += 2;
      else if (o < 55296 || o >= 57344) n += 3;
      else {
        if (r + 1 < t.length) {
          const s = t.charCodeAt(r + 1);
          if (s >= 56320 && s < 57344) {
            r++, n += 4;
            continue;
          }
        }
        n += 3;
      }
    }
    return n;
  },
  /**
   * Gets the current time in epoch milliseconds.
   */
  getCurrentTimeInEpoch() {
    return Date.now();
  },
  /**
   * Gets the time elapsed in milliseconds since the given epoch time.
   * @param epoch - The epoch time in milliseconds.
   */
  getTimeElapsedInMillis(e) {
    return Date.now() - e;
  },
  /**
   * Standardizes the HTTP method by trimming whitespace and converting to lowercase.
   * @param method - HTTP method (GET, POST, etc.)
   */
  standardizeMethod(e) {
    return e.trim().toLowerCase();
  },
  /**
   * Standardizes the query parameters by sorting keys, trimming whitespace, and converting to lowercase.
   * @param queryParams - The query parameters to be standardized.
   */
  standardizeQueryParams(e) {
    const t = (n) => {
      const r = Object.keys(n).sort(), o = {};
      for (const s of r) {
        const i = n[s], a = s.trim().toLowerCase();
        typeof i == "object" && i !== null && !Array.isArray(i) ? o[a] = t(i) : o[a] = (i ?? "").toString().trim().toLowerCase();
      }
      return o;
    };
    return JSON.stringify(t(e));
  },
  /**
   * Standardizes the request data for HMAC computation.
   * @param param0 - Request data object
   * @param param0.contentLength - Content length of the request body
   * @param param0.method - HTTP method (GET, POST, etc.)
   * @param param0.queryParams - Query parameters (optional)
   * @param param0.url - Request URL (optional)
   * @param timestamp - Timestamp in milliseconds
   */
  standardizeRequest({
    contentLength: e,
    method: t,
    queryParams: n,
    url: r
  }, o) {
    let s = rt.standardizeMethod(t);
    r && (s += " " + rt.standardizeUrl(r)), s += " " + e;
    const i = n ? Object.fromEntries(Object.entries(n).filter(([, a]) => a != null)) : void 0;
    return i && Object.keys(i).length > 0 && (s += " " + rt.standardizeQueryParams(i)), s.trim() + " " + o;
  },
  /**
   * Standardizes the URL by trimming whitespace, converting to lowercase, removing extra slashes, and ensuring it starts with a single slash.
   * @param url - The URL to be standardized.
   */
  standardizeUrl(e) {
    let t;
    try {
      t = new URL(e).pathname;
    } catch {
      t = e;
    }
    return t = t.trim().toLowerCase().replace(/\s+/g, "").replace(/^\/+|\/+$/g, "").replace(/\/+/g, "/"), t === "" ? "/" : "/" + t;
  }
}, ku = 15e3, Pu = "HMAC content length mismatch.", xu = "HMAC request timestamp is outside the allowed time delta.", Iu = "HMAC signature mismatch.", Nu = {
  /**
   * Computes the hash signature for the given request data.
   * For timestampOffset - Positive value: Server time is ahead of client time. Negative value: Client time is ahead of server time.
   * @param secret - The secret key used to compute the hash.
   * @param requestData - The request data to be used to compute the hash.
   * @param timestampOffset - Optional offset in milliseconds to adjust for clock skew between client and server.
   */
  compute: (e, t, n) => {
    const r = Date.now() + (n || 0), o = rt.getContentLength(t.body), s = rt.standardizeRequest({
      ...t,
      contentLength: o
    }, r), i = rn.hmac(e, s);
    return {
      contentLength: o,
      hash: i,
      timestamp: r
    };
  },
  /**
   * Deterministically derives an opaque 32-char runtime token from a human-readable, non-secret label.
   * Used at CDK synth time to turn the friendly `hmacToken` config label (eg: `hmac-authservicestaff-prod-x7k2m9`)
   * into the actual `BF_HMAC_SECRET` value handed to browsers via `GET /v1/hmac`. The HMAC token is not a real
   * secret — it is a public spam / rate-limiting deterrent — so this derivation only needs to be stable and opaque.
   * Uses only browser-safe `@blufin/security` primitives (no Node `crypto`): sha256 → Base64 → strip non-alphanumerics → slice(32).
   * IMPORTANT: This algorithm is FROZEN after the first deploy. Changing it re-derives every token and invalidates
   * every cached client token (they 401 once, clear localStorage, and refetch) — acceptable for a one-time cutover, not as churn.
   * @param label - The public, non-secret config label to derive from.
   * @returns A deterministic 32-char mixed-case alphanumeric token.
   */
  deriveToken: (e) => tn.encode(rn.hash(e)).replace(/[^a-zA-Z0-9]/g, "").slice(0, 32),
  /**
   * Verifies the hash signature for the given request data.
   * @param secret - The secret key used to compute the hash.
   * @param requestData - The request data to be used to compute the hash.
   * @param timestamp - The timestamp when the hash was computed on the client-side.
   * @param expectedHash - The expected hash signature.
   */
  verify: (e, t, n, r) => {
    const o = rt.getTimeElapsedInMillis(n);
    if (Math.abs(o) > ku) throw new Error(xu);
    if (rt.getContentLength(t.body) !== t.contentLength) throw new Error(Pu);
    const i = rt.standardizeRequest(t, n), a = rn.hmac(e, i);
    if (!Mu(a, r)) throw new Error(Iu);
  }
}, Mu = (e, t) => {
  if (e.length !== t.length) return !1;
  let n = 0;
  for (let r = 0; r < e.length; r++)
    n |= e.charCodeAt(r) ^ t.charCodeAt(r);
  return n === 0;
};
var fs = /* @__PURE__ */ ((e) => (e.APP_ELECTRON_BUNDLED = "app-electron-bundled", e.APP_ELECTRON_WEB = "app-electron-web", e.APP_REACT = "app-react", e.MODULE_BROWSER = "module-browser", e.MODULE_NODE = "module-node", e.MODULE_NODE_BIN = "module-node-bin", e.MODULE_UI = "module-ui", e.PLUGIN = "plugin", e.SDK_DYNAMODB = "sdk-dynamodb", e.SDK_IOT_CLIENT = "sdk-iot-client", e.SDK_IOT_SERVER = "sdk-iot-server", e.SDK_MYSQL = "sdk-mysql", e.SDK_POSTGRES = "sdk-postgres", e.SDK_SERVICE = "sdk-service", e.SERVICE = "service", e.SITE_NEXTJS = "site-nextjs", e))(fs || {}), nn = /* @__PURE__ */ ((e) => (e.ELECTRON = "ELECTRON", e.FILE_REGISTRY = "FILE_REGISTRY", e.SPA = "SPA", e.STATIC_SITE = "STATIC_SITE", e.STORYBOOK = "STORYBOOK", e))(nn || {});
const Qa = "0.0.0-dev", Za = ["localhost", "dev", "stg", "prod"];
nn.ELECTRON, nn.SPA, nn.STATIC_SITE, nn.STORYBOOK;
const {
  APP_REACT: my,
  APP_ELECTRON_BUNDLED: gy,
  APP_ELECTRON_WEB: yy,
  MODULE_NODE: _y,
  MODULE_NODE_BIN: by,
  MODULE_BROWSER: Ey,
  MODULE_UI: vy,
  SITE_NEXTJS: wy,
  SDK_DYNAMODB: Ry,
  SDK_IOT_CLIENT: Sy,
  SDK_IOT_SERVER: Ty,
  SDK_MYSQL: Ay,
  SDK_POSTGRES: Cy,
  SDK_SERVICE: Oy,
  SERVICE: ky
} = fs;
Object.values(fs);
var ot = /* @__PURE__ */ ((e) => (e.COGNITO = "COGNITO", e.HMAC = "HMAC", e.NONE = "NONE", e))(ot || {});
const Du = "hmac", ju = "V1", Lu = "client-config", Hu = "V1";
var nr = /* @__PURE__ */ ((e) => (e.COMPILED = "compiled", e.HMR = "hmr", e))(nr || {});
const kr = "Content-Type", Uu = "Content-Length", qu = "X-Hmac-Signature", Fu = "X-Hmac-Timestamp", dt = "X-Request-Meta", Pr = "application/json", Xo = 15e3;
var et = /* @__PURE__ */ ((e) => (e.DELETE = "DELETE", e.GET = "GET", e.PATCH = "PATCH", e.POST = "POST", e.PUT = "PUT", e))(et || {});
const Bu = [408, 429, 500, 502, 503, 504], $u = {
  /**
   * Unwraps the inner `data` payload from a service success envelope (`{ data, responseType, statusCode }`).
   * The service serializes every response as this envelope, so consumers reading a raw `fetch`/SDK return
   * must strip the wrapper to reach the bare payload — returning the envelope nests the value one level too
   * deep. Centralizes the hand-rolled `.data` access that previously recurred across call sites.
   * @param response - The success envelope to unwrap.
   * @returns The inner `data` payload.
   */
  unwrap: (e) => e.data
};
class on {
  constructor(t) {
    N(this, "promise");
    this.promise = t;
  }
  /**
   * Typed then method that preserves error types.
   * @param onfulfilled - Success callback.
   * @param onrejected - Error callback.
   */
  then(t, n) {
    const r = this.promise.then(t, n);
    return new on(r);
  }
  /**
   * Typed catch method that preserves error types.
   * @param onrejected - Error callback.
   */
  catch(t) {
    const n = this.promise.catch(t);
    return new on(n);
  }
  /**
   * Typed finally method.
   * @param onFinally - Finally callback.
   */
  finally(t) {
    const n = this.promise.finally(t ?? void 0);
    return new on(n);
  }
  /** Make it compatible with native Promise. */
  get [Symbol.toStringTag]() {
    return "TypedPromise";
  }
}
const fe = (e) => new on(new Promise(e)), Vo = {
  /**
   * Parse request metadata information from request headers (client to server).
   * @param headers - The request headers.
   */
  decodeRequest: (e) => {
    const t = (e || {})[dt] || (e || {})[dt.toLowerCase()];
    if (t)
      try {
        const n = tn.decode(t);
        return JSON.parse(n);
      } catch (n) {
        throw new Error(`Failed to parse request meta header: ${n instanceof Error ? n.message : String(n)}`);
      }
  },
  /**
   * Parse response metadata information from response headers (server to client).
   * @param headers - The response headers.
   */
  decodeResponse: (e) => {
    const t = (e || {})[dt] || (e || {})[dt.toLowerCase()];
    if (t)
      try {
        const n = tn.decode(t);
        return JSON.parse(n);
      } catch (n) {
        throw new Error(`Failed to parse response meta header: ${n instanceof Error ? n.message : String(n)}`);
      }
  },
  /**
   * Encode request metadata sent from client to server, via HTTP header.
   * @param meta - The data to encode and send.
   */
  encodeRequest(e) {
    const t = JSON.stringify(e);
    return tn.encode(t);
  },
  /**
   * Encode response metadata sent from server to client via HTTP header.
   * @param meta - The response metadata to encode and send.
   */
  encodeResponse(e) {
    const t = JSON.stringify(e);
    return tn.encode(t);
  }
};
class Wu {
  constructor() {
    N(this, "requestIsEncrypted");
    N(this, "encryptResponse");
  }
  /** Set if the payload sent to the server is encrypted. */
  markPayloadEncrypted() {
    this.requestIsEncrypted = !0;
  }
  /** Set to true if the client wants the response payload to be encrypted. */
  requestEncryptedResponse() {
    this.encryptResponse = !0;
  }
  /** Serialize to a plain object for JSON encoding. */
  toJSON() {
    const t = {};
    return this.requestIsEncrypted && (t.isEncrypted = !0), this.encryptResponse && (t.encryptResponse = !0), t;
  }
}
const zu = () => {
  if (typeof globalThis > "u") return !1;
  const t = globalThis.window?.location?.hostname;
  return t === "localhost" || t === "127.0.0.1";
}, De = class De {
  constructor() {
    N(this, "config", null);
  }
  /**
   * Unregister the telemetry agent when its React host tears down (eg: the authenticated tree
   * unmounting on logout). Guarded: only clears when `agent` is the currently-registered
   * reference, so a newer agent already registered by a subsequent mount is never clobbered by a
   * late cleanup — a no-op otherwise. This is what lets a re-login register a fresh agent instead
   * of tripping the "already registered" guard in `setAgent`.
   * @param agent - The telemetry agent being torn down.
   */
  static clearAgent(t) {
    De._registeredAgent === t && (De._registeredAgent = null);
  }
  /** Returns the currently registered telemetry agent, or `null` if none. */
  static getAgent() {
    return De._registeredAgent;
  }
  /**
   * Register the singleton telemetry agent at app boot.
   * - Same-reference calls are no-ops (idempotent).
   * - Different-reference calls throw, EXCEPT on localhost (where Vite HMR may rebuild the agent).
   * @param agent - The telemetry agent.
   */
  static setAgent(t) {
    if (De._registeredAgent !== t) {
      if (De._registeredAgent !== null) {
        if (zu()) {
          De._registeredAgent = t;
          return;
        }
        throw new Error("TelemetryAgent is already registered. Replacing the agent is only permitted on localhost (for Vite HMR).");
      }
      De._registeredAgent = t;
    }
  }
  /** Test-only: clear the registered agent. Production code must never call this. */
  static _resetAgentForTests() {
    De._registeredAgent = null;
  }
  /**
   * Initialize the logger context with the provided configuration.
   * @param config - The logger context configuration.
   */
  init(t) {
    this.config || (this.config = t);
  }
  /**
   * Retrieves the logger context configuration.
   */
  getConfig() {
    return this.config;
  }
};
/**
 * Module-level singleton agent registry used by `LoggerType.APP` flush delegation.
 * The agent is registered via `LoggerContext.setAgent(...)` when its React host mounts and
 * unregistered via `LoggerContext.clearAgent(...)` when that host tears down (eg: the app
 * unmounting its authenticated tree on logout), so a subsequent mount can register a fresh
 * agent. Tests use `LoggerContext._resetAgentForTests()` between cases.
 */
N(De, "_registeredAgent", null);
let it = De;
var Ne = /* @__PURE__ */ ((e) => (e.DEBUG = "DEBUG", e.ERROR = "ERROR", e.INFO = "INFO", e.WARN = "WARN", e))(Ne || {}), Le = /* @__PURE__ */ ((e) => (e.COUNTER = "counter", e.GAUGE = "gauge", e.HISTOGRAM = "histogram", e))(Le || {});
const Gu = [408, 429, 500, 502, 503, 504], ec = (e) => e === null ? !0 : Gu.includes(e), Xu = 6e4, xr = /* @__PURE__ */ new Map(), tc = {
  /**
   * Emit a `console.warn` for a given key, suppressing repeats within `intervalMs`.
   * @param key - Stable identifier per warning site; rate-limit state is tracked per key.
   * @param message - The message to log via `console.warn`.
   * @param intervalMs - Minimum interval between emissions for the same key (default 60s).
   */
  warn(e, t, n = Xu) {
    const r = Date.now(), o = xr.get(e) ?? -1 / 0;
    r - o >= n && (xr.set(e, r), console.warn(t));
  },
  /** Test-only: reset all rate-limit state. Production code must never call this. */
  _resetForTests() {
    xr.clear();
  }
};
class sn extends Error {
  /**
   * @param message - Human-readable failure description.
   * @param options - Error metadata.
   * @param options.retryable - Whether the agent should retry this batch.
   * @param options.statusCode - The HTTP status code, when a response was received.
   */
  constructor(n, r) {
    super(n);
    N(this, "retryable");
    N(this, "statusCode");
    this.name = "TelemetryTransportError", this.retryable = r.retryable, this.statusCode = r.statusCode;
  }
}
const ni = 1e3, ri = 5e3, Vu = 50, Ku = 1e3, zt = 32 * 1024, Yu = 1024 * 1024, oi = [1e3, 2e3, 4e3, 8e3, 16e3, 3e4], si = 300 * 1e3;
class Ju {
  /**
   * @param options - Construction options.
   * @param options.clock - Injected clock for `now()` and `sleep(ms)`; production = `Date.now` + `setTimeout`.
   * @param options.context - Initial context attached to every emitted batch.
   * @param options.flushIntervalMs - When > 0, also drain the queue on this cadence (ms). Defaults to 0 (disabled).
   * @param options.rateLimitedLogger - Optional override for the rate-limited warn helper.
   * @param options.registry - The typed metric registry for compile-time name/label checks.
   * @param options.transport - Concrete transport (web HTTP, Electron IPC, Node-fetch, etc.).
   */
  constructor(t) {
    N(this, "_clock");
    N(this, "_context");
    N(this, "_errorFlushScheduled", !1);
    N(this, "_flushInFlight", null);
    N(this, "_flushIntervalMs");
    N(this, "_periodicFlushActive", !1);
    N(this, "_logQueue", []);
    N(this, "_metricQueue", []);
    N(this, "_metrics", {
      dropped_event_count: 0,
      dropped_oversized_batch_count: 0,
      dropped_oversized_event_count: 0,
      in_flight_request_count: 0,
      last_flush_at_ms: 0,
      queue_high_water_mark: 0
    });
    N(this, "_rateLimitedLogger");
    N(this, "_registry");
    N(this, "_softCapWarned", !1);
    N(this, "_transport");
    this._clock = t.clock, this._context = {
      ...t.context
    }, this._flushIntervalMs = t.flushIntervalMs ?? 0, this._rateLimitedLogger = t.rateLimitedLogger ?? tc, this._registry = t.registry, this._transport = t.transport, this._flushIntervalMs > 0 && this._startPeriodicFlush();
  }
  /**
   * Record a counter metric.
   * @param name - Metric name (must be a COUNTER entry in the registry).
   * @param value - The amount to add.
   * @param labels - Label keys must match `registry[name].labelKeys`.
   */
  counter(t, n, r) {
    this._recordMetric(t, Le.COUNTER, n, r);
  }
  /**
   * Stop the periodic flush loop (if running). Idempotent and non-blocking — it does NOT drain the
   * queue; callers that need a final send should `await flush()` separately (eg: on app teardown).
   */
  dispose() {
    this._periodicFlushActive = !1;
  }
  /** Drain the in-memory queues to the transport. Coalesces concurrent callers. */
  async flush() {
    if (!(this._flushInFlight && (await this._flushInFlight, this._logQueue.length === 0 && this._metricQueue.length === 0))) {
      this._flushInFlight = this._flushNow();
      try {
        await this._flushInFlight;
      } finally {
        this._flushInFlight = null;
      }
    }
  }
  /**
   * Record a gauge metric.
   * @param name - Metric name (must be a GAUGE entry in the registry).
   * @param value - The current value.
   * @param labels - Label keys must match `registry[name].labelKeys`.
   */
  gauge(t, n, r) {
    this._recordMetric(t, Le.GAUGE, n, r);
  }
  /** Returns a snapshot of internal counters and water-marks for operator inspection. */
  getMetrics() {
    return {
      ...this._metrics
    };
  }
  /**
   * Record a histogram observation.
   * @param name - Metric name (must be a HISTOGRAM entry in the registry).
   * @param value - The observed value.
   * @param labels - Label keys must match `registry[name].labelKeys`.
   */
  histogram(t, n, r) {
    this._recordMetric(t, Le.HISTOGRAM, n, r);
  }
  /**
   * Enqueue a log event. DEBUG events are silently dropped without enqueueing. When a machine-readable
   * `event` key is present, it must be registered in `registry.events` — an unregistered event is
   * warn-and-dropped (mirroring the unknown-metric gate), never emitted.
   * @param event - The log event; the agent stamps `ts`.
   */
  log(t) {
    if (t.level === Ne.DEBUG) return;
    if (t.event !== void 0 && !this._registry.events[t.event]) {
      this._rateLimitedLogger.warn("telemetry-agent:unknown-event", `[TelemetryAgent] Unknown event "${t.event}"; dropping.`), this._metrics.dropped_event_count += 1;
      return;
    }
    const n = {
      ...t,
      ts: this._clock.now()
    };
    this._enqueueLog(n) && (t.level === Ne.ERROR && this._scheduleErrorFlush(), this._maybeFlushBySize());
  }
  /**
   * Merge new fields into the agent context. On identity change (userId or sessionId),
   * any pending events are flushed under the OUTGOING identity before the new fields apply.
   * @param partial - Fields to merge into the context.
   */
  async setContext(t) {
    (t.userId !== void 0 && t.userId !== this._context.userId || t.sessionId !== void 0 && t.sessionId !== this._context.sessionId) && (this._logQueue.length > 0 || this._metricQueue.length > 0) && await this.flush(), this._context = {
      ...this._context,
      ...t
    };
  }
  /** Test/integration hook: signal that the network came back online. */
  triggerOnlineFlush() {
    this.flush();
  }
  /** Test/integration hook: signal page is unloading; consumers wire to `pagehide`/`before-quit`. */
  triggerLifecycleFlush() {
    this.flush();
  }
  /**
   * Enqueue a stamped log event after enforcing per-event size limits.
   * @param event - The stamped log event.
   */
  _enqueueLog(t) {
    const n = this._eventSize(t);
    return n > zt ? (this._metrics.dropped_oversized_event_count += 1, this._metrics.dropped_event_count += 1, this._rateLimitedLogger.warn("telemetry-agent:oversized-event", `[TelemetryAgent] Dropped oversized log event (${n} bytes > ${zt}).`), !1) : (this._logQueue.push(t), this._updateWaterMark(), this._enforceQueueCaps(), !0);
  }
  /**
   * Enqueue a stamped metric event after enforcing per-event size limits.
   * @param event - The stamped metric event.
   */
  _enqueueMetric(t) {
    const n = this._eventSize(t);
    return n > zt ? (this._metrics.dropped_oversized_event_count += 1, this._metrics.dropped_event_count += 1, this._rateLimitedLogger.warn("telemetry-agent:oversized-event", `[TelemetryAgent] Dropped oversized metric event (${n} bytes > ${zt}).`), !1) : (this._metricQueue.push(t), this._updateWaterMark(), this._enforceQueueCaps(), !0);
  }
  _enforceQueueCaps() {
    const t = this._logQueue.length + this._metricQueue.length;
    if (t > ri) {
      const n = t - ri;
      for (let r = 0; r < n; r += 1)
        this._logQueue.length > 0 ? this._logQueue.shift() : this._metricQueue.length > 0 && this._metricQueue.shift(), this._metrics.dropped_event_count += 1;
    } else t >= ni && !this._softCapWarned && (this._softCapWarned = !0, this._rateLimitedLogger.warn("telemetry-agent:soft-cap", `[TelemetryAgent] Queue soft cap reached (${t} >= ${ni}).`));
  }
  /**
   * Approximate per-event size in bytes (JSON length).
   * @param event - The event to measure.
   */
  _eventSize(t) {
    try {
      return JSON.stringify(t).length;
    } catch {
      return this._rateLimitedLogger.warn("telemetry-agent:stringify-error", "[TelemetryAgent] Failed to serialize event for size check; treating as oversized."), zt + 1;
    }
  }
  /**
   * Send a batch, halving and retrying if it exceeds the per-batch byte cap.
   * @param endpoint - Wire endpoint discriminator.
   * @param events - The batch payload.
   */
  async _flushBatch(t, n) {
    if (n.length === 0) return;
    const r = {
      ...this._context
    };
    let o;
    try {
      o = JSON.stringify({
        context: r,
        events: n
      }).length;
    } catch {
      this._rateLimitedLogger.warn("telemetry-agent:stringify-error", `[TelemetryAgent] Failed to serialize batch on ${t}; dropping ${n.length} events.`), this._metrics.dropped_event_count += n.length;
      return;
    }
    if (o > Yu) {
      if (n.length === 1) {
        this._metrics.dropped_oversized_batch_count += 1, this._metrics.dropped_event_count += 1, this._rateLimitedLogger.warn("telemetry-agent:oversized-batch", `[TelemetryAgent] Dropped oversized singleton batch on ${t} (${o} bytes).`);
        return;
      }
      const s = Math.ceil(n.length / 2);
      await this._flushBatch(t, n.slice(0, s)), await this._flushBatch(t, n.slice(s));
      return;
    }
    await this._sendWithRetry(t, n, r);
  }
  async _flushNow() {
    const t = this._logQueue.splice(0, this._logQueue.length), n = this._metricQueue.splice(0, this._metricQueue.length);
    this._softCapWarned = !1;
    try {
      t.length > 0 && await this._flushBatch("/v1/logs", t), n.length > 0 && await this._flushBatch("/v1/metrics", n);
    } finally {
      this._metrics.last_flush_at_ms = this._clock.now();
    }
  }
  _maybeFlushBySize() {
    this._logQueue.length + this._metricQueue.length >= Vu && this.flush();
  }
  /**
   * Timer-driven flush loop: sleeps `_flushIntervalMs`, then flushes when the queue is non-empty.
   * Guarantees a low-traffic session (fewer than `FLUSH_SIZE_TRIGGER` events, no ERROR log, no quit)
   * still ships its telemetry. Started from the constructor when `_flushIntervalMs > 0`; stopped by `dispose()`.
   */
  async _periodicFlushLoop() {
    for (; this._periodicFlushActive; ) {
      if (await this._clock.sleep(this._flushIntervalMs), !this._periodicFlushActive) return;
      if (this._logQueue.length + this._metricQueue.length !== 0)
        try {
          await this.flush();
        } catch {
        }
    }
  }
  /**
   * Internal recorder used by `counter`/`gauge`/`histogram` after type narrowing.
   * @param name - Metric name (must exist in the registry).
   * @param type - Metric type discriminator.
   * @param value - The metric value.
   * @param labels - Optional labels.
   */
  _recordMetric(t, n, r, o) {
    if (!this._registry.metrics[t]) {
      this._rateLimitedLogger.warn("telemetry-agent:unknown-metric", `[TelemetryAgent] Unknown metric "${t}"; dropping.`), this._metrics.dropped_event_count += 1;
      return;
    }
    const i = {
      name: t,
      ts: this._clock.now(),
      type: n,
      value: r,
      ...o ? {
        labels: o
      } : {}
    };
    this._enqueueMetric(i) && this._maybeFlushBySize();
  }
  _scheduleErrorFlush() {
    this._errorFlushScheduled || (this._errorFlushScheduled = !0, this._clock.sleep(Ku).then(() => {
      this._errorFlushScheduled = !1, this.flush();
    }));
  }
  /**
   * Issue the transport call with exponential-backoff retry (1,2,4,8,16,30s capped at 5min total).
   * Drops the batch and increments `dropped_event_count` when the retry budget is exhausted.
   * @param endpoint - Wire endpoint discriminator.
   * @param events - The batch payload.
   * @param context - The agent context snapshot to send alongside.
   */
  async _sendWithRetry(t, n, r) {
    this._metrics.in_flight_request_count += 1;
    const o = this._clock.now();
    let s = 0, i = null;
    try {
      for (; ; )
        try {
          t === "/v1/logs" ? await this._transport.send("/v1/logs", {
            context: r,
            events: n
          }) : await this._transport.send("/v1/metrics", {
            context: r,
            events: n
          });
          return;
        } catch (a) {
          if (i = a, a instanceof sn && !a.retryable) {
            this._metrics.dropped_event_count += n.length, this._rateLimitedLogger.warn("telemetry-agent:non-retryable", `[TelemetryAgent] Dropping ${n.length} events on ${t}; non-retryable status ${a.statusCode}.`);
            return;
          }
          const c = this._clock.now() - o;
          if (c >= si) {
            this._metrics.dropped_event_count += n.length, this._rateLimitedLogger.warn("telemetry-agent:retry-exhausted", `[TelemetryAgent] Retry budget exhausted on ${t}; dropping ${n.length} events. Last error: ${String(i)}`);
            return;
          }
          const l = oi[Math.min(s, oi.length - 1)];
          s += 1;
          const u = si - c, d = Math.min(l, u);
          await this._clock.sleep(d);
        }
    } finally {
      this._metrics.in_flight_request_count -= 1;
    }
  }
  _startPeriodicFlush() {
    this._periodicFlushActive || (this._periodicFlushActive = !0, this._periodicFlushLoop());
  }
  _updateWaterMark() {
    const t = this._logQueue.length + this._metricQueue.length;
    t > this._metrics.queue_high_water_mark && (this._metrics.queue_high_water_mark = t);
  }
}
const Qu = {
  "/v1/logs": "/v1/beacon/logs",
  "/v1/metrics": "/v1/beacon/metrics"
};
class Zu {
  /**
   * @param options - Construction options.
   * @param options.baseUrl - Ingest origin (no trailing path); the beacon subpath is appended per endpoint.
   * @param options.fetchFn - Override for the `fetch(keepalive)` fallback (test-only / non-browser).
   * @param options.rateLimitedLogger - Override for the rate-limited warn helper.
   * @param options.sendBeacon - Override for `navigator.sendBeacon`; `null` forces the fetch fallback.
   */
  constructor(t) {
    N(this, "_baseUrl");
    N(this, "_fetchFn");
    N(this, "_rateLimitedLogger");
    N(this, "_sendBeacon");
    this._baseUrl = t.baseUrl.replace(/\/+$/, ""), this._fetchFn = t.fetchFn ?? (typeof globalThis.fetch == "function" ? globalThis.fetch.bind(globalThis) : void 0), this._rateLimitedLogger = t.rateLimitedLogger ?? tc, this._sendBeacon = t.sendBeacon !== void 0 ? t.sendBeacon : typeof navigator < "u" && typeof navigator.sendBeacon == "function" ? navigator.sendBeacon.bind(navigator) : null;
  }
  /**
   * Flush one batch to the beacon ingest pair. Tries `navigator.sendBeacon` first (survives `pagehide`),
   * falling back to `fetch(url, { keepalive: true })` when it is missing or refuses the payload.
   * @param endpoint - Wire discriminator (`/v1/logs` or `/v1/metrics`); routed to `/v1/beacon/*`.
   * @param body - The agent context + events payload.
   * @param body.context - The agent context snapshot sent alongside the batch.
   * @param body.events - The batch of log or metric events.
   */
  async send(t, n) {
    const r = `${this._baseUrl}${Qu[t]}`, o = JSON.stringify(n);
    this._trySendBeacon(r, o) || await this._fetchFallback(r, o);
  }
  /**
   * Fire the `fetch(keepalive)` fallback, throwing a classified `TelemetryTransportError` on failure.
   * @param url - The fully-qualified beacon URL.
   * @param payload - The serialized `{ context, events }` body.
   */
  async _fetchFallback(t, n) {
    if (!this._fetchFn)
      throw new sn("SiteBeaconTransport: no sendBeacon and no fetch available.", {
        retryable: !1
      });
    let r;
    try {
      const o = await this._fetchFn(t, {
        body: n,
        headers: {
          "Content-Type": "application/json"
        },
        keepalive: !0,
        method: "POST"
      });
      if (r = o.status, o.ok) return;
    } catch (o) {
      const s = o instanceof Error ? o.message : typeof o == "string" ? o : JSON.stringify(o);
      throw new sn(s, {
        retryable: !0
      });
    }
    throw new sn(`SiteBeaconTransport: beacon POST failed with status ${r}.`, {
      retryable: ec(r ?? null),
      statusCode: r
    });
  }
  /**
   * Attempt the `navigator.sendBeacon` path. Returns `false` (so the caller falls back to `fetch`)
   * when `sendBeacon` is absent, throws, or refuses the payload (browser queue full / oversized).
   * @param url - The fully-qualified beacon URL.
   * @param payload - The serialized `{ context, events }` body.
   */
  _trySendBeacon(t, n) {
    if (!this._sendBeacon) return !1;
    try {
      const r = new Blob([n], {
        type: "application/json"
      }), o = this._sendBeacon(t, r);
      return o || this._rateLimitedLogger.warn("site-beacon:queue-refused", "[SiteBeaconTransport] sendBeacon refused the payload; falling back to fetch(keepalive)."), o;
    } catch {
      return this._rateLimitedLogger.warn("site-beacon:send-threw", "[SiteBeaconTransport] sendBeacon threw; falling back to fetch(keepalive)."), !1;
    }
  }
}
const ii = "blufin.telemetry.sessionId";
class ed {
  /**
   * @param options - Construction options.
   * @param options.now - Monotonic-enough clock (ms); production = `Date.now`.
   * @param options.onSessionEnded - Called once on the first `pagehide` with the sealed payload.
   * @param options.sessionStorage - Per-tab store for the `sessionId`; production = `window.sessionStorage`.
   * @param options.visibilityDocument - Foreground/background source; production = `document`.
   * @param options.window - Terminal-flush source; production = `window`.
   */
  constructor(t) {
    N(this, "_accumulatedMs", 0);
    N(this, "_ended", !1);
    N(this, "_now");
    N(this, "_onSessionEnded");
    N(this, "_pagesViewed", 0);
    N(this, "_sessionId");
    /** `undefined` while backgrounded; the ms timestamp foreground time started while visible. */
    N(this, "_visibleSince");
    this._now = t.now, this._onSessionEnded = t.onSessionEnded, this._sessionId = this._resolveSessionId(t.sessionStorage), t.visibilityDocument.visibilityState === "visible" && (this._visibleSince = this._now()), t.visibilityDocument.addEventListener("visibilitychange", () => this._onVisibilityChange(t.visibilityDocument.visibilityState)), t.window.addEventListener("pagehide", () => this._onPageHide());
  }
  /** The per-tab anonymous session id (stable for the life of the tab). */
  getSessionId() {
    return this._sessionId;
  }
  /** Increment the `pages_viewed` counter — called by the provider on each App Router route change. */
  recordPageView() {
    this._pagesViewed += 1;
  }
  /** Seal foreground time up to `now`, folding any open visible window into the accumulator. */
  _accumulateVisible() {
    this._visibleSince !== void 0 && (this._accumulatedMs += this._now() - this._visibleSince, this._visibleSince = void 0);
  }
  _onPageHide() {
    this._ended || (this._ended = !0, this._accumulateVisible(), this._onSessionEnded({
      duration_seconds: Math.round(this._accumulatedMs / 1e3),
      pages_viewed: this._pagesViewed
    }));
  }
  /**
   * Fold foreground time on background transitions; reopen the visible window on foreground.
   * @param state - The current document visibility state.
   */
  _onVisibilityChange(t) {
    t === "visible" ? this._visibleSince === void 0 && (this._visibleSince = this._now()) : this._accumulateVisible();
  }
  /**
   * Read the existing per-tab `sessionId` or mint + persist a fresh `crypto.randomUUID()`.
   * @param sessionStorage - The per-tab store.
   */
  _resolveSessionId(t) {
    const n = t.getItem(ii);
    if (n) return n;
    const r = typeof globalThis.crypto?.randomUUID == "function" ? globalThis.crypto.randomUUID() : `${Math.random().toString(36).slice(2)}-${Date.now().toString(36)}`;
    return t.setItem(ii, r), r;
  }
}
const td = {
  metrics: {
    app_error_total: {
      type: Le.COUNTER,
      labelKeys: []
    },
    app_interaction_total: {
      type: Le.COUNTER,
      labelKeys: ["action"]
    },
    app_launch_total: {
      type: Le.COUNTER,
      labelKeys: []
    },
    app_page_view_total: {
      type: Le.COUNTER,
      labelKeys: ["page"]
    },
    app_session_start_total: {
      type: Le.COUNTER,
      labelKeys: []
    },
    /**
     * INFRASTRUCTURE metrics — unlike every other entry, these are not emitted by a client app. The
     * `tableSizePoller` Lambda (`@blufin/aws-cdk`, owned by the Grafana stacks) writes them as NDJSON
     * metric lines which `lambdaMimirPush` pushes to Mimir. `labelKeys: ['table']` is LOAD-BEARING:
     * `lambdaMimirPush.filterLabels` keeps only the labels listed here and drops every other one
     * SILENTLY, so removing it would collapse every table's series into one unlabelled line — a panel
     * that renders, and is wrong.
     */
    blufin_dynamodb_item_count: {
      type: Le.GAUGE,
      labelKeys: ["table"]
    },
    blufin_dynamodb_table_size_bytes: {
      type: Le.GAUGE,
      labelKeys: ["table"]
    }
  },
  events: {
    "app.error.thrown": {
      fields: ["message", "stack_hash", "page"]
    },
    /**
     * A data refresh that failed while its surface already had data on screen — a handled failure the user
     * saw as a toast, NOT an unhandled throw. Deliberately its own event rather than a second producer of
     * `app.error.thrown`/`app_error_total`, which would inflate the unhandled-error signal the dashboards
     * chart. `surface` is the app's own nav label for the failing view (eg: `Lambda Functions`).
     */
    "app.refresh.failed": {
      fields: ["message", "surface"]
    },
    "site.cta.clicked": {
      fields: ["action", "page"]
    },
    "site.session.ended": {
      fields: ["duration_seconds", "pages_viewed"]
    },
    "site.session.started": {
      fields: ["referrer_domain", "landing_page", "user_agent_class"]
    }
  }
}, nd = 16, rd = {
  /**
   * Report an unhandled React error exactly once, from either boundary mechanism: the console line a
   * developer reads, plus — when a telemetry agent is registered — the `app_error_total` counter and the
   * structured `app.error.thrown` event. This is a plain function rather than a hook because the class
   * `ErrorBoundaryAlpha.componentDidCatch` must call it, and React error boundaries must be classes.
   * The agent is resolved at call time via `LoggerContext.getAgent()`; no agent is a safe no-op.
   * @param options - What to report.
   * @param options.componentStack - React's component stack, when available. Console only.
   * @param options.error - The normalized error.
   * @param options.page - Current route path, when known.
   * @param options.raw - The raw pre-normalization value, when the caller had one. Console only.
   * @param options.source - Which boundary caught it.
   */
  report(e) {
    const {
      componentStack: t,
      error: n,
      page: r,
      raw: o,
      source: s
    } = e;
    try {
      const i = [];
      t !== void 0 && i.push({
        componentStack: t
      }), o !== void 0 && i.push({
        raw: o
      }), console.error(`[${s}] Unhandled error`, n, ...i);
      const a = it.getAgent();
      if (!a) return;
      const c = {
        stack_hash: od(n)
      };
      r !== void 0 && (c.page = r), a.counter("app_error_total", 1), a.log({
        data: c,
        event: "app.error.thrown",
        level: Ne.ERROR,
        message: n.message
      });
    } catch {
    }
  }
}, od = (e) => rn.hash(e.stack ?? e.message ?? "").slice(0, nd), sd = {
  /**
   * Reloads the current page. Wrapped on a stable, mockable object so the
   * fallback UI's reload button can be unit-tested in a jsdom environment that
   * marks `window.location` as non-configurable.
   */
  reloadPage() {
    window.location.reload();
  }
}, id = (e) => {
  const t = re.c(8), {
    error: n
  } = e;
  let r, o, s;
  t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ C.jsxs("svg", { className: lt.icon, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", children: [
    /* @__PURE__ */ C.jsx("circle", { cx: "12", cy: "12", r: "10" }),
    /* @__PURE__ */ C.jsx("line", { x1: "12", y1: "8", x2: "12", y2: "12" }),
    /* @__PURE__ */ C.jsx("line", { x1: "12", y1: "16", x2: "12.01", y2: "16" })
  ] }), o = /* @__PURE__ */ C.jsx("h1", { className: lt.title, children: "Something went wrong" }), s = /* @__PURE__ */ C.jsx("p", { className: lt.description, children: "The application encountered an unexpected error. Please reload the page to continue." }), t[0] = r, t[1] = o, t[2] = s) : (r = t[0], o = t[1], s = t[2]);
  let i;
  t[3] !== n ? (i = n && /* @__PURE__ */ C.jsxs("pre", { className: lt.errorDetails, children: [
    n.name,
    ": ",
    n.message
  ] }), t[3] = n, t[4] = i) : i = t[4];
  let a;
  t[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ C.jsx("button", { type: "button", className: lt.button, onClick: ad, children: "Reload page" }), t[5] = a) : a = t[5];
  let c;
  return t[6] !== i ? (c = /* @__PURE__ */ C.jsx("div", { className: lt.overlay, role: "alert", "aria-live": "assertive", children: /* @__PURE__ */ C.jsxs("div", { className: lt.card, children: [
    r,
    o,
    s,
    i,
    a
  ] }) }), t[6] = i, t[7] = c) : c = t[7], c;
};
class nc extends ce.Component {
  /**
   * Initialize the boundary in the non-error state.
   * @param props - Component props.
   */
  constructor(t) {
    super(t), this.state = {
      error: null,
      hasError: !1
    };
  }
  /**
   * React lifecycle hook invoked after a descendant throws during render.
   * Flips the boundary into the error state and captures the error so the
   * fallback UI can display its message.
   * @param error - The error thrown by a descendant component.
   * @returns The next state for the boundary.
   */
  static getDerivedStateFromError(t) {
    return {
      error: t,
      hasError: !0
    };
  }
  /**
   * React lifecycle hook invoked after an error has been caught. Delegates to the shared
   * `reportUnhandledError` so this class path and the router-level `RouteErrorBoundary` emit an
   * identical console line and structured telemetry record.
   * @param error - The error thrown by a descendant component.
   * @param errorInfo - React-provided info including the component stack.
   */
  componentDidCatch(t, n) {
    rd.report({
      componentStack: n.componentStack ?? void 0,
      error: t,
      source: "ErrorBoundaryAlpha"
    });
  }
  /**
   * Renders the fallback UI when an error has been caught, otherwise renders
   * the protected children unchanged.
   * @returns The fallback UI or the children.
   */
  render() {
    return this.state.hasError ? /* @__PURE__ */ C.jsx(id, { error: this.state.error }) : this.props.children;
  }
}
function ad() {
  return sd.reloadPage();
}
const cd = "_devFooterAlpha_15r5e_1", ld = {
  devFooterAlpha: cd
};
class rc {
  /**
   * Protected constructor for subclasses.
   * Initializes all environment configuration properties with proper typing.
   * @param config - Configuration object containing version, environment, apiConfig, and customConfig.
   */
  constructor(t) {
    N(this, "apiConfig");
    N(this, "appConfig");
    N(this, "environment");
    N(this, "version");
    this.apiConfig = t.apiConfig, this.appConfig = t.appConfig, this.environment = t.environment, this.version = t.version;
  }
  /**
   * Validates that an environment value is in the list of valid values.
   * Throws an error if validation fails.
   * @param value - The environment value to validate.
   * @param validValues - The list of valid values.
   * @param fieldName - The name of the field being validated (used in error messages).
   */
  validateEnvironmentValue(t, n, r = "environment") {
    if (!n.includes(t)) throw new Error(`Invalid ${r} "${t}". Must be one of: ${n.join(", ")}`);
  }
  /**
   * Validates that a required field is present.
   * Throws an error if the field is falsy.
   * @param value - The value to validate.
   * @param fieldName - The name of the field being validated (used in error messages).
   */
  validateRequiredField(t, n) {
    if (!t) throw new Error(`Runtime config missing required field: ${n}`);
  }
}
class ud extends rc {
  /**
   * Creates an instance of ReactEnvironmentClientAlpha.
   * @param viteMetaEnv - The Vite meta environment object containing environment variables.
   * @param runtimeConfig - The runtime configuration loaded from config.json (base + custom fields nested under config).
   */
  constructor(n, r) {
    const o = n.VITE_APP_VERSION || Qa, {
      environment: s,
      apiConfig: i,
      appConfig: a = {}
    } = r;
    super({
      apiConfig: i,
      appConfig: a,
      environment: s,
      version: o
    });
    N(this, "mode");
    this._validateViteEnv(n), this._validateRuntimeConfig(r), this.mode = n.DEV ? nr.HMR : nr.COMPILED;
  }
  /**
   * Gets all environment variables as a single object.
   */
  getAllEnvironmentVariables() {
    return {
      apiConfig: this.apiConfig,
      appConfig: this.appConfig,
      environment: this.environment,
      mode: this.mode,
      version: this.version
    };
  }
  /**
   * Validates that the Vite environment object contains all required variables.
   * @param env - The environment object to validate.
   */
  _validateViteEnv(n) {
    const o = ["DEV", "PROD", "MODE"].filter((s) => !Object.prototype.hasOwnProperty.call(n, s));
    if (o.length) throw new Error(`Missing required Vite environment variables: ${o.join(", ")}`);
    if (typeof n.DEV != "boolean") throw new Error("DEV must be a boolean");
    if (typeof n.PROD != "boolean") throw new Error("PROD must be a boolean");
  }
  /**
   * Validates that the runtime configuration contains all required base fields.
   * @param config - The combined runtime config (base + custom fields nested under config).
   */
  _validateRuntimeConfig(n) {
    this.validateRequiredField(n.environment, "environment"), this.validateRequiredField(n.apiConfig, "apiConfig"), this.validateEnvironmentValue(n.environment, Za);
  }
}
class dd extends rc {
  /**
   * Creates an instance of NextJsReactEnvironmentClientAlpha.
   * @param runtimeConfig - The runtime configuration parsed from NEXT_PUBLIC_APP_CONFIG.
   * @param version - Optional app version (defaults to LOCALHOST_BUILD_VERSION).
   */
  constructor(t, n) {
    const {
      environment: r,
      apiConfig: o,
      appConfig: s = {}
    } = t;
    super({
      apiConfig: o,
      appConfig: s,
      environment: r,
      version: n || Qa
    }), this._validateRuntimeConfig(t);
  }
  /**
   * Gets all environment variables as a single object.
   */
  getAllEnvironmentVariables() {
    return {
      apiConfig: this.apiConfig,
      appConfig: this.appConfig,
      environment: this.environment,
      version: this.version
    };
  }
  /**
   * Validates that the runtime configuration contains all required base fields.
   * @param config - The runtime config to validate.
   */
  _validateRuntimeConfig(t) {
    this.validateRequiredField(t.environment, "environment"), this.validateRequiredField(t.apiConfig, "apiConfig"), this.validateEnvironmentValue(t.environment, Za);
  }
}
class ai {
  /**
   * Type guard to check if code is running in Electron renderer context.
   * @returns True if window.electronAPI is available (running in Electron).
   */
  static isElectronRenderer() {
    return typeof window < "u" && "electronAPI" in window;
  }
  /**
   * Get main process environment variables.
   * Only available when running in Electron renderer process.
   * @returns Promise resolving to main process environment configuration.
   * @throws Error if not running in Electron context or IPC fails.
   */
  static async getMainEnvironment() {
    if (!this.isElectronRenderer())
      throw new Error("EnvironmentBridgeAlpha.getMainEnvironment() is only available in Electron renderer context. Check EnvironmentBridgeAlpha.isElectronRenderer() before calling this method.");
    try {
      const {
        electronAPI: t
      } = window;
      return await t.invoke("environment:get-main", void 0);
    } catch (t) {
      throw new Error(`Failed to retrieve main process environment: ${t instanceof Error ? t.message : String(t)}`);
    }
  }
}
const hs = ln(null), oc = ({
  viteMetaEnv: e,
  runtimeConfig: t,
  children: n
}) => {
  const r = he(null);
  return r.current || (r.current = new ud(e, t)), /* @__PURE__ */ C.jsx(hs.Provider, { value: r.current, children: n });
}, at = () => {
  const e = Me(hs);
  if (!e)
    throw new Error("useEnvironmentAlpha() must be used within <EnvironmentProviderAlpha.Provider/>");
  return e;
}, fd = () => {
  const e = re.c(3), t = at();
  let n;
  return e[0] !== t.environment || e[1] !== t.version ? (n = /* @__PURE__ */ C.jsx("div", { className: ld.devFooterAlpha, "aria-hidden": !0, children: /* @__PURE__ */ C.jsxs("span", { children: [
    "DEV MODE | ",
    t.environment,
    " | v",
    t.version
  ] }) }), e[0] = t.environment, e[1] = t.version, e[2] = n) : n = e[2], n;
}, hd = "_siteContainerAlpha_xzb4e_1", pd = "_unselectable_xzb4e_5", ci = {
  siteContainerAlpha: hd,
  unselectable: pd
};
function sc(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = sc(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function md() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = sc(e)) && (r && (r += " "), r += t);
  return r;
}
const gd = (e, t) => {
  const n = new Array(e.length + t.length);
  for (let r = 0; r < e.length; r++)
    n[r] = e[r];
  for (let r = 0; r < t.length; r++)
    n[e.length + r] = t[r];
  return n;
}, yd = (e, t) => ({
  classGroupId: e,
  validator: t
}), ic = (e = /* @__PURE__ */ new Map(), t = null, n) => ({
  nextPart: e,
  validators: t,
  classGroupId: n
}), rr = "-", li = [], _d = "arbitrary..", bd = (e) => {
  const t = vd(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (i) => {
      if (i.startsWith("[") && i.endsWith("]"))
        return Ed(i);
      const a = i.split(rr), c = a[0] === "" && a.length > 1 ? 1 : 0;
      return ac(a, c, t);
    },
    getConflictingClassGroupIds: (i, a) => {
      if (a) {
        const c = r[i], l = n[i];
        return c ? l ? gd(l, c) : c : l || li;
      }
      return n[i] || li;
    }
  };
}, ac = (e, t, n) => {
  if (e.length - t === 0)
    return n.classGroupId;
  const o = e[t], s = n.nextPart.get(o);
  if (s) {
    const l = ac(e, t + 1, s);
    if (l) return l;
  }
  const i = n.validators;
  if (i === null)
    return;
  const a = t === 0 ? e.join(rr) : e.slice(t).join(rr), c = i.length;
  for (let l = 0; l < c; l++) {
    const u = i[l];
    if (u.validator(a))
      return u.classGroupId;
  }
}, Ed = (e) => e.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
  const t = e.slice(1, -1), n = t.indexOf(":"), r = t.slice(0, n);
  return r ? _d + r : void 0;
})(), vd = (e) => {
  const {
    theme: t,
    classGroups: n
  } = e;
  return wd(n, t);
}, wd = (e, t) => {
  const n = ic();
  for (const r in e) {
    const o = e[r];
    ps(o, n, r, t);
  }
  return n;
}, ps = (e, t, n, r) => {
  const o = e.length;
  for (let s = 0; s < o; s++) {
    const i = e[s];
    Rd(i, t, n, r);
  }
}, Rd = (e, t, n, r) => {
  if (typeof e == "string") {
    Sd(e, t, n);
    return;
  }
  if (typeof e == "function") {
    Td(e, t, n, r);
    return;
  }
  Ad(e, t, n, r);
}, Sd = (e, t, n) => {
  const r = e === "" ? t : cc(t, e);
  r.classGroupId = n;
}, Td = (e, t, n, r) => {
  if (Cd(e)) {
    ps(e(r), t, n, r);
    return;
  }
  t.validators === null && (t.validators = []), t.validators.push(yd(n, e));
}, Ad = (e, t, n, r) => {
  const o = Object.entries(e), s = o.length;
  for (let i = 0; i < s; i++) {
    const [a, c] = o[i];
    ps(c, cc(t, a), n, r);
  }
}, cc = (e, t) => {
  let n = e;
  const r = t.split(rr), o = r.length;
  for (let s = 0; s < o; s++) {
    const i = r[s];
    let a = n.nextPart.get(i);
    a || (a = ic(), n.nextPart.set(i, a)), n = a;
  }
  return n;
}, Cd = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, Od = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null);
  const o = (s, i) => {
    n[s] = i, t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ Object.create(null));
  };
  return {
    get(s) {
      let i = n[s];
      if (i !== void 0)
        return i;
      if ((i = r[s]) !== void 0)
        return o(s, i), i;
    },
    set(s, i) {
      s in n ? n[s] = i : o(s, i);
    }
  };
}, Ko = "!", ui = ":", kd = [], di = (e, t, n, r, o) => ({
  modifiers: e,
  hasImportantModifier: t,
  baseClassName: n,
  maybePostfixModifierPosition: r,
  isExternal: o
}), Pd = (e) => {
  const {
    prefix: t,
    experimentalParseClassName: n
  } = e;
  let r = (o) => {
    const s = [];
    let i = 0, a = 0, c = 0, l;
    const u = o.length;
    for (let R = 0; R < u; R++) {
      const b = o[R];
      if (i === 0 && a === 0) {
        if (b === ui) {
          s.push(o.slice(c, R)), c = R + 1;
          continue;
        }
        if (b === "/") {
          l = R;
          continue;
        }
      }
      b === "[" ? i++ : b === "]" ? i-- : b === "(" ? a++ : b === ")" && a--;
    }
    const d = s.length === 0 ? o : o.slice(c);
    let f = d, p = !1;
    d.endsWith(Ko) ? (f = d.slice(0, -1), p = !0) : (
      /**
       * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
       * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
       */
      d.startsWith(Ko) && (f = d.slice(1), p = !0)
    );
    const m = l && l > c ? l - c : void 0;
    return di(s, p, f, m);
  };
  if (t) {
    const o = t + ui, s = r;
    r = (i) => i.startsWith(o) ? s(i.slice(o.length)) : di(kd, !1, i, void 0, !0);
  }
  if (n) {
    const o = r;
    r = (s) => n({
      className: s,
      parseClassName: o
    });
  }
  return r;
}, xd = (e) => {
  const t = /* @__PURE__ */ new Map();
  return e.orderSensitiveModifiers.forEach((n, r) => {
    t.set(n, 1e6 + r);
  }), (n) => {
    const r = [];
    let o = [];
    for (let s = 0; s < n.length; s++) {
      const i = n[s], a = i[0] === "[", c = t.has(i);
      a || c ? (o.length > 0 && (o.sort(), r.push(...o), o = []), r.push(i)) : o.push(i);
    }
    return o.length > 0 && (o.sort(), r.push(...o)), r;
  };
}, Id = (e) => ({
  cache: Od(e.cacheSize),
  parseClassName: Pd(e),
  sortModifiers: xd(e),
  ...bd(e)
}), Nd = /\s+/, Md = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: o,
    sortModifiers: s
  } = t, i = [], a = e.trim().split(Nd);
  let c = "";
  for (let l = a.length - 1; l >= 0; l -= 1) {
    const u = a[l], {
      isExternal: d,
      modifiers: f,
      hasImportantModifier: p,
      baseClassName: m,
      maybePostfixModifierPosition: R
    } = n(u);
    if (d) {
      c = u + (c.length > 0 ? " " + c : c);
      continue;
    }
    let b = !!R, _ = r(b ? m.substring(0, R) : m);
    if (!_) {
      if (!b) {
        c = u + (c.length > 0 ? " " + c : c);
        continue;
      }
      if (_ = r(m), !_) {
        c = u + (c.length > 0 ? " " + c : c);
        continue;
      }
      b = !1;
    }
    const k = f.length === 0 ? "" : f.length === 1 ? f[0] : s(f).join(":"), S = p ? k + Ko : k, w = S + _;
    if (i.indexOf(w) > -1)
      continue;
    i.push(w);
    const h = o(_, b);
    for (let g = 0; g < h.length; ++g) {
      const y = h[g];
      i.push(S + y);
    }
    c = u + (c.length > 0 ? " " + c : c);
  }
  return c;
}, Dd = (...e) => {
  let t = 0, n, r, o = "";
  for (; t < e.length; )
    (n = e[t++]) && (r = lc(n)) && (o && (o += " "), o += r);
  return o;
}, lc = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = lc(e[r])) && (n && (n += " "), n += t);
  return n;
}, jd = (e, ...t) => {
  let n, r, o, s;
  const i = (c) => {
    const l = t.reduce((u, d) => d(u), e());
    return n = Id(l), r = n.cache.get, o = n.cache.set, s = a, a(c);
  }, a = (c) => {
    const l = r(c);
    if (l)
      return l;
    const u = Md(c, n);
    return o(c, u), u;
  };
  return s = i, (...c) => s(Dd(...c));
}, Ld = [], Se = (e) => {
  const t = (n) => n[e] || Ld;
  return t.isThemeGetter = !0, t;
}, uc = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, dc = /^\((?:(\w[\w-]*):)?(.+)\)$/i, Hd = /^\d+\/\d+$/, Ud = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, qd = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Fd = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, Bd = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, $d = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Nt = (e) => Hd.test(e), Y = (e) => !!e && !Number.isNaN(Number(e)), Je = (e) => !!e && Number.isInteger(Number(e)), Ir = (e) => e.endsWith("%") && Y(e.slice(0, -1)), $e = (e) => Ud.test(e), Wd = () => !0, zd = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  qd.test(e) && !Fd.test(e)
), fc = () => !1, Gd = (e) => Bd.test(e), Xd = (e) => $d.test(e), Vd = (e) => !F(e) && !B(e), Kd = (e) => Ht(e, mc, fc), F = (e) => uc.test(e), ut = (e) => Ht(e, gc, zd), Nr = (e) => Ht(e, ef, Y), fi = (e) => Ht(e, hc, fc), Yd = (e) => Ht(e, pc, Xd), vn = (e) => Ht(e, yc, Gd), B = (e) => dc.test(e), Gt = (e) => Ut(e, gc), Jd = (e) => Ut(e, tf), hi = (e) => Ut(e, hc), Qd = (e) => Ut(e, mc), Zd = (e) => Ut(e, pc), wn = (e) => Ut(e, yc, !0), Ht = (e, t, n) => {
  const r = uc.exec(e);
  return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, Ut = (e, t, n = !1) => {
  const r = dc.exec(e);
  return r ? r[1] ? t(r[1]) : n : !1;
}, hc = (e) => e === "position" || e === "percentage", pc = (e) => e === "image" || e === "url", mc = (e) => e === "length" || e === "size" || e === "bg-size", gc = (e) => e === "length", ef = (e) => e === "number", tf = (e) => e === "family-name", yc = (e) => e === "shadow", nf = () => {
  const e = Se("color"), t = Se("font"), n = Se("text"), r = Se("font-weight"), o = Se("tracking"), s = Se("leading"), i = Se("breakpoint"), a = Se("container"), c = Se("spacing"), l = Se("radius"), u = Se("shadow"), d = Se("inset-shadow"), f = Se("text-shadow"), p = Se("drop-shadow"), m = Se("blur"), R = Se("perspective"), b = Se("aspect"), _ = Se("ease"), k = Se("animate"), S = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], w = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], h = () => [...w(), B, F], g = () => ["auto", "hidden", "clip", "visible", "scroll"], y = () => ["auto", "contain", "none"], E = () => [B, F, c], A = () => [Nt, "full", "auto", ...E()], H = () => [Je, "none", "subgrid", B, F], x = () => ["auto", {
    span: ["full", Je, B, F]
  }, Je, B, F], M = () => [Je, "auto", B, F], L = () => ["auto", "min", "max", "fr", B, F], $ = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], U = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], z = () => ["auto", ...E()], V = () => [Nt, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...E()], D = () => [e, B, F], Z = () => [...w(), hi, fi, {
    position: [B, F]
  }], ie = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], T = () => ["auto", "cover", "contain", Qd, Kd, {
    size: [B, F]
  }], q = () => [Ir, Gt, ut], I = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    l,
    B,
    F
  ], j = () => ["", Y, Gt, ut], Q = () => ["solid", "dashed", "dotted", "double"], K = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], W = () => [Y, Ir, hi, fi], ae = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    m,
    B,
    F
  ], oe = () => ["none", Y, B, F], ue = () => ["none", Y, B, F], ve = () => [Y, B, F], ge = () => [Nt, "full", ...E()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [$e],
      breakpoint: [$e],
      color: [Wd],
      container: [$e],
      "drop-shadow": [$e],
      ease: ["in", "out", "in-out"],
      font: [Vd],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [$e],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [$e],
      shadow: [$e],
      spacing: ["px", Y],
      text: [$e],
      "text-shadow": [$e],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", Nt, F, B, b]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Y, F, B, a]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": S()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": S()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: h()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: g()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": g()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": g()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: y()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": y()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": y()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: A()
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": A()
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": A()
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: A()
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: A()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: A()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: A()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: A()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: A()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [Je, "auto", B, F]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [Nt, "full", "auto", a, ...E()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [Y, Nt, "auto", "initial", "none", F]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", Y, B, F]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", Y, B, F]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [Je, "first", "last", "none", B, F]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": H()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: x()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": M()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": M()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": H()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: x()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": M()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": M()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": L()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": L()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: E()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": E()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": E()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...$(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...U(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...U()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...$()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...U(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...U(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": $()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...U(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...U()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: E()
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: E()
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: E()
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: E()
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: E()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: E()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: E()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: E()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: E()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: z()
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: z()
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: z()
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: z()
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: z()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: z()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: z()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: z()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: z()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": E()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": E()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: V()
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [a, "screen", ...V()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          a,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...V()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          a,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [i]
          },
          ...V()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...V()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...V()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...V()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", n, Gt, ut]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [r, B, Nr]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", Ir, F]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Jd, F, t]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [o, B, F]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [Y, "none", B, Nr]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          s,
          ...E()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", B, F]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", B, F]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: D()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: D()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...Q(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [Y, "from-font", "auto", B, ut]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: D()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [Y, "auto", B, F]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: E()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", B, F]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", B, F]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: Z()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ie()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: T()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, Je, B, F],
          radial: ["", B, F],
          conic: [Je, B, F]
        }, Zd, Yd]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: D()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: q()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: q()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: q()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: D()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: D()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: D()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: I()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": I()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": I()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": I()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": I()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": I()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": I()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": I()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": I()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": I()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": I()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": I()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": I()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": I()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": I()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: j()
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": j()
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": j()
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": j()
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": j()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": j()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": j()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": j()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": j()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": j()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": j()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...Q(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...Q(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: D()
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": D()
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": D()
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": D()
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": D()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": D()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": D()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": D()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": D()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: D()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...Q(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Y, B, F]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", Y, Gt, ut]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: D()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          u,
          wn,
          vn
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: D()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", d, wn, vn]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": D()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: j()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: D()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [Y, ut]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": D()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": j()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": D()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", f, wn, vn]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": D()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [Y, B, F]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...K(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": K()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [Y]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": W()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": W()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": D()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": D()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": W()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": W()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": D()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": D()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": W()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": W()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": D()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": D()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": W()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": W()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": D()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": D()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": W()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": W()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": D()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": D()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": W()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": W()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": D()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": D()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": W()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": W()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": D()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": D()
      }],
      "mask-image-radial": [{
        "mask-radial": [B, F]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": W()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": W()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": D()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": D()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": w()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [Y]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": W()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": W()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": D()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": D()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: Z()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: ie()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: T()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", B, F]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          B,
          F
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: ae()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [Y, B, F]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [Y, B, F]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          p,
          wn,
          vn
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": D()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", Y, B, F]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [Y, B, F]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", Y, B, F]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [Y, B, F]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", Y, B, F]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          B,
          F
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": ae()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [Y, B, F]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [Y, B, F]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", Y, B, F]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [Y, B, F]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", Y, B, F]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [Y, B, F]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [Y, B, F]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", Y, B, F]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": E()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": E()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": E()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", B, F]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [Y, "initial", B, F]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", _, B, F]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [Y, B, F]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", k, B, F]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [R, B, F]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": h()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: oe()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": oe()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": oe()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": oe()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: ue()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": ue()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": ue()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": ue()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: ve()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": ve()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": ve()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [B, F, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: h()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: ge()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": ge()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": ge()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": ge()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: D()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: D()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", B, F]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": E()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": E()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": E()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": E()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": E()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": E()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": E()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": E()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": E()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": E()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": E()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": E()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": E()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": E()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": E()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": E()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": E()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": E()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", B, F]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...D()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Y, Gt, ut, Nr]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...D()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, rf = /* @__PURE__ */ jd(nf), _c = (...e) => rf(md(e)), of = ({
  runtimeConfig: e,
  version: t,
  children: n
}) => {
  const r = he(null);
  return r.current || (r.current = new dd(e, t)), /* @__PURE__ */ C.jsx(hs.Provider, { value: r.current, children: n });
};
var nt = /* @__PURE__ */ ((e) => (e.LOADED = "LOADED", e.LOADED_WITH_ERRORS = "LOADED_WITH_ERRORS", e.LOADING = "LOADING", e))(nt || {});
const sf = {
  baseDelayMs: 1e3,
  maxDelayMs: 1e4,
  maxRetries: 3,
  retryableStatusCodes: [...Bu]
}, af = {
  /**
   * Calculates the delay for exponential backoff with jitter.
   * @param attempt - The current attempt number (0-indexed).
   * @param config - The retry configuration.
   * @returns The delay in milliseconds.
   */
  calculateBackoffDelay(e, t) {
    const n = t.baseDelayMs * Math.pow(2, e), r = Math.random() * 0.3 * n, o = n + r;
    return Math.min(o, t.maxDelayMs);
  },
  /**
   * Executes a function with exponential backoff retry logic.
   * @param fn - The async function to execute.
   * @param config - Optional retry configuration (uses defaults if not provided).
   * @param onRetry - Optional callback called before each retry with attempt number and delay.
   * @returns The result of the function.
   * @throws The last error if all retries are exhausted.
   */
  async execute(e, t = {}, n) {
    const r = {
      ...sf,
      ...t
    };
    let o;
    for (let s = 0; s <= r.maxRetries; s++)
      try {
        return await e();
      } catch (i) {
        const a = typeof i == "object" && i !== null ? {
          message: i.message,
          statusCode: i.statusCode
        } : {
          message: String(i)
        };
        if (o = a, !(!(s === r.maxRetries) && this.isRetryableError(a, r))) throw i;
        const u = this.calculateBackoffDelay(s, r);
        n && n(s + 1, u, a), await new Promise((d) => setTimeout(d, u));
      }
    throw o;
  },
  /**
   * Determines whether an error should trigger a retry based on status code.
   * @param error - The error to check.
   * @param config - The retry configuration.
   * @returns True if the error is retryable.
   */
  isRetryableError(e, t) {
    return e.statusCode === void 0 ? !1 : t.retryableStatusCodes.includes(e.statusCode);
  }
};
class bc {
  /**
   * Creates a new HttpClientPublicAlpha instance.
   * @param apiConfig - Configuration mapping service names to their base URLs.
   */
  constructor(t) {
    N(this, "apiConfig");
    N(this, "hmacCache", /* @__PURE__ */ new Map());
    this.apiConfig = t;
  }
  /**
   * Makes a GET request.
   * @param service - The service identifier from apiConfig.
   * @param authMethod - The authentication method to use.
   * @param path - The API endpoint path.
   * @param options - Optional request options.
   */
  async get(t, n, r, o) {
    return this._requestWithRetry("GET", t, n, r, void 0, o);
  }
  /**
   * Makes a POST request.
   * @param service - The service identifier from apiConfig.
   * @param authMethod - The authentication method to use.
   * @param path - The API endpoint path.
   * @param payload - Optional request body payload.
   * @param options - Optional request options.
   */
  async post(t, n, r, o, s) {
    return this._requestWithRetry("POST", t, n, r, o, s);
  }
  /**
   * Makes a PUT request.
   * @param service - The service identifier from apiConfig.
   * @param authMethod - The authentication method to use.
   * @param path - The API endpoint path.
   * @param payload - The request body payload.
   * @param options - Optional request options.
   */
  async put(t, n, r, o, s) {
    return this._requestWithRetry("PUT", t, n, r, o, s);
  }
  /**
   * Makes a PATCH request.
   * @param service - The service identifier from apiConfig.
   * @param authMethod - The authentication method to use.
   * @param path - The API endpoint path.
   * @param payload - The request body payload.
   * @param options - Optional request options.
   */
  async patch(t, n, r, o, s) {
    return this._requestWithRetry("PATCH", t, n, r, o, s);
  }
  /**
   * Makes a DELETE request.
   * @param service - The service identifier from apiConfig.
   * @param authMethod - The authentication method to use.
   * @param path - The API endpoint path.
   * @param options - Optional request options.
   */
  async delete(t, n, r, o) {
    return this._requestWithRetry("DELETE", t, n, r, void 0, o);
  }
  /** No-op — public client has no auth tokens. */
  setAuthData() {
  }
  /** Terminates the HTTP client and clears cached data. */
  terminate() {
    this.hmacCache.clear();
  }
  /** Clears the HMAC token cache (eg: on wake from sleep). */
  clearHmacCache() {
    this.hmacCache.clear();
  }
  /**
   * Wraps request() with retry logic and 401 HMAC refresh.
   * @param method - The HTTP method.
   * @param service - The service identifier from apiConfig.
   * @param authMethod - The authentication method to use.
   * @param path - The API endpoint path.
   * @param payload - Optional request body payload.
   * @param options - Optional request options.
   */
  async _requestWithRetry(t, n, r, o, s, i) {
    const a = i?.retry ? {
      ...i.retry
    } : {};
    let c = !1;
    return af.execute(async () => {
      try {
        return await this._request(t, n, r, o, s, i);
      } catch (l) {
        if ((typeof l == "object" && l !== null ? l.statusCode : void 0) === 401 && r === ot.HMAC && !c) {
          c = !0;
          const d = this.apiConfig[n];
          return d && this.hmacCache.delete(d.baseUrl), this._request(t, n, r, o, s, i);
        }
        throw l;
      }
    }, a);
  }
  /**
   * Internal method that handles all HTTP requests.
   * @param method - The HTTP method (GET, POST, etc.).
   * @param service - The service identifier from apiConfig.
   * @param authMethod - The authentication method to use.
   * @param path - The API endpoint path.
   * @param payload - Optional request body payload.
   * @param options - Optional request options.
   */
  async _request(t, n, r, o, s, i) {
    const a = this.apiConfig[n];
    if (!a) throw new Error(`Unknown service: ${n}. Available services: ${Object.keys(this.apiConfig).join(", ")}`);
    const c = this._buildUrl(a.baseUrl, o, i?.params), l = {
      [kr]: Pr,
      ...i?.headers
    };
    if (r === ot.HMAC) {
      const m = await this._computeHmacHeaders(a.baseUrl, t, i?.params, s);
      Object.assign(l, m);
    }
    if (i?.encrypt) {
      const m = new Wu();
      i.encrypt.request && m.markPayloadEncrypted(), i.encrypt.response && m.requestEncryptedResponse(), l[dt] = Vo.encodeRequest(m);
    }
    if (i?.encrypt?.request && s) {
      const m = this.hmacCache.get(a.baseUrl);
      m && (s = er.encryptPayload(m.secret, Wo.REQUEST, s));
    }
    const u = {
      headers: l,
      method: t
    };
    s !== void 0 && t !== "GET" && (u.body = JSON.stringify(s));
    const d = i?.timeout ?? Xo, f = new AbortController(), p = setTimeout(() => f.abort(), d);
    u.signal = f.signal;
    try {
      const m = await fetch(c, u);
      clearTimeout(p);
      const R = m.headers.get(kr.toLowerCase());
      let b;
      if (R?.includes(Pr)) {
        const k = await m.text();
        b = k.trim() ? JSON.parse(k) : null;
      } else b = await m.text();
      const _ = m.headers.get(dt);
      if (m.ok && _ && b?.data) {
        const k = this.hmacCache.get(a.baseUrl);
        k && Vo.decodeResponse({
          [dt]: _
        })?.isEncrypted && (b = {
          ...b,
          data: er.decryptPayload(k.secret, Wo.RESPONSE, b.data)
        });
      }
      if (!m.ok) throw {
        statusCode: m.status,
        ...typeof b == "object" && b || {
          data: b
        }
      };
      return b;
    } catch (m) {
      throw clearTimeout(p), m instanceof Error && m.name === "AbortError" ? {
        message: `Request timed out after ${d}ms`,
        name: "TimeoutError",
        statusCode: 408,
        timeoutMs: d
      } : m;
    }
  }
  /**
   * Builds the full URL with query parameters.
   * @param baseUrl - The base URL of the service.
   * @param path - The API endpoint path.
   * @param params - Optional query parameters.
   */
  _buildUrl(t, n, r) {
    const o = t.replace(/\/$/, ""), s = n.replace(/^\//, "");
    let i = `${o}/${s}`;
    if (r && Object.keys(r).length > 0) {
      const a = new URLSearchParams();
      for (const [l, u] of Object.entries(r))
        Array.isArray(u) ? u.forEach((d) => a.append(l, String(d))) : u != null && a.append(l, String(u));
      const c = a.toString();
      c && (i += `?${c}`);
    }
    return i;
  }
  /**
   * Computes HMAC authentication headers.
   * @param baseUrl - The base URL of the service (used to look up HMAC token).
   * @param method - The HTTP method.
   * @param queryParams - Optional query parameters to include in the signature.
   * @param payload - Optional request body to include in the signature.
   */
  async _computeHmacHeaders(t, n, r, o) {
    let s = this.hmacCache.get(t);
    s || (s = await this._fetchHmacToken(t), this.hmacCache.set(t, s));
    const {
      contentLength: i,
      hash: a,
      timestamp: c
    } = Nu.compute(s.secret, {
      body: o,
      method: n.toUpperCase(),
      queryParams: r && Object.keys(r).length > 0 ? r : void 0
    }, s.timestampOffset);
    return {
      [qu]: a,
      [Fu]: c.toString(),
      [Uu]: i.toString()
    };
  }
  /**
   * Fetches the HMAC token from the service.
   * @param baseUrl - The base URL of the service.
   */
  async _fetchHmacToken(t) {
    const n = `${t}/v1/hmac`, r = await fetch(n, {
      headers: {
        [kr]: Pr
      },
      method: "GET"
    });
    if (!r.ok) throw new Error(`Failed to fetch HMAC token: ${r.status} ${r.statusText}`);
    const o = await r.json();
    if (!o.data?.hmacToken || !o.data?.timestamp) throw new Error("Invalid HMAC response: missing hmacToken or timestamp");
    const i = new Date(o.data.timestamp).getTime() - Date.now();
    return {
      secret: o.data.hmacToken,
      timestampOffset: i
    };
  }
}
const ms = ln(null), cf = ({
  children: e
}) => {
  const t = he(null), r = at().apiConfig;
  if (!r) throw new Error("SiteHttpProviderAlpha requires apiConfig in runtime configuration");
  return t.current || (t.current = new bc(r)), le(() => () => {
    t.current && t.current.terminate();
  }, []), /* @__PURE__ */ C.jsx(ms.Provider, { value: t.current, children: e });
}, qt = (e) => {
  let t = e;
  const n = /* @__PURE__ */ new Set(), r = (a) => (n.add(a), () => {
    n.delete(a);
  });
  return {
    getState: () => t,
    setState: (a) => {
      const c = typeof a == "function" ? a(t) : a;
      t = {
        ...t,
        ...c
      }, n.forEach((l) => l());
    },
    subscribe: r,
    use: (a) => us(r, () => a(t), () => a(t))
  };
}, lf = {
  appIsUnselectable: !1
}, Mr = qt({
  ...lf
}), Yo = {
  /** Returns the current selectability snapshot. */
  getState: Mr.getState,
  /**
   * Set whether the app root should be unselectable. Components that initiate a drag call
   * this with `true` on pointer-down and `false` when the drag ends.
   * @param value - The new unselectable state.
   */
  setUnselectable: (e) => Mr.setState({
    appIsUnselectable: e
  }),
  /** React hook that subscribes to a slice of state via `useSyncExternalStore`. */
  use: Mr.use
}, gs = () => ({
  appIsUnselectable: Yo.use((t) => t.appIsUnselectable),
  setAppIsUnselectable: Yo.setUnselectable
});
function uf(e) {
  return { all: e = e || /* @__PURE__ */ new Map(), on: function(t, n) {
    var r = e.get(t);
    r ? r.push(n) : e.set(t, [n]);
  }, off: function(t, n) {
    var r = e.get(t);
    r && (n ? r.splice(r.indexOf(n) >>> 0, 1) : e.set(t, []));
  }, emit: function(t, n) {
    var r = e.get(t);
    r && r.slice().map(function(o) {
      o(n);
    }), (r = e.get("*")) && r.slice().map(function(o) {
      o(t, n);
    });
  } };
}
var df = /* @__PURE__ */ ((e) => (e.MouseClick = "MouseClick", e.MouseDown = "MouseDown", e.MouseEnter = "MouseEnter", e.MouseLeave = "MouseLeave", e.MouseMove = "MouseMove", e.MouseUp = "MouseUp", e))(df || {});
const Dr = uf(), Qe = {
  /**
   * Emits an event with the given name and data to all registered listeners.
   * @param eventName - The event to emit.
   * @param data - The payload to send with the event.
   */
  emit: (e, t) => Dr.emit(e, t),
  /**
   * Removes a previously registered event listener for the given event name.
   * @param eventName - The event to unsubscribe from.
   * @param callback - The listener function to remove.
   */
  off: (e, t) => Dr.off(e, t),
  /**
   * Registers a callback to be invoked whenever the given event is emitted.
   * @param eventName - The event to subscribe to.
   * @param callback - The listener function to invoke on each event.
   */
  on: (e, t) => Dr.on(e, t)
}, Ec = () => ({
  EventBus: Qe,
  globalMouseClick: (i) => {
    Qe.emit("MouseClick", i);
  },
  globalMouseDown: (i) => {
    Qe.emit("MouseDown", i);
  },
  globalMouseEnter: (i) => {
    Qe.emit("MouseEnter", i), i.buttons === 0 && Qe.emit("MouseUp", i);
  },
  globalMouseLeave: (i) => {
    Qe.emit("MouseLeave", i);
  },
  globalMouseMove: (i) => {
    Qe.emit("MouseMove", i);
  },
  globalMouseUp: (i) => {
    Qe.emit("MouseUp", i);
  },
  setAppIsUnselectable: Yo.setUnselectable
}), vc = () => {
  const e = Me(ms);
  if (!e)
    throw new Error("useHttpClientBeta() must be used within <HttpProviderAlpha.Provider/>");
  return e;
}, wc = (e) => {
  const {
    onWakeFromSleep: t,
    sleepThresholdMs: n = 3e4,
    enabled: r = !0
  } = e, o = he(Date.now()), s = he(r);
  return le(() => {
    if (!r) {
      s.current = !1;
      return;
    }
    s.current = !0, o.current = Date.now();
    const i = () => {
      o.current = Date.now();
    }, a = () => {
      const p = Date.now();
      p - o.current >= n && t(), o.current = p;
    }, c = () => {
      document.visibilityState === "visible" ? a() : i();
    }, l = () => {
      a();
    }, u = () => {
      i();
    }, d = setInterval(() => {
      if (document.visibilityState === "visible" && document.hasFocus()) {
        const p = Date.now();
        p - o.current >= n && t(), o.current = p;
      }
    }, 5e3);
    document.addEventListener("visibilitychange", c), window.addEventListener("focus", l), window.addEventListener("blur", u);
    const f = ["mousedown", "mousemove", "keypress", "scroll", "touchstart"];
    return f.forEach((p) => {
      document.addEventListener(p, i, {
        passive: !0
      });
    }), () => {
      clearInterval(d), document.removeEventListener("visibilitychange", c), window.removeEventListener("focus", l), window.removeEventListener("blur", u), f.forEach((p) => {
        document.removeEventListener(p, i);
      }), s.current = !1;
    };
  }, [t, n, r]), {
    isActive: s.current
  };
}, ff = "_host_1beql_8", hf = {
  host: ff
}, Rc = (e) => {
  const t = re.c(10), {
    children: n
  } = e, r = ce.useRef(null), [o, s] = ce.useState(!1);
  let i, a;
  t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = () => {
    s(!0);
  }, a = [], t[0] = i, t[1] = a) : (i = t[0], a = t[1]), ce.useEffect(i, a);
  let c, l;
  t[2] !== o ? (c = () => {
    if (!o)
      return;
    const p = r.current;
    if (p) {
      if (typeof p.showPopover != "function") {
        p.removeAttribute("popover");
        return;
      }
      try {
        p.showPopover();
      } catch {
        p.removeAttribute("popover");
        return;
      }
      return () => p.hidePopover();
    }
  }, l = [o], t[2] = o, t[3] = c, t[4] = l) : (c = t[3], l = t[4]), ce.useEffect(c, l);
  let u, d;
  if (t[5] !== o ? (u = () => {
    if (!o)
      return;
    const p = r.current;
    if (!p)
      return;
    const m = () => document.documentElement.style.setProperty("--dev-footer-height", `${Math.round(p.getBoundingClientRect().height)}px`);
    m();
    const R = typeof ResizeObserver > "u" ? null : new ResizeObserver(m);
    return R?.observe(p), () => {
      R?.disconnect(), document.documentElement.style.removeProperty("--dev-footer-height");
    };
  }, d = [o], t[5] = o, t[6] = u, t[7] = d) : (u = t[6], d = t[7]), ce.useEffect(u, d), !o)
    return null;
  let f;
  return t[8] !== n ? (f = Tl(/* @__PURE__ */ C.jsx("div", { ref: r, className: hf.host, popover: "manual", "aria-live": "off", children: n }), document.body), t[8] = n, t[9] = f) : f = t[9], f;
}, pf = (e) => {
  const t = re.c(31), {
    children: n
  } = e, {
    globalMouseClick: r,
    globalMouseDown: o,
    globalMouseEnter: s,
    globalMouseLeave: i,
    globalMouseMove: a,
    globalMouseUp: c
  } = Ec(), {
    appIsUnselectable: l,
    setAppIsUnselectable: u
  } = gs(), d = at(), f = vc();
  let p;
  t[0] !== f ? (p = () => {
    f instanceof bc && f.clearHmacCache();
  }, t[0] = f, t[1] = p) : p = t[1];
  const m = p;
  let R;
  t[2] !== m ? (R = {
    onWakeFromSleep: m,
    sleepThresholdMs: 3e4
  }, t[2] = m, t[3] = R) : R = t[3], wc(R);
  let b;
  t[4] !== c || t[5] !== u ? (b = (x) => {
    c(x), u(!1);
  }, t[4] = c, t[5] = u, t[6] = b) : b = t[6];
  const _ = b, k = l && ci.unselectable;
  let S;
  t[7] !== k ? (S = _c(ci.siteContainerAlpha, k), t[7] = k, t[8] = S) : S = t[8];
  let w;
  t[9] !== r ? (w = (x) => r(x), t[9] = r, t[10] = w) : w = t[10];
  let h;
  t[11] !== o ? (h = (x) => o(x), t[11] = o, t[12] = h) : h = t[12];
  let g;
  t[13] !== s ? (g = (x) => s(x), t[13] = s, t[14] = g) : g = t[14];
  let y;
  t[15] !== i ? (y = (x) => i(x), t[15] = i, t[16] = y) : y = t[16];
  let E;
  t[17] !== a ? (E = (x) => a(x), t[17] = a, t[18] = E) : E = t[18];
  let A;
  t[19] !== d.environment ? (A = d.environment !== "prod" ? /* @__PURE__ */ C.jsx(Rc, { children: /* @__PURE__ */ C.jsx(fd, {}) }) : null, t[19] = d.environment, t[20] = A) : A = t[20];
  let H;
  return t[21] !== n || t[22] !== _ || t[23] !== E || t[24] !== A || t[25] !== S || t[26] !== w || t[27] !== h || t[28] !== g || t[29] !== y ? (H = /* @__PURE__ */ C.jsxs("div", { className: S, role: "application", onClick: w, onMouseDown: h, onMouseEnter: g, onMouseLeave: y, onMouseMove: E, onMouseUp: _, children: [
    n,
    A
  ] }), t[21] = n, t[22] = _, t[23] = E, t[24] = A, t[25] = S, t[26] = w, t[27] = h, t[28] = g, t[29] = y, t[30] = H) : H = t[30], H;
}, Py = (e) => {
  const t = re.c(6), {
    runtimeConfig: n,
    version: r
  } = e;
  let o;
  t[0] !== e ? (o = /* @__PURE__ */ C.jsx(cf, { children: /* @__PURE__ */ C.jsx(ds, { children: /* @__PURE__ */ C.jsx(pf, { ...e }) }) }), t[0] = e, t[1] = o) : o = t[1];
  let s;
  return t[2] !== n || t[3] !== o || t[4] !== r ? (s = /* @__PURE__ */ C.jsx(of, { runtimeConfig: n, version: r, children: o }), t[2] = n, t[3] = o, t[4] = r, t[5] = s) : s = t[5], s;
}, xy = (e) => {
  const t = re.c(9), {
    as: n,
    children: r,
    className: o,
    density: s,
    mode: i,
    theme: a
  } = e, c = n === void 0 ? "div" : n, l = s === void 0 ? void 0 : `density-${s}`;
  let u;
  t[0] !== o || t[1] !== l ? (u = [l, o].filter(Boolean), t[0] = o, t[1] = l, t[2] = u) : u = t[2];
  const d = u.join(" "), f = d === "" ? void 0 : d;
  let p;
  return t[3] !== c || t[4] !== r || t[5] !== i || t[6] !== f || t[7] !== a ? (p = /* @__PURE__ */ C.jsx(c, { "data-theme": a, "data-mode": i, className: f, children: r }), t[3] = c, t[4] = r, t[5] = i, t[6] = f, t[7] = a, t[8] = p) : p = t[8], p;
}, Sc = ne.createContext(null), mf = (e) => {
  const t = re.c(3), {
    appName: n,
    children: r
  } = e;
  let o;
  return t[0] !== n || t[1] !== r ? (o = /* @__PURE__ */ C.jsx(Sc.Provider, { value: n, children: r }), t[0] = n, t[1] = r, t[2] = o) : o = t[2], o;
}, Tc = ln(void 0), Iy = (e) => {
  const t = re.c(3), {
    agent: n,
    children: r
  } = e;
  let o;
  return t[0] !== n || t[1] !== r ? (o = /* @__PURE__ */ C.jsx(Tc.Provider, { value: n, children: r }), t[0] = n, t[1] = r, t[2] = o) : o = t[2], o;
}, gf = () => Me(Tc), yf = {
  keyPrefix: ""
};
class Ac {
  /**
   * Initializes the TypedLocalStorage service with optional configuration.
   * @param config - Partial configuration to override defaults.
   */
  constructor(t = {}) {
    N(this, "config");
    this.config = {
      ...yf,
      ...t
    };
  }
  /**
   * Reads a raw string value from localStorage.
   * Returns null if unavailable, missing, or on error.
   * @param key - The key to retrieve.
   */
  get(t) {
    if (typeof window > "u") return null;
    try {
      return window.localStorage.getItem(this._getPrefixedKey(t));
    } catch {
      return null;
    }
  }
  /**
   * Reads and JSON-parses a value from localStorage.
   * Returns null if unavailable, missing, or unparseable.
   * @param key - The key to retrieve and parse.
   */
  getJSON(t) {
    if (typeof window > "u") return null;
    try {
      const n = window.localStorage.getItem(this._getPrefixedKey(t));
      return n === null ? null : JSON.parse(n);
    } catch {
      return null;
    }
  }
  /**
   * Checks if localStorage is available and functional.
   */
  isLocalStorageAvailable() {
    if (typeof window > "u") return !1;
    try {
      const t = "__localStorage_test__";
      return window.localStorage.setItem(t, "test"), window.localStorage.removeItem(t), !0;
    } catch {
      return !1;
    }
  }
  /**
   * Removes a key from localStorage. Silently ignores errors.
   * @param key - The key to remove.
   */
  remove(t) {
    if (!(typeof window > "u"))
      try {
        window.localStorage.removeItem(this._getPrefixedKey(t));
      } catch {
      }
  }
  /**
   * Writes a string value to localStorage. Silently ignores errors.
   * @param key - The key to write.
   * @param value - The string value to store.
   */
  set(t, n) {
    if (!(typeof window > "u"))
      try {
        window.localStorage.setItem(this._getPrefixedKey(t), n);
      } catch {
      }
  }
  /**
   * JSON-stringifies and writes a value to localStorage. Silently ignores errors.
   * @param key - The key to write.
   * @param value - The value to JSON-stringify and store.
   */
  setJSON(t, n) {
    if (!(typeof window > "u"))
      try {
        window.localStorage.setItem(this._getPrefixedKey(t), JSON.stringify(n));
      } catch {
      }
  }
  /**
   * Writes a string value to localStorage, propagating any error (eg: `QuotaExceededError`).
   * Use this when the caller needs to react to a failed write — most callers should use `set` instead.
   * SSR is still short-circuited to a no-op.
   * @param key - The key to write.
   * @param value - The string value to store.
   */
  setStrict(t, n) {
    typeof window > "u" || window.localStorage.setItem(this._getPrefixedKey(t), n);
  }
  /**
   * Generates a prefixed key to avoid collisions in localStorage.
   * Eg: If the key is "userSettings" and the prefix is "app_", the resulting key will be "app_userSettings".
   * @param key - The original key (non-prefixed).
   */
  _getPrefixedKey(t) {
    return `${this.config.keyPrefix}${t}`;
  }
}
const zn = "app_", Oe = new Ac({
  keyPrefix: zn
}), _f = ["compact", "spacious", "standard"], bf = ["dark", "light", "system"], Cc = {
  /**
   * Narrow an untrusted value to a valid `Density`.
   * @param raw - The untrusted value to check.
   */
  isDensity: (e) => typeof e == "string" && _f.includes(e),
  /**
   * Narrow an untrusted value to a valid `ThemeMode`.
   * @param raw - The untrusted value to check.
   */
  isThemeMode: (e) => typeof e == "string" && bf.includes(e)
}, un = ne.createContext(void 0), Gn = "density", Jo = "mode", Qo = "theme", Ef = ["density-compact", "density-spacious", "density-standard"], jr = ["compact", "standard", "spacious"], vf = (e) => {
  if (typeof document > "u") return;
  const t = document.documentElement;
  Rl.run(() => {
    for (const n of Ef) t.classList.remove(n);
    t.classList.add(`density-${e}`);
  });
}, pi = (e) => {
  const t = Oe.get(Gn);
  return Cc.isDensity(t) ? t : e;
}, mi = (e) => {
  const t = Oe.get(Jo);
  return Cc.isThemeMode(t) ? t : e;
}, gi = (e, t) => {
  const n = Oe.get(Qo);
  return n === null ? e : t.some((r) => r.name === n) ? n : (console.warn(`[ThemeProvider] ignoring unknown theme '${n}'`), e);
}, wf = (e, t) => e === "system" ? t : e, Lr = typeof window < "u" ? ne.useLayoutEffect : ne.useEffect, Oc = ({
  children: e,
  initialDensity: t = "standard",
  initialMode: n,
  initialTheme: r,
  themes: o
}) => {
  if (o.length === 0) throw new Error("ThemeProvider requires at least one theme.");
  const [s, i] = ne.useState(() => gi(r, o)), [a, c] = ne.useState(() => mi(n)), [l, u] = ne.useState(() => pi(t)), [d, f] = ne.useState("light"), p = wf(a, d), m = ne.useRef(a), R = ne.useRef(l), b = ne.useRef(s);
  m.current = a, R.current = l, b.current = s, Lr(() => {
    Ps.setTheme(s);
  }, [s]), Lr(() => {
    Ps.setMode(p);
  }, [p]), Lr(() => {
    vf(l);
  }, [l]), ne.useEffect(() => {
    typeof window > "u" || typeof window.matchMedia != "function" || f(Pe.getSystemThemePreference());
  }, []), ne.useEffect(() => {
    if (typeof window > "u" || typeof window.matchMedia != "function") return;
    const y = window.matchMedia("(prefers-color-scheme: dark)"), E = (A) => {
      f(A.matches ? "dark" : "light");
    };
    return y.addEventListener("change", E), () => y.removeEventListener("change", E);
  }, []), ne.useEffect(() => {
    if (typeof window > "u") return;
    const y = (E) => {
      if (E.key !== null) {
        if (E.key === `${zn}${Jo}`) {
          const A = mi(m.current);
          A !== m.current && c(A);
        } else if (E.key === `${zn}${Gn}`) {
          const A = pi(R.current);
          A !== R.current && u(A);
        } else if (E.key === `${zn}${Qo}`) {
          const A = gi(b.current, o);
          A !== b.current && i(A);
        }
      }
    };
    return window.addEventListener("storage", y), () => window.removeEventListener("storage", y);
  }, [o]);
  const _ = ne.useCallback((y) => {
    Oe.set(Jo, y), c(y);
  }, []), k = ne.useCallback((y) => {
    Oe.set(Qo, y), i(y);
  }, []), S = ne.useCallback((y) => {
    Oe.set(Gn, y), u(y);
  }, []), w = ne.useCallback(() => {
    u((y) => {
      const E = jr.indexOf(y), A = jr[(E + 1) % jr.length];
      return Oe.set(Gn, A), A;
    });
  }, []), h = ne.useMemo(() => o.map((y) => ({
    displayName: y.displayName ?? y.name,
    name: y.name
  })), [o]), g = ne.useMemo(() => ({
    available: h,
    current: s,
    cycleDensity: w,
    density: l,
    mode: a,
    resolvedMode: p,
    setDensity: S,
    setMode: _,
    setTheme: k
  }), [h, s, w, l, a, p, S, _, k]);
  return /* @__PURE__ */ C.jsx(un.Provider, { value: g, children: e });
};
class Ny {
  /**
   * @param options - Construction options.
   * @param options.httpClient - The `HttpClientAlpha` instance (or compatible `IHttpClient`).
   * @param options.serviceKey - The `apiConfig` key for the metrics-service (eg: `'@blufin/metrics-service'`).
   */
  constructor(t) {
    N(this, "_httpClient");
    N(this, "_serviceKey");
    this._httpClient = t.httpClient, this._serviceKey = t.serviceKey;
  }
  /**
   * Send a batch to the metrics-service via the configured HTTP client.
   * @param endpoint - Wire endpoint discriminator (`/v1/logs` or `/v1/metrics`).
   * @param body - The agent context + events payload.
   * @param body.context - The agent context snapshot sent alongside the batch.
   * @param body.events - The batch of log or metric events.
   */
  async send(t, n) {
    try {
      await this._httpClient.post(this._serviceKey, ot.HMAC, t, n, {
        retry: {
          maxRetries: 0
        },
        surfaceHttpStatus: !0
      });
    } catch (r) {
      const o = r.statusCode, s = r instanceof Error ? r.message : typeof r == "string" ? r : JSON.stringify(r);
      throw new sn(s, {
        retryable: ec(o ?? null),
        statusCode: o
      });
    }
  }
}
var Rn = { exports: {} }, Hr = {}, yi;
function kc() {
  if (yi) return Hr;
  yi = 1;
  function e(n) {
    if (typeof WeakMap != "function") return null;
    var r = /* @__PURE__ */ new WeakMap(), o = /* @__PURE__ */ new WeakMap();
    return (e = function(s) {
      return s ? o : r;
    })(n);
  }
  function t(n, r) {
    if (!r && n && n.__esModule) return n;
    if (n === null || typeof n != "object" && typeof n != "function") return { default: n };
    var o = e(r);
    if (o && o.has(n)) return o.get(n);
    var s = { __proto__: null }, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var a in n)
      if (a !== "default" && Object.prototype.hasOwnProperty.call(n, a)) {
        var c = i ? Object.getOwnPropertyDescriptor(n, a) : null;
        c && (c.get || c.set) ? Object.defineProperty(s, a, c) : s[a] = n[a];
      }
    return s.default = n, o && o.set(n, s), s;
  }
  return Hr._ = t, Hr;
}
var Ur = {}, qr = {}, _i;
function Rf() {
  if (_i) return qr;
  _i = 1;
  function e(t) {
    return t && t.__esModule ? t : { default: t };
  }
  return qr._ = e, qr;
}
var bi;
function Sf() {
  return bi || (bi = 1, (function(e) {
    "use client";
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(l, u) {
      for (var d in u) Object.defineProperty(l, d, {
        enumerable: !0,
        get: u[d]
      });
    }
    t(e, {
      AppRouterContext: function() {
        return o;
      },
      GlobalLayoutRouterContext: function() {
        return i;
      },
      LayoutRouterContext: function() {
        return s;
      },
      MissingSlotContext: function() {
        return c;
      },
      TemplateContext: function() {
        return a;
      }
    });
    const r = /* @__PURE__ */ (/* @__PURE__ */ Rf())._(ce), o = r.default.createContext(null), s = r.default.createContext(null), i = r.default.createContext(null), a = r.default.createContext(null);
    process.env.NODE_ENV !== "production" && (o.displayName = "AppRouterContext", s.displayName = "LayoutRouterContext", i.displayName = "GlobalLayoutRouterContext", a.displayName = "TemplateContext");
    const c = r.default.createContext(/* @__PURE__ */ new Set());
  })(Ur)), Ur;
}
var Fr = {}, Sn = { exports: {} }, Ei;
function Pc() {
  return Ei || (Ei = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "ReadonlyURLSearchParams", {
      enumerable: !0,
      get: function() {
        return r;
      }
    });
    class n extends Error {
      constructor() {
        super("Method unavailable on `ReadonlyURLSearchParams`. Read more: https://nextjs.org/docs/app/api-reference/functions/use-search-params#updating-searchparams");
      }
    }
    class r extends URLSearchParams {
      /** @deprecated Method unavailable on `ReadonlyURLSearchParams`. Read more: https://nextjs.org/docs/app/api-reference/functions/use-search-params#updating-searchparams */
      append() {
        throw new n();
      }
      /** @deprecated Method unavailable on `ReadonlyURLSearchParams`. Read more: https://nextjs.org/docs/app/api-reference/functions/use-search-params#updating-searchparams */
      delete() {
        throw new n();
      }
      /** @deprecated Method unavailable on `ReadonlyURLSearchParams`. Read more: https://nextjs.org/docs/app/api-reference/functions/use-search-params#updating-searchparams */
      set() {
        throw new n();
      }
      /** @deprecated Method unavailable on `ReadonlyURLSearchParams`. Read more: https://nextjs.org/docs/app/api-reference/functions/use-search-params#updating-searchparams */
      sort() {
        throw new n();
      }
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  })(Sn, Sn.exports)), Sn.exports;
}
var vi;
function Tf() {
  return vi || (vi = 1, (function(e) {
    "use client";
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(l, u) {
      for (var d in u) Object.defineProperty(l, d, {
        enumerable: !0,
        get: u[d]
      });
    }
    t(e, {
      NavigationPromisesContext: function() {
        return a;
      },
      PathParamsContext: function() {
        return i;
      },
      PathnameContext: function() {
        return s;
      },
      ReadonlyURLSearchParams: function() {
        return r.ReadonlyURLSearchParams;
      },
      SearchParamsContext: function() {
        return o;
      },
      createDevToolsInstrumentedPromise: function() {
        return c;
      }
    });
    const n = ce, r = Pc(), o = (0, n.createContext)(null), s = (0, n.createContext)(null), i = (0, n.createContext)(null), a = (0, n.createContext)(null);
    function c(l, u) {
      const d = Promise.resolve(u);
      return d.status = "fulfilled", d.value = u, d.displayName = `${l} (SSR)`, d;
    }
    process.env.NODE_ENV !== "production" && (o.displayName = "SearchParamsContext", s.displayName = "PathnameContext", i.displayName = "PathParamsContext", a.displayName = "NavigationPromisesContext");
  })(Fr)), Fr;
}
var Br = {}, wi;
function xc() {
  return wi || (wi = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(d, f) {
      for (var p in f) Object.defineProperty(d, p, {
        enumerable: !0,
        get: f[p]
      });
    }
    t(e, {
      DEFAULT_SEGMENT_KEY: function() {
        return l;
      },
      NOT_FOUND_SEGMENT_KEY: function() {
        return u;
      },
      PAGE_SEGMENT_KEY: function() {
        return c;
      },
      addSearchParamsIfPageSegment: function() {
        return s;
      },
      computeSelectedLayoutSegment: function() {
        return i;
      },
      getSegmentValue: function() {
        return n;
      },
      getSelectedLayoutSegmentPath: function() {
        return a;
      },
      isGroupSegment: function() {
        return r;
      },
      isParallelRouteSegment: function() {
        return o;
      }
    });
    function n(d) {
      return Array.isArray(d) ? d[1] : d;
    }
    function r(d) {
      return d[0] === "(" && d.endsWith(")");
    }
    function o(d) {
      return d.startsWith("@") && d !== "@children";
    }
    function s(d, f) {
      if (d.includes(c)) {
        const m = JSON.stringify(f);
        return m !== "{}" ? c + "?" + m : c;
      }
      return d;
    }
    function i(d, f) {
      if (!d || d.length === 0)
        return null;
      const p = f === "children" ? d[0] : d[d.length - 1];
      return p === l ? null : p;
    }
    function a(d, f, p = !0, m = []) {
      let R;
      if (p)
        R = d[1][f];
      else {
        const k = d[1];
        R = k.children ?? Object.values(k)[0];
      }
      if (!R) return m;
      const b = R[0];
      let _ = n(b);
      return !_ || _.startsWith(c) ? m : (m.push(_), a(R, f, !1, m));
    }
    const c = "__PAGE__", l = "__DEFAULT__", u = "/_not-found";
  })(Br)), Br;
}
var $r = {}, Ri;
function Af() {
  return Ri || (Ri = 1, (function(e) {
    "use client";
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(i, a) {
      for (var c in a) Object.defineProperty(i, c, {
        enumerable: !0,
        get: a[c]
      });
    }
    t(e, {
      ServerInsertedHTMLContext: function() {
        return o;
      },
      useServerInsertedHTML: function() {
        return s;
      }
    });
    const r = /* @__PURE__ */ (/* @__PURE__ */ kc())._(ce), o = /* @__PURE__ */ r.default.createContext(null);
    function s(i) {
      const a = (0, r.useContext)(o);
      a && a(i);
    }
  })($r)), $r;
}
var Tn = { exports: {} }, Si;
function Cf() {
  return Si || (Si = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(s, i) {
      for (var a in i) Object.defineProperty(s, a, {
        enumerable: !0,
        get: i[a]
      });
    }
    n(t, {
      UnrecognizedActionError: function() {
        return r;
      },
      unstable_isUnrecognizedActionError: function() {
        return o;
      }
    });
    class r extends Error {
      constructor(...i) {
        super(...i), this.name = "UnrecognizedActionError";
      }
    }
    function o(s) {
      return !!(s && typeof s == "object" && s instanceof r);
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  })(Tn, Tn.exports)), Tn.exports;
}
var An = { exports: {} }, Cn = { exports: {} }, On = { exports: {} }, Ti;
function Ic() {
  return Ti || (Ti = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "RedirectStatusCode", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    var n = /* @__PURE__ */ (function(r) {
      return r[r.SeeOther = 303] = "SeeOther", r[r.TemporaryRedirect = 307] = "TemporaryRedirect", r[r.PermanentRedirect = 308] = "PermanentRedirect", r;
    })({});
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  })(On, On.exports)), On.exports;
}
var kn = { exports: {} }, Ai;
function Nc() {
  return Ai || (Ai = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(i, a) {
      for (var c in a) Object.defineProperty(i, c, {
        enumerable: !0,
        get: a[c]
      });
    }
    n(t, {
      REDIRECT_ERROR_CODE: function() {
        return o;
      },
      isRedirectError: function() {
        return s;
      }
    });
    const r = Ic(), o = "NEXT_REDIRECT";
    function s(i) {
      if (typeof i != "object" || i === null || !("digest" in i) || typeof i.digest != "string")
        return !1;
      const a = i.digest.split(";"), [c, l] = a, u = a.slice(2, -2).join(";"), d = a.at(-2), f = Number(d);
      return c === o && (l === "replace" || l === "push") && typeof u == "string" && !isNaN(f) && f in r.RedirectStatusCode;
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  })(kn, kn.exports)), kn.exports;
}
var Wr = {}, zr = {}, Gr = {}, Ci;
function ys() {
  return Ci || (Ci = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(c, l) {
      for (var u in l) Object.defineProperty(c, u, {
        enumerable: !0,
        get: l[u]
      });
    }
    t(e, {
      bindSnapshot: function() {
        return i;
      },
      createAsyncLocalStorage: function() {
        return s;
      },
      createSnapshot: function() {
        return a;
      }
    });
    const n = Object.defineProperty(new Error("Invariant: AsyncLocalStorage accessed in runtime where it is not available"), "__NEXT_ERROR_CODE", {
      value: "E504",
      enumerable: !1,
      configurable: !0
    });
    class r {
      disable() {
        throw n;
      }
      getStore() {
      }
      run() {
        throw n;
      }
      exit() {
        throw n;
      }
      enterWith() {
        throw n;
      }
      static bind(l) {
        return l;
      }
    }
    const o = typeof globalThis < "u" && globalThis.AsyncLocalStorage;
    function s() {
      return o ? new o() : new r();
    }
    function i(c) {
      return o ? o.bind(c) : r.bind(c);
    }
    function a() {
      return o ? o.snapshot() : function(c, ...l) {
        return c(...l);
      };
    }
  })(Gr)), Gr;
}
var Oi;
function Of() {
  return Oi || (Oi = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "actionAsyncStorageInstance", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const n = (0, ys().createAsyncLocalStorage)();
  })(zr)), zr;
}
var ki;
function kf() {
  return ki || (ki = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "actionAsyncStorage", {
      enumerable: !0,
      get: function() {
        return t.actionAsyncStorageInstance;
      }
    });
    const t = Of();
  })(Wr)), Wr;
}
var Pi;
function Pf() {
  return Pi || (Pi = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(f, p) {
      for (var m in p) Object.defineProperty(f, m, {
        enumerable: !0,
        get: p[m]
      });
    }
    n(t, {
      getRedirectError: function() {
        return i;
      },
      getRedirectStatusCodeFromError: function() {
        return d;
      },
      getRedirectTypeFromError: function() {
        return u;
      },
      getURLFromRedirectError: function() {
        return l;
      },
      permanentRedirect: function() {
        return c;
      },
      redirect: function() {
        return a;
      }
    });
    const r = Ic(), o = Nc(), s = typeof window > "u" ? kf().actionAsyncStorage : void 0;
    function i(f, p, m = r.RedirectStatusCode.TemporaryRedirect) {
      const R = Object.defineProperty(new Error(o.REDIRECT_ERROR_CODE), "__NEXT_ERROR_CODE", {
        value: "E394",
        enumerable: !1,
        configurable: !0
      });
      return R.digest = `${o.REDIRECT_ERROR_CODE};${p};${f};${m};`, R;
    }
    function a(f, p) {
      throw p ?? (p = s?.getStore()?.isAction ? "push" : "replace"), i(f, p, r.RedirectStatusCode.TemporaryRedirect);
    }
    function c(f, p = "replace") {
      throw i(f, p, r.RedirectStatusCode.PermanentRedirect);
    }
    function l(f) {
      return (0, o.isRedirectError)(f) ? f.digest.split(";").slice(2, -2).join(";") : null;
    }
    function u(f) {
      if (!(0, o.isRedirectError)(f))
        throw Object.defineProperty(new Error("Not a redirect error"), "__NEXT_ERROR_CODE", {
          value: "E260",
          enumerable: !1,
          configurable: !0
        });
      return f.digest.split(";", 2)[1];
    }
    function d(f) {
      if (!(0, o.isRedirectError)(f))
        throw Object.defineProperty(new Error("Not a redirect error"), "__NEXT_ERROR_CODE", {
          value: "E260",
          enumerable: !1,
          configurable: !0
        });
      return Number(f.digest.split(";").at(-2));
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  })(Cn, Cn.exports)), Cn.exports;
}
var Pn = { exports: {} }, xn = { exports: {} }, xi;
function cr() {
  return xi || (xi = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(l, u) {
      for (var d in u) Object.defineProperty(l, d, {
        enumerable: !0,
        get: u[d]
      });
    }
    n(t, {
      HTTPAccessErrorStatus: function() {
        return r;
      },
      HTTP_ERROR_FALLBACK_ERROR_CODE: function() {
        return s;
      },
      getAccessFallbackErrorTypeByStatus: function() {
        return c;
      },
      getAccessFallbackHTTPStatus: function() {
        return a;
      },
      isHTTPAccessFallbackError: function() {
        return i;
      }
    });
    const r = {
      NOT_FOUND: 404,
      FORBIDDEN: 403,
      UNAUTHORIZED: 401
    }, o = new Set(Object.values(r)), s = "NEXT_HTTP_ERROR_FALLBACK";
    function i(l) {
      if (typeof l != "object" || l === null || !("digest" in l) || typeof l.digest != "string")
        return !1;
      const [u, d] = l.digest.split(";");
      return u === s && o.has(Number(d));
    }
    function a(l) {
      const u = l.digest.split(";")[1];
      return Number(u);
    }
    function c(l) {
      switch (l) {
        case 401:
          return "unauthorized";
        case 403:
          return "forbidden";
        case 404:
          return "not-found";
        default:
          return;
      }
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  })(xn, xn.exports)), xn.exports;
}
var Ii;
function xf() {
  return Ii || (Ii = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "notFound", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const r = `${cr().HTTP_ERROR_FALLBACK_ERROR_CODE};404`;
    function o() {
      const s = Object.defineProperty(new Error(r), "__NEXT_ERROR_CODE", {
        value: "E1041",
        enumerable: !1,
        configurable: !0
      });
      throw s.digest = r, s;
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  })(Pn, Pn.exports)), Pn.exports;
}
var In = { exports: {} }, Ni;
function If() {
  return Ni || (Ni = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "forbidden", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const r = `${cr().HTTP_ERROR_FALLBACK_ERROR_CODE};403`;
    function o() {
      if (!process.env.__NEXT_EXPERIMENTAL_AUTH_INTERRUPTS)
        throw Object.defineProperty(new Error("`forbidden()` is experimental and only allowed to be enabled when `experimental.authInterrupts` is enabled."), "__NEXT_ERROR_CODE", {
          value: "E488",
          enumerable: !1,
          configurable: !0
        });
      const s = Object.defineProperty(new Error(r), "__NEXT_ERROR_CODE", {
        value: "E1019",
        enumerable: !1,
        configurable: !0
      });
      throw s.digest = r, s;
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  })(In, In.exports)), In.exports;
}
var Nn = { exports: {} }, Mi;
function Nf() {
  return Mi || (Mi = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "unauthorized", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const r = `${cr().HTTP_ERROR_FALLBACK_ERROR_CODE};401`;
    function o() {
      if (!process.env.__NEXT_EXPERIMENTAL_AUTH_INTERRUPTS)
        throw Object.defineProperty(new Error("`unauthorized()` is experimental and only allowed to be used when `experimental.authInterrupts` is enabled."), "__NEXT_ERROR_CODE", {
          value: "E411",
          enumerable: !1,
          configurable: !0
        });
      const s = Object.defineProperty(new Error(r), "__NEXT_ERROR_CODE", {
        value: "E1002",
        enumerable: !1,
        configurable: !0
      });
      throw s.digest = r, s;
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  })(Nn, Nn.exports)), Nn.exports;
}
var Mn = { exports: {} }, Dn = { exports: {} }, Xr = {}, Vr = {}, Kr = {}, Di;
function lr() {
  return Di || (Di = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "InvariantError", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    class t extends Error {
      constructor(r, o) {
        super(`Invariant: ${r.endsWith(".") ? r : r + "."} This is a bug in Next.js.`, o), this.name = "InvariantError";
      }
    }
  })(Kr)), Kr;
}
var Yr = {}, ji;
function Mf() {
  return ji || (ji = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "createPromiseWithResolvers", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t() {
      let n, r;
      const o = new Promise((s, i) => {
        n = s, r = i;
      });
      return {
        resolve: n,
        reject: r,
        promise: o
      };
    }
  })(Yr)), Yr;
}
var Li;
function Mc() {
  return Li || (Li = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(c, l) {
      for (var u in l) Object.defineProperty(c, u, {
        enumerable: !0,
        get: l[u]
      });
    }
    t(e, {
      RenderStage: function() {
        return o;
      },
      StagedRenderingController: function() {
        return s;
      }
    });
    const n = lr(), r = Mf();
    var o = /* @__PURE__ */ (function(c) {
      return c[c.Before = 1] = "Before", c[c.EarlyStatic = 2] = "EarlyStatic", c[c.Static = 3] = "Static", c[c.EarlyRuntime = 4] = "EarlyRuntime", c[c.Runtime = 5] = "Runtime", c[c.Dynamic = 6] = "Dynamic", c[c.Abandoned = 7] = "Abandoned", c;
    })({});
    class s {
      constructor(l, u, d) {
        this.abortSignal = l, this.abandonController = u, this.shouldTrackSyncIO = d, this.currentStage = 1, this.syncInterruptReason = null, this.staticStageEndTime = 1 / 0, this.runtimeStageEndTime = 1 / 0, this.staticStageListeners = [], this.earlyRuntimeStageListeners = [], this.runtimeStageListeners = [], this.dynamicStageListeners = [], this.staticStagePromise = (0, r.createPromiseWithResolvers)(), this.earlyRuntimeStagePromise = (0, r.createPromiseWithResolvers)(), this.runtimeStagePromise = (0, r.createPromiseWithResolvers)(), this.dynamicStagePromise = (0, r.createPromiseWithResolvers)(), l && l.addEventListener("abort", () => {
          const { reason: f } = l;
          this.staticStagePromise.promise.catch(i), this.staticStagePromise.reject(f), this.earlyRuntimeStagePromise.promise.catch(i), this.earlyRuntimeStagePromise.reject(f), this.runtimeStagePromise.promise.catch(i), this.runtimeStagePromise.reject(f), this.dynamicStagePromise.promise.catch(i), this.dynamicStagePromise.reject(f);
        }, {
          once: !0
        }), u && u.signal.addEventListener("abort", () => {
          this.abandonRender();
        }, {
          once: !0
        });
      }
      onStage(l, u) {
        if (this.currentStage >= l)
          u();
        else if (l === 3)
          this.staticStageListeners.push(u);
        else if (l === 4)
          this.earlyRuntimeStageListeners.push(u);
        else if (l === 5)
          this.runtimeStageListeners.push(u);
        else if (l === 6)
          this.dynamicStageListeners.push(u);
        else
          throw Object.defineProperty(new n.InvariantError(`Invalid render stage: ${l}`), "__NEXT_ERROR_CODE", {
            value: "E881",
            enumerable: !1,
            configurable: !0
          });
      }
      shouldTrackSyncInterrupt() {
        if (!this.shouldTrackSyncIO)
          return !1;
        switch (this.currentStage) {
          case 1:
            return !1;
          case 2:
          case 3:
            return !0;
          case 4:
            return !0;
          case 5:
            return !1;
          case 6:
          case 7:
            return !1;
          default:
            return !1;
        }
      }
      syncInterruptCurrentStageWithReason(l) {
        if (this.currentStage !== 1 && this.currentStage !== 7) {
          if (this.abandonController) {
            this.abandonController.abort();
            return;
          }
          if (this.abortSignal) {
            this.syncInterruptReason = l, this.currentStage = 7;
            return;
          }
          switch (this.currentStage) {
            case 2:
            case 3:
            case 4: {
              this.syncInterruptReason = l, this.advanceStage(6);
              return;
            }
            case 5:
              return;
          }
        }
      }
      getSyncInterruptReason() {
        return this.syncInterruptReason;
      }
      getStaticStageEndTime() {
        return this.staticStageEndTime;
      }
      getRuntimeStageEndTime() {
        return this.runtimeStageEndTime;
      }
      abandonRender() {
        const { currentStage: l } = this;
        switch (l) {
          case 2:
            this.resolveStaticStage();
          // intentional fallthrough
          case 3:
            this.resolveEarlyRuntimeStage();
          // intentional fallthrough
          case 4:
            this.resolveRuntimeStage();
          // intentional fallthrough
          case 5: {
            this.currentStage = 7;
            return;
          }
        }
      }
      advanceStage(l) {
        if (l <= this.currentStage)
          return;
        let u = this.currentStage;
        if (this.currentStage = l, u < 3 && l >= 3 && this.resolveStaticStage(), u < 4 && l >= 4 && this.resolveEarlyRuntimeStage(), u < 5 && l >= 5 && (this.staticStageEndTime = performance.now() + performance.timeOrigin, this.resolveRuntimeStage()), u < 6 && l >= 6) {
          this.runtimeStageEndTime = performance.now() + performance.timeOrigin, this.resolveDynamicStage();
          return;
        }
      }
      /** Fire the `onStage` listeners for the static stage and unblock any promises waiting for it. */
      resolveStaticStage() {
        const l = this.staticStageListeners;
        for (let u = 0; u < l.length; u++)
          l[u]();
        l.length = 0, this.staticStagePromise.resolve();
      }
      /** Fire the `onStage` listeners for the early runtime stage and unblock any promises waiting for it. */
      resolveEarlyRuntimeStage() {
        const l = this.earlyRuntimeStageListeners;
        for (let u = 0; u < l.length; u++)
          l[u]();
        l.length = 0, this.earlyRuntimeStagePromise.resolve();
      }
      /** Fire the `onStage` listeners for the runtime stage and unblock any promises waiting for it. */
      resolveRuntimeStage() {
        const l = this.runtimeStageListeners;
        for (let u = 0; u < l.length; u++)
          l[u]();
        l.length = 0, this.runtimeStagePromise.resolve();
      }
      /** Fire the `onStage` listeners for the dynamic stage and unblock any promises waiting for it. */
      resolveDynamicStage() {
        const l = this.dynamicStageListeners;
        for (let u = 0; u < l.length; u++)
          l[u]();
        l.length = 0, this.dynamicStagePromise.resolve();
      }
      getStagePromise(l) {
        switch (l) {
          case 3:
            return this.staticStagePromise.promise;
          case 4:
            return this.earlyRuntimeStagePromise.promise;
          case 5:
            return this.runtimeStagePromise.promise;
          case 6:
            return this.dynamicStagePromise.promise;
          default:
            throw Object.defineProperty(new n.InvariantError(`Invalid render stage: ${l}`), "__NEXT_ERROR_CODE", {
              value: "E881",
              enumerable: !1,
              configurable: !0
            });
        }
      }
      waitForStage(l) {
        return this.getStagePromise(l);
      }
      delayUntilStage(l, u, d) {
        const f = this.getStagePromise(l), p = a(f, u, d);
        return this.abortSignal && p.catch(i), p;
      }
    }
    function i() {
    }
    function a(c, l, u) {
      const d = new Promise((f, p) => {
        c.then(f.bind(null, u), p);
      });
      return l !== void 0 && (d.displayName = l), d;
    }
  })(Vr)), Vr;
}
var Hi;
function Dc() {
  return Hi || (Hi = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(f, p) {
      for (var m in p) Object.defineProperty(f, m, {
        enumerable: !0,
        get: p[m]
      });
    }
    t(e, {
      delayUntilRuntimeStage: function() {
        return d;
      },
      getRuntimeStage: function() {
        return u;
      },
      isHangingPromiseRejectionError: function() {
        return r;
      },
      makeDevtoolsIOAwarePromise: function() {
        return l;
      },
      makeHangingPromise: function() {
        return a;
      }
    });
    const n = Mc();
    function r(f) {
      return typeof f != "object" || f === null || !("digest" in f) ? !1 : f.digest === o;
    }
    const o = "HANGING_PROMISE_REJECTION";
    class s extends Error {
      constructor(p, m) {
        super(`During prerendering, ${m} rejects when the prerender is complete. Typically these errors are handled by React but if you move ${m} to a different context by using \`setTimeout\`, \`after\`, or similar functions you may observe this error and you should handle it in that context. This occurred at route "${p}".`), this.route = p, this.expression = m, this.digest = o;
      }
    }
    const i = /* @__PURE__ */ new WeakMap();
    function a(f, p, m) {
      if (f.aborted)
        return Promise.reject(new s(p, m));
      {
        const R = new Promise((b, _) => {
          const k = _.bind(null, new s(p, m));
          let S = i.get(f);
          if (S)
            S.push(k);
          else {
            const w = [
              k
            ];
            i.set(f, w), f.addEventListener("abort", () => {
              for (let h = 0; h < w.length; h++)
                w[h]();
            }, {
              once: !0
            });
          }
        });
        return R.catch(c), R;
      }
    }
    function c() {
    }
    function l(f, p, m) {
      return p.stagedRendering ? p.stagedRendering.delayUntilStage(m, void 0, f) : new Promise((R) => {
        setTimeout(() => {
          R(f);
        }, 0);
      });
    }
    function u(f) {
      return f.currentStage === n.RenderStage.EarlyStatic || f.currentStage === n.RenderStage.EarlyRuntime ? n.RenderStage.EarlyRuntime : n.RenderStage.Runtime;
    }
    function d(f, p) {
      const { stagedRendering: m } = f;
      return m ? m.waitForStage(u(m)).then(() => p) : p;
    }
  })(Xr)), Xr;
}
var Jr = {}, Ui;
function Df() {
  return Ui || (Ui = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "isPostpone", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const t = /* @__PURE__ */ Symbol.for("react.postpone");
    function n(r) {
      return typeof r == "object" && r !== null && r.$$typeof === t;
    }
  })(Jr)), Jr;
}
var Qr = {}, qi;
function _s() {
  return qi || (qi = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(s, i) {
      for (var a in i) Object.defineProperty(s, a, {
        enumerable: !0,
        get: i[a]
      });
    }
    t(e, {
      BailoutToCSRError: function() {
        return r;
      },
      isBailoutToCSRError: function() {
        return o;
      }
    });
    const n = "BAILOUT_TO_CLIENT_SIDE_RENDERING";
    class r extends Error {
      constructor(i) {
        super(`Bail out to client-side rendering: ${i}`), this.reason = i, this.digest = n;
      }
    }
    function o(s) {
      return typeof s != "object" || s === null || !("digest" in s) ? !1 : s.digest === n;
    }
  })(Qr)), Qr;
}
var jn = { exports: {} }, Fi;
function jc() {
  return Fi || (Fi = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "isNextRouterError", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const n = cr(), r = Nc();
    function o(s) {
      return (0, r.isRedirectError)(s) || (0, n.isHTTPAccessFallbackError)(s);
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  })(jn, jn.exports)), jn.exports;
}
var Zr = {}, Ln = { exports: {} }, Bi;
function Lc() {
  return Bi || (Bi = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(i, a) {
      for (var c in a) Object.defineProperty(i, c, {
        enumerable: !0,
        get: a[c]
      });
    }
    n(t, {
      DynamicServerError: function() {
        return o;
      },
      isDynamicServerError: function() {
        return s;
      }
    });
    const r = "DYNAMIC_SERVER_USAGE";
    class o extends Error {
      constructor(a) {
        super(`Dynamic server usage: ${a}`), this.description = a, this.digest = r;
      }
    }
    function s(i) {
      return typeof i != "object" || i === null || !("digest" in i) || typeof i.digest != "string" ? !1 : i.digest === r;
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  })(Ln, Ln.exports)), Ln.exports;
}
var Hn = { exports: {} }, $i;
function jf() {
  return $i || ($i = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(i, a) {
      for (var c in a) Object.defineProperty(i, c, {
        enumerable: !0,
        get: a[c]
      });
    }
    n(t, {
      StaticGenBailoutError: function() {
        return o;
      },
      isStaticGenBailoutError: function() {
        return s;
      }
    });
    const r = "NEXT_STATIC_GEN_BAILOUT";
    class o extends Error {
      constructor(...a) {
        super(...a), this.code = r;
      }
    }
    function s(i) {
      return typeof i != "object" || i === null || !("code" in i) ? !1 : i.code === r;
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  })(Hn, Hn.exports)), Hn.exports;
}
var eo = {}, to = {}, Wi;
function Lf() {
  return Wi || (Wi = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "workUnitAsyncStorageInstance", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const n = (0, ys().createAsyncLocalStorage)();
  })(to)), to;
}
var Un = { exports: {} }, zi;
function Hf() {
  return zi || (zi = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(A, H) {
      for (var x in H) Object.defineProperty(A, x, {
        enumerable: !0,
        get: H[x]
      });
    }
    n(t, {
      ACTION_HEADER: function() {
        return o;
      },
      FLIGHT_HEADERS: function() {
        return m;
      },
      NEXT_ACTION_NOT_FOUND_HEADER: function() {
        return h;
      },
      NEXT_ACTION_REVALIDATED_HEADER: function() {
        return E;
      },
      NEXT_DID_POSTPONE_HEADER: function() {
        return _;
      },
      NEXT_HMR_REFRESH_HASH_COOKIE: function() {
        return l;
      },
      NEXT_HMR_REFRESH_HEADER: function() {
        return c;
      },
      NEXT_HTML_REQUEST_ID_HEADER: function() {
        return y;
      },
      NEXT_INSTANT_PREFETCH_HEADER: function() {
        return f;
      },
      NEXT_INSTANT_TEST_COOKIE: function() {
        return p;
      },
      NEXT_IS_PRERENDER_HEADER: function() {
        return w;
      },
      NEXT_REQUEST_ID_HEADER: function() {
        return g;
      },
      NEXT_REWRITTEN_PATH_HEADER: function() {
        return k;
      },
      NEXT_REWRITTEN_QUERY_HEADER: function() {
        return S;
      },
      NEXT_ROUTER_PREFETCH_HEADER: function() {
        return i;
      },
      NEXT_ROUTER_SEGMENT_PREFETCH_HEADER: function() {
        return a;
      },
      NEXT_ROUTER_STALE_TIME_HEADER: function() {
        return b;
      },
      NEXT_ROUTER_STATE_TREE_HEADER: function() {
        return s;
      },
      NEXT_RSC_UNION_QUERY: function() {
        return R;
      },
      NEXT_URL: function() {
        return u;
      },
      RSC_CONTENT_TYPE_HEADER: function() {
        return d;
      },
      RSC_HEADER: function() {
        return r;
      }
    });
    const r = "rsc", o = "next-action", s = "next-router-state-tree", i = "next-router-prefetch", a = "next-router-segment-prefetch", c = "next-hmr-refresh", l = "__next_hmr_refresh_hash__", u = "next-url", d = "text/x-component", f = "next-instant-navigation-testing-prefetch", p = "next-instant-navigation-testing", m = [
      r,
      s,
      i,
      c,
      a
    ], R = "_rsc", b = "x-nextjs-stale-time", _ = "x-nextjs-postponed", k = "x-nextjs-rewritten-path", S = "x-nextjs-rewritten-query", w = "x-nextjs-prerender", h = "x-nextjs-action-not-found", g = "x-nextjs-request-id", y = "x-nextjs-html-request-id", E = "x-action-revalidated";
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  })(Un, Un.exports)), Un.exports;
}
var Gi;
function bs() {
  return Gi || (Gi = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(_, k) {
      for (var S in k) Object.defineProperty(_, S, {
        enumerable: !0,
        get: k[S]
      });
    }
    t(e, {
      getCacheSignal: function() {
        return b;
      },
      getDraftModeProviderForCacheScope: function() {
        return m;
      },
      getHmrRefreshHash: function() {
        return d;
      },
      getPrerenderResumeDataCache: function() {
        return l;
      },
      getRenderResumeDataCache: function() {
        return u;
      },
      getServerComponentsHmrCache: function() {
        return p;
      },
      getStagedRenderingController: function() {
        return R;
      },
      isHmrRefresh: function() {
        return f;
      },
      isInEarlyRenderStage: function() {
        return i;
      },
      throwForMissingRequestStore: function() {
        return a;
      },
      throwInvariantForMissingStore: function() {
        return c;
      },
      workUnitAsyncStorage: function() {
        return n.workUnitAsyncStorageInstance;
      }
    });
    const n = Lf(), r = Hf(), o = lr(), s = Mc();
    function i(_) {
      const k = _.stagedRendering;
      return k ? k.currentStage === s.RenderStage.EarlyStatic || k.currentStage === s.RenderStage.EarlyRuntime : !1;
    }
    function a(_) {
      throw Object.defineProperty(new Error(`\`${_}\` was called outside a request scope. Read more: https://nextjs.org/docs/messages/next-dynamic-api-wrong-context`), "__NEXT_ERROR_CODE", {
        value: "E251",
        enumerable: !1,
        configurable: !0
      });
    }
    function c() {
      throw Object.defineProperty(new o.InvariantError("Expected workUnitAsyncStorage to have a store."), "__NEXT_ERROR_CODE", {
        value: "E696",
        enumerable: !1,
        configurable: !0
      });
    }
    function l(_) {
      switch (_.type) {
        case "prerender":
        case "prerender-runtime":
        case "prerender-ppr":
          return _.prerenderResumeDataCache;
        case "prerender-client":
        case "validation-client":
          return _.prerenderResumeDataCache;
        case "request":
          if (_.prerenderResumeDataCache)
            return _.prerenderResumeDataCache;
        case "prerender-legacy":
        case "cache":
        case "private-cache":
        case "unstable-cache":
        case "generate-static-params":
          return null;
        default:
          return _;
      }
    }
    function u(_) {
      switch (_.type) {
        case "request":
        case "prerender":
        case "prerender-runtime":
        case "prerender-client":
        case "validation-client":
          if (_.renderResumeDataCache)
            return _.renderResumeDataCache;
        // fallthrough
        case "prerender-ppr":
          return _.prerenderResumeDataCache ?? null;
        case "cache":
        case "private-cache":
        case "unstable-cache":
        case "prerender-legacy":
        case "generate-static-params":
          return null;
        default:
          return _;
      }
    }
    function d(_) {
      if (process.env.__NEXT_DEV_SERVER)
        switch (_.type) {
          case "cache":
          case "private-cache":
          case "prerender":
          case "prerender-runtime":
            return _.hmrRefreshHash;
          case "request":
            var k;
            return (k = _.cookies.get(r.NEXT_HMR_REFRESH_HASH_COOKIE)) == null ? void 0 : k.value;
        }
    }
    function f(_) {
      if (process.env.__NEXT_DEV_SERVER)
        switch (_.type) {
          case "cache":
          case "private-cache":
          case "request":
            return _.isHmrRefresh ?? !1;
        }
      return !1;
    }
    function p(_) {
      if (process.env.__NEXT_DEV_SERVER)
        switch (_.type) {
          case "cache":
          case "private-cache":
          case "request":
            return _.serverComponentsHmrCache;
        }
    }
    function m(_, k) {
      if (_.isDraftMode)
        switch (k.type) {
          case "cache":
          case "private-cache":
          case "unstable-cache":
          case "prerender-runtime":
          case "request":
            return k.draftMode;
        }
    }
    function R(_) {
      switch (_.type) {
        case "request":
        case "prerender-runtime":
          return _.stagedRendering ?? null;
        case "prerender":
        case "prerender-client":
        case "validation-client":
        case "prerender-ppr":
        case "prerender-legacy":
        case "cache":
        case "private-cache":
        case "unstable-cache":
        case "generate-static-params":
          return null;
        default:
          return _;
      }
    }
    function b(_) {
      switch (_.type) {
        case "prerender":
        case "prerender-client":
        case "validation-client":
        case "prerender-runtime":
          return _.cacheSignal;
        case "request":
          if (_.cacheSignal)
            return _.cacheSignal;
        case "prerender-ppr":
        case "prerender-legacy":
        case "cache":
        case "private-cache":
        case "unstable-cache":
        case "generate-static-params":
          return null;
        default:
          return _;
      }
    }
  })(eo)), eo;
}
var no = {}, ro = {}, Xi;
function Uf() {
  return Xi || (Xi = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "workAsyncStorageInstance", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const n = (0, ys().createAsyncLocalStorage)();
  })(ro)), ro;
}
var Vi;
function Es() {
  return Vi || (Vi = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "workAsyncStorage", {
      enumerable: !0,
      get: function() {
        return t.workAsyncStorageInstance;
      }
    });
    const t = Uf();
  })(no)), no;
}
var oo = {}, Ki;
function qf() {
  return Ki || (Ki = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(i, a) {
      for (var c in a) Object.defineProperty(i, c, {
        enumerable: !0,
        get: a[c]
      });
    }
    t(e, {
      METADATA_BOUNDARY_NAME: function() {
        return n;
      },
      OUTLET_BOUNDARY_NAME: function() {
        return o;
      },
      ROOT_LAYOUT_BOUNDARY_NAME: function() {
        return s;
      },
      VIEWPORT_BOUNDARY_NAME: function() {
        return r;
      }
    });
    const n = "__next_metadata_boundary__", r = "__next_viewport_boundary__", o = "__next_outlet_boundary__", s = "__next_root_layout_boundary__";
  })(oo)), oo;
}
var so = {}, Yi;
function Ff() {
  return Yi || (Yi = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(i, a) {
      for (var c in a) Object.defineProperty(i, c, {
        enumerable: !0,
        get: a[c]
      });
    }
    t(e, {
      atLeastOneTask: function() {
        return o;
      },
      scheduleImmediate: function() {
        return r;
      },
      scheduleOnNextTick: function() {
        return n;
      },
      waitAtLeastOneReactRenderTask: function() {
        return s;
      }
    });
    const n = (i) => {
      Promise.resolve().then(() => {
        process.env.NEXT_RUNTIME === "edge" ? setTimeout(i, 0) : process.nextTick(i);
      });
    }, r = (i) => {
      process.env.NEXT_RUNTIME === "edge" ? setTimeout(i, 0) : setImmediate(i);
    };
    function o() {
      return new Promise((i) => r(i));
    }
    function s() {
      return process.env.NEXT_RUNTIME === "edge" ? new Promise((i) => setTimeout(i, 0)) : new Promise((i) => setImmediate(i));
    }
  })(so)), so;
}
var io = {}, Ji;
function Bf() {
  return Ji || (Ji = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "INSTANT_VALIDATION_BOUNDARY_NAME", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    const t = "__next_instant_validation_boundary__";
  })(io)), io;
}
var Qi;
function Zo() {
  return Qi || (Qi = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(v, P) {
      for (var O in P) Object.defineProperty(v, O, {
        enumerable: !0,
        get: P[O]
      });
    }
    t(e, {
      DynamicHoleKind: function() {
        return He;
      },
      Postpone: function() {
        return E;
      },
      PreludeState: function() {
        return Ft;
      },
      abortAndThrowOnSynchronousRequestDataAccess: function() {
        return y;
      },
      abortOnSynchronousPlatformIOAccess: function() {
        return g;
      },
      accessedDynamicData: function() {
        return z;
      },
      annotateDynamicAccess: function() {
        return q;
      },
      consumeDynamicAccess: function() {
        return V;
      },
      createDynamicTrackingState: function() {
        return R;
      },
      createDynamicValidationState: function() {
        return b;
      },
      createHangingInputAbortSignal: function() {
        return T;
      },
      createInstantValidationState: function() {
        return Ce;
      },
      createRenderInBrowserAbortSignal: function() {
        return ie;
      },
      formatDynamicAPIAccesses: function() {
        return D;
      },
      getFirstDynamicReason: function() {
        return _;
      },
      getNavigationDisallowedDynamicReasons: function() {
        return Ve;
      },
      getStaticShellDisallowedDynamicReasons: function() {
        return Xe;
      },
      isDynamicPostpone: function() {
        return x;
      },
      isPrerenderInterruptedError: function() {
        return U;
      },
      logDisallowedDynamicError: function() {
        return ct;
      },
      markCurrentScopeAsDynamic: function() {
        return k;
      },
      postponeWithTracking: function() {
        return A;
      },
      throwIfDisallowedDynamic: function() {
        return Ge;
      },
      throwToInterruptStaticGeneration: function() {
        return S;
      },
      trackAllowedDynamicAccess: function() {
        return ge;
      },
      trackDynamicDataInDynamicRender: function() {
        return w;
      },
      trackDynamicHoleInNavigation: function() {
        return Fe;
      },
      trackDynamicHoleInRuntimeShell: function() {
        return We;
      },
      trackDynamicHoleInStaticShell: function() {
        return ze;
      },
      trackThrownErrorInNavigation: function() {
        return Be;
      },
      useDynamicRouteParams: function() {
        return I;
      },
      useDynamicSearchParams: function() {
        return j;
      }
    });
    const n = /* @__PURE__ */ p(ce), r = Lc(), o = jf(), s = bs(), i = Es(), a = Dc(), c = qf(), l = Ff(), u = _s(), d = lr(), f = Bf();
    function p(v) {
      return v && v.__esModule ? v : {
        default: v
      };
    }
    const m = typeof n.default.unstable_postpone == "function";
    function R(v) {
      return {
        isDebugDynamicAccesses: v,
        dynamicAccesses: [],
        syncDynamicErrorWithStack: null
      };
    }
    function b() {
      return {
        hasSuspenseAboveBody: !1,
        hasDynamicMetadata: !1,
        dynamicMetadata: null,
        hasDynamicViewport: !1,
        hasAllowedDynamic: !1,
        dynamicErrors: []
      };
    }
    function _(v) {
      var P;
      return (P = v.dynamicAccesses[0]) == null ? void 0 : P.expression;
    }
    function k(v, P, O) {
      if (P)
        switch (P.type) {
          case "cache":
          case "unstable-cache":
            return;
          case "private-cache":
            return;
        }
      if (!(v.forceDynamic || v.forceStatic)) {
        if (v.dynamicShouldError)
          throw Object.defineProperty(new o.StaticGenBailoutError(`Route ${v.route} with \`dynamic = "error"\` couldn't be rendered statically because it used \`${O}\`. See more info here: https://nextjs.org/docs/app/building-your-application/rendering/static-and-dynamic#dynamic-rendering`), "__NEXT_ERROR_CODE", {
            value: "E553",
            enumerable: !1,
            configurable: !0
          });
        if (P)
          switch (P.type) {
            case "prerender-ppr":
              return A(v.route, O, P.dynamicTracking);
            case "prerender-legacy":
              P.revalidate = 0;
              const G = Object.defineProperty(new r.DynamicServerError(`Route ${v.route} couldn't be rendered statically because it used ${O}. See more info here: https://nextjs.org/docs/messages/dynamic-server-error`), "__NEXT_ERROR_CODE", {
                value: "E550",
                enumerable: !1,
                configurable: !0
              });
              throw v.dynamicUsageDescription = O, v.dynamicUsageStack = G.stack, G;
            case "request":
              process.env.NODE_ENV !== "production" && (P.usedDynamic = !0);
              break;
          }
      }
    }
    function S(v, P, O) {
      const G = Object.defineProperty(new r.DynamicServerError(`Route ${P.route} couldn't be rendered statically because it used \`${v}\`. See more info here: https://nextjs.org/docs/messages/dynamic-server-error`), "__NEXT_ERROR_CODE", {
        value: "E558",
        enumerable: !1,
        configurable: !0
      });
      throw O.revalidate = 0, P.dynamicUsageDescription = v, P.dynamicUsageStack = G.stack, G;
    }
    function w(v) {
      switch (v.type) {
        case "cache":
        case "unstable-cache":
          return;
        case "private-cache":
          return;
        case "prerender":
        case "prerender-runtime":
        case "prerender-legacy":
        case "prerender-ppr":
        case "prerender-client":
        case "validation-client":
        case "generate-static-params":
          break;
        case "request":
          process.env.NODE_ENV !== "production" && (v.usedDynamic = !0);
          break;
      }
    }
    function h(v, P, O) {
      const G = `Route ${v} needs to bail out of prerendering at this point because it used ${P}.`, J = $(G);
      O.controller.abort(J);
      const ee = O.dynamicTracking;
      ee && ee.dynamicAccesses.push({
        // When we aren't debugging, we don't need to create another error for the
        // stack trace.
        stack: ee.isDebugDynamicAccesses ? new Error().stack : void 0,
        expression: P
      });
    }
    function g(v, P, O, G) {
      const J = G.dynamicTracking;
      h(v, P, G), J && J.syncDynamicErrorWithStack === null && (J.syncDynamicErrorWithStack = O);
    }
    function y(v, P, O, G) {
      if (G.controller.signal.aborted === !1) {
        h(v, P, G);
        const ee = G.dynamicTracking;
        ee && ee.syncDynamicErrorWithStack === null && (ee.syncDynamicErrorWithStack = O);
      }
      throw $(`Route ${v} needs to bail out of prerendering at this point because it used ${P}.`);
    }
    function E({ reason: v, route: P }) {
      const O = s.workUnitAsyncStorage.getStore(), G = O && O.type === "prerender-ppr" ? O.dynamicTracking : null;
      A(P, v, G);
    }
    function A(v, P, O) {
      Z(), O && O.dynamicAccesses.push({
        // When we aren't debugging, we don't need to create another error for the
        // stack trace.
        stack: O.isDebugDynamicAccesses ? new Error().stack : void 0,
        expression: P
      }), n.default.unstable_postpone(H(v, P));
    }
    function H(v, P) {
      return `Route ${v} needs to bail out of prerendering at this point because it used ${P}. React throws this special object to indicate where. It should not be caught by your own try/catch. Learn more: https://nextjs.org/docs/messages/ppr-caught-error`;
    }
    function x(v) {
      return typeof v == "object" && v !== null && typeof v.message == "string" ? M(v.message) : !1;
    }
    function M(v) {
      return v.includes("needs to bail out of prerendering at this point because it used") && v.includes("Learn more: https://nextjs.org/docs/messages/ppr-caught-error");
    }
    if (M(H("%%%", "^^^")) === !1)
      throw Object.defineProperty(new Error("Invariant: isDynamicPostpone misidentified a postpone reason. This is a bug in Next.js"), "__NEXT_ERROR_CODE", {
        value: "E296",
        enumerable: !1,
        configurable: !0
      });
    const L = "NEXT_PRERENDER_INTERRUPTED";
    function $(v) {
      const P = Object.defineProperty(new Error(v), "__NEXT_ERROR_CODE", {
        value: "E394",
        enumerable: !1,
        configurable: !0
      });
      return P.digest = L, P;
    }
    function U(v) {
      return typeof v == "object" && v !== null && v.digest === L && "name" in v && "message" in v && v instanceof Error;
    }
    function z(v) {
      return v.length > 0;
    }
    function V(v, P) {
      return v.dynamicAccesses.push(...P.dynamicAccesses), v.dynamicAccesses;
    }
    function D(v) {
      return v.filter((P) => typeof P.stack == "string" && P.stack.length > 0).map(({ expression: P, stack: O }) => (O = O.split(`
`).slice(4).filter((G) => !(G.includes("node_modules/next/") || G.includes(" (<anonymous>)") || G.includes(" (node:"))).join(`
`), `Dynamic API Usage Debug - ${P}:
${O}`));
    }
    function Z() {
      if (!m)
        throw Object.defineProperty(new Error("Invariant: React.unstable_postpone is not defined. This suggests the wrong version of React was loaded. This is a bug in Next.js"), "__NEXT_ERROR_CODE", {
          value: "E224",
          enumerable: !1,
          configurable: !0
        });
    }
    function ie() {
      const v = new AbortController();
      return v.abort(Object.defineProperty(new u.BailoutToCSRError("Render in Browser"), "__NEXT_ERROR_CODE", {
        value: "E721",
        enumerable: !1,
        configurable: !0
      })), v.signal;
    }
    function T(v) {
      switch (v.type) {
        case "prerender":
        case "prerender-runtime":
          const P = new AbortController();
          if (v.cacheSignal)
            v.cacheSignal.inputReady().then(() => {
              P.abort();
            });
          else if (
            // eslint-disable-next-line no-restricted-syntax -- We are discriminating between two different refined types and don't need an addition exhaustive switch here
            v.type === "prerender-runtime" && v.stagedRendering
          ) {
            const { stagedRendering: O } = v;
            O.waitForStage((0, a.getRuntimeStage)(O)).then(() => (0, l.scheduleOnNextTick)(() => P.abort()));
          } else
            (0, l.scheduleOnNextTick)(() => P.abort());
          return P.signal;
        case "prerender-client":
        case "validation-client":
        case "prerender-ppr":
        case "prerender-legacy":
        case "request":
        case "cache":
        case "private-cache":
        case "unstable-cache":
        case "generate-static-params":
          return;
      }
    }
    function q(v, P) {
      const O = P.dynamicTracking;
      O && O.dynamicAccesses.push({
        stack: O.isDebugDynamicAccesses ? new Error().stack : void 0,
        expression: v
      });
    }
    function I(v) {
      const P = i.workAsyncStorage.getStore(), O = s.workUnitAsyncStorage.getStore();
      if (P && O)
        switch (O.type) {
          case "prerender-client":
          case "prerender": {
            const G = O.fallbackRouteParams;
            G && G.size > 0 && n.default.use((0, a.makeHangingPromise)(O.renderSignal, P.route, v));
            break;
          }
          case "prerender-ppr": {
            const G = O.fallbackRouteParams;
            if (G && G.size > 0)
              return A(P.route, v, O.dynamicTracking);
            break;
          }
          case "validation-client":
            break;
          case "prerender-runtime":
            throw Object.defineProperty(new d.InvariantError(`\`${v}\` was called during a runtime prerender. Next.js should be preventing ${v} from being included in server components statically, but did not in this case.`), "__NEXT_ERROR_CODE", {
              value: "E771",
              enumerable: !1,
              configurable: !0
            });
          case "cache":
          case "private-cache":
            throw Object.defineProperty(new d.InvariantError(`\`${v}\` was called inside a cache scope. Next.js should be preventing ${v} from being included in server components statically, but did not in this case.`), "__NEXT_ERROR_CODE", {
              value: "E745",
              enumerable: !1,
              configurable: !0
            });
          case "generate-static-params":
            throw Object.defineProperty(new d.InvariantError(`\`${v}\` was called in \`generateStaticParams\`. Next.js should be preventing ${v} from being included in server component files statically, but did not in this case.`), "__NEXT_ERROR_CODE", {
              value: "E1130",
              enumerable: !1,
              configurable: !0
            });
        }
    }
    function j(v) {
      const P = i.workAsyncStorage.getStore(), O = s.workUnitAsyncStorage.getStore();
      if (P)
        switch (O || (0, s.throwForMissingRequestStore)(v), O.type) {
          case "validation-client":
            return;
          case "prerender-client": {
            n.default.use((0, a.makeHangingPromise)(O.renderSignal, P.route, v));
            break;
          }
          case "prerender-legacy":
          case "prerender-ppr": {
            if (P.forceStatic)
              return;
            throw Object.defineProperty(new u.BailoutToCSRError(v), "__NEXT_ERROR_CODE", {
              value: "E394",
              enumerable: !1,
              configurable: !0
            });
          }
          case "prerender":
          case "prerender-runtime":
            throw Object.defineProperty(new d.InvariantError(`\`${v}\` was called from a Server Component. Next.js should be preventing ${v} from being included in server components statically, but did not in this case.`), "__NEXT_ERROR_CODE", {
              value: "E795",
              enumerable: !1,
              configurable: !0
            });
          case "cache":
          case "unstable-cache":
          case "private-cache":
            throw Object.defineProperty(new d.InvariantError(`\`${v}\` was called inside a cache scope. Next.js should be preventing ${v} from being included in server components statically, but did not in this case.`), "__NEXT_ERROR_CODE", {
              value: "E745",
              enumerable: !1,
              configurable: !0
            });
          case "generate-static-params":
            throw Object.defineProperty(new d.InvariantError(`\`${v}\` was called in \`generateStaticParams\`. Next.js should be preventing ${v} from being included in server component files statically, but did not in this case.`), "__NEXT_ERROR_CODE", {
              value: "E1130",
              enumerable: !1,
              configurable: !0
            });
          case "request":
            return;
        }
    }
    const Q = /\n\s+at Suspense \(<anonymous>\)/, K = "body|div|main|section|article|aside|header|footer|nav|form|p|span|h1|h2|h3|h4|h5|h6", W = new RegExp(`\\n\\s+at Suspense \\(<anonymous>\\)(?:(?!\\n\\s+at (?:${K}) \\(<anonymous>\\))[\\s\\S])*?\\n\\s+at ${c.ROOT_LAYOUT_BOUNDARY_NAME} \\([^\\n]*\\)`), ae = new RegExp(`\\n\\s+at ${c.METADATA_BOUNDARY_NAME}[\\n\\s]`), oe = new RegExp(`\\n\\s+at ${c.VIEWPORT_BOUNDARY_NAME}[\\n\\s]`), ue = new RegExp(`\\n\\s+at ${c.OUTLET_BOUNDARY_NAME}[\\n\\s]`), ve = new RegExp(`\\n\\s+at ${f.INSTANT_VALIDATION_BOUNDARY_NAME}[\\n\\s]`);
    function ge(v, P, O, G) {
      if (!ue.test(P))
        if (ae.test(P)) {
          O.hasDynamicMetadata = !0;
          return;
        } else if (oe.test(P)) {
          O.hasDynamicViewport = !0;
          return;
        } else if (W.test(P)) {
          O.hasAllowedDynamic = !0, O.hasSuspenseAboveBody = !0;
          return;
        } else if (Q.test(P)) {
          O.hasAllowedDynamic = !0;
          return;
        } else if (G.syncDynamicErrorWithStack) {
          O.dynamicErrors.push(G.syncDynamicErrorWithStack);
          return;
        } else {
          const J = `Route "${v.route}": Uncached data was accessed outside of <Suspense>. This delays the entire page from rendering, resulting in a slow user experience. Learn more: https://nextjs.org/docs/messages/blocking-route`, ee = ye(Object.defineProperty(new Error(J), "__NEXT_ERROR_CODE", {
            value: "E1079",
            enumerable: !1,
            configurable: !0
          }), P, null);
          O.dynamicErrors.push(ee);
          return;
        }
    }
    var He = /* @__PURE__ */ (function(v) {
      return v[v.Runtime = 1] = "Runtime", v[v.Dynamic = 2] = "Dynamic", v;
    })({});
    function Ce(v) {
      return {
        hasDynamicMetadata: !1,
        hasAllowedClientDynamicAboveBoundary: !1,
        dynamicMetadata: null,
        hasDynamicViewport: !1,
        hasAllowedDynamic: !1,
        dynamicErrors: [],
        validationPreventingErrors: [],
        thrownErrorsOutsideBoundary: [],
        createInstantStack: v
      };
    }
    function Fe(v, P, O, G, J, ee) {
      if (ue.test(P))
        return;
      if (ae.test(P)) {
        const we = J === 1 ? "Runtime data such as `cookies()`, `headers()`, `params`, or `searchParams` was accessed inside `generateMetadata` or you have file-based metadata such as icons that depend on dynamic params segments." : "Uncached data or `connection()` was accessed inside `generateMetadata`.", xe = `Route "${v.route}": ${we} Except for this instance, the page would have been entirely prerenderable which may have been the intended behavior. See more info here: https://nextjs.org/docs/messages/next-prerender-dynamic-metadata`, Ke = ye(Object.defineProperty(new Error(xe), "__NEXT_ERROR_CODE", {
          value: "E1076",
          enumerable: !1,
          configurable: !0
        }), P, O.createInstantStack);
        O.dynamicMetadata = Ke;
        return;
      }
      if (oe.test(P)) {
        const we = J === 1 ? "Runtime data such as `cookies()`, `headers()`, `params`, or `searchParams` was accessed inside `generateViewport`." : "Uncached data or `connection()` was accessed inside `generateViewport`.", xe = `Route "${v.route}": ${we} This delays the entire page from rendering, resulting in a slow user experience. Learn more: https://nextjs.org/docs/messages/next-prerender-dynamic-viewport`, Ke = ye(Object.defineProperty(new Error(xe), "__NEXT_ERROR_CODE", {
          value: "E1086",
          enumerable: !1,
          configurable: !0
        }), P, O.createInstantStack);
        O.dynamicErrors.push(Ke);
        return;
      }
      const se = ve.exec(P);
      if (se) {
        const we = Q.exec(P);
        if (we && we.index < se.index) {
          O.hasAllowedDynamic = !0;
          return;
        }
      } else if (ee.expectedIds.size === ee.renderedIds.size) {
        O.hasAllowedClientDynamicAboveBoundary = !0, O.hasAllowedDynamic = !0;
        return;
      } else {
        const we = `Route "${v.route}": Could not validate \`unstable_instant\` because a Client Component in a parent segment prevented the page from rendering.`, xe = ye(Object.defineProperty(new Error(we), "__NEXT_ERROR_CODE", {
          value: "E1082",
          enumerable: !1,
          configurable: !0
        }), P, O.createInstantStack);
        O.validationPreventingErrors.push(xe);
        return;
      }
      if (G.syncDynamicErrorWithStack) {
        const we = G.syncDynamicErrorWithStack;
        O.createInstantStack !== null && we.cause === void 0 && (we.cause = O.createInstantStack()), O.dynamicErrors.push(we);
        return;
      }
      const me = J === 1 ? "Runtime data such as `cookies()`, `headers()`, `params`, or `searchParams` was accessed outside of `<Suspense>`." : "Uncached data or `connection()` was accessed outside of `<Suspense>`.", ke = `Route "${v.route}": ${me} This delays the entire page from rendering, resulting in a slow user experience. Learn more: https://nextjs.org/docs/messages/blocking-route`, _e = ye(Object.defineProperty(new Error(ke), "__NEXT_ERROR_CODE", {
        value: "E1078",
        enumerable: !1,
        configurable: !0
      }), P, O.createInstantStack);
      O.dynamicErrors.push(_e);
    }
    function Be(v, P, O, G) {
      const J = ve.exec(G);
      if (J) {
        const ee = Q.exec(G);
        if (ee && ee.index < J.index)
          return;
        const se = `Route "${v.route}": Could not validate \`unstable_instant\` because an error prevented the target segment from rendering.`, me = ye(
          Object.defineProperty(new Error(se, {
            cause: O
          }), "__NEXT_ERROR_CODE", {
            value: "E1112",
            enumerable: !1,
            configurable: !0
          }),
          G,
          null
          // TODO(instant-validation-build): conflicting use of cause
        );
        P.validationPreventingErrors.push(me);
      } else {
        const ee = ye(Object.defineProperty(new Error("An error occurred while attempting to validate instant UI. This error may be preventing the validation from completing.", {
          cause: O
        }), "__NEXT_ERROR_CODE", {
          value: "E1118",
          enumerable: !1,
          configurable: !0
        }), G, null);
        P.thrownErrorsOutsideBoundary.push(ee);
      }
    }
    function We(v, P, O, G) {
      if (ue.test(P))
        return;
      if (ae.test(P)) {
        const se = `Route "${v.route}": Uncached data or \`connection()\` was accessed inside \`generateMetadata\`. Except for this instance, the page would have been entirely prerenderable which may have been the intended behavior. See more info here: https://nextjs.org/docs/messages/next-prerender-dynamic-metadata`, me = ye(Object.defineProperty(new Error(se), "__NEXT_ERROR_CODE", {
          value: "E1080",
          enumerable: !1,
          configurable: !0
        }), P, null);
        O.dynamicMetadata = me;
        return;
      } else if (oe.test(P)) {
        const se = `Route "${v.route}": Uncached data or \`connection()\` was accessed inside \`generateViewport\`. This delays the entire page from rendering, resulting in a slow user experience. Learn more: https://nextjs.org/docs/messages/next-prerender-dynamic-viewport`, me = ye(Object.defineProperty(new Error(se), "__NEXT_ERROR_CODE", {
          value: "E1077",
          enumerable: !1,
          configurable: !0
        }), P, null);
        O.dynamicErrors.push(me);
        return;
      } else if (W.test(P)) {
        O.hasAllowedDynamic = !0, O.hasSuspenseAboveBody = !0;
        return;
      } else if (Q.test(P)) {
        O.hasAllowedDynamic = !0;
        return;
      } else if (G.syncDynamicErrorWithStack) {
        O.dynamicErrors.push(G.syncDynamicErrorWithStack);
        return;
      }
      const J = `Route "${v.route}": Uncached data or \`connection()\` was accessed outside of \`<Suspense>\`. This delays the entire page from rendering, resulting in a slow user experience. Learn more: https://nextjs.org/docs/messages/blocking-route`, ee = ye(Object.defineProperty(new Error(J), "__NEXT_ERROR_CODE", {
        value: "E1084",
        enumerable: !1,
        configurable: !0
      }), P, null);
      O.dynamicErrors.push(ee);
    }
    function ze(v, P, O, G) {
      if (!ue.test(P))
        if (ae.test(P)) {
          const J = `Route "${v.route}": Runtime data such as \`cookies()\`, \`headers()\`, \`params\`, or \`searchParams\` was accessed inside \`generateMetadata\` or you have file-based metadata such as icons that depend on dynamic params segments. Except for this instance, the page would have been entirely prerenderable which may have been the intended behavior. See more info here: https://nextjs.org/docs/messages/next-prerender-dynamic-metadata`, ee = ye(Object.defineProperty(new Error(J), "__NEXT_ERROR_CODE", {
            value: "E1085",
            enumerable: !1,
            configurable: !0
          }), P, null);
          O.dynamicMetadata = ee;
          return;
        } else if (oe.test(P)) {
          const J = `Route "${v.route}": Runtime data such as \`cookies()\`, \`headers()\`, \`params\`, or \`searchParams\` was accessed inside \`generateViewport\`. This delays the entire page from rendering, resulting in a slow user experience. Learn more: https://nextjs.org/docs/messages/next-prerender-dynamic-viewport`, ee = ye(Object.defineProperty(new Error(J), "__NEXT_ERROR_CODE", {
            value: "E1081",
            enumerable: !1,
            configurable: !0
          }), P, null);
          O.dynamicErrors.push(ee);
          return;
        } else if (W.test(P)) {
          O.hasAllowedDynamic = !0, O.hasSuspenseAboveBody = !0;
          return;
        } else if (Q.test(P)) {
          O.hasAllowedDynamic = !0;
          return;
        } else if (G.syncDynamicErrorWithStack) {
          O.dynamicErrors.push(G.syncDynamicErrorWithStack);
          return;
        } else {
          const J = `Route "${v.route}": Runtime data such as \`cookies()\`, \`headers()\`, \`params\`, or \`searchParams\` was accessed outside of \`<Suspense>\`. This delays the entire page from rendering, resulting in a slow user experience. Learn more: https://nextjs.org/docs/messages/blocking-route`, ee = ye(Object.defineProperty(new Error(J), "__NEXT_ERROR_CODE", {
            value: "E1083",
            enumerable: !1,
            configurable: !0
          }), P, null);
          O.dynamicErrors.push(ee);
          return;
        }
    }
    function ye(v, P, O) {
      const G = process.env.NODE_ENV !== "production" && n.default.captureOwnerStack ? n.default.captureOwnerStack() : null;
      return O !== null && (v.cause = O()), v.stack = v.name + ": " + v.message + (G || P), v;
    }
    var Ft = /* @__PURE__ */ (function(v) {
      return v[v.Full = 0] = "Full", v[v.Empty = 1] = "Empty", v[v.Errored = 2] = "Errored", v;
    })({});
    function ct(v, P) {
      console.error(P), process.env.NODE_ENV !== "development" ? console.error(`To get a more detailed stack trace and pinpoint the issue, try one of the following:
  - Start the app in development mode by running \`next dev\`, then open "${v.route}" in your browser to investigate the error.
  - Rerun the production build with \`next build --debug-prerender\` to generate better stack traces.`) : process.env.__NEXT_DEV_SERVER || console.error(`To debug the issue, start the app in development mode by running \`next dev\`, then open "${v.route}" in your browser to investigate the error.`);
    }
    function Ge(v, P, O, G) {
      if (G.syncDynamicErrorWithStack)
        throw ct(v, G.syncDynamicErrorWithStack), new o.StaticGenBailoutError();
      if (P !== 0) {
        if (O.hasSuspenseAboveBody)
          return;
        const J = O.dynamicErrors;
        if (J.length > 0) {
          for (let ee = 0; ee < J.length; ee++)
            ct(v, J[ee]);
          throw new o.StaticGenBailoutError();
        }
        if (O.hasDynamicViewport)
          throw console.error(`Route "${v.route}" has a \`generateViewport\` that depends on Request data (\`cookies()\`, etc...) or uncached external data (\`fetch(...)\`, etc...) without explicitly allowing fully dynamic rendering. See more info here: https://nextjs.org/docs/messages/next-prerender-dynamic-viewport`), new o.StaticGenBailoutError();
        if (P === 1)
          throw console.error(`Route "${v.route}" did not produce a static shell and Next.js was unable to determine a reason. This is a bug in Next.js.`), new o.StaticGenBailoutError();
      } else if (O.hasAllowedDynamic === !1 && O.hasDynamicMetadata)
        throw console.error(`Route "${v.route}" has a \`generateMetadata\` that depends on Request data (\`cookies()\`, etc...) or uncached external data (\`fetch(...)\`, etc...) when the rest of the route does not. See more info here: https://nextjs.org/docs/messages/next-prerender-dynamic-metadata`), new o.StaticGenBailoutError();
    }
    function Xe(v, P, O, G) {
      if (G || O.hasSuspenseAboveBody)
        return [];
      if (P !== 0) {
        const J = O.dynamicErrors;
        if (J.length > 0)
          return J;
        if (P === 1)
          return [
            Object.defineProperty(new d.InvariantError(`Route "${v.route}" did not produce a static shell and Next.js was unable to determine a reason.`), "__NEXT_ERROR_CODE", {
              value: "E936",
              enumerable: !1,
              configurable: !0
            })
          ];
      } else if (O.hasAllowedDynamic === !1 && O.dynamicErrors.length === 0 && O.dynamicMetadata)
        return [
          O.dynamicMetadata
        ];
      return [];
    }
    function Ve(v, P, O, G, J) {
      if (G) {
        const { missingSampleErrors: se } = G;
        if (se.length > 0)
          return se;
      }
      const { validationPreventingErrors: ee } = O;
      if (ee.length > 0)
        return ee;
      if (J.renderedIds.size < J.expectedIds.size) {
        const { thrownErrorsOutsideBoundary: se, createInstantStack: me } = O;
        if (se.length === 0) {
          const ke = `Route "${v.route}": Could not validate \`unstable_instant\` because the target segment was prevented from rendering for an unknown reason.`, _e = me !== null ? me() : new Error();
          return _e.name = "Error", _e.message = ke, [
            _e
          ];
        } else if (se.length === 1) {
          const ke = `Route "${v.route}": Could not validate \`unstable_instant\` because the target segment was prevented from rendering, likely due to the following error.`, _e = me !== null ? me() : new Error();
          return _e.name = "Error", _e.message = ke, [
            _e,
            se[0]
          ];
        } else {
          const ke = `Route "${v.route}": Could not validate \`unstable_instant\` because the target segment was prevented from rendering, likely due to one of the following errors.`, _e = me !== null ? me() : new Error();
          return _e.name = "Error", _e.message = ke, [
            _e,
            ...se
          ];
        }
      }
      if (P !== 0) {
        const se = O.dynamicErrors;
        if (se.length > 0)
          return se;
        if (P === 1)
          return O.hasAllowedClientDynamicAboveBoundary ? [] : [
            Object.defineProperty(new d.InvariantError(`Route "${v.route}" failed to render during instant validation and Next.js was unable to determine a reason.`), "__NEXT_ERROR_CODE", {
              value: "E1055",
              enumerable: !1,
              configurable: !0
            })
          ];
      } else {
        const se = O.dynamicErrors;
        if (se.length > 0)
          return se;
        if (O.hasAllowedDynamic === !1 && O.dynamicMetadata)
          return [
            O.dynamicMetadata
          ];
      }
      return [];
    }
  })(Zr)), Zr;
}
var Zi;
function $f() {
  return Zi || (Zi = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "unstable_rethrow", {
      enumerable: !0,
      get: function() {
        return c;
      }
    });
    const n = Dc(), r = Df(), o = _s(), s = jc(), i = Zo(), a = Lc();
    function c(l) {
      if ((0, s.isNextRouterError)(l) || (0, o.isBailoutToCSRError)(l) || (0, a.isDynamicServerError)(l) || (0, i.isDynamicPostpone)(l) || (0, r.isPostpone)(l) || (0, n.isHangingPromiseRejectionError)(l) || (0, i.isPrerenderInterruptedError)(l))
        throw l;
      l instanceof Error && "cause" in l && c(l.cause);
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  })(Dn, Dn.exports)), Dn.exports;
}
var qn = { exports: {} }, ea;
function Wf() {
  return ea || (ea = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "unstable_rethrow", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const n = _s(), r = jc();
    function o(s) {
      if ((0, r.isNextRouterError)(s) || (0, n.isBailoutToCSRError)(s))
        throw s;
      s instanceof Error && "cause" in s && o(s.cause);
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  })(qn, qn.exports)), qn.exports;
}
var ta;
function zf() {
  return ta || (ta = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "unstable_rethrow", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const n = typeof window > "u" ? $f().unstable_rethrow : Wf().unstable_rethrow;
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  })(Mn, Mn.exports)), Mn.exports;
}
var na;
function Gf() {
  return na || (na = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(d, f) {
      for (var p in f) Object.defineProperty(d, p, {
        enumerable: !0,
        get: f[p]
      });
    }
    n(t, {
      ReadonlyURLSearchParams: function() {
        return r.ReadonlyURLSearchParams;
      },
      RedirectType: function() {
        return u;
      },
      forbidden: function() {
        return i.forbidden;
      },
      notFound: function() {
        return s.notFound;
      },
      permanentRedirect: function() {
        return o.permanentRedirect;
      },
      redirect: function() {
        return o.redirect;
      },
      unauthorized: function() {
        return a.unauthorized;
      },
      unstable_isUnrecognizedActionError: function() {
        return l;
      },
      unstable_rethrow: function() {
        return c.unstable_rethrow;
      }
    });
    const r = Pc(), o = Pf(), s = xf(), i = If(), a = Nf(), c = zf();
    function l() {
      throw Object.defineProperty(new Error("`unstable_isUnrecognizedActionError` can only be used on the client."), "__NEXT_ERROR_CODE", {
        value: "E776",
        enumerable: !1,
        configurable: !0
      });
    }
    const u = {
      push: "push",
      replace: "replace"
    };
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  })(An, An.exports)), An.exports;
}
var ao = {}, co = {}, lo = {}, uo, ra;
function Xf() {
  if (ra) return uo;
  ra = 1;
  var e = Object.defineProperty, t = Object.getOwnPropertyDescriptor, n = Object.getOwnPropertyNames, r = Object.prototype.hasOwnProperty, o = (h, g) => {
    for (var y in g)
      e(h, y, { get: g[y], enumerable: !0 });
  }, s = (h, g, y, E) => {
    if (g && typeof g == "object" || typeof g == "function")
      for (let A of n(g))
        !r.call(h, A) && A !== y && e(h, A, { get: () => g[A], enumerable: !(E = t(g, A)) || E.enumerable });
    return h;
  }, i = (h) => s(e({}, "__esModule", { value: !0 }), h), a = {};
  o(a, {
    RequestCookies: () => _,
    ResponseCookies: () => k,
    parseCookie: () => l,
    parseSetCookie: () => u,
    stringifyCookie: () => c
  }), uo = i(a);
  function c(h) {
    var g;
    const y = [
      "path" in h && h.path && `Path=${h.path}`,
      "expires" in h && (h.expires || h.expires === 0) && `Expires=${(typeof h.expires == "number" ? new Date(h.expires) : h.expires).toUTCString()}`,
      "maxAge" in h && typeof h.maxAge == "number" && `Max-Age=${h.maxAge}`,
      "domain" in h && h.domain && `Domain=${h.domain}`,
      "secure" in h && h.secure && "Secure",
      "httpOnly" in h && h.httpOnly && "HttpOnly",
      "sameSite" in h && h.sameSite && `SameSite=${h.sameSite}`,
      "partitioned" in h && h.partitioned && "Partitioned",
      "priority" in h && h.priority && `Priority=${h.priority}`
    ].filter(Boolean), E = `${h.name}=${encodeURIComponent((g = h.value) != null ? g : "")}`;
    return y.length === 0 ? E : `${E}; ${y.join("; ")}`;
  }
  function l(h) {
    const g = /* @__PURE__ */ new Map();
    for (const y of h.split(/; */)) {
      if (!y)
        continue;
      const E = y.indexOf("=");
      if (E === -1) {
        g.set(y, "true");
        continue;
      }
      const [A, H] = [y.slice(0, E), y.slice(E + 1)];
      try {
        g.set(A, decodeURIComponent(H ?? "true"));
      } catch {
      }
    }
    return g;
  }
  function u(h) {
    if (!h)
      return;
    const [[g, y], ...E] = l(h), {
      domain: A,
      expires: H,
      httponly: x,
      maxage: M,
      path: L,
      samesite: $,
      secure: U,
      partitioned: z,
      priority: V
    } = Object.fromEntries(
      E.map(([Z, ie]) => [
        Z.toLowerCase().replace(/-/g, ""),
        ie
      ])
    ), D = {
      name: g,
      value: decodeURIComponent(y),
      domain: A,
      ...H && { expires: new Date(H) },
      ...x && { httpOnly: !0 },
      ...typeof M == "string" && { maxAge: Number(M) },
      path: L,
      ...$ && { sameSite: p($) },
      ...U && { secure: !0 },
      ...V && { priority: R(V) },
      ...z && { partitioned: !0 }
    };
    return d(D);
  }
  function d(h) {
    const g = {};
    for (const y in h)
      h[y] && (g[y] = h[y]);
    return g;
  }
  var f = ["strict", "lax", "none"];
  function p(h) {
    return h = h.toLowerCase(), f.includes(h) ? h : void 0;
  }
  var m = ["low", "medium", "high"];
  function R(h) {
    return h = h.toLowerCase(), m.includes(h) ? h : void 0;
  }
  function b(h) {
    if (!h)
      return [];
    var g = [], y = 0, E, A, H, x, M;
    function L() {
      for (; y < h.length && /\s/.test(h.charAt(y)); )
        y += 1;
      return y < h.length;
    }
    function $() {
      return A = h.charAt(y), A !== "=" && A !== ";" && A !== ",";
    }
    for (; y < h.length; ) {
      for (E = y, M = !1; L(); )
        if (A = h.charAt(y), A === ",") {
          for (H = y, y += 1, L(), x = y; y < h.length && $(); )
            y += 1;
          y < h.length && h.charAt(y) === "=" ? (M = !0, y = x, g.push(h.substring(E, H)), E = y) : y = H + 1;
        } else
          y += 1;
      (!M || y >= h.length) && g.push(h.substring(E, h.length));
    }
    return g;
  }
  var _ = class {
    constructor(h) {
      this._parsed = /* @__PURE__ */ new Map(), this._headers = h;
      const g = h.get("cookie");
      if (g) {
        const y = l(g);
        for (const [E, A] of y)
          this._parsed.set(E, { name: E, value: A });
      }
    }
    [Symbol.iterator]() {
      return this._parsed[Symbol.iterator]();
    }
    /**
     * The amount of cookies received from the client
     */
    get size() {
      return this._parsed.size;
    }
    get(...h) {
      const g = typeof h[0] == "string" ? h[0] : h[0].name;
      return this._parsed.get(g);
    }
    getAll(...h) {
      var g;
      const y = Array.from(this._parsed);
      if (!h.length)
        return y.map(([A, H]) => H);
      const E = typeof h[0] == "string" ? h[0] : (g = h[0]) == null ? void 0 : g.name;
      return y.filter(([A]) => A === E).map(([A, H]) => H);
    }
    has(h) {
      return this._parsed.has(h);
    }
    set(...h) {
      const [g, y] = h.length === 1 ? [h[0].name, h[0].value] : h, E = this._parsed;
      return E.set(g, { name: g, value: y }), this._headers.set(
        "cookie",
        Array.from(E).map(([A, H]) => c(H)).join("; ")
      ), this;
    }
    /**
     * Delete the cookies matching the passed name or names in the request.
     */
    delete(h) {
      const g = this._parsed, y = Array.isArray(h) ? h.map((E) => g.delete(E)) : g.delete(h);
      return this._headers.set(
        "cookie",
        Array.from(g).map(([E, A]) => c(A)).join("; ")
      ), y;
    }
    /**
     * Delete all the cookies in the cookies in the request.
     */
    clear() {
      return this.delete(Array.from(this._parsed.keys())), this;
    }
    /**
     * Format the cookies in the request as a string for logging
     */
    [/* @__PURE__ */ Symbol.for("edge-runtime.inspect.custom")]() {
      return `RequestCookies ${JSON.stringify(Object.fromEntries(this._parsed))}`;
    }
    toString() {
      return [...this._parsed.values()].map((h) => `${h.name}=${encodeURIComponent(h.value)}`).join("; ");
    }
  }, k = class {
    constructor(h) {
      this._parsed = /* @__PURE__ */ new Map();
      var g, y, E;
      this._headers = h;
      const A = (E = (y = (g = h.getSetCookie) == null ? void 0 : g.call(h)) != null ? y : h.get("set-cookie")) != null ? E : [], H = Array.isArray(A) ? A : b(A);
      for (const x of H) {
        const M = u(x);
        M && this._parsed.set(M.name, M);
      }
    }
    /**
     * {@link https://wicg.github.io/cookie-store/#CookieStore-get CookieStore#get} without the Promise.
     */
    get(...h) {
      const g = typeof h[0] == "string" ? h[0] : h[0].name;
      return this._parsed.get(g);
    }
    /**
     * {@link https://wicg.github.io/cookie-store/#CookieStore-getAll CookieStore#getAll} without the Promise.
     */
    getAll(...h) {
      var g;
      const y = Array.from(this._parsed.values());
      if (!h.length)
        return y;
      const E = typeof h[0] == "string" ? h[0] : (g = h[0]) == null ? void 0 : g.name;
      return y.filter((A) => A.name === E);
    }
    has(h) {
      return this._parsed.has(h);
    }
    /**
     * {@link https://wicg.github.io/cookie-store/#CookieStore-set CookieStore#set} without the Promise.
     */
    set(...h) {
      const [g, y, E] = h.length === 1 ? [h[0].name, h[0].value, h[0]] : h, A = this._parsed;
      return A.set(g, w({ name: g, value: y, ...E })), S(A, this._headers), this;
    }
    /**
     * {@link https://wicg.github.io/cookie-store/#CookieStore-delete CookieStore#delete} without the Promise.
     */
    delete(...h) {
      const [g, y] = typeof h[0] == "string" ? [h[0]] : [h[0].name, h[0]];
      return this.set({ ...y, name: g, value: "", expires: /* @__PURE__ */ new Date(0) });
    }
    [/* @__PURE__ */ Symbol.for("edge-runtime.inspect.custom")]() {
      return `ResponseCookies ${JSON.stringify(Object.fromEntries(this._parsed))}`;
    }
    toString() {
      return [...this._parsed.values()].map(c).join("; ");
    }
  };
  function S(h, g) {
    g.delete("set-cookie");
    for (const [, y] of h) {
      const E = c(y);
      g.append("set-cookie", E);
    }
  }
  function w(h = { name: "", value: "" }) {
    return typeof h.expires == "number" && (h.expires = new Date(h.expires)), h.maxAge && (h.expires = new Date(Date.now() + h.maxAge * 1e3)), (h.path === null || h.path === void 0) && (h.path = "/"), h;
  }
  return uo;
}
var oa;
function Hc() {
  return oa || (oa = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(r, o) {
      for (var s in o) Object.defineProperty(r, s, {
        enumerable: !0,
        get: o[s]
      });
    }
    t(e, {
      RequestCookies: function() {
        return n.RequestCookies;
      },
      ResponseCookies: function() {
        return n.ResponseCookies;
      },
      stringifyCookie: function() {
        return n.stringifyCookie;
      }
    });
    const n = Xf();
  })(lo)), lo;
}
var fo = {}, ho = {}, sa;
function Uc() {
  return sa || (sa = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "ReflectAdapter", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    class t {
      static get(r, o, s) {
        const i = Reflect.get(r, o, s);
        return typeof i == "function" ? i.bind(r) : i;
      }
      static set(r, o, s, i) {
        return Reflect.set(r, o, s, i);
      }
      static has(r, o) {
        return Reflect.has(r, o);
      }
      static deleteProperty(r, o) {
        return Reflect.deleteProperty(r, o);
      }
    }
  })(ho)), ho;
}
var po = {}, ia;
function Vf() {
  return ia || (ia = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(s, i) {
      for (var a in i) Object.defineProperty(s, a, {
        enumerable: !0,
        get: i[a]
      });
    }
    t(e, {
      ActionDidNotRevalidate: function() {
        return n;
      },
      ActionDidRevalidateDynamicOnly: function() {
        return o;
      },
      ActionDidRevalidateStaticAndDynamic: function() {
        return r;
      }
    });
    const n = 0, r = 1, o = 2;
  })(po)), po;
}
var aa;
function Kf() {
  return aa || (aa = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(b, _) {
      for (var k in _) Object.defineProperty(b, k, {
        enumerable: !0,
        get: _[k]
      });
    }
    t(e, {
      MutableRequestCookiesAdapter: function() {
        return d;
      },
      ReadonlyRequestCookiesError: function() {
        return i;
      },
      RequestCookiesAdapter: function() {
        return a;
      },
      appendMutableCookies: function() {
        return u;
      },
      areCookiesMutableInCurrentPhase: function() {
        return p;
      },
      createCookiesWithMutableAccessCheck: function() {
        return f;
      },
      getModifiedCookieValues: function() {
        return l;
      },
      responseCookiesToRequestCookies: function() {
        return R;
      }
    });
    const n = Hc(), r = Uc(), o = Es(), s = Vf();
    class i extends Error {
      constructor() {
        super("Cookies can only be modified in a Server Action or Route Handler. Read more: https://nextjs.org/docs/app/api-reference/functions/cookies#options");
      }
      static callable() {
        throw new i();
      }
    }
    class a {
      static seal(_) {
        return new Proxy(_, {
          get(k, S, w) {
            switch (S) {
              case "clear":
              case "delete":
              case "set":
                return i.callable;
              default:
                return r.ReflectAdapter.get(k, S, w);
            }
          }
        });
      }
    }
    const c = /* @__PURE__ */ Symbol.for("next.mutated.cookies");
    function l(b) {
      const _ = b[c];
      return !_ || !Array.isArray(_) || _.length === 0 ? [] : _;
    }
    function u(b, _) {
      const k = l(_);
      if (k.length === 0)
        return !1;
      const S = new n.ResponseCookies(b), w = S.getAll();
      for (const h of k)
        S.set(h);
      for (const h of w)
        S.set(h);
      return !0;
    }
    class d {
      static wrap(_, k) {
        const S = new n.ResponseCookies(new Headers());
        for (const E of _.getAll())
          S.set(E);
        let w = [];
        const h = /* @__PURE__ */ new Set(), g = () => {
          const E = o.workAsyncStorage.getStore();
          if (E && (E.pathWasRevalidated = s.ActionDidRevalidateStaticAndDynamic), w = S.getAll().filter((H) => h.has(H.name)), k) {
            const H = [];
            for (const x of w) {
              const M = new n.ResponseCookies(new Headers());
              M.set(x), H.push(M.toString());
            }
            k(H);
          }
        }, y = new Proxy(S, {
          get(E, A, H) {
            switch (A) {
              // A special symbol to get the modified cookie values
              case c:
                return w;
              // TODO: Throw error if trying to set a cookie after the response
              // headers have been set.
              case "delete":
                return function(...x) {
                  h.add(typeof x[0] == "string" ? x[0] : x[0].name);
                  try {
                    return E.delete(...x), y;
                  } finally {
                    g();
                  }
                };
              case "set":
                return function(...x) {
                  h.add(typeof x[0] == "string" ? x[0] : x[0].name);
                  try {
                    return E.set(...x), y;
                  } finally {
                    g();
                  }
                };
              default:
                return r.ReflectAdapter.get(E, A, H);
            }
          }
        });
        return y;
      }
    }
    function f(b) {
      const _ = new Proxy(b.mutableCookies, {
        get(k, S, w) {
          switch (S) {
            case "delete":
              return function(...h) {
                return m(b), k.delete(...h), _;
              };
            case "set":
              return function(...h) {
                return m(b), k.set(...h), _;
              };
            default:
              return r.ReflectAdapter.get(k, S, w);
          }
        }
      });
      return _;
    }
    function p(b) {
      return b.phase === "action";
    }
    function m(b, _) {
      if (!p(b))
        throw new i();
    }
    function R(b) {
      const _ = new n.RequestCookies(new Headers());
      for (const k of b.getAll())
        _.set(k);
      return _;
    }
  })(fo)), fo;
}
var mo = {}, ca;
function Yf() {
  return ca || (ca = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(s, i) {
      for (var a in i) Object.defineProperty(s, a, {
        enumerable: !0,
        get: i[a]
      });
    }
    t(e, {
      HeadersAdapter: function() {
        return o;
      },
      ReadonlyHeadersError: function() {
        return r;
      }
    });
    const n = Uc();
    class r extends Error {
      constructor() {
        super("Headers cannot be modified. Read more: https://nextjs.org/docs/app/api-reference/functions/headers");
      }
      static callable() {
        throw new r();
      }
    }
    class o extends Headers {
      constructor(i) {
        super(), this.headers = new Proxy(i, {
          get(a, c, l) {
            if (typeof c == "symbol")
              return n.ReflectAdapter.get(a, c, l);
            const u = c.toLowerCase(), d = Object.keys(i).find((f) => f.toLowerCase() === u);
            if (!(typeof d > "u"))
              return n.ReflectAdapter.get(a, d, l);
          },
          set(a, c, l, u) {
            if (typeof c == "symbol")
              return n.ReflectAdapter.set(a, c, l, u);
            const d = c.toLowerCase(), f = Object.keys(i).find((p) => p.toLowerCase() === d);
            return n.ReflectAdapter.set(a, f ?? c, l, u);
          },
          has(a, c) {
            if (typeof c == "symbol") return n.ReflectAdapter.has(a, c);
            const l = c.toLowerCase(), u = Object.keys(i).find((d) => d.toLowerCase() === l);
            return typeof u > "u" ? !1 : n.ReflectAdapter.has(a, u);
          },
          deleteProperty(a, c) {
            if (typeof c == "symbol") return n.ReflectAdapter.deleteProperty(a, c);
            const l = c.toLowerCase(), u = Object.keys(i).find((d) => d.toLowerCase() === l);
            return typeof u > "u" ? !0 : n.ReflectAdapter.deleteProperty(a, u);
          }
        });
      }
      /**
      * Seals a Headers instance to prevent modification by throwing an error when
      * any mutating method is called.
      */
      static seal(i) {
        return new Proxy(i, {
          get(a, c, l) {
            switch (c) {
              case "append":
              case "delete":
              case "set":
                return r.callable;
              default:
                return n.ReflectAdapter.get(a, c, l);
            }
          }
        });
      }
      /**
      * Merges a header value into a string. This stores multiple values as an
      * array, so we need to merge them into a string.
      *
      * @param value a header value
      * @returns a merged header value (a string)
      */
      merge(i) {
        return Array.isArray(i) ? i.join(", ") : i;
      }
      /**
      * Creates a Headers instance from a plain object or a Headers instance.
      *
      * @param headers a plain object or a Headers instance
      * @returns a headers instance
      */
      static from(i) {
        return i instanceof Headers ? i : new o(i);
      }
      append(i, a) {
        const c = this.headers[i];
        typeof c == "string" ? this.headers[i] = [
          c,
          a
        ] : Array.isArray(c) ? c.push(a) : this.headers[i] = a;
      }
      delete(i) {
        delete this.headers[i];
      }
      get(i) {
        const a = this.headers[i];
        return typeof a < "u" ? this.merge(a) : null;
      }
      has(i) {
        return typeof this.headers[i] < "u";
      }
      set(i, a) {
        this.headers[i] = a;
      }
      forEach(i, a) {
        for (const [c, l] of this.entries())
          i.call(a, l, c, this);
      }
      *entries() {
        for (const i of Object.keys(this.headers)) {
          const a = i.toLowerCase(), c = this.get(a);
          yield [
            a,
            c
          ];
        }
      }
      *keys() {
        for (const i of Object.keys(this.headers))
          yield i.toLowerCase();
      }
      *values() {
        for (const i of Object.keys(this.headers))
          yield this.get(i);
      }
      [Symbol.iterator]() {
        return this.entries();
      }
    }
  })(mo)), mo;
}
var go = {}, yo = {}, _o = {}, bo = {}, la;
function Jf() {
  return la || (la = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "ensureLeadingSlash", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(n) {
      return n.startsWith("/") ? n : `/${n}`;
    }
  })(bo)), bo;
}
var ua;
function Qf() {
  return ua || (ua = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(a, c) {
      for (var l in c) Object.defineProperty(a, l, {
        enumerable: !0,
        get: c[l]
      });
    }
    t(e, {
      compareAppPaths: function() {
        return s;
      },
      normalizeAppPath: function() {
        return o;
      },
      normalizeRscURL: function() {
        return i;
      }
    });
    const n = Jf(), r = xc();
    function o(a) {
      return (0, n.ensureLeadingSlash)(a.split("/").reduce((c, l, u, d) => !l || (0, r.isGroupSegment)(l) || l[0] === "@" || (l === "page" || l === "route") && u === d.length - 1 ? c : `${c}/${l}`, ""));
    }
    function s(a, c) {
      const l = a.includes("/@"), u = c.includes("/@");
      return l && !u ? -1 : !l && u ? 1 : a.localeCompare(c);
    }
    function i(a) {
      return a.replace(
        /\.rsc($|\?)/,
        // $1 ensures `?` is preserved
        "$1"
      );
    }
  })(_o)), _o;
}
var da;
function Zf() {
  return da || (da = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(i, a) {
      for (var c in a) Object.defineProperty(i, c, {
        enumerable: !0,
        get: a[c]
      });
    }
    t(e, {
      INTERCEPTION_ROUTE_MARKERS: function() {
        return r;
      },
      extractInterceptionRouteInformation: function() {
        return s;
      },
      isInterceptionRouteAppPath: function() {
        return o;
      }
    });
    const n = Qf(), r = [
      "(..)(..)",
      "(.)",
      "(..)",
      "(...)"
    ];
    function o(i) {
      return i.split("/").find((a) => r.find((c) => a.startsWith(c))) !== void 0;
    }
    function s(i) {
      let a, c, l;
      for (const u of i.split("/"))
        if (c = r.find((d) => u.startsWith(d)), c) {
          [a, l] = i.split(c, 2);
          break;
        }
      if (!a || !c || !l)
        throw Object.defineProperty(new Error(`Invalid interception route: ${i}. Must be in the format /<intercepting route>/(..|...|..)(..)/<intercepted route>`), "__NEXT_ERROR_CODE", {
          value: "E269",
          enumerable: !1,
          configurable: !0
        });
      switch (a = (0, n.normalizeAppPath)(a), c) {
        case "(.)":
          a === "/" ? l = `/${l}` : l = a + "/" + l;
          break;
        case "(..)":
          if (a === "/")
            throw Object.defineProperty(new Error(`Invalid interception route: ${i}. Cannot use (..) marker at the root level, use (.) instead.`), "__NEXT_ERROR_CODE", {
              value: "E207",
              enumerable: !1,
              configurable: !0
            });
          l = a.split("/").slice(0, -1).concat(l).join("/");
          break;
        case "(...)":
          l = "/" + l;
          break;
        case "(..)(..)":
          const u = a.split("/");
          if (u.length <= 2)
            throw Object.defineProperty(new Error(`Invalid interception route: ${i}. Cannot use (..)(..) marker at the root level or one level up.`), "__NEXT_ERROR_CODE", {
              value: "E486",
              enumerable: !1,
              configurable: !0
            });
          l = u.slice(0, -2).concat(l).join("/");
          break;
        default:
          throw Object.defineProperty(new Error("Invariant: unexpected marker"), "__NEXT_ERROR_CODE", {
            value: "E112",
            enumerable: !1,
            configurable: !0
          });
      }
      return {
        interceptingRoute: a,
        interceptedRoute: l
      };
    }
  })(yo)), yo;
}
var fa;
function eh() {
  return fa || (fa = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(i, a) {
      for (var c in a) Object.defineProperty(i, c, {
        enumerable: !0,
        get: a[c]
      });
    }
    t(e, {
      getParamProperties: function() {
        return s;
      },
      getSegmentParam: function() {
        return r;
      },
      isCatchAll: function() {
        return o;
      }
    });
    const n = Zf();
    function r(i) {
      const a = n.INTERCEPTION_ROUTE_MARKERS.find((c) => i.startsWith(c));
      return a && (i = i.slice(a.length)), i.startsWith("[[...") && i.endsWith("]]") ? {
        // TODO-APP: Optional catchall does not currently work with parallel routes,
        // so for now aren't handling a potential interception marker.
        paramType: "optional-catchall",
        paramName: i.slice(5, -2)
      } : i.startsWith("[...") && i.endsWith("]") ? {
        paramType: a ? `catchall-intercepted-${a}` : "catchall",
        paramName: i.slice(4, -1)
      } : i.startsWith("[") && i.endsWith("]") ? {
        paramType: a ? `dynamic-intercepted-${a}` : "dynamic",
        paramName: i.slice(1, -1)
      } : null;
    }
    function o(i) {
      return i === "catchall" || i === "catchall-intercepted-(..)(..)" || i === "catchall-intercepted-(.)" || i === "catchall-intercepted-(..)" || i === "catchall-intercepted-(...)" || i === "optional-catchall";
    }
    function s(i) {
      let a = !1, c = !1;
      switch (i) {
        case "catchall":
        case "catchall-intercepted-(..)(..)":
        case "catchall-intercepted-(.)":
        case "catchall-intercepted-(..)":
        case "catchall-intercepted-(...)":
          a = !0;
          break;
        case "optional-catchall":
          a = !0, c = !0;
          break;
      }
      return {
        repeat: a,
        optional: c
      };
    }
  })(go)), go;
}
var Eo = {}, vo = {}, ha;
function th() {
  return ha || (ha = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(w, h) {
      for (var g in h) Object.defineProperty(w, g, {
        enumerable: !0,
        get: h[g]
      });
    }
    t(e, {
      DecodeError: function() {
        return m;
      },
      MiddlewareNotFoundError: function() {
        return k;
      },
      MissingStaticPage: function() {
        return _;
      },
      NormalizeError: function() {
        return R;
      },
      PageNotFoundError: function() {
        return b;
      },
      SP: function() {
        return f;
      },
      ST: function() {
        return p;
      },
      WEB_VITALS: function() {
        return n;
      },
      execOnce: function() {
        return r;
      },
      getDisplayName: function() {
        return c;
      },
      getLocationOrigin: function() {
        return i;
      },
      getURL: function() {
        return a;
      },
      isAbsoluteUrl: function() {
        return s;
      },
      isResSent: function() {
        return l;
      },
      loadGetInitialProps: function() {
        return d;
      },
      normalizeRepeatedSlashes: function() {
        return u;
      },
      stringifyError: function() {
        return S;
      }
    });
    const n = [
      "CLS",
      "FCP",
      "FID",
      "INP",
      "LCP",
      "TTFB"
    ];
    function r(w) {
      let h = !1, g;
      return (...y) => (h || (h = !0, g = w(...y)), g);
    }
    const o = /^[a-zA-Z][a-zA-Z\d+\-.]*?:/, s = (w) => o.test(w);
    function i() {
      const { protocol: w, hostname: h, port: g } = window.location;
      return `${w}//${h}${g ? ":" + g : ""}`;
    }
    function a() {
      const { href: w } = window.location, h = i();
      return w.substring(h.length);
    }
    function c(w) {
      return typeof w == "string" ? w : w.displayName || w.name || "Unknown";
    }
    function l(w) {
      return w.finished || w.headersSent;
    }
    function u(w) {
      const h = w.split("?");
      return h[0].replace(/\\/g, "/").replace(/\/\/+/g, "/") + (h[1] ? `?${h.slice(1).join("?")}` : "");
    }
    async function d(w, h) {
      if (process.env.NODE_ENV !== "production" && w.prototype?.getInitialProps) {
        const E = `"${c(w)}.getInitialProps()" is defined as an instance method - visit https://nextjs.org/docs/messages/get-initial-props-as-an-instance-method for more information.`;
        throw Object.defineProperty(new Error(E), "__NEXT_ERROR_CODE", {
          value: "E1035",
          enumerable: !1,
          configurable: !0
        });
      }
      const g = h.res || h.ctx && h.ctx.res;
      if (!w.getInitialProps)
        return h.ctx && h.Component ? {
          pageProps: await d(h.Component, h.ctx)
        } : {};
      const y = await w.getInitialProps(h);
      if (g && l(g))
        return y;
      if (!y) {
        const E = `"${c(w)}.getInitialProps()" should resolve to an object. But found "${y}" instead.`;
        throw Object.defineProperty(new Error(E), "__NEXT_ERROR_CODE", {
          value: "E1025",
          enumerable: !1,
          configurable: !0
        });
      }
      return process.env.NODE_ENV !== "production" && Object.keys(y).length === 0 && !h.ctx && console.warn(`${c(w)} returned an empty object from \`getInitialProps\`. This de-optimizes and prevents automatic static optimization. https://nextjs.org/docs/messages/empty-object-getInitialProps`), y;
    }
    const f = typeof performance < "u", p = f && [
      "mark",
      "measure",
      "getEntriesByName"
    ].every((w) => typeof performance[w] == "function");
    class m extends Error {
    }
    class R extends Error {
    }
    class b extends Error {
      constructor(h) {
        super(), this.code = "ENOENT", this.name = "PageNotFoundError", this.message = `Cannot find module for page: ${h}`;
      }
    }
    class _ extends Error {
      constructor(h, g) {
        super(), this.message = `Failed to load static file for page: ${h} ${g}`;
      }
    }
    class k extends Error {
      constructor() {
        super(), this.code = "ENOENT", this.message = "Cannot find the middleware module";
      }
    }
    function S(w) {
      return JSON.stringify({
        message: w.message,
        stack: w.stack
      });
    }
  })(vo)), vo;
}
var wo = {}, pa;
function nh() {
  return pa || (pa = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(i, a) {
      for (var c in a) Object.defineProperty(i, c, {
        enumerable: !0,
        get: a[c]
      });
    }
    t(e, {
      assign: function() {
        return s;
      },
      searchParamsToUrlQuery: function() {
        return n;
      },
      urlQueryToSearchParams: function() {
        return o;
      }
    });
    function n(i) {
      const a = {};
      for (const [c, l] of i.entries()) {
        const u = a[c];
        typeof u > "u" ? a[c] = l : Array.isArray(u) ? u.push(l) : a[c] = [
          u,
          l
        ];
      }
      return a;
    }
    function r(i) {
      return typeof i == "string" ? i : typeof i == "number" && !isNaN(i) || typeof i == "boolean" ? String(i) : "";
    }
    function o(i) {
      const a = new URLSearchParams();
      for (const [c, l] of Object.entries(i))
        if (Array.isArray(l))
          for (const u of l)
            a.append(c, r(u));
        else
          a.set(c, r(l));
      return a;
    }
    function s(i, ...a) {
      for (const c of a) {
        for (const l of c.keys())
          i.delete(l);
        for (const [l, u] of c.entries())
          i.append(l, u);
      }
      return i;
    }
  })(wo)), wo;
}
var ma;
function rh() {
  return ma || (ma = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "parseRelativeUrl", {
      enumerable: !0,
      get: function() {
        return r;
      }
    });
    const t = th(), n = nh();
    function r(o, s, i = !0) {
      const a = new URL(typeof window > "u" ? "http://n" : (0, t.getLocationOrigin)()), c = s ? new URL(s, a) : o.startsWith(".") ? new URL(typeof window > "u" ? "http://n" : window.location.href) : a, { pathname: l, searchParams: u, search: d, hash: f, href: p, origin: m } = o.startsWith("/") ? (
        // See https://nodejs.org/api/http.html#messageurl
        // Not using `origin` to support other protocols
        new URL(`${c.protocol}//${c.host}${o}`)
      ) : new URL(o, c);
      if (m !== a.origin)
        throw Object.defineProperty(new Error(`invariant: invalid relative URL, router received ${o}`), "__NEXT_ERROR_CODE", {
          value: "E159",
          enumerable: !1,
          configurable: !0
        });
      return {
        auth: null,
        host: null,
        hostname: null,
        pathname: l,
        port: null,
        protocol: null,
        query: i ? (0, n.searchParamsToUrlQuery)(u) : void 0,
        search: d,
        hash: f,
        href: p.slice(m.length),
        // We don't know for relative URLs at this point since we set a custom, internal
        // base that isn't surfaced to users.
        slashes: null
      };
    }
  })(Eo)), Eo;
}
var Ro = {}, ga;
function qc() {
  return ga || (ga = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(s, i) {
      for (var a in i) Object.defineProperty(s, a, {
        enumerable: !0,
        get: i[a]
      });
    }
    t(e, {
      InstantValidationError: function() {
        return o;
      },
      isInstantValidationError: function() {
        return r;
      }
    });
    const n = "INSTANT_VALIDATION_ERROR";
    function r(s) {
      return !!(s && typeof s == "object" && s instanceof Error && s.digest === n);
    }
    class o extends Error {
      constructor(...i) {
        super(...i), this.digest = n;
      }
    }
  })(Ro)), Ro;
}
var So = {}, ya;
function oh() {
  return ya || (ya = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(i, a) {
      for (var c in a) Object.defineProperty(i, c, {
        enumerable: !0,
        get: a[c]
      });
    }
    t(e, {
      describeHasCheckingStringProperty: function() {
        return o;
      },
      describeStringPropertyAccess: function() {
        return r;
      },
      wellKnownProperties: function() {
        return s;
      }
    });
    const n = /^[A-Za-z_$][A-Za-z0-9_$]*$/;
    function r(i, a) {
      return n.test(a) ? `\`${i}.${a}\`` : `\`${i}[${JSON.stringify(a)}]\``;
    }
    function o(i, a) {
      const c = JSON.stringify(a);
      return `\`Reflect.has(${i}, ${c})\`, \`${c} in ${i}\`, or similar`;
    }
    const s = /* @__PURE__ */ new Set([
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "toString",
      "valueOf",
      "toLocaleString",
      // Promise prototype
      "then",
      "catch",
      "finally",
      // React Promise extension
      "status",
      // 'value',
      // 'error',
      // React introspection
      "displayName",
      "_debugInfo",
      // Common tested properties
      "toJSON",
      "$$typeof",
      "__esModule",
      // Tested by flight when checking for iterables
      "@@iterator"
    ]);
  })(So)), So;
}
var _a;
function sh() {
  return _a || (_a = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(x, M) {
      for (var L in M) Object.defineProperty(x, L, {
        enumerable: !0,
        get: M[L]
      });
    }
    t(e, {
      assertRootParamInSamples: function() {
        return H;
      },
      createCookiesFromSample: function() {
        return R;
      },
      createDraftModeForValidation: function() {
        return k;
      },
      createExhaustiveParamsProxy: function() {
        return S;
      },
      createExhaustiveSearchParamsProxy: function() {
        return w;
      },
      createExhaustiveURLSearchParamsProxy: function() {
        return h;
      },
      createHeadersFromSample: function() {
        return _;
      },
      createRelativeURLFromSamples: function() {
        return y;
      },
      createValidationSampleTracking: function() {
        return d;
      },
      trackMissingSampleError: function() {
        return p;
      },
      trackMissingSampleErrorAndThrow: function() {
        return m;
      }
    });
    const n = Hc(), r = Kf(), o = Yf(), s = eh(), i = rh(), a = lr(), c = qc(), l = bs(), u = oh();
    function d() {
      return {
        missingSampleErrors: []
      };
    }
    function f() {
      let x = null;
      const M = l.workUnitAsyncStorage.getStore();
      if (M)
        switch (M.type) {
          case "request":
          case "validation-client":
            x = M.validationSampleTracking ?? null;
            break;
        }
      if (!x)
        throw Object.defineProperty(new a.InvariantError("Expected to have a workUnitStore that provides validationSampleTracking"), "__NEXT_ERROR_CODE", {
          value: "E1110",
          enumerable: !1,
          configurable: !0
        });
      return x;
    }
    function p(x) {
      f().missingSampleErrors.push(x);
    }
    function m(x) {
      throw p(x), x;
    }
    function R(x, M) {
      const L = /* @__PURE__ */ new Set(), $ = new n.RequestCookies(new Headers());
      if (x)
        for (const z of x)
          L.add(z.name), z.value !== null && $.set(z.name, z.value);
      const U = r.RequestCookiesAdapter.seal($);
      return new Proxy(U, {
        get(z, V, D) {
          if (V === "has") {
            const Z = Reflect.get(z, V, D);
            return function(T) {
              return L.has(T) || m(b(M, T)), Z.call(z, T);
            };
          }
          if (V === "get") {
            const Z = Reflect.get(z, V, D);
            return function(T) {
              let q;
              if (typeof T == "string")
                q = T;
              else if (T && typeof T == "object" && typeof T.name == "string")
                q = T.name;
              else
                return Z.call(z, T);
              return L.has(q) || m(b(M, q)), Z.call(z, q);
            };
          }
          return Reflect.get(z, V, D);
        }
      });
    }
    function b(x, M) {
      return Object.defineProperty(new c.InstantValidationError(`Route "${x}" accessed cookie "${M}" which is not defined in the \`samples\` of \`unstable_instant\`. Add it to the sample's \`cookies\` array, or \`{ name: "${M}", value: null }\` if it should be absent.`), "__NEXT_ERROR_CODE", {
        value: "E1115",
        enumerable: !1,
        configurable: !0
      });
    }
    function _(x, M, L) {
      const $ = x ? [
        ...x
      ] : [];
      if ($.find(([D]) => D.toLowerCase() === "cookie"))
        throw Object.defineProperty(new c.InstantValidationError('Invalid sample: Defining cookies via a "cookie" header is not supported. Use `cookies: [{ name: ..., value: ... }]` instead.'), "__NEXT_ERROR_CODE", {
          value: "E1111",
          enumerable: !1,
          configurable: !0
        });
      if (M) {
        const D = M.toString();
        $.push([
          "cookie",
          // if the `cookies` samples were empty, or they were all `null`, then we have no cookies,
          // and the header isn't present, but should remains readable, so we set it to null.
          D !== "" ? D : null
        ]);
      }
      const U = /* @__PURE__ */ new Set(), z = {};
      for (const [D, Z] of $)
        U.add(D.toLowerCase()), Z !== null && (z[D.toLowerCase()] = Z);
      const V = o.HeadersAdapter.seal(o.HeadersAdapter.from(z));
      return new Proxy(V, {
        get(D, Z, ie) {
          if (Z === "get" || Z === "has") {
            const T = Reflect.get(D, Z, ie);
            return function(I) {
              const j = I.toLowerCase();
              return U.has(j) || m(Object.defineProperty(new c.InstantValidationError(`Route "${L}" accessed header "${j}" which is not defined in the \`samples\` of \`unstable_instant\`. Add it to the sample's \`headers\` array, or \`["${j}", null]\` if it should be absent.`), "__NEXT_ERROR_CODE", {
                value: "E1116",
                enumerable: !1,
                configurable: !0
              })), T.call(D, j);
            };
          }
          return Reflect.get(D, Z, ie);
        }
      });
    }
    function k() {
      return {
        get isEnabled() {
          return !1;
        },
        enable() {
          throw Object.defineProperty(new Error("Draft mode cannot be enabled during build-time instant validation."), "__NEXT_ERROR_CODE", {
            value: "E1092",
            enumerable: !1,
            configurable: !0
          });
        },
        disable() {
          throw Object.defineProperty(new Error("Draft mode cannot be disabled during build-time instant validation."), "__NEXT_ERROR_CODE", {
            value: "E1094",
            enumerable: !1,
            configurable: !0
          });
        }
      };
    }
    function S(x, M, L) {
      return new Proxy(x, {
        get($, U, z) {
          return typeof U == "string" && !u.wellKnownProperties.has(U) && // Only error when accessing a param that is part of the route but wasn't provided.
          // accessing properties that aren't expected to be a valid param value is fine.
          U in x && !M.has(U) && m(Object.defineProperty(new c.InstantValidationError(`Route "${L}" accessed param "${U}" which is not defined in the \`samples\` of \`unstable_instant\`. Add it to the sample's \`params\` object.`), "__NEXT_ERROR_CODE", {
            value: "E1095",
            enumerable: !1,
            configurable: !0
          })), Reflect.get($, U, z);
        }
      });
    }
    function w(x, M, L) {
      return new Proxy(x, {
        get($, U, z) {
          return typeof U == "string" && !u.wellKnownProperties.has(U) && !M.has(U) && m(g(L, U)), Reflect.get($, U, z);
        },
        has($, U) {
          return typeof U == "string" && !u.wellKnownProperties.has(U) && !M.has(U) && m(g(L, U)), Reflect.has($, U);
        }
      });
    }
    function h(x, M, L) {
      return new Proxy(x, {
        get($, U, z) {
          if (U === "get" || U === "getAll" || U === "has") {
            const D = Reflect.get($, U, z);
            return (Z) => (typeof Z == "string" && !M.has(Z) && m(g(L, Z)), D.call($, Z));
          }
          const V = Reflect.get($, U, z);
          return typeof V == "function" && !Object.hasOwn($, U) ? V.bind($) : V;
        }
      });
    }
    function g(x, M) {
      return Object.defineProperty(new c.InstantValidationError(`Route "${x}" accessed searchParam "${M}" which is not defined in the \`samples\` of \`unstable_instant\`. Add it to the sample's \`searchParams\` object, or \`{ "${M}": null }\` if it should be absent.`), "__NEXT_ERROR_CODE", {
        value: "E1098",
        enumerable: !1,
        configurable: !0
      });
    }
    function y(x, M, L) {
      const $ = A(x, M ?? {});
      let U = "";
      if (L) {
        const z = E(L).toString();
        z && (U = "?" + z);
      }
      return (0, i.parseRelativeUrl)($ + U, void 0, !0);
    }
    function E(x) {
      const M = new URLSearchParams();
      if (x) {
        for (const [L, $] of Object.entries(x))
          if ($ != null)
            if (Array.isArray($))
              for (const U of $)
                M.append(L, U);
            else
              M.set(L, $);
      }
      return M;
    }
    function A(x, M) {
      let L = [];
      const $ = x.split("/");
      for (const U of $) {
        const z = (0, s.getSegmentParam)(U);
        if (z)
          switch (z.paramType) {
            case "catchall":
            case "optional-catchall": {
              let V = M[z.paramName];
              if (V === void 0)
                V = [
                  U
                ];
              else if (!Array.isArray(V))
                throw Object.defineProperty(new c.InstantValidationError(`Expected sample param value for segment '${U}' to be an array of strings, got ${typeof V}`), "__NEXT_ERROR_CODE", {
                  value: "E1104",
                  enumerable: !1,
                  configurable: !0
                });
              L.push(...V.map((D) => encodeURIComponent(D)));
              break;
            }
            case "dynamic": {
              let V = M[z.paramName];
              if (V === void 0)
                V = U;
              else if (typeof V != "string")
                throw Object.defineProperty(new c.InstantValidationError(`Expected sample param value for segment '${U}' to be a string, got ${typeof V}`), "__NEXT_ERROR_CODE", {
                  value: "E1108",
                  enumerable: !1,
                  configurable: !0
                });
              L.push(encodeURIComponent(V));
              break;
            }
            case "catchall-intercepted-(..)(..)":
            case "catchall-intercepted-(.)":
            case "catchall-intercepted-(..)":
            case "catchall-intercepted-(...)":
            case "dynamic-intercepted-(..)(..)":
            case "dynamic-intercepted-(.)":
            case "dynamic-intercepted-(..)":
            case "dynamic-intercepted-(...)":
              throw Object.defineProperty(new a.InvariantError("Not implemented: Validation of interception routes"), "__NEXT_ERROR_CODE", {
                value: "E1106",
                enumerable: !1,
                configurable: !0
              });
            default:
              z.paramType;
          }
        else
          L.push(U);
      }
      return L.join("/");
    }
    function H(x, M, L) {
      if (!(M && L in M)) {
        const $ = x.route;
        m(Object.defineProperty(new c.InstantValidationError(`Route "${$}" accessed root param "${L}" which is not defined in the \`samples\` of \`unstable_instant\`. Add it to the sample's \`params\` object.`), "__NEXT_ERROR_CODE", {
          value: "E1114",
          enumerable: !1,
          configurable: !0
        }));
      }
    }
  })(co)), co;
}
var ba;
function ih() {
  return ba || (ba = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(l, u) {
      for (var d in u) Object.defineProperty(l, d, {
        enumerable: !0,
        get: u[d]
      });
    }
    t(e, {
      expectCompleteParamsInClientValidation: function() {
        return a;
      },
      instrumentParamsForClientValidation: function() {
        return i;
      },
      instrumentSearchParamsForClientValidation: function() {
        return c;
      }
    });
    const n = bs(), r = Es(), o = sh(), s = qc();
    function i(l) {
      const u = r.workAsyncStorage.getStore(), d = n.workUnitAsyncStorage.getStore();
      if (u && d)
        switch (d.type) {
          case "validation-client": {
            if (d.validationSamples) {
              const f = new Set(Object.keys(d.validationSamples.params ?? {}));
              return (0, o.createExhaustiveParamsProxy)(l, f, u.route);
            }
            break;
          }
        }
      return l;
    }
    function a(l) {
      const u = r.workAsyncStorage.getStore(), d = n.workUnitAsyncStorage.getStore();
      if (u && d)
        switch (d.type) {
          case "validation-client": {
            if (d.validationSamples) {
              const f = d.fallbackRouteParams;
              if (f && f.size > 0) {
                const p = Array.from(f.keys());
                (0, o.trackMissingSampleErrorAndThrow)(Object.defineProperty(new s.InstantValidationError(`Route "${u.route}" called ${l} but param${p.length > 1 ? "s" : ""} ${p.map((m) => `"${m}"`).join(", ")} ${p.length > 1 ? "are" : "is"} not defined in the \`samples\` of \`unstable_instant\`. ${l} requires all route params to be provided.`), "__NEXT_ERROR_CODE", {
                  value: "E1109",
                  enumerable: !1,
                  configurable: !0
                }));
              }
            }
            break;
          }
        }
    }
    function c(l) {
      const u = r.workAsyncStorage.getStore(), d = n.workUnitAsyncStorage.getStore();
      if (u && d)
        switch (d.type) {
          case "validation-client": {
            if (d.validationSamples) {
              const f = new Set(Object.keys(d.validationSamples.searchParams ?? {}));
              return (0, o.createExhaustiveURLSearchParamsProxy)(l, f, u.route);
            }
            break;
          }
        }
      return l;
    }
  })(ao)), ao;
}
var Ea;
function ah() {
  return Ea || (Ea = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(g, y) {
      for (var E in y) Object.defineProperty(g, E, {
        enumerable: !0,
        get: y[E]
      });
    }
    n(t, {
      // We need the same class that was used to instantiate the context value
      // Otherwise instanceof checks will fail in usercode
      ReadonlyURLSearchParams: function() {
        return i.ReadonlyURLSearchParams;
      },
      RedirectType: function() {
        return u.RedirectType;
      },
      ServerInsertedHTMLContext: function() {
        return c.ServerInsertedHTMLContext;
      },
      forbidden: function() {
        return u.forbidden;
      },
      notFound: function() {
        return u.notFound;
      },
      permanentRedirect: function() {
        return u.permanentRedirect;
      },
      redirect: function() {
        return u.redirect;
      },
      unauthorized: function() {
        return u.unauthorized;
      },
      unstable_isUnrecognizedActionError: function() {
        return l.unstable_isUnrecognizedActionError;
      },
      unstable_rethrow: function() {
        return u.unstable_rethrow;
      },
      useParams: function() {
        return S;
      },
      usePathname: function() {
        return _;
      },
      useRouter: function() {
        return k;
      },
      useSearchParams: function() {
        return b;
      },
      useSelectedLayoutSegment: function() {
        return h;
      },
      useSelectedLayoutSegments: function() {
        return w;
      },
      useServerInsertedHTML: function() {
        return c.useServerInsertedHTML;
      }
    });
    const o = /* @__PURE__ */ (/* @__PURE__ */ kc())._(ce), s = Sf(), i = Tf(), a = xc(), c = Af(), l = Cf(), u = Gf(), d = typeof window > "u" ? Zo().useDynamicRouteParams : void 0, f = typeof window > "u" ? Zo().useDynamicSearchParams : void 0, { instrumentParamsForClientValidation: p, instrumentSearchParamsForClientValidation: m, expectCompleteParamsInClientValidation: R } = typeof window > "u" && process.env.__NEXT_CACHE_COMPONENTS ? ih() : {};
    function b() {
      f?.("useSearchParams()");
      const g = (0, o.useContext)(i.SearchParamsContext), y = (0, o.useMemo)(() => g ? new i.ReadonlyURLSearchParams(g) : null, [
        g
      ]);
      if (typeof window > "u" && process.env.__NEXT_CACHE_COMPONENTS && y)
        return m(y);
      if (process.env.NODE_ENV !== "production" && "use" in o.default) {
        const E = (0, o.use)(i.NavigationPromisesContext);
        if (E)
          return (0, o.use)(E.searchParams);
      }
      return y;
    }
    function _() {
      d?.("usePathname()");
      const g = (0, o.useContext)(i.PathnameContext);
      if (typeof window > "u" && process.env.__NEXT_CACHE_COMPONENTS && g)
        return R("usePathname()"), g;
      if (process.env.NODE_ENV !== "production" && "use" in o.default) {
        const y = (0, o.use)(i.NavigationPromisesContext);
        if (y)
          return (0, o.use)(y.pathname);
      }
      return g;
    }
    function k() {
      const g = (0, o.useContext)(s.AppRouterContext);
      if (g === null)
        throw Object.defineProperty(new Error("invariant expected app router to be mounted"), "__NEXT_ERROR_CODE", {
          value: "E238",
          enumerable: !1,
          configurable: !0
        });
      return g;
    }
    function S() {
      d?.("useParams()");
      const g = (0, o.useContext)(i.PathParamsContext);
      if (typeof window > "u" && process.env.__NEXT_CACHE_COMPONENTS && g)
        return p(g);
      if (process.env.NODE_ENV !== "production" && "use" in o.default) {
        const y = (0, o.use)(i.NavigationPromisesContext);
        if (y)
          return (0, o.use)(y.params);
      }
      return g;
    }
    function w(g = "children") {
      d?.("useSelectedLayoutSegments()");
      const y = (0, o.useContext)(s.LayoutRouterContext);
      if (!y) return null;
      if (typeof window > "u" && process.env.__NEXT_CACHE_COMPONENTS && y && R("useSelectedLayoutSegments()"), process.env.NODE_ENV !== "production" && "use" in o.default) {
        const E = (0, o.use)(i.NavigationPromisesContext);
        if (E) {
          const A = E.selectedLayoutSegmentsPromises?.get(g);
          if (A)
            return (0, o.use)(A);
        }
      }
      return (0, a.getSelectedLayoutSegmentPath)(y.parentTree, g);
    }
    function h(g = "children") {
      d?.("useSelectedLayoutSegment()");
      const y = (0, o.useContext)(i.NavigationPromisesContext), E = w(g);
      if (typeof window > "u" && process.env.__NEXT_CACHE_COMPONENTS && R("useSelectedLayoutSegment()"), process.env.NODE_ENV !== "production" && y && "use" in o.default) {
        const A = y.selectedLayoutSegmentPromises?.get(g);
        if (A)
          return (0, o.use)(A);
      }
      return (0, a.computeSelectedLayoutSegment)(E, g);
    }
    (typeof t.default == "function" || typeof t.default == "object" && t.default !== null) && typeof t.default.__esModule > "u" && (Object.defineProperty(t.default, "__esModule", { value: !0 }), Object.assign(t.default, t), e.exports = t.default);
  })(Rn, Rn.exports)), Rn.exports;
}
var To, va;
function ch() {
  return va || (va = 1, To = ah()), To;
}
var wa = ch();
const lh = ["bot", "crawl", "headless", "http", "lighthouse", "python", "scan", "slurp", "spider", "wget"], uh = ["android", "iphone", "ipod", "mobile", "windows phone"], dh = {
  /**
   * Classify a raw UA string.
   * @param userAgent - The `navigator.userAgent` string (may be empty).
   * @returns One of `bot-suspect | desktop | mobile`.
   */
  fromUserAgent(e) {
    const t = e.trim().toLowerCase();
    return t.length === 0 || lh.some((n) => t.includes(n)) ? "bot-suspect" : uh.some((n) => t.includes(n)) ? "mobile" : "desktop";
  }
}, fh = {
  /**
   * Derive the bounded route pattern.
   * @param pathname - The concrete pathname from `usePathname()` (eg: `/blog/my-post`).
   * @param params - The dynamic params from `useParams()` (eg: `{ slug: ['blog', 'my-post'] }`).
   * @returns The route pattern (eg: `/[...slug]`), or the pathname unchanged when it has no params.
   */
  fromPathname(e, t) {
    const n = e.split("/").filter((i) => i.length > 0);
    if (n.length === 0) return "/";
    const r = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
    for (const [i, a] of Object.entries(t))
      Array.isArray(a) ? r.set(a.join("/"), `[...${i}]`) : o.set(a, `[${i}]`);
    for (const [i, a] of r) {
      const c = i.split("/").filter((u) => u.length > 0), l = hh(n, c);
      l !== -1 && n.splice(l, c.length, a);
    }
    return `/${n.map((i) => o.get(i) ?? i).join("/")}`;
  }
}, hh = (e, t) => {
  if (t.length === 0 || t.length > e.length) return -1;
  for (let n = 0; n <= e.length - t.length; n += 1) {
    let r = !0;
    for (let o = 0; o < t.length; o += 1)
      if (e[n + o] !== t[o]) {
        r = !1;
        break;
      }
    if (r) return n;
  }
  return -1;
}, ph = "https://metrics-dev.blufin.org/telemetry", mh = "https://metrics.blufin.org/telemetry", gh = {
  /**
   * Map a raw `window.location.hostname` to its ingest edge.
   * @param hostname - The browser hostname (eg: `localhost`, `127.0.0.1`, `builtbybert.com`).
   * @returns The ingest origin + canonical `appEnv`.
   */
  fromHostname(e) {
    const t = e.trim().toLowerCase();
    return t === "localhost" || t === "::1" || t.startsWith("127.") ? {
      appEnv: "dev",
      baseUrl: ph
    } : {
      appEnv: "prod",
      baseUrl: mh
    };
  }
}, yh = {
  /** Returns the current wall-clock time. */
  now: () => Date.now(),
  /**
   * Resolves after `ms` milliseconds.
   * @param ms - Delay in milliseconds.
   */
  sleep: (e) => new Promise((t) => setTimeout(t, e))
}, _h = (e, t) => {
  const [n, r] = pe(void 0);
  return le(() => {
    const o = e.createTransport();
    if (!o) {
      r(void 0);
      return;
    }
    const s = new Ju({
      clock: e.clock ?? yh,
      context: e.context,
      ...e.flushIntervalMs ? {
        flushIntervalMs: e.flushIntervalMs
      } : {},
      registry: e.registry,
      transport: o
    });
    return it.setAgent(s), r(s), e.onStart?.(s), () => {
      it.clearAgent(s), s.dispose();
    };
  }, t), n;
}, bh = 1e4, My = ({
  app: e,
  children: t
}) => {
  const n = wa.usePathname(), r = wa.useParams(), o = he(void 0), s = _h({
    context: {
      app: e,
      appEnv: Ra().appEnv,
      appVersion: vh()
    },
    /**
     * Build the browser beacon transport pointed at the env-derived ingest edge.
     * @returns The `SiteBeaconTransport` for this hostname, or `undefined` server-side (no beacon).
     */
    createTransport: () => {
      if (!(typeof window > "u"))
        return new Zu({
          baseUrl: Ra().baseUrl
        });
    },
    /**
     * Marketing sites are low-traffic: a session may emit far fewer than the agent's size trigger,
     * so without a cadence the started + page-view batch would sit queued until `pagehide`. A 10s
     * drain ships them while the tab is open; the terminal `site.session.ended` flush handles close.
     */
    flushIntervalMs: bh,
    /**
     * First-light per tab: stamp the per-tab session id, emit `site.session.started` with the
     * coarse UA class, and arm the `SiteSessionTracker` so `site.session.ended` flushes on tab close.
     * @param liveAgent - The freshly-created telemetry agent.
     */
    onStart: (i) => {
      if (typeof window > "u") return;
      const a = new ed({
        /** Wall-clock source for the foreground-duration accumulator. */
        now: () => Date.now(),
        /**
         * Terminal flush on tab close: emit `site.session.ended` and drain the queue immediately.
         * @param payload - The sealed `{ duration_seconds, pages_viewed }` from the tracker.
         */
        onSessionEnded: (c) => {
          i.log({
            data: {
              duration_seconds: c.duration_seconds,
              pages_viewed: c.pages_viewed
            },
            event: "site.session.ended",
            level: Ne.INFO,
            message: "site.session.ended"
          }), i.flush();
        },
        sessionStorage: wh(),
        visibilityDocument: document,
        window
      });
      i.setContext({
        sessionId: a.getSessionId()
      }), i.log({
        data: {
          landing_page: window.location.pathname,
          referrer_domain: Eh(document.referrer),
          user_agent_class: dh.fromUserAgent(navigator.userAgent)
        },
        event: "site.session.started",
        level: Ne.INFO,
        message: "site.session.started"
      }), i.counter("app_session_start_total", 1), o.current = a;
    },
    registry: td
  }, [e]);
  return le(() => {
    if (!s || n === null) return;
    const i = fh.fromPathname(n, r);
    s.counter("app_page_view_total", 1, {
      page: i
    }), o.current?.recordPageView();
  }, [s, n]), /* @__PURE__ */ C.jsx(C.Fragment, { children: t });
}, Eh = (e) => {
  if (!e) return "";
  try {
    return new URL(e).hostname;
  } catch {
    return "";
  }
}, Ra = () => {
  const e = typeof window < "u" ? window.location.hostname : "";
  return gh.fromHostname(e);
}, vh = () => {
  const e = typeof process < "u" ? process.env?.NEXT_PUBLIC_APP_VERSION : void 0;
  return e && e.length > 0 ? e : "0.0.0";
}, wh = () => {
  try {
    const e = window.sessionStorage, t = "__blufin_ss_probe__";
    return e.setItem(t, "1"), e.removeItem(t), e;
  } catch {
    const e = /* @__PURE__ */ new Map();
    return {
      /**
       * Read a value from the in-memory fallback store.
       * @param key - The storage key.
       */
      getItem: (t) => e.get(t) ?? null,
      /**
       * Write a value to the in-memory fallback store.
       * @param key - The storage key.
       * @param value - The value to store.
       */
      setItem: (t, n) => {
        e.set(t, n);
      }
    };
  }
}, Fc = {
  authData: null,
  isAuthenticated: !1,
  isAuthInitialized: !1
}, Mt = qt({
  ...Fc
}), je = {
  /** Returns the current auth state snapshot. */
  getState: Mt.getState,
  /** React hook that subscribes to a slice of auth state via `useSyncExternalStore`. */
  use: Mt.use,
  /**
   * Sets the authenticated user data and marks the user as logged in.
   * @param authData - The authenticated user's AuthData.
   */
  loginSuccess: (e) => Mt.setState({
    authData: e,
    isAuthenticated: !0
  }),
  /** Clears the auth data and marks the user as logged out. */
  logout: () => Mt.setState({
    authData: null,
    isAuthenticated: !1
  }),
  /** Marks the auth system as fully initialized after the initial token hydration (one-way operation). */
  setAuthAsInitialized: () => Mt.setState({
    isAuthInitialized: !0
  }),
  /** Resets all auth state back to its initial values. Intended for use in tests. */
  resetForTesting: () => Mt.setState({
    ...Fc
  })
}, Bc = {
  isProfileInitialized: !1,
  profile: null
}, Xt = qt({
  ...Bc
}), ft = {
  /** Returns the current profile state snapshot. */
  getState: Xt.getState,
  /** React hook that subscribes to a slice of profile state via `useSyncExternalStore`. */
  use: Xt.use,
  /** Clears the profile back to its initial values. Called on logout, so the next user never sees this one's photo. */
  clear: () => Xt.setState({
    ...Bc
  }),
  /**
   * Resets all profile state back to its initial values. Intended for use in tests. Delegates to `clear`:
   * unlike `AuthStoreAlpha`, whose `logout` is a partial reset, every field this store owns belongs to the
   * signed-in user, so the logout reset and the test reset are necessarily the same operation.
   */
  resetForTesting: () => ft.clear(),
  /**
   * Sets (or clears) the signed-in user's profile record.
   * @param profile - The profile record, or null when the user has none yet.
   */
  setProfile: (e) => Xt.setState({
    profile: e
  }),
  /** Marks the profile as initialized once the first fetch has settled — success or failure (one-way operation). */
  setProfileAsInitialized: () => Xt.setState({
    isProfileInitialized: !0
  })
};
class es {
  constructor(t) {
    N(this, "httpClient");
    this.httpClient = t;
  }
  deleteAlpha(t, n) {
    return fe((r, o) => {
      this.httpClient.delete("@blufin/asset-service", "COGNITO", "alpha/delete", {
        ...n,
        params: t
      }).then((s) => r(s)).catch((s) => o(s));
    });
  }
  listAlpha(t, n) {
    return fe((r, o) => {
      this.httpClient.get("@blufin/asset-service", "COGNITO", "alpha/list", {
        ...n,
        params: t
      }).then((s) => r(s)).catch((s) => o(s));
    });
  }
  async *listAlphaAll(t, n) {
    let r;
    for (; ; ) {
      const o = await this.listAlpha({
        ...t,
        cursor: r,
        limit: t?.limit
      }, n);
      if (yield o.data, !o.pagination.hasMore || !o.pagination.cursor) break;
      r = o.pagination.cursor;
    }
  }
  resolveAlpha(t, n) {
    return fe((r, o) => {
      this.httpClient.get("@blufin/asset-service", "COGNITO", "alpha/resolve", {
        ...n,
        params: t
      }).then((s) => r(s)).catch((s) => o(s));
    });
  }
  uploadRequestAlpha(t, n) {
    return fe((r, o) => {
      this.httpClient.post("@blufin/asset-service", "COGNITO", "alpha/upload-request", t, n).then((s) => r(s)).catch((s) => o(s));
    });
  }
}
N(es, "serviceName", "asset"), N(es, "endpointMeta", {
  deleteAlpha: {
    httpMethod: "DELETE"
  },
  listAlpha: {
    httpMethod: "GET",
    pagination: {
      type: "CURSOR",
      defaultLimit: 50,
      maxLimit: 100
    }
  },
  resolveAlpha: {
    httpMethod: "GET"
  },
  uploadRequestAlpha: {
    httpMethod: "POST"
  }
});
const Ao = 100, Rh = "IdSet cannot have blank sections between commas. Got → {0}", Sh = "ID(s) cannot be zero. Contains zero → {0}", Th = "ID(s) must be a number. Got → {0}", Ah = "ID(s) must be an Integer value between 1 and 2147483648. Contains out of bounds value → {0}", Ch = "Maximum number of {1} IDs has been exceeded. Got → {0}", Oh = "1st number is equal to or larger than the 2nd number in a sequence pair. Invalid sequence → {0}", kh = "IdSet can only contain numbers, commas & hyphens (IE: 1,5-9,21,50). Got → {0}", Sa = "Invalid syntax or possible negative number(s) → {0}", Ph = "An unknown error occurred instantiating an IdSet. Invalid IdSet → {0}", xh = /^[0-9,-]+$/;
class Ih {
  /**
   * Creates a new IdSet from various input formats.
   * @param ids - The input to create the IdSet from. Can be a number, array of numbers, comma-separated string (eg: "1,4-10"), or any iterable of numbers.
   */
  constructor(t) {
    N(this, "errors", []);
    N(this, "ids", /* @__PURE__ */ new Set());
    N(this, "counter", 0);
    N(this, "sortedCache", null);
    if (t === void 0) this._initialize(null);
    else if (typeof t == "number") this._initialize(t.toString());
    else if (typeof t == "string") this._initialize(t);
    else if (Array.isArray(t)) this._initialize(t.join(","));
    else if (t[Symbol.iterator]) {
      const n = [];
      for (const r of t)
        n.push(r);
      this._initialize(n.join(","));
    } else throw new Error(`Invalid constructor argument: ${t}`);
  }
  /**
   * Parses and initializes the IdSet from a string representation.
   * @param idSet - The string representation of the IdSet (eg: "1,4-10") or null for an empty set.
   */
  _initialize(t) {
    try {
      if (t === null || t.trim() === "") return;
      t = t.replace(/\s/g, ""), xh.test(t) || this._throwException(t, kh);
      const n = t.includes(",") ? t.split(",") : [t];
      for (const r of n)
        if (r === "" && this._throwException(t, Rh), r.includes("-")) {
          const o = r.split("-");
          (o.length !== 2 || o[0] === "" || o[1] === "") && this._throwException(t, Sa);
          const s = this._convertToInteger(o[0], t), i = this._convertToInteger(o[1], t);
          s >= i && this._throwException(t, Oh);
          for (let a = s; a <= i; a++)
            this._addInternally(a, t);
        } else
          /^\d+$/.test(r) || this._throwException(t, Sa), this._addInternally(this._convertToInteger(r, t), t);
    } catch (n) {
      if (n instanceof Co) this.errors.push(n.message);
      else
        throw this.errors.push(Ph.replace("{0}", t ?? "")), new Error(`Attempt to convert '${t}' to an IdSet failed in a way the system was unable to handle.`);
    }
  }
  /**
   * Adds an ID to the set.
   * @param id - The ID number to add to the set.
   */
  add(t) {
    this.ids.add(t), this._invalidateCache();
  }
  /**
   * Removes an ID from the set.
   * @param id - The ID number to remove from the set.
   */
  remove(t) {
    this.ids.delete(t), this._invalidateCache();
  }
  /**
   * Gets the lowest ID in the set.
   */
  getLowest() {
    return this.ids.size ? Math.min(...this.ids) : null;
  }
  /**
   * Gets the highest ID in the set.
   */
  getHighest() {
    return this.ids.size ? Math.max(...this.ids) : null;
  }
  /**
   * Checks if the set contains a specific ID.
   * @param id - The ID number to check for existence in the set.
   * @returns True if the ID exists in the set, false otherwise.
   */
  has(t) {
    return this.ids.has(t);
  }
  /**
   * Gets all IDs in the set as a sorted array.
   */
  getIds() {
    return this._getSortedIds();
  }
  /**
   * Returns the number of IDs in the set.
   */
  size() {
    return this.ids.size;
  }
  /**
   * Converts the set to a comma-separated string of sorted IDs.
   */
  toString() {
    return this._getSortedIds().join(",");
  }
  /**
   * Converts the set to a compact string representation with ranges (eg: "1,4-10,21").
   */
  toCompactString() {
    const t = this._getSortedIds();
    if (t.length === 0) return "";
    const n = [];
    let r = t[0], o = t[0];
    for (let s = 1; s < t.length; s++)
      t[s] === o + 1 ? o = t[s] : (n.push(r === o ? `${r}` : `${r}-${o}`), [r, o] = [t[s], t[s]]);
    return n.push(r === o ? `${r}` : `${r}-${o}`), n.join(",");
  }
  /**
   * Iterates over all IDs in the set in sorted order, executing a callback for each.
   * @param callback - The function to execute for each ID in the set.
   */
  forEach(t) {
    this._getSortedIds().forEach(t);
  }
  /**
   * Returns an iterator over the IDs in the set in sorted order.
   */
  [Symbol.iterator]() {
    const t = this._getSortedIds();
    let n = 0;
    return {
      /** Returns the next ID in sorted iteration order. */
      next: () => ({
        done: n >= t.length,
        value: t[n++]
      })
    };
  }
  /**
   * Adds an ID to the set internally during initialization with size limit enforcement.
   * @param id - The ID number to add to the set.
   * @param idSetString - The original string representation of the IdSet being parsed.
   */
  _addInternally(t, n) {
    if (this.ids.add(t), this._invalidateCache(), this.counter++, this.counter > Ao && this.ids.size > Ao)
      throw new Co(Ch.replace("{0}", n).replace("{1}", Ao.toString()));
  }
  /**
   * Converts a string to an integer with validation for valid ID ranges.
   * @param id - The string representation of the ID to convert.
   * @param idSet - The original string representation of the IdSet being parsed.
   * @returns The parsed integer value.
   */
  _convertToInteger(t, n) {
    const r = parseInt(t, 10);
    return isNaN(r) ? this._throwException(n, Th) : r < 0 || r > 2147483647 ? this._throwException(n, Ah) : r === 0 && this._throwException(n, Sh), r;
  }
  /**
   * Gets the sorted array of IDs, using cache when available.
   */
  _getSortedIds() {
    return this.sortedCache === null && (this.sortedCache = Array.from(this.ids).sort((t, n) => t - n)), this.sortedCache;
  }
  /**
   * Invalidates the sorted cache. Called whenever the set is modified.
   */
  _invalidateCache() {
    this.sortedCache = null;
  }
  /**
   * Throws an IdSetException with a formatted error message.
   * @param ids - The invalid IdSet string that caused the error.
   * @param errorMessage - The error message template with placeholder for the invalid IdSet value.
   */
  _throwException(t, n) {
    throw new Co(n.replace("{0}", t ?? ""));
  }
}
class Co extends Error {
  /**
   * Creates a new IdSetException.
   * @param message - The error message describing what went wrong.
   */
  constructor(t) {
    super(t), this.name = "IdSetException";
  }
}
class ts {
  constructor(t) {
    N(this, "httpClient");
    this.httpClient = t;
  }
  associateSoftwareTokenAlpha(t, n) {
    return fe((r, o) => {
      this.httpClient.post("@blufin/auth-service", "HMAC", "alpha/associate-software-token", t, n).then((s) => r(s)).catch((s) => o(s));
    });
  }
  authenticateUserAlpha(t, n) {
    return fe((r, o) => {
      this.httpClient.post("@blufin/auth-service", "HMAC", "alpha/authenticate-user", t, n).then((s) => r(s)).catch((s) => o(s));
    });
  }
  changeEmailAlpha(t, n) {
    return fe((r, o) => {
      this.httpClient.post("@blufin/auth-service", "COGNITO", "alpha/change-email", t, n).then((s) => r(s)).catch((s) => o(s));
    });
  }
  changePasswordAlpha(t, n) {
    return fe((r, o) => {
      this.httpClient.post("@blufin/auth-service", "COGNITO", "alpha/change-password", t, n).then((s) => r(s)).catch((s) => o(s));
    });
  }
  completeNewPasswordChallengeAlpha(t, n) {
    return fe((r, o) => {
      this.httpClient.post("@blufin/auth-service", "HMAC", "alpha/complete-new-password-challenge", t, n).then((s) => r(s)).catch((s) => o(s));
    });
  }
  confirmRegistrationAlpha(t, n) {
    return fe((r, o) => {
      this.httpClient.post("@blufin/auth-service", "HMAC", "alpha/confirm-registration", t, n).then((s) => r(s)).catch((s) => o(s));
    });
  }
  forgotPasswordAlpha(t, n) {
    return fe((r, o) => {
      this.httpClient.post("@blufin/auth-service", "HMAC", "alpha/forgot-password", t, n).then((s) => r(s)).catch((s) => o(s));
    });
  }
  forgotPasswordConfirmAlpha(t, n) {
    return fe((r, o) => {
      this.httpClient.post("@blufin/auth-service", "HMAC", "alpha/forgot-password-confirm", t, n).then((s) => r(s)).catch((s) => o(s));
    });
  }
  getProfilesAlpha(t, n) {
    return fe((r, o) => {
      this.httpClient.get("@blufin/auth-service", "COGNITO", "alpha/profile", {
        ...n,
        params: t
      }).then((s) => r(s)).catch((s) => o(s));
    });
  }
  listMyOrgsAlpha(t) {
    return fe((n, r) => {
      this.httpClient.get("@blufin/auth-service", "COGNITO", "alpha/list-my-orgs", t).then((o) => n(o)).catch((o) => r(o));
    });
  }
  refreshSessionAlpha(t, n) {
    return fe((r, o) => {
      this.httpClient.post("@blufin/auth-service", "HMAC", "alpha/refresh-session", t, n).then((s) => r(s)).catch((s) => o(s));
    });
  }
  resendConfirmationCodeAlpha(t, n) {
    return fe((r, o) => {
      this.httpClient.post("@blufin/auth-service", "HMAC", "alpha/resend-confirmation-code", t, n).then((s) => r(s)).catch((s) => o(s));
    });
  }
  respondToMfaChallengeAlpha(t, n) {
    return fe((r, o) => {
      this.httpClient.post("@blufin/auth-service", "HMAC", "alpha/respond-to-mfa-challenge", t, n).then((s) => r(s)).catch((s) => o(s));
    });
  }
  signUpAlpha(t, n) {
    return fe((r, o) => {
      this.httpClient.post("@blufin/auth-service", "HMAC", "alpha/sign-up", t, n).then((s) => r(s)).catch((s) => o(s));
    });
  }
  testEndpointAlpha(t, n, r, o, s) {
    return fe((i, a) => {
      const c = new Ih(n).toCompactString();
      this.httpClient.post("@blufin/auth-service", "NONE", `alpha/test-endpoint/${t}/${c}`, r, {
        ...s,
        params: o
      }).then((l) => i(l)).catch((l) => a(l));
    });
  }
  testEndpointNoBodyAlpha(t) {
    return fe((n, r) => {
      this.httpClient.post("@blufin/auth-service", "NONE", "alpha/test-endpoint/no-content", t).then((o) => n(o)).catch((o) => r(o));
    });
  }
  updateProfileAlpha(t, n) {
    return fe((r, o) => {
      this.httpClient.post("@blufin/auth-service", "COGNITO", "alpha/profile", t, n).then((s) => r(s)).catch((s) => o(s));
    });
  }
  verifyEmailChangeAlpha(t, n) {
    return fe((r, o) => {
      this.httpClient.post("@blufin/auth-service", "HMAC", "alpha/verify-email-change", t, n).then((s) => r(s)).catch((s) => o(s));
    });
  }
  verifySoftwareTokenAlpha(t, n) {
    return fe((r, o) => {
      this.httpClient.post("@blufin/auth-service", "HMAC", "alpha/verify-software-token", t, n).then((s) => r(s)).catch((s) => o(s));
    });
  }
}
N(ts, "serviceName", "auth"), N(ts, "endpointMeta", {
  associateSoftwareTokenAlpha: {
    httpMethod: "POST",
    encrypt: {
      request: !0,
      response: !0
    }
  },
  authenticateUserAlpha: {
    httpMethod: "POST",
    encrypt: {
      request: !0,
      response: !0
    }
  },
  changeEmailAlpha: {
    httpMethod: "POST"
  },
  changePasswordAlpha: {
    httpMethod: "POST"
  },
  completeNewPasswordChallengeAlpha: {
    httpMethod: "POST",
    encrypt: {
      request: !0,
      response: !0
    }
  },
  confirmRegistrationAlpha: {
    httpMethod: "POST",
    encrypt: {
      request: !0,
      response: !0
    }
  },
  forgotPasswordAlpha: {
    httpMethod: "POST",
    encrypt: {
      request: !0,
      response: !0
    }
  },
  forgotPasswordConfirmAlpha: {
    httpMethod: "POST",
    encrypt: {
      request: !0,
      response: !0
    }
  },
  getProfilesAlpha: {
    httpMethod: "GET"
  },
  listMyOrgsAlpha: {
    httpMethod: "GET"
  },
  refreshSessionAlpha: {
    httpMethod: "POST",
    encrypt: {
      request: !0,
      response: !0
    }
  },
  resendConfirmationCodeAlpha: {
    httpMethod: "POST",
    encrypt: {
      request: !0,
      response: !0
    }
  },
  respondToMfaChallengeAlpha: {
    httpMethod: "POST",
    encrypt: {
      request: !0,
      response: !0
    }
  },
  signUpAlpha: {
    httpMethod: "POST",
    encrypt: {
      request: !0,
      response: !0
    }
  },
  testEndpointAlpha: {
    httpMethod: "POST"
  },
  testEndpointNoBodyAlpha: {
    httpMethod: "POST"
  },
  updateProfileAlpha: {
    httpMethod: "POST"
  },
  verifyEmailChangeAlpha: {
    httpMethod: "POST"
  },
  verifySoftwareTokenAlpha: {
    httpMethod: "POST",
    encrypt: {
      request: !0,
      response: !0
    }
  }
});
const $c = () => {
  const e = re.c(7), t = vc();
  let n;
  e[0] !== t ? (n = new es(t), e[0] = t, e[1] = n) : n = e[1];
  const r = n;
  let o;
  e[2] !== t ? (o = new ts(t), e[2] = t, e[3] = o) : o = e[3];
  const s = o;
  let i;
  return e[4] !== r || e[5] !== s ? (i = {
    assetService: r,
    authService: s
  }, e[4] = r, e[5] = s, e[6] = i) : i = e[6], i;
}, Wc = () => gf() ?? it.getAgent() ?? void 0, Ee = {
  clientErrorBg: "background: #fd7e14; color: white; padding: 2px 6px; border-radius: 3px; font-weight: 600; font-family: monospace;",
  darkgray: "color: #666666; font-weight: 600; font-family: monospace;",
  errorBg: "background: #dc3545; color: white; padding: 2px 6px; border-radius: 3px; font-weight: 700; font-family: monospace;",
  green: "color: #28a745; font-weight: 600; font-family: monospace;",
  methodBg: "background: #6f42c1; color: white; padding: 2px 6px; border-radius: 3px; font-weight: 600; font-family: monospace;",
  purple: "color: #805ad5; font-weight: 600; font-family: monospace;",
  serverErrorBg: "background: #dc3545; color: white; padding: 2px 6px; border-radius: 3px; font-weight: 600; font-family: monospace;",
  successBg: "background: #28a745; color: white; padding: 2px 6px; border-radius: 3px; font-weight: 600; font-family: monospace;"
}, Oo = (e, t) => {
  const n = {
    component: e
  };
  return t.length > 0 && (n.params = t), n;
}, mt = (e, t) => {
  const n = re.c(34);
  let r;
  n[0] !== t ? (r = t === void 0 ? {} : t, n[0] = t, n[1] = r) : r = n[1];
  const o = r, {
    ship: s
  } = o, i = s === void 0 ? "warn+" : s, a = at(), c = a.environment, l = a.mode, u = Wc(), d = c === "localhost" || l === nr.HMR, f = i === "all", p = i !== "none";
  let m;
  n[2] !== e ? (m = e.length > 16 ? e.substring(0, 16) : e.padEnd(16, " "), n[2] = e, n[3] = m) : m = n[3];
  const R = m;
  let b;
  n[4] !== R || n[5] !== d ? (b = (x, ...M) => {
    const L = M;
    if (d) {
      const $ = (/* @__PURE__ */ new Date()).toISOString().split("T")[1].slice(0, 12);
      console.debug(`%c${$} %c${R}`, Ee.green, Ee.darkgray, x, ...L);
    }
  }, n[4] = R, n[5] = d, n[6] = b) : b = n[6];
  const _ = b;
  let k;
  n[7] !== u || n[8] !== e || n[9] !== R || n[10] !== f ? (k = (x, ...M) => {
    const L = M, $ = (/* @__PURE__ */ new Date()).toISOString().split("T")[1].slice(0, 12);
    console.info(`%c${$} %c${R}`, Ee.green, Ee.darkgray, x, ...L), f && u?.log({
      data: Oo(e, L),
      level: Ne.INFO,
      message: x
    });
  }, n[7] = u, n[8] = e, n[9] = R, n[10] = f, n[11] = k) : k = n[11];
  const S = k;
  let w;
  n[12] !== u || n[13] !== e || n[14] !== R || n[15] !== p ? (w = (x, ...M) => {
    const L = M, $ = (/* @__PURE__ */ new Date()).toISOString().split("T")[1].slice(0, 12);
    console.warn(`%c${$} %c${R}`, Ee.green, Ee.darkgray, x, ...L), p && u?.log({
      data: Oo(e, L),
      level: Ne.WARN,
      message: x
    });
  }, n[12] = u, n[13] = e, n[14] = R, n[15] = p, n[16] = w) : w = n[16];
  const h = w;
  let g;
  n[17] !== u || n[18] !== e || n[19] !== R || n[20] !== p ? (g = (x, ...M) => {
    const L = M, $ = (/* @__PURE__ */ new Date()).toISOString().split("T")[1].slice(0, 12);
    console.error(`%c${$} %c${R}`, Ee.green, Ee.darkgray, x, ...L), p && u?.log({
      data: Oo(e, L),
      level: Ne.ERROR,
      message: x
    });
  }, n[17] = u, n[18] = e, n[19] = R, n[20] = p, n[21] = g) : g = n[21];
  const y = g;
  let E;
  n[22] !== u || n[23] !== e || n[24] !== f || n[25] !== p || n[26] !== d ? (E = (x, M, L, $, U) => {
    if (d) {
      const D = (/* @__PURE__ */ new Date()).toISOString().split("T")[1].slice(0, 12), Z = e.length > 16 ? e.substring(0, 16) : e.padEnd(16, " ");
      let ie = Ee.darkgray;
      L === null ? ie = Ee.errorBg : typeof L == "string" ? ie = Ee.serverErrorBg : L >= 200 && L < 300 ? ie = Ee.successBg : L >= 400 && L < 500 ? ie = Ee.clientErrorBg : L >= 500 && (ie = Ee.serverErrorBg), console.debug(`%c${D} %c${Z} %c${L}%c %c${x}%c ${M} %c[${$}ms]`, Ee.green, Ee.darkgray, ie, Ee.darkgray, Ee.methodBg, Ee.purple, Ee.darkgray, JSON.parse(JSON.stringify({
        request: U.request,
        response: U.response
      })));
    }
    const z = {
      component: e,
      durationMs: $,
      method: x,
      statusCode: L,
      url: M
    };
    if (d && (z.request = U.request, z.response = U.response), L === null || L === "Timeout" || typeof L == "number" && L >= 400) {
      if (p) {
        const D = typeof L == "number" && L < 500 ? Ne.WARN : Ne.ERROR;
        u?.log({
          data: z,
          level: D,
          message: `${x} ${M}`
        });
      }
    } else
      f && u?.log({
        data: z,
        level: Ne.INFO,
        message: `${x} ${M}`
      });
  }, n[22] = u, n[23] = e, n[24] = f, n[25] = p, n[26] = d, n[27] = E) : E = n[27];
  const A = E;
  let H;
  return n[28] !== y || n[29] !== A || n[30] !== S || n[31] !== _ || n[32] !== h ? (H = {
    logError: y,
    logHttpRequest: A,
    logInfo: S,
    logTrace: _,
    logWarn: h
  }, n[28] = y, n[29] = A, n[30] = S, n[31] = _, n[32] = h, n[33] = H) : H = n[33], H;
}, Vt = /* @__PURE__ */ new Map();
let Xn;
const Nh = (e) => (Xn === void 0 && (Xn = e.isLocalStorageAvailable()), Xn), zc = () => {
  const e = re.c(11), {
    logError: t
  } = mt("useLocalStorageBeta"), n = Oe;
  let r;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = Nh(n), e[0] = r) : r = e[0];
  const o = r;
  let s;
  e[1] !== t ? (s = (f) => {
    const p = String(f);
    if (Vt.has(p))
      return Vt.get(p);
    try {
      const m = n.getJSON(f);
      return Vt.set(p, m), m;
    } catch (m) {
      const R = m;
      return t(`Failed to get localStorage value for key "${String(f)}":`, R), null;
    }
  }, e[1] = t, e[2] = s) : s = e[2];
  const i = s;
  let a;
  e[3] !== t ? (a = (f, p) => {
    const m = String(f);
    try {
      n.setJSON(f, p), Vt.set(m, p);
    } catch (R) {
      const b = R;
      t(`Failed to set localStorage value for key "${String(f)}":`, b);
    }
  }, e[3] = t, e[4] = a) : a = e[4];
  const c = a;
  let l;
  e[5] !== t ? (l = (f) => {
    const p = String(f);
    try {
      n.remove(f), Vt.delete(p);
    } catch (m) {
      const R = m;
      t(`Failed to delete localStorage value for key "${String(f)}":`, R);
    }
  }, e[5] = t, e[6] = l) : l = e[6];
  const u = l;
  let d;
  return e[7] !== u || e[8] !== i || e[9] !== c ? (d = {
    deleteLocalStorageValue: u,
    getLocalStorageValue: i,
    isLocalStorageAvailable: o,
    setLocalStorageValue: c
  }, e[7] = u, e[8] = i, e[9] = c, e[10] = d) : d = e[10], d;
}, Mh = () => {
  Xn = void 0;
};
Object.defineProperty(zc, "__resetAvailabilityCache", {
  value: Mh,
  enumerable: !1
});
const Dh = {
  enableLogging: !1,
  keyPrefix: "app_"
};
class jh {
  /**
   * Initializes the SessionStorage service with optional configuration.
   * @param config - Partial configuration to override defaults.
   */
  constructor(t = {}) {
    N(this, "config");
    this.config = {
      ...Dh,
      ...t
    };
  }
  /**
   * Retrieves a value from sessionStorage with error handling and validation.
   * @param key - The key to retrieve.
   */
  get(t) {
    this._validateKey(t);
    const n = this._getPrefixedKey(t), r = window.sessionStorage.getItem(n);
    if (r === null) return null;
    try {
      return JSON.parse(r);
    } catch {
      return r;
    }
  }
  /**
   * Stores a value in sessionStorage with error handling and validation.
   * @param key - The key to store the value under.
   * @param value - The value to store.
   */
  set(t, n) {
    if (n === void 0) throw new Error("Cannot store undefined value");
    this._validateKey(t);
    const r = this._getPrefixedKey(t);
    let o;
    try {
      o = typeof n == "string" ? n : JSON.stringify(n);
    } catch (s) {
      throw new Error(`Failed to serialize value: ${s instanceof Error ? s.message : "Unknown error"}`);
    }
    try {
      window.sessionStorage.setItem(r, o);
      const s = window.sessionStorage.getItem(r);
      if (s !== o)
        throw new Error("Failed to verify stored value. Possible sessionStorage issue. Tried to store: " + o + ", but got back: " + s);
    } catch (s) {
      throw s instanceof DOMException && s.name === "QuotaExceededError" ? new Error("Failed to store value in sessionStorage: Storage quota exceeded") : s;
    }
  }
  /**
   * Deletes a value from sessionStorage with error handling and validation.
   * @param key - The key to delete.
   */
  delete(t) {
    this._validateKey(t);
    const n = this._getPrefixedKey(t);
    window.sessionStorage.removeItem(n);
  }
  /**
   * Checks if sessionStorage is available and functional.
   */
  isSessionStorageAvailable() {
    try {
      const t = "__sessionStorage_test__";
      return window.sessionStorage.setItem(t, "test"), window.sessionStorage.removeItem(t), !0;
    } catch {
      return !1;
    }
  }
  /**
   * Generates a prefixed key to avoid collisions in sessionStorage.
   * Eg: If the key is "userSettings" and the prefix is "app_", the resulting key will be "app_userSettings".
   * @param key - The original key (non-prefixed).
   */
  _getPrefixedKey(t) {
    return `${this.config.keyPrefix}${String(t)}`;
  }
  /**
   * Validates the provided key.
   * Eg: Ensures the key is a non-empty string. If the key is "" or only whitespace, an error is thrown.
   * @param key - The key to validate.
   */
  _validateKey(t) {
    const n = String(t);
    if (!n || n.trim() === "") throw new Error("Invalid key: Key must be a non-empty string");
  }
}
let ko = null;
const Kt = /* @__PURE__ */ new Map(), Lh = () => (ko || (ko = new jh()), ko), Hh = () => {
  const e = re.c(12), {
    logError: t
  } = mt("useSessionStorageBeta");
  let n, r;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = Lh(), r = n.isSessionStorageAvailable(), e[0] = n, e[1] = r) : (n = e[0], r = e[1]);
  const o = r;
  let s;
  e[2] !== t ? (s = (f) => {
    const p = String(f);
    if (Kt.has(p))
      return Kt.get(p);
    try {
      const m = n.get(f);
      return Kt.set(p, m), m;
    } catch (m) {
      const R = m;
      return t(`Failed to get sessionStorage value for key "${String(f)}":`, R), null;
    }
  }, e[2] = t, e[3] = s) : s = e[3];
  const i = s;
  let a;
  e[4] !== t ? (a = (f, p) => {
    const m = String(f);
    try {
      n.set(f, p), Kt.set(m, p);
    } catch (R) {
      const b = R;
      t(`Failed to set sessionStorage value for key "${String(f)}":`, b);
    }
  }, e[4] = t, e[5] = a) : a = e[5];
  const c = a;
  let l;
  e[6] !== t ? (l = (f) => {
    const p = String(f);
    try {
      n.delete(f), Kt.delete(p);
    } catch (m) {
      const R = m;
      t(`Failed to delete sessionStorage value for key "${String(f)}":`, R);
    }
  }, e[6] = t, e[7] = l) : l = e[7];
  const u = l;
  let d;
  return e[8] !== u || e[9] !== i || e[10] !== c ? (d = {
    deleteSessionStorageValue: u,
    getSessionStorageValue: i,
    isSessionStorageAvailable: o,
    setSessionStorageValue: c
  }, e[8] = u, e[9] = i, e[10] = c, e[11] = d) : d = e[11], d;
}, Uh = 30;
let Fn = null;
const vs = () => {
  const e = je.use((S) => S.authData), t = je.use((S) => S.isAuthenticated), n = je.use((S) => S.isAuthInitialized), {
    authService: r
  } = $c(), {
    getLocalStorageValue: o,
    setLocalStorageValue: s,
    deleteLocalStorageValue: i
  } = zc(), {
    getSessionStorageValue: a,
    setSessionStorageValue: c,
    deleteSessionStorageValue: l
  } = Hh(), {
    logTrace: u,
    logError: d
  } = mt("useAuthAlphaHook"), f = Me(Sc), p = Te(async () => {
    try {
      const S = it.getAgent();
      S && await S.setContext({
        userId: void 0
      }), b(), je.logout(), ft.clear(), i("authAppName"), i("authToken"), i("authRememberMe"), i("userProfile"), l("authAppName"), l("authToken"), l("authRememberMe");
    } catch (S) {
      d("[logout] Error occurred during logout.", S);
    }
  }, [i, l, d]), m = Te(
    (S) => {
      b();
      const w = gn.diffInSeconds(Date.now(), S.exp), h = Math.max(0, w - Uh);
      h > 0 ? (u("[scheduleTokenRefresh] Token is valid for a while, scheduled a refresh.", {
        secondsUntilAccessTokenExpiry: w,
        secondsUntilScheduledRefresh: h
      }), Fn = setTimeout(() => {
        R(S).then(() => u("[scheduleTokenRefresh] Scheduled token refresh completed successfully.")).catch((g) => d("[scheduleTokenRefresh] Scheduled token refresh failed.", g));
      }, h * 1e3)) : (u("[scheduleTokenRefresh] Token is expired or about to expire, refresh immediately.", {
        secondsUntilAccessTokenExpiry: w,
        secondsUntilScheduledRefresh: h
      }), R(S).then(() => u("[scheduleTokenRefresh] Immediate token refresh completed successfully.")).catch((g) => d("[scheduleTokenRefresh] Immediate token refresh failed.", g)));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [d, u]
  ), R = Te(async (S) => {
    if (S?.refreshToken)
      try {
        let w = o("authRememberMe");
        w === null && (w = a("authRememberMe"));
        let h = o("authAppName");
        h === null && (h = a("authAppName"));
        const g = f ?? h ?? "";
        if (!g) {
          d("[refreshToken] No appName available (no AppNameProvider and none persisted). Logging out."), await p();
          return;
        }
        const E = (await r.refreshSessionAlpha({
          appName: g,
          cognitoUsername: S.cognitoUsername,
          refreshToken: S.refreshToken
        }, {
          encrypt: {
            request: !0,
            response: !0
          }
        })).data;
        u("[refreshToken] Token refresh successful."), je.loginSuccess(E), w ? s("authToken", E) : c("authToken", E), m(E);
      } catch (w) {
        u("[refreshToken] Token refresh failed. Logging out.", w), await p();
      }
    else
      d("[refreshToken] Refresh token not found. Logging out.", S), await p();
  }, [r, f, o, a, d, u, p, m, s, c]), b = () => {
    Fn && (clearTimeout(Fn), Fn = null);
  }, _ = Te(async () => {
    try {
      const S = Sl.getNavigationContext(), {
        isPageRefresh: w,
        isFirstPageLoadInSession: h,
        navigationType: g
      } = S;
      u("Hydrating auth token", {
        isFirstPageLoadInSession: h,
        isPageRefresh: w,
        navigationType: g
      });
      let y = o("authToken"), E = o("authRememberMe"), A = "local";
      if (y || (y = a("authToken"), E = a("authRememberMe"), A = "session"), !E && E !== !1) {
        u('Not restoring auth token because "remember me" setting was not found.', {
          isPageRefresh: w,
          navigationType: g
        }), p().then();
        return;
      }
      y ? gn.compareEpochs(Date.now(), y.exp) >= 0 ? (u(`Found auth token in ${A} storage (expired).`, {
        expiredSecondsAgo: gn.diffInSeconds(Date.now(), y.exp),
        isPageRefresh: w,
        navigationType: g,
        rememberMe: E
      }), await R(y)) : (u(`Found auth token in ${A} storage (not expired).`, {
        expiresInSeconds: gn.diffInSeconds(Date.now(), y.exp),
        isPageRefresh: w,
        navigationType: g,
        rememberMe: E
      }), je.loginSuccess(y), m(y)) : (u("Did not find auth token in local or session storage, logging out.", {
        isPageRefresh: w,
        navigationType: g
      }), p().then());
    } catch (S) {
      d("[hydrateAuthToken] Something went wrong checking storage for auth token, logging out.", S), p().then();
    } finally {
      je.setAuthAsInitialized();
    }
  }, [d, u, o, a, p, R, m]);
  return {
    authData: e,
    hydrateAuthToken: _,
    isAuthenticated: t,
    isAuthInitialized: n,
    loginSuccess: async (S, w, h) => {
      je.loginSuccess(S), m(S), i("authAppName"), l("authAppName"), w ? (s("authToken", S), s("authRememberMe", w), h && s("authAppName", h)) : (c("authToken", S), c("authRememberMe", w), h && c("authAppName", h)), it.getAgent()?.setContext({
        userId: S.sub
      });
    },
    logout: p
  };
}, Vn = /* @__PURE__ */ new Map(), Po = /* @__PURE__ */ new Map(), Ta = 4, qh = 100;
class ns extends Error {
}
const Dy = (e) => {
  const t = re.c(15), {
    authData: n
  } = vs(), r = at(), o = n?.idToken, s = r.apiConfig[e]?.baseUrl, i = `${e}|${s}`;
  let a;
  t[0] !== i ? (a = () => Vn.get(i) ?? {}, t[0] = i, t[1] = a) : a = t[1];
  const [c, l] = pe(a), [u, d] = pe(null), [f, p] = pe(!1), [m, R] = pe(0), [b, _] = pe(i);
  b !== i && (_(i), l(Vn.get(i) ?? {}), d(null), p(!1));
  let k;
  t[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (k = () => R(Wh), t[2] = k) : k = t[2];
  const S = k;
  let w, h;
  t[3] !== s || t[4] !== i || t[5] !== r.apiConfig || t[6] !== o || t[7] !== m || t[8] !== e ? (w = () => {
    let y = !0;
    if (!o)
      return;
    if (!s) {
      d(new Error(`Unknown service: ${e}. Available services: ${Object.keys(r.apiConfig).join(", ")}`)), p(!1);
      return;
    }
    const E = Vn.get(i);
    if (m === 0 && E) {
      l(E), d(null), p(!1);
      return;
    }
    return (async () => {
      p(!0), d(null);
      try {
        const H = await Bh({
          baseUrl: s,
          cacheKey: i,
          idToken: o
        });
        if (!y)
          return;
        l(H), p(!1);
      } catch (H) {
        const x = H;
        if (!y)
          return;
        d(x instanceof Error ? x : new Error(String(x))), p(!1);
      }
    })().then(), () => {
      y = !1;
    };
  }, h = [s, i, r.apiConfig, o, m, e], t[3] = s, t[4] = i, t[5] = r.apiConfig, t[6] = o, t[7] = m, t[8] = e, t[9] = w, t[10] = h) : (w = t[9], h = t[10]), le(w, h);
  let g;
  return t[11] !== c || t[12] !== u || t[13] !== f ? (g = {
    data: c,
    error: u,
    isLoading: f,
    refetch: S
  }, t[11] = c, t[12] = u, t[13] = f, t[14] = g) : g = t[14], g;
}, Fh = async (e) => {
  const {
    baseUrl: t,
    idToken: n
  } = e, r = `${t}/${`${Hu}/${Lu}`.toLowerCase()}`;
  let o;
  try {
    o = await fetch(r, {
      headers: {
        Authorization: `Bearer ${n}`
      }
    });
  } catch (s) {
    throw new ns(s instanceof Error ? s.message : String(s));
  }
  if (o.status === 404) return {};
  if (o.status === 429 || o.status >= 500) throw new ns(`Client config request failed with status ${o.status}.`);
  if (o.status < 200 || o.status >= 300) throw new Error(`Client config request failed with status ${o.status}.`);
  return $u.unwrap(await o.json());
}, Bh = (e) => {
  const {
    baseUrl: t,
    cacheKey: n,
    idToken: r
  } = e, o = Po.get(n);
  if (o) return o;
  const i = (async () => {
    let a;
    for (let c = 1; c <= Ta; c++)
      try {
        return await Fh({
          baseUrl: t,
          idToken: r
        });
      } catch (l) {
        if (!(l instanceof ns)) throw l;
        a = l, c < Ta && await $h(qh * 2 ** (c - 1));
      }
    throw a;
  })().then((a) => (Vn.set(n, a), a)).finally(() => Po.delete(n));
  return Po.set(n, i), i;
}, $h = (e) => new Promise((t) => setTimeout(t, e));
function Wh(e) {
  return e + 1;
}
const rs = /* @__PURE__ */ new Set(), Gc = () => Oe.get("debug") === "true", zh = (e) => {
  for (const t of rs) t(e);
}, Xc = () => {
  const e = re.c(4), [t, n] = ne.useState(Gc);
  let r, o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = () => {
    const a = (c) => n(c);
    return rs.add(a), () => {
      rs.delete(a);
    };
  }, o = [], e[0] = r, e[1] = o) : (r = e[0], o = e[1]), ne.useEffect(r, o);
  const s = Gh;
  let i;
  return e[2] !== t ? (i = {
    isDebug: t,
    toggleDebug: s
  }, e[2] = t, e[3] = i) : i = e[3], i;
};
function Gh() {
  const e = !Gc();
  Oe.set("debug", String(e)), zh(e);
}
const Xh = () => {
  const e = re.c(4), t = ne.useContext(un);
  if (t === void 0)
    throw new Error("useDensity must be used within a ThemeProvider");
  const {
    cycleDensity: n,
    density: r,
    setDensity: o
  } = t;
  let s;
  return e[0] !== n || e[1] !== r || e[2] !== o ? (s = {
    cycleDensity: n,
    density: r,
    setDensity: o
  }, e[0] = n, e[1] = r, e[2] = o, e[3] = s) : s = e[3], s;
}, Vh = "fullscreen:get", Aa = "fullscreen:changed", jy = () => {
  const e = re.c(2), [t, n] = ne.useState(!1);
  let r, o;
  return e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = () => {
    const s = Pe.getElectronApi();
    if (s) {
      let c = !0;
      const l = (u) => n(!!u?.isFullscreen);
      return s.on(Aa, l), s.invoke(Vh).then((u) => {
        c && n(!!u?.isFullscreen);
      }).catch(Kh), () => {
        c = !1, s.off(Aa, l);
      };
    }
    if (typeof window > "u" || typeof window.matchMedia != "function")
      return;
    const i = window.matchMedia("(display-mode: fullscreen)"), a = () => n(i.matches);
    return i.addEventListener("change", a), n(i.matches), () => i.removeEventListener("change", a);
  }, o = [], e[0] = r, e[1] = o) : (r = e[0], o = e[1]), ne.useEffect(r, o), t;
};
function Kh() {
}
const xo = 768, Ly = () => {
  const e = re.c(2), [t, n] = ne.useState(void 0);
  let r, o;
  return e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = () => {
    const s = window.matchMedia(`(max-width: ${xo - 1}px)`), i = () => {
      n(window.innerWidth < xo);
    };
    return s.addEventListener("change", i), n(window.innerWidth < xo), () => s.removeEventListener("change", i);
  }, o = [], e[0] = r, e[1] = o) : (r = e[0], o = e[1]), ne.useEffect(r, o), !!t;
}, Hy = (e) => {
  const t = re.c(14);
  let n;
  t[0] !== e ? (n = e === void 0 ? {} : e, t[0] = e, t[1] = n) : n = t[1];
  const r = n, {
    autoRetry: o,
    maxRetries: s,
    retryDelay: i
  } = r, a = o === void 0 ? !0 : o, c = s === void 0 ? 3 : s, l = i === void 0 ? 1e3 : i, [u, d] = pe(null), [f, p] = pe(!0), [m, R] = pe(null), [b, _] = pe(0);
  let k, S;
  t[2] !== a || t[3] !== c || t[4] !== b || t[5] !== l ? (k = () => {
    let g = !0, y = null;
    const E = async () => {
      try {
        if (p(!0), R(null), !ai.isElectronRenderer()) {
          g && (R(new Error("Not running in Electron renderer context")), p(!1));
          return;
        }
        const A = await ai.getMainEnvironment();
        g && (d(A), p(!1), _(0));
      } catch (A) {
        const H = A;
        if (!g)
          return;
        const x = H instanceof Error ? H : new Error(String(H));
        R(x), a && b < c ? y = setTimeout(() => {
          g && _(Yh);
        }, l) : p(!1);
      }
    };
    return (b === 0 || a && b < c) && E().then(), () => {
      g = !1, y && clearTimeout(y);
    };
  }, S = [a, c, l, b], t[2] = a, t[3] = c, t[4] = b, t[5] = l, t[6] = k, t[7] = S) : (k = t[6], S = t[7]), le(k, S);
  let w;
  t[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (w = () => {
    _(0), d(null);
  }, t[8] = w) : w = t[8];
  let h;
  return t[9] !== u || t[10] !== m || t[11] !== f || t[12] !== b ? (h = {
    error: m,
    environment: u,
    isLoading: f,
    refetch: w,
    retryCount: b
  }, t[9] = u, t[10] = m, t[11] = f, t[12] = b, t[13] = h) : h = t[13], h;
};
function Yh(e) {
  return e + 1;
}
const Jh = () => {
  const e = re.c(5);
  let t;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t = Pe.getElectronApi(), e[0] = t) : t = e[0];
  const n = t, [r, o] = ne.useState(void 0);
  let s, i;
  e[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = () => {
    if (!n)
      return;
    let c = !1;
    n.invoke("memory:get").then((u) => {
      c || o(u);
    }).catch(Qh);
    const l = (u) => o(u);
    return n.on("memory:snapshot", l), () => {
      c = !0, n.off("memory:snapshot", l);
    };
  }, i = [n], e[1] = s, e[2] = i) : (s = e[1], i = e[2]), ne.useEffect(s, i);
  let a;
  return e[3] !== r ? (a = {
    snapshot: r
  }, e[3] = r, e[4] = a) : a = e[4], a;
};
function Qh() {
}
const Io = () => {
}, Uy = () => {
  const e = re.c(11), t = Wc();
  if (!t) {
    let i;
    return e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = {
      counter: Io,
      gauge: Io,
      histogram: Io
    }, e[0] = i) : i = e[0], i;
  }
  let n;
  e[1] !== t ? (n = t.counter.bind(t), e[1] = t, e[2] = n) : n = e[2];
  let r;
  e[3] !== t ? (r = t.gauge.bind(t), e[3] = t, e[4] = r) : r = e[4];
  let o;
  e[5] !== t ? (o = t.histogram.bind(t), e[5] = t, e[6] = o) : o = e[6];
  let s;
  return e[7] !== n || e[8] !== r || e[9] !== o ? (s = {
    counter: n,
    gauge: r,
    histogram: o
  }, e[7] = n, e[8] = r, e[9] = o, e[10] = s) : s = e[10], s;
}, Zh = () => {
  const e = re.c(4), t = ne.useContext(un);
  if (t === void 0)
    throw new Error("usePaletteSelector must be used within a ThemeProvider");
  let n;
  return e[0] !== t.available || e[1] !== t.current || e[2] !== t.setTheme ? (n = {
    available: t.available,
    current: t.current,
    setTheme: t.setTheme
  }, e[0] = t.available, e[1] = t.current, e[2] = t.setTheme, e[3] = n) : n = e[3], n;
}, qy = () => {
  const e = ft.use((r) => r.profile), t = ft.use((r) => r.isProfileInitialized), n = je.use((r) => r.authData?.email) ?? "";
  return {
    avatarThumbUrl: e?.avatarThumbUrl ?? "",
    displayName: e?.displayName.trim() || n.split("@")[0] || "",
    email: n,
    isLoaded: t,
    profile: e
  };
}, Ca = {
  /**
   * Starts loading an image in the background. Never throws and never resolves — nothing awaits the result.
   * @param url - Absolute image URL. An empty string is a no-op.
   */
  preload: (e) => {
    if (!e) return;
    const t = globalThis.window;
    if (t?.Image)
      try {
        const n = new t.Image();
        n.decoding = "async", n.src = e;
      } catch {
      }
  }
}, Bn = "userProfile", No = {
  /** Removes the persisted snapshot. Called on logout and whenever the signed-in user has no profile record. */
  clear: () => Oe.remove(Bn),
  /**
   * Reads the persisted snapshot for the live session. Returns null — and DELETES the key — when the stored
   * record is malformed or belongs to a different user, so one user's photo can never paint for another.
   * @param sub - The live session's Cognito sub, which the snapshot's `userId` must equal.
   */
  read: (e) => {
    const t = Oe.getJSON(Bn);
    return !ep(t) || t.userId !== e ? (Oe.remove(Bn), null) : t;
  },
  /**
   * Persists the signed-in user's profile record verbatim — `avatarAssetId` included, since the avatar
   * uploader reads it to delete the superseded asset.
   * @param profile - The profile record to persist.
   */
  write: (e) => Oe.setJSON(Bn, e)
}, ep = (e) => e !== null && typeof e.userId == "string" && typeof e.displayName == "string" && typeof e.avatarAssetId == "string" && typeof e.avatarUrl == "string" && typeof e.avatarThumbUrl == "string", Oa = {
  /**
   * Fetches the signed-in user's profile record, writes it to the store and re-persists the snapshot.
   * A user with no record yet clears both. Errors are logged and swallowed — a failed refresh must never
   * crash the shell, and the initialized flag is set either way so `isLoading` cannot hang.
   * @param options - The auth SDK to fetch through and the signed-in user's sub.
   */
  load: async (e) => {
    const {
      authService: t,
      sub: n
    } = e;
    try {
      const o = (await t.getProfilesAlpha({
        userIds: [n]
      })).data.find((s) => s.userId === n) ?? null;
      ft.setProfile(o), o ? (No.write(o), Ca.preload(o.avatarThumbUrl)) : No.clear();
    } catch (r) {
      console.error("[ProfileLoader] Failed to load the signed-in user profile.", r);
    } finally {
      ft.setProfileAsInitialized();
    }
  },
  /**
   * Seeds the store from the persisted snapshot and warms the avatar image. Deliberately does NOT set the
   * initialized flag — a seed is not a fetch, and `load` still has to settle.
   * @param sub - The signed-in user's Cognito sub; a snapshot belonging to anyone else is ignored and deleted.
   */
  seed: (e) => {
    const t = No.read(e);
    t && (ft.setProfile(t), Ca.preload(t.avatarThumbUrl));
  }
}, tp = () => {
  const e = je.use((n) => n.authData?.sub) ?? "", {
    authService: t
  } = $c();
  wl(() => {
    e && Oa.seed(e);
  }, [e]), le(() => {
    e && Oa.load({
      authService: t,
      sub: e
    });
  }, [e]);
}, np = () => {
  const e = re.c(4), [t, n] = ne.useState(void 0);
  let r, o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = () => {
    const i = () => {
      const c = window.performance.memory;
      if (!c)
        return;
      const l = c.jsHeapSizeLimit, u = c.usedJSHeapSize, d = Math.round(u / l * 1e4) / 100;
      n({
        heapLimit: l,
        heapUsed: u,
        usagePercent: d
      });
    };
    i();
    const a = setInterval(i, 2e3);
    return () => clearInterval(a);
  }, o = [], e[0] = r, e[1] = o) : (r = e[0], o = e[1]), ne.useEffect(r, o);
  let s;
  return e[2] !== t ? (s = {
    snapshot: t
  }, e[2] = t, e[3] = s) : s = e[3], s;
}, ws = ln(null), Fy = () => {
  const e = Me(ws);
  if (!e)
    throw new Error("useSecondaryWindowProps must be used inside a SecondaryWindowRoot.");
  return e.input;
}, rp = "window:result", By = () => {
  const e = re.c(2), t = Me(ws);
  if (!t)
    throw new Error("useSecondaryWindowResult must be used inside a SecondaryWindowRoot.");
  const n = t.wid;
  let r;
  return e[0] !== n ? (r = (o) => {
    Pe.getElectronApi()?.invoke(rp, {
      result: o,
      wid: n
    });
  }, e[0] = n, e[1] = r) : r = e[1], r;
}, Vc = {
  hasCustomLayout: !1,
  resetLayout: null
}, or = qt({
  ...Vc
}), sr = /* @__PURE__ */ new Map(), ka = () => {
  if (sr.size === 0) {
    or.setState({
      ...Vc
    });
    return;
  }
  let e = !1;
  const t = [];
  for (const r of sr.values())
    r.hasCustomLayout && (e = !0), r.resetLayout && t.push(r.resetLayout);
  const n = t.length === 0 ? null : () => t.forEach((r) => r());
  or.setState({
    hasCustomLayout: e,
    resetLayout: n
  });
}, op = {
  /** Returns the aggregated layout state snapshot across all registered splits. */
  getState: or.getState,
  /**
   * Register (or replace) the entry for a given token. Called by each split component
   * on mount and on every layout change. Tokens are typically `React.useId()` values.
   * @param token - Stable per-instance token identifying this split.
   * @param entry - Current `hasCustomLayout` flag and optional `resetLayout` callback.
   */
  register: (e, t) => {
    sr.set(e, t), ka();
  },
  /**
   * Remove the entry for a given token when its component unmounts.
   * @param token - Stable per-instance token identifying this split.
   */
  unregister: (e) => {
    sr.delete(e), ka();
  },
  /** React hook that subscribes to a slice of the aggregated state via `useSyncExternalStore`. */
  use: or.use
}, sp = () => op.use(ip);
let Yt = {
  hasCustomLayout: !1,
  resetLayout: null
};
const ip = (e) => {
  const t = e.hasCustomLayout === Yt.hasCustomLayout, n = e.resetLayout == null == (Yt.resetLayout == null);
  return t && n || (Yt = {
    hasCustomLayout: e.hasCustomLayout,
    resetLayout: e.resetLayout
  }), Yt;
}, ap = () => {
  const e = re.c(8), t = ne.useContext(un);
  if (t === void 0)
    throw new Error("useTheme must be used within a ThemeProvider");
  const {
    mode: n,
    resolvedMode: r,
    setMode: o
  } = t;
  let s;
  e[0] !== r || e[1] !== o ? (s = () => o(r === "light" ? "dark" : "light"), e[0] = r, e[1] = o, e[2] = s) : s = e[2];
  const i = s;
  let a;
  return e[3] !== n || e[4] !== r || e[5] !== o || e[6] !== i ? (a = {
    mode: n,
    resolvedMode: r,
    setMode: o,
    toggleMode: i
  }, e[3] = n, e[4] = r, e[5] = o, e[6] = i, e[7] = a) : a = e[7], a;
}, $y = () => {
  const e = ne.useContext(un);
  if (e === void 0)
    throw new Error("useThemeName must be used within a ThemeProvider");
  return e.current;
}, cp = "window:open", lp = "window:close-by-opener", Wy = (e) => {
  const t = he(/* @__PURE__ */ new Set()), n = he(e?.onError);
  return n.current = e?.onError, le(() => {
    const o = t.current;
    return () => {
      const s = Pe.getElectronApi();
      for (const i of [...o])
        s?.invoke(lp, {
          key: i.key,
          kind: i.kind
        }).catch(() => {
        }), i.resolveNull();
      o.clear();
    };
  }, []), {
    openWindow: Te((o) => {
      const s = Pe.getElectronApi();
      return s ? new Promise((i) => {
        const a = t.current;
        let c = !1;
        const l = (p) => {
          c || (c = !0, a.delete(d), i(p));
        }, u = () => l(null), d = {
          key: o.key,
          kind: o.kind,
          resolveNull: u
        };
        a.add(d);
        const f = {
          input: o.input,
          key: o.key,
          kind: o.kind
        };
        s.invoke(cp, f).then((p) => l(p)).catch((p) => {
          n.current?.(p), l(null);
        });
      }) : Promise.resolve(null);
    }, [])
  };
}, Mo = (e) => {
  if (!e.workerInitialized) return nt.LOADING;
  const t = Object.entries(e.hmacTokensStatus).filter(([, r]) => r.required);
  if (t.length === 0) return e.clientInitialized ? nt.LOADED : nt.LOADING;
  const n = t.filter(([, r]) => r.loaded).length;
  return n === 0 ? nt.LOADING : n === t.length && e.clientInitialized ? nt.LOADED : nt.LOADED_WITH_ERRORS;
}, Kc = () => ({
  clientInitialized: !1,
  hmacTokensStatus: {},
  status: nt.LOADING,
  workerInitialized: !1
}), Dt = qt(Kc()), Ze = {
  /** Returns the current HTTP client state snapshot. */
  getState: Dt.getState,
  /** React hook that subscribes to a slice of HTTP client state via `useSyncExternalStore`. */
  use: Dt.use,
  /** Resets all HTTP client state back to its initial loading values. */
  resetHttpClientState: () => Dt.setState(Kc()),
  /**
   * Updates the HTTP client initialization flag and recalculates readiness.
   * @param clientInitialized - Whether the HTTP client is initialized.
   */
  setClientInitialized: (e) => Dt.setState((t) => {
    const n = {
      ...t,
      clientInitialized: e
    };
    return {
      clientInitialized: e,
      status: Mo(n)
    };
  }),
  /**
   * Records the HMAC token load status for a service and recalculates readiness.
   * @param payload - The service name, required flag, and loaded flag.
   * @param payload.loaded - Whether the HMAC token has been loaded.
   * @param payload.required - Whether the service requires an HMAC token.
   * @param payload.service - The service name.
   */
  setHmacTokenStatus: ({
    service: e,
    required: t,
    loaded: n
  }) => Dt.setState((r) => {
    const o = {
      ...r.hmacTokensStatus,
      [e]: {
        loaded: n,
        required: t
      }
    }, s = {
      ...r,
      hmacTokensStatus: o
    };
    return {
      hmacTokensStatus: o,
      status: Mo(s)
    };
  }),
  /**
   * Updates the web worker initialization flag and recalculates readiness.
   * @param workerInitialized - Whether the web worker is initialized.
   */
  setWorkerInitialized: (e) => Dt.setState((t) => {
    const n = {
      ...t,
      workerInitialized: e
    };
    return {
      workerInitialized: e,
      status: Mo(n)
    };
  })
}, Yc = {
  snapshot: null
}, $n = qt({
  ...Yc
}), up = {
  /** Returns the current settings-debug snapshot state. */
  getState: $n.getState,
  /** React hook that subscribes to a slice of the settings-debug state via `useSyncExternalStore`. */
  use: $n.use,
  /**
   * Publishes the latest resolved settings snapshot for the dev footer to read.
   * @param snapshot - The fully resolved settings snapshot (every section's live values).
   */
  setSnapshot: (e) => $n.setState({
    snapshot: e
  }),
  /** Clears the published snapshot (eg: when the settings provider unmounts). */
  clear: () => $n.setState({
    ...Yc
  })
}, dp = (e, t) => t.some((n) => e instanceof n);
let Pa, xa;
function fp() {
  return Pa || (Pa = [
    IDBDatabase,
    IDBObjectStore,
    IDBIndex,
    IDBCursor,
    IDBTransaction
  ]);
}
function hp() {
  return xa || (xa = [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey
  ]);
}
const Jc = /* @__PURE__ */ new WeakMap(), os = /* @__PURE__ */ new WeakMap(), Qc = /* @__PURE__ */ new WeakMap(), Do = /* @__PURE__ */ new WeakMap(), Rs = /* @__PURE__ */ new WeakMap();
function pp(e) {
  const t = new Promise((n, r) => {
    const o = () => {
      e.removeEventListener("success", s), e.removeEventListener("error", i);
    }, s = () => {
      n(st(e.result)), o();
    }, i = () => {
      r(e.error), o();
    };
    e.addEventListener("success", s), e.addEventListener("error", i);
  });
  return t.then((n) => {
    n instanceof IDBCursor && Jc.set(n, e);
  }).catch(() => {
  }), Rs.set(t, e), t;
}
function mp(e) {
  if (os.has(e))
    return;
  const t = new Promise((n, r) => {
    const o = () => {
      e.removeEventListener("complete", s), e.removeEventListener("error", i), e.removeEventListener("abort", i);
    }, s = () => {
      n(), o();
    }, i = () => {
      r(e.error || new DOMException("AbortError", "AbortError")), o();
    };
    e.addEventListener("complete", s), e.addEventListener("error", i), e.addEventListener("abort", i);
  });
  os.set(e, t);
}
let ss = {
  get(e, t, n) {
    if (e instanceof IDBTransaction) {
      if (t === "done")
        return os.get(e);
      if (t === "objectStoreNames")
        return e.objectStoreNames || Qc.get(e);
      if (t === "store")
        return n.objectStoreNames[1] ? void 0 : n.objectStore(n.objectStoreNames[0]);
    }
    return st(e[t]);
  },
  set(e, t, n) {
    return e[t] = n, !0;
  },
  has(e, t) {
    return e instanceof IDBTransaction && (t === "done" || t === "store") ? !0 : t in e;
  }
};
function gp(e) {
  ss = e(ss);
}
function yp(e) {
  return e === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype) ? function(t, ...n) {
    const r = e.call(jo(this), t, ...n);
    return Qc.set(r, t.sort ? t.sort() : [t]), st(r);
  } : hp().includes(e) ? function(...t) {
    return e.apply(jo(this), t), st(Jc.get(this));
  } : function(...t) {
    return st(e.apply(jo(this), t));
  };
}
function _p(e) {
  return typeof e == "function" ? yp(e) : (e instanceof IDBTransaction && mp(e), dp(e, fp()) ? new Proxy(e, ss) : e);
}
function st(e) {
  if (e instanceof IDBRequest)
    return pp(e);
  if (Do.has(e))
    return Do.get(e);
  const t = _p(e);
  return t !== e && (Do.set(e, t), Rs.set(t, e)), t;
}
const jo = (e) => Rs.get(e);
function Zc(e, t, { blocked: n, upgrade: r, blocking: o, terminated: s } = {}) {
  const i = indexedDB.open(e, t), a = st(i);
  return r && i.addEventListener("upgradeneeded", (c) => {
    r(st(i.result), c.oldVersion, c.newVersion, st(i.transaction), c);
  }), n && i.addEventListener("blocked", (c) => n(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    c.oldVersion,
    c.newVersion,
    c
  )), a.then((c) => {
    s && c.addEventListener("close", () => s()), o && c.addEventListener("versionchange", (l) => o(l.oldVersion, l.newVersion, l));
  }).catch(() => {
  }), a;
}
const bp = ["get", "getKey", "getAll", "getAllKeys", "count"], Ep = ["put", "add", "delete", "clear"], Lo = /* @__PURE__ */ new Map();
function Ia(e, t) {
  if (!(e instanceof IDBDatabase && !(t in e) && typeof t == "string"))
    return;
  if (Lo.get(t))
    return Lo.get(t);
  const n = t.replace(/FromIndex$/, ""), r = t !== n, o = Ep.includes(n);
  if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(n in (r ? IDBIndex : IDBObjectStore).prototype) || !(o || bp.includes(n))
  )
    return;
  const s = async function(i, ...a) {
    const c = this.transaction(i, o ? "readwrite" : "readonly");
    let l = c.store;
    return r && (l = l.index(a.shift())), (await Promise.all([
      l[n](...a),
      o && c.done
    ]))[0];
  };
  return Lo.set(t, s), s;
}
gp((e) => ({
  ...e,
  get: (t, n, r) => Ia(t, n) || e.get(t, n, r),
  has: (t, n) => !!Ia(t, n) || e.has(t, n)
}));
let el;
const Na = "sys", Ho = /^[a-z0-9-]+$/, Jt = async () => await Zc(el.dbName), zy = {
  CACHE_KEY_PREFIX: Na,
  CACHE_KEY_REGEX: Ho,
  /**
   * Remove all entries from the specified object store.
   * @param table - The object store name to clear.
   */
  clear: async (e) => (await Jt()).clear(e),
  /**
   * Delete a single entry from the specified object store by key.
   * @param table - The object store name.
   * @param key - The key of the entry to delete.
   */
  delete: async (e, t) => (await Jt()).delete(e, t),
  /**
   * Retrieve a value from the specified object store by key.
   * @param table - The object store name.
   * @param key - The key to look up.
   */
  get: async (e, t) => (await Jt()).get(e, t),
  /**
   * Takes a string and converts it to an IndexDB cache-key, kept consistent across app.
   * @param str - The string to convert to a cache key.
   * @returns The prefixed cache key.
   * @throws Error if the string doesn't match the required regex pattern.
   */
  getCacheKey(e) {
    if (!Ho.test(e)) throw new Error(`Invalid cache key: ${e} (string that not match regex: ${Ho})`);
    return `${Na}-${e}`;
  },
  /**
   * Initialize the IndexedDB database, creating or upgrading object stores as needed.
   * @param dbName - The name of the database to open.
   * @param version - The schema version number for triggering upgrades.
   * @param tables - The list of object store names to ensure exist.
   */
  init: (e, t, n) => {
    el = {
      dbName: e,
      tables: n,
      version: t
    }, Zc(e, t, {
      /**
       * Runs schema migrations by creating missing stores and deleting stale ones.
       * @param db - The IndexedDB database instance being upgraded.
       * @param oldVersion - The previous schema version number.
       * @param newVersion - The new schema version number being upgraded to.
       */
      async upgrade(r, o, s) {
        console.warn(`IndexDB - Schema upgrade from version: ${o} => ${s}`);
        const i = Object.values(r.objectStoreNames);
        n.forEach((a) => {
          const c = i.indexOf(a);
          c !== -1 ? i.splice(c, 1) : (console.warn(`IndexDB - Creating: ${a}`), r.createObjectStore(a));
        }), i.forEach((a) => {
          console.warn(`IndexDB - Deleting: ${a}`), r.deleteObjectStore(a);
        });
      }
    }).then();
  },
  /**
   * Retrieve all keys from the specified object store.
   * @param table - The object store name to read keys from.
   */
  keys: async (e) => (await Jt()).getAllKeys(e),
  /**
   * Store a value in the specified object store under the given key.
   * @param table - The object store name.
   * @param key - The key to store the value under.
   * @param val - The object value to persist.
   */
  set: async (e, t, n) => (await Jt()).put(e, {
    ...n
  }, t)
}, Gy = new Ac(), Kn = "/assets/HttpWorkerAlpha-Di_fAB-K.js", vp = (e, t, n) => {
  const r = new Date(n).getTime(), o = Math.round((e + t) / 2);
  return r - o;
}, wp = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 };
class tl {
  /**
   * Get the `import.meta.env` object (Vite-injected environment).
   * Wrapped here (like `getImportMetaUrl`) so callers in `@blufin/react/vite` can read it
   * without a `@ts-ignore` at every site, and so unit tests can mock the whole accessor — jest runs
   * under CommonJS where `import.meta` is unavailable. Returns an empty object in environments that do
   * not inject it (eg: a non-Vite test harness), so consumers must supply their own fallbacks.
   * @returns The Vite meta environment record.
   */
  static getImportMetaEnv() {
    return wp ?? {};
  }
  /**
   * Get the import.meta.url value.
   * Needed mainly to avoid TypeScript errors in certain build environments, as well as to make unit testing easier.
   * @returns The URL of the current module.
   */
  static getImportMetaUrl() {
    return import.meta.url;
  }
}
const Rp = () => {
  const e = tl.getImportMetaUrl(), t = e.startsWith("file://") ? new URL(Kn.split("/").pop() || Kn, e).href : new URL(Kn, e).href;
  return new Worker(t, {
    type: "module"
  });
}, Ma = {
  /**
   * Builds the localStorage key for a service's HMAC cache entry.
   * Eg: `@blufin/auth-service` → `hmacBlufinAuthService`.
   * @param service - The service package identifier (typically `@blufin/<service-name>`).
   */
  fromService(e) {
    return `hmac${e.replace(/^@/, "").split(/[/-]/).filter(Boolean).map((o) => o.charAt(0).toUpperCase() + o.slice(1)).join("")}`;
  }
};
let Ie = null;
const Sp = 10080 * 60 * 1e3;
class Tp {
  /**
   * Creates an instance of HttpClientAlpha.
   * @param config - The HTTP client configuration.
   * @param useTraceLoggingHook - The trace logging hook for logging.
   */
  constructor(t, n) {
    N(this, "apiConfig");
    /** Caches the base URL for each service. */
    N(this, "apiConfigUrlCache", {});
    /** Caches the HMAC token and timestamp for each service. */
    N(this, "apiConfigHmacCache", {});
    /** Tracks pending requests to the worker. */
    N(this, "pendingRequests", {});
    /** Tracks in-flight token refresh operations per service to prevent concurrent refreshes. */
    N(this, "refreshInFlight", /* @__PURE__ */ new Map());
    /** Tracks abort signal cleanup handlers per request ID. */
    N(this, "abortCleanupHandlers", /* @__PURE__ */ new Map());
    /** Tracks cancelled request IDs to silently ignore worker responses. */
    N(this, "cancelledRequestIds", /* @__PURE__ */ new Set());
    /** The logging and tracing hooks. */
    N(this, "logTrace");
    N(this, "logWarn");
    N(this, "logError");
    N(this, "logHttpRequest");
    N(this, "authData", null);
    /** Set to true once initialization is complete. */
    N(this, "httpClientIsInitialized", !1);
    N(this, "workerIsInitialized", !1);
    /** Used for tracking pending requests to the worker. */
    N(this, "requestIdCounter", 0);
    if (this.apiConfig = t, this.logTrace = n.logTrace, this.logWarn = n.logWarn, this.logError = n.logError, this.logHttpRequest = n.logHttpRequest, !Ie)
      try {
        Ie = Rp();
      } catch (r) {
        this.logError("Falling back to direct Worker instantiation for HTTP Worker.", r), Ie = new Worker(Kn, {
          type: "module"
        });
      }
    Ze.resetHttpClientState(), Object.entries(this.apiConfig).forEach(([r, o]) => {
      Ze.setHmacTokenStatus({
        loaded: !1,
        required: o.hasHmac === !0,
        service: r
      });
    });
    try {
      this._init("initial").catch((r) => {
        this.logError("Error occurred during HttpClientSlice initialization.", r.stack || r.message || r);
      }), this._waitForWorkerInitialization().then(() => {
        Ie.onmessage = this._httpWorkerOnMessage.bind(this), Ie.onerror = this._httpWorkerOnError.bind(this), this.workerIsInitialized = !0, Ze.setWorkerInitialized(!0), this.logTrace("HTTP Worker initialized and ready.");
      }).catch((r) => {
        this.workerIsInitialized = !1, Ze.setWorkerInitialized(!1), this.logError("Error occurred while waiting for HTTP Worker initialization.", r.message || r);
      });
    } catch (r) {
      this.logError("HTTP client constructor error:", r);
    }
  }
  /**
   * Makes a GET request to the specified service and path.
   * @param service - The service name, eg: @blufin/auth-service
   * @param authMethod - The authentication method to use, eg: 'HMAC' or 'None'
   * @param path - The API path, eg: 'api/v1/users'
   * @param options - Optional HTTP client options.
   */
  get(t, n, r, o) {
    return this._sendRequest(et.GET, n, t, r, void 0, o);
  }
  /**
   * Makes a POST request to the specified service and path.
   * @param service - The service name, eg: @blufin/auth-service
   * @param authMethod - The authentication method to use, eg: 'HMAC' or 'None'
   * @param path - The API path, eg: 'api/v1/users'
   * @param payload - The request payload/body.
   * @param options - Optional HTTP client options.
   */
  post(t, n, r, o, s) {
    return this._sendRequest(et.POST, n, t, r, o, s);
  }
  /**
   * Makes a PUT request to the specified service and path.
   * @param service - The service name, eg: @blufin/auth-service
   * @param authMethod - The authentication method to use, eg: 'HMAC' or 'None'
   * @param path - The API path, eg: 'api/v1/users'
   * @param payload - The request payload/body.
   * @param options - Optional HTTP client options.
   */
  put(t, n, r, o, s) {
    return this._sendRequest(et.PUT, n, t, r, o, s);
  }
  /**
   * Makes a PATCH request to the specified service and path.
   * @param service - The service name, eg: @blufin/auth-service
   * @param authMethod - The authentication method to use, eg: 'HMAC' or 'None'
   * @param path - The API path, eg: 'api/v1/users'
   * @param payload - The request payload/body.
   * @param options - Optional HTTP client options.
   */
  patch(t, n, r, o, s) {
    return this._sendRequest(et.PATCH, n, t, r, o, s);
  }
  /**
   * Makes a DELETE request to the specified service and path.
   * @param service - The service name, eg: @blufin/auth-service
   * @param authMethod - The authentication method to use, eg: 'HMAC' or 'None'
   * @param path - The API path, eg: 'api/v1/users'
   * @param options - Optional HTTP client options.
   */
  delete(t, n, r, o) {
    return this._sendRequest(et.DELETE, n, t, r, void 0, o);
  }
  /**
   * Sets the authentication data (eg: Cognito tokens).
   * @param authData - The authentication data object or null to clear.
   */
  setAuthData(t) {
    this.logTrace(t ? "HTTP client received and stored JWT token." : "HTTP client cleared JWT token."), this.authData = t;
  }
  /** Terminates the HTTP client and rejects all pending requests. */
  terminate() {
    Object.values(this.pendingRequests).forEach(({
      reject: t
    }) => {
      t("HTTP client terminated");
    }), this.abortCleanupHandlers.forEach((t) => t()), this.abortCleanupHandlers.clear(), this.pendingRequests = {}, this.logTrace("HTTP client was terminated. All pending requests were rejected.");
  }
  /**
   * Initializes the HTTP client. This runs once during application startup.
   * @param trigger - The initialization trigger source, either initial startup or wait-loop retry.
   */
  async _init(t) {
    this.logTrace("HTTP client Initializing.", {
      apiConfig: this.apiConfig,
      trigger: t
    });
    const n = [];
    Object.entries(this.apiConfig).forEach(([r, o]) => {
      if (o.baseUrl && o.baseUrl.trim()) {
        const s = o.baseUrl.trim().replace(/\/+$/, "");
        if (s) this.apiConfigUrlCache[r] = s;
        else {
          this.logError("Invalid base URL after processing.", {
            originalBaseUrl: o.baseUrl,
            service: r
          });
          return;
        }
      } else this.logError(`Missing or invalid base URL for service '${r}'.`, {
        config: o
      });
      o.hasHmac === !0 && n.push(this._loadOrFetchHmacToken(r));
    }), n.length > 0 && (await this._waitForWorkerInitialization(), await Promise.all(n)), this.httpClientIsInitialized = !0, Ze.setClientInitialized(!0), this.logTrace("HTTP client initialized.");
  }
  /**
   * Loads a cached HMAC token from localStorage if valid, otherwise fetches a new one.
   * @param service - The service name to load/fetch the HMAC token for, eg: @blufin/auth-service
   */
  async _loadOrFetchHmacToken(t) {
    try {
      const n = Oe.getJSON(Ma.fromService(t));
      if (n) {
        const r = Date.now() - n.fetchedAt;
        if (r < Sp) {
          this.apiConfigHmacCache[t] = {
            fetchedAt: n.fetchedAt,
            hmacToken: n.hmacToken,
            timestamp: n.timestamp,
            timestampOffset: n.timestampOffset
          }, Ze.setHmacTokenStatus({
            loaded: !0,
            required: !0,
            service: t
          }), this.logTrace(`HMAC token loaded from cache for service '${t}'.`, {
            timestampOffset: n.timestampOffset,
            tokenAge: Math.round(r / 1e3)
          });
          return;
        } else
          this.logTrace(`Cached HMAC token for service '${t}' is expired (age: ${Math.round(r / 1e3)}s). Fetching fresh token.`);
      }
    } catch (n) {
      this.logWarn(`Failed to load cached HMAC token for service '${t}':`, n.message || n);
    }
    await this._fetchHmacToken(t);
  }
  /**
   * Fetches the HMAC token for a given service and stores it in the cache.
   * @param service - The service name to fetch the HMAC token for, eg: @blufin/auth-service
   */
  async _fetchHmacToken(t) {
    try {
      const n = this.apiConfigUrlCache[t];
      if (!n) {
        this.logError(`Cannot fetch HMAC token: No base URL found for service '${t}'`);
        return;
      }
      const r = `${n}/${`${ju}/${Du}`.toLowerCase()}`, o = Date.now(), s = await new Promise((l, u) => {
        const d = this._generateRequestId();
        this.pendingRequests[d] = {
          authMethod: ot.NONE,
          method: et.GET,
          reject: u,
          resolve: l,
          service: t,
          url: r
        }, Ie.postMessage({
          id: d,
          method: et.GET,
          url: r
        });
      }), {
        data: i
      } = s;
      if (!i?.hmacToken || !i?.timestamp) {
        this.logError(`HMAC token not set for '${t}' because fetch returned unsupported format.`, s);
        return;
      }
      const a = Date.now(), c = vp(o, a, i.timestamp);
      this.apiConfigHmacCache[t] = {
        fetchedAt: a,
        hmacToken: i.hmacToken,
        timestamp: i.timestamp,
        timestampOffset: c
      };
      try {
        Oe.setJSON(Ma.fromService(t), {
          fetchedAt: a,
          hmacToken: i.hmacToken,
          timestamp: i.timestamp,
          timestampOffset: c
        }), this.logTrace(`HMAC token persisted to localStorage for service '${t}'.`);
      } catch (l) {
        this.logWarn(`Failed to persist HMAC token to localStorage for service '${t}':`, l.message || l);
      }
      Ze.setHmacTokenStatus({
        loaded: !0,
        required: this.apiConfig[t]?.hasHmac === !0,
        service: t
      }), this.logTrace(`HMAC token fetched and cached for service '${t}'.`, {
        timestamp: i.timestamp,
        timestampOffset: c
      });
    } catch (n) {
      this.logError(`HMAC token fetch failed for '${t}':`, n.message || n), Ze.setHmacTokenStatus({
        loaded: !1,
        required: this.apiConfig[t]?.hasHmac === !0,
        service: t
      });
    }
  }
  /**
   * Ensures a valid HMAC token is cached for a service so an encrypted request can be sent, even when the service is
   * not HMAC-authenticated (COGNITO + `options.encrypt`). Reuses the exact same load/fetch path the HMAC branch relies
   * on (`_loadOrFetchHmacToken` → localStorage cache → `_fetchHmacToken`). No-op when a token is already cached.
   * Deduplicates concurrent callers via `refreshInFlight` (same map as `_handleHmacTokenRefresh`) so two concurrent
   * encrypted requests don't each fire their own `/v1/hmac` fetch.
   * Rejects (throws) if no token can be obtained — callers must NOT send an encrypt-requested message without one.
   * @param service - The service name to ensure an HMAC token for, eg: @blufin/admin-service
   */
  async _ensureHmacTokenForEncrypt(t) {
    if (this.apiConfigHmacCache[t]?.hmacToken) return;
    let n = this.refreshInFlight.get(t);
    if (n || (n = (async () => {
      try {
        await this._loadOrFetchHmacToken(t);
      } finally {
        this.refreshInFlight.delete(t);
      }
    })(), this.refreshInFlight.set(t, n)), await n, !this.apiConfigHmacCache[t]?.hmacToken) throw new Error(`Failed to obtain HMAC token required to encrypt request for service '${t}'.`);
  }
  /**
   * Generates a uniquer request ID (for tracking pending requests).
   */
  _generateRequestId() {
    return `req_${++this.requestIdCounter}_${Date.now()}`;
  }
  /**
   * Handles HMAC token refresh when a 401 is received for an HMAC-authenticated request.
   * Coordinates refresh to prevent concurrent refresh requests for the same service.
   * @param request - The pending request that received a 401.
   * @param workerMessageId - The worker message ID of the failed request.
   */
  async _handleHmacTokenRefresh(t, n) {
    const r = t.service;
    let o = this.refreshInFlight.get(r);
    o ? this.logTrace(`HMAC token refresh already in progress for service '${r}', waiting...`) : (o = (async () => {
      try {
        this.logTrace(`Starting HMAC token refresh for service '${r}'.`), await this._fetchHmacToken(r), this.logTrace(`HMAC token refresh completed for service '${r}'.`);
      } catch (s) {
        throw this.logError(`HMAC token refresh failed for service '${r}':`, s.message || s), new Error(`Token refresh failed: ${s.message || s}`);
      } finally {
        this.refreshInFlight.delete(r);
      }
    })(), this.refreshInFlight.set(r, o)), await o, this.logTrace(`Retrying original request for service '${r}' with refreshed token.`);
    try {
      const s = this.apiConfigHmacCache[r]?.hmacToken, i = this.apiConfigHmacCache[r]?.timestampOffset;
      if (!s || i === void 0) throw new Error(`HMAC token or timestamp offset not available after refresh for service '${r}'`);
      t.retryCount = (t.retryCount || 0) + 1;
      const {
        signal: a,
        ...c
      } = t.options ?? {}, l = {
        authMethod: t.authMethod,
        hmacTimestampOffset: i,
        hmacToken: s,
        id: n,
        method: t.method,
        options: c,
        payload: t.payload,
        requestId: t.requestId,
        url: t.url
      };
      Ie.postMessage(l), this.logTrace(`Retry request sent to worker for service '${r}'.`);
    } catch (s) {
      throw delete this.pendingRequests[n], s;
    }
  }
  /**
   * Handles incoming messages from the HTTP worker.
   * @param event - The message event from the worker.
   */
  _httpWorkerOnMessage(t) {
    if (t.data && t.data.type === "init") {
      this.logTrace("HTTP Worker initialization message received.");
      return;
    }
    const {
      id: n,
      success: r,
      data: o,
      error: s,
      statusCode: i,
      executionTimeMs: a,
      headers: c,
      wasResponseEncrypted: l,
      timedOut: u,
      networkError: d
    } = t.data;
    let f = !0;
    try {
      const p = this.pendingRequests[n];
      if (!p) {
        if (this.cancelledRequestIds.has(n)) {
          this.cancelledRequestIds.delete(n);
          return;
        }
        this.logWarn("Received HTTP Worker response for unknown request. ID not found in 'pendingRequests' at response time.");
        return;
      }
      const m = p.options?.encrypt?.request === !0, R = l === !0;
      if (this.logHttpRequest(p.method, p.url, i || (u ? "Timeout" : null), a, {
        request: m ? {
          ...p,
          payload: "[HIDDEN]"
        } : p,
        response: R ? "[HIDDEN]" : o
      }), r) p.resolve(o);
      else if (u) {
        const b = {
          message: s || `Request aborted due to timeout (${p.options?.timeout || Xo}ms)`,
          name: "TimeoutError",
          timeoutMs: p.options?.timeout || Xo
        };
        p.reject(b);
      } else if (s) {
        const b = Vo.decodeResponse(c || {});
        if (i === 401 && p.authMethod === ot.HMAC && b?.invalidHmac === !0) {
          if ((p.retryCount || 0) > 0) {
            this.logWarn(`Received 401 on retry attempt for service '${p.service}'. Token refresh did not resolve authentication issue.`), p.reject(new Error(`Authentication failed after token refresh for service '${p.service}'. The refreshed token was rejected by the API.`));
            return;
          }
          this.logTrace(`Received 401 for HMAC request to service '${p.service}'. Attempting token refresh.`), this._handleHmacTokenRefresh(p, n).then(() => {
          }).catch((w) => {
            p.reject(w), delete this.pendingRequests[n];
          }), f = !1;
          return;
        }
        let _;
        try {
          _ = JSON.parse(s);
        } catch {
          _ = s;
        }
        if (p.options?.surfaceHttpStatus) {
          const k = typeof _ == "object" && _ !== null, S = k ? _.message ?? _.data?.message ?? `Request failed (${i})` : _, w = new Error(S);
          k && Object.assign(w, _), w.statusCode = i ?? void 0, d && (w.networkError = !0), p.reject(w);
        } else p.reject(_);
      } else p.reject("Unknown error occurred");
    } catch (p) {
      this.logError("Error processing HTTP Worker response:", p.message || p, t.data);
    } finally {
      if (f) {
        delete this.pendingRequests[n];
        const p = this.abortCleanupHandlers.get(n);
        p && (p(), this.abortCleanupHandlers.delete(n));
      }
    }
  }
  /**
   * Handles uncaught errors from the HTTP worker.
   * @param err - The error event from the worker.
   */
  _httpWorkerOnError(t) {
    this.logError("HTTP Worker encountered an error:", t.message || t), Object.values(this.pendingRequests).forEach(({
      reject: n
    }) => {
      n("Request rejected because HTTP Worker encountered an error.");
    }), this.abortCleanupHandlers.forEach((n) => n()), this.abortCleanupHandlers.clear(), this.pendingRequests = {};
  }
  /**
   * Sends request to worker and returns promise
   * @param method - The HTTP method to use for the request.
   * @param authMethod - The authentication method to use for the request.
   * @param service - The service name to send the request to.
   * @param path - The API path for the request.
   * @param payload - Optional request payload/body.
   * @param options - Optional HTTP client options.
   */
  _sendRequest(t, n, r, o, s, i) {
    return new Promise((a, c) => {
      Promise.all([this.workerIsInitialized ? Promise.resolve() : this._waitForWorkerInitialization(), this.httpClientIsInitialized ? Promise.resolve() : this._waitForClientInitialization()]).then(async () => {
        const l = this._generateRequestId(), u = crypto.randomUUID(), d = this.apiConfigUrlCache[r];
        if (!d) {
          this.logError(`No base URL found for service '${r}.`), c(`No base URL found for service '${r}.`);
          return;
        }
        const f = o.trim().replace(/^\/+/, ""), p = f ? `${d}/${f}` : d, {
          signal: m,
          ...R
        } = i ?? {}, b = {
          authMethod: n,
          id: l,
          method: t,
          options: R,
          payload: s,
          requestId: u,
          url: p
        };
        if (n === ot.HMAC) {
          const _ = this.apiConfigHmacCache[r]?.hmacToken, k = this.apiConfigHmacCache[r]?.timestampOffset;
          if (!_) {
            this.logError(`No HMAC token found for service '${r}'.`), c(`No HMAC token found for service '${r}'.`);
            return;
          }
          if (k === void 0) {
            this.logError(`No HMAC timestamp offset found for service '${r}'.`), c(`No HMAC timestamp offset found for service '${r}'.`);
            return;
          }
          b.hmacToken = _, b.hmacTimestampOffset = k;
        } else if (n === ot.COGNITO) {
          if (!this.authData?.idToken) {
            this.logError("Cannot make Cognito-authenticated request because no authentication data is set.", {
              authMethod: n,
              method: t,
              path: o,
              service: r
            }), c("Cannot make Cognito-authenticated request because no authentication data is set.");
            return;
          }
          if (b.jwtToken = this.authData.idToken, R.encrypt) {
            try {
              await this._ensureHmacTokenForEncrypt(r);
            } catch (S) {
              c(S);
              return;
            }
            const _ = this.apiConfigHmacCache[r]?.hmacToken, k = this.apiConfigHmacCache[r]?.timestampOffset;
            if (!_ || k === void 0) {
              const S = `Cannot encrypt Cognito request because no HMAC token could be obtained for service '${r}'.`;
              this.logError(S), c(S);
              return;
            }
            b.hmacToken = _, b.hmacTimestampOffset = k;
          }
        }
        if (this.pendingRequests[l] = {
          authMethod: n,
          method: t,
          options: i,
          payload: s,
          reject: c,
          requestId: u,
          resolve: a,
          service: r,
          url: p
        }, i?.signal) {
          const _ = i.signal;
          if (_.aborted) {
            delete this.pendingRequests[l], this.cancelledRequestIds.add(l);
            const S = {
              id: l,
              type: "cancel"
            };
            Ie.postMessage(S), c(new DOMException("Request was cancelled", "AbortError"));
            return;
          }
          const k = () => {
            const S = this.pendingRequests[l];
            if (S) {
              delete this.pendingRequests[l];
              const w = this.abortCleanupHandlers.get(l);
              w && (w(), this.abortCleanupHandlers.delete(l)), this.cancelledRequestIds.add(l);
              const h = {
                id: l,
                type: "cancel"
              };
              Ie.postMessage(h), S.reject(new DOMException("Request was cancelled", "AbortError"));
            }
          };
          _.addEventListener("abort", k), this.abortCleanupHandlers.set(l, () => {
            _.removeEventListener("abort", k);
          });
        }
        Ie.postMessage(b);
      }).catch(c);
    });
  }
  /** Waits for worker to be initialized with timeout. */
  _waitForWorkerInitialization() {
    return Ie ? Promise.resolve() : new Promise((t, n) => {
      const i = Date.now();
      let a = -1e3;
      const c = () => {
        if (Ie) {
          t();
          return;
        }
        const l = Date.now() - i;
        if (l >= 5e3) {
          this.logError("HTTP worker failed to initialize within 5000ms timeout period."), n("HTTP worker not initialized within timeout period");
          return;
        } else
          l - a >= 1e3 && (a = l, this.logWarn("HTTP worker not yet initialized, continuing to wait...", {
            elapsed: l
          })), setTimeout(c, 50);
      };
      c();
    });
  }
  /** Waits for client initialization with timeout */
  _waitForClientInitialization() {
    return this.httpClientIsInitialized ? Promise.resolve() : new Promise((t, n) => {
      const a = Date.now();
      let c = 0, l = 0, u = -2500;
      const d = () => {
        if (this.httpClientIsInitialized) {
          t();
          return;
        }
        const f = Date.now() - a;
        if (f >= 15e3) {
          this.logError("HTTP client failed to initialize within 15000ms timeout period."), n("HTTP client not initialized within timeout period");
          return;
        } else
          f - l >= 2500 && c < 3 && (l = f, c++, this._init("wait-loop").catch((m) => {
            this.logError("Error during HTTP client re-initialization attempt:", m);
          })), f - u >= 2500 && (u = f, this.logWarn("HTTP client not yet initialized, continuing to wait...", {
            elapsed: f
          })), setTimeout(d, 100);
      };
      d();
    });
  }
  /**
   * Type guard to check if an error is a TimeoutError.
   * @param error - The error to check.
   * @returns True if the error is a TimeoutError, false otherwise.
   */
  static isTimeoutError(t) {
    return typeof t == "object" && t !== null && "name" in t && t.name === "TimeoutError" && "timeoutMs" in t;
  }
}
const nl = ({
  children: e
}) => {
  const t = he(null), n = at(), r = je.use((i) => i.authData), o = mt("HttpClientAlpha"), s = n.apiConfig;
  if (!s) throw new Error("HttpProviderAlpha requires apiConfig in runtime configuration");
  return t.current || (t.current = new Tp(s, o)), le(() => () => {
    t.current && t.current.terminate();
  }, []), le(() => {
    t.current && t.current.setAuthData(r);
  }, [r]), /* @__PURE__ */ C.jsx(ms.Provider, { value: t.current, children: e });
}, Ap = "_appContainerInnerAlpha_14xoe_1", Cp = "_unselectable_14xoe_6", Op = "_content_14xoe_10", kp = "_hasDevFooter_14xoe_17", Pp = "_electronDragBar_14xoe_29", xp = "_debug_14xoe_39", qe = {
  appContainerInnerAlpha: Ap,
  unselectable: Cp,
  content: Op,
  hasDevFooter: kp,
  electronDragBar: Pp,
  debug: xp
};
function Ip(e, t) {
  const n = e.icons, r = e.aliases || /* @__PURE__ */ Object.create(null), o = /* @__PURE__ */ Object.create(null);
  function s(i) {
    if (n[i]) return o[i] = [];
    if (!(i in o)) {
      o[i] = null;
      const a = r[i] && r[i].parent, c = a && s(a);
      c && (o[i] = [a].concat(c));
    }
    return o[i];
  }
  return Object.keys(n).concat(Object.keys(r)).forEach(s), o;
}
const rl = Object.freeze({
  left: 0,
  top: 0,
  width: 16,
  height: 16
}), ir = Object.freeze({
  rotate: 0,
  vFlip: !1,
  hFlip: !1
}), Ss = Object.freeze({
  ...rl,
  ...ir
}), is = Object.freeze({
  ...Ss,
  body: "",
  hidden: !1
});
function Np(e, t) {
  const n = {};
  !e.hFlip != !t.hFlip && (n.hFlip = !0), !e.vFlip != !t.vFlip && (n.vFlip = !0);
  const r = ((e.rotate || 0) + (t.rotate || 0)) % 4;
  return r && (n.rotate = r), n;
}
function Da(e, t) {
  const n = Np(e, t);
  for (const r in is) r in ir ? r in e && !(r in n) && (n[r] = ir[r]) : r in t ? n[r] = t[r] : r in e && (n[r] = e[r]);
  return n;
}
function Mp(e, t, n) {
  const r = e.icons, o = e.aliases || /* @__PURE__ */ Object.create(null);
  let s = {};
  function i(a) {
    s = Da(r[a] || o[a], s);
  }
  return i(t), n.forEach(i), Da(e, s);
}
function ol(e, t) {
  const n = [];
  if (typeof e != "object" || typeof e.icons != "object") return n;
  e.not_found instanceof Array && e.not_found.forEach((o) => {
    t(o, null), n.push(o);
  });
  const r = Ip(e);
  for (const o in r) {
    const s = r[o];
    s && (t(o, Mp(e, o, s)), n.push(o));
  }
  return n;
}
const Dp = {
  provider: "",
  aliases: {},
  not_found: {},
  ...rl
};
function Uo(e, t) {
  for (const n in t) if (n in e && typeof e[n] != typeof t[n]) return !1;
  return !0;
}
function sl(e) {
  if (typeof e != "object" || e === null) return null;
  const t = e;
  if (typeof t.prefix != "string" || !e.icons || typeof e.icons != "object" || !Uo(e, Dp)) return null;
  const n = t.icons;
  for (const o in n) {
    const s = n[o];
    if (!o || typeof s.body != "string" || !Uo(s, is)) return null;
  }
  const r = t.aliases || /* @__PURE__ */ Object.create(null);
  for (const o in r) {
    const s = r[o], i = s.parent;
    if (!o || typeof i != "string" || !n[i] && !r[i] || !Uo(s, is)) return null;
  }
  return t;
}
const ja = /* @__PURE__ */ Object.create(null);
function jp(e, t) {
  return {
    provider: e,
    prefix: t,
    icons: /* @__PURE__ */ Object.create(null),
    missing: /* @__PURE__ */ new Set()
  };
}
function Lt(e, t) {
  const n = ja[e] || (ja[e] = /* @__PURE__ */ Object.create(null));
  return n[t] || (n[t] = jp(e, t));
}
function il(e, t) {
  return sl(t) ? ol(t, (n, r) => {
    r ? e.icons[n] = r : e.missing.add(n);
  }) : [];
}
function Lp(e, t, n) {
  try {
    if (typeof n.body == "string")
      return e.icons[t] = { ...n }, !0;
  } catch {
  }
  return !1;
}
const al = /^[a-z0-9]+(-[a-z0-9]+)*$/, ur = (e, t, n, r = "") => {
  const o = e.split(":");
  if (e.slice(0, 1) === "@") {
    if (o.length < 2 || o.length > 3) return null;
    r = o.shift().slice(1);
  }
  if (o.length > 3 || !o.length) return null;
  if (o.length > 1) {
    const a = o.pop(), c = o.pop(), l = {
      provider: o.length > 0 ? o[0] : r,
      prefix: c,
      name: a
    };
    return t && !Yn(l) ? null : l;
  }
  const s = o[0], i = s.split("-");
  if (i.length > 1) {
    const a = {
      provider: r,
      prefix: i.shift(),
      name: i.join("-")
    };
    return t && !Yn(a) ? null : a;
  }
  if (n && r === "") {
    const a = {
      provider: r,
      prefix: "",
      name: s
    };
    return t && !Yn(a, n) ? null : a;
  }
  return null;
}, Yn = (e, t) => e ? !!((t && e.prefix === "" || e.prefix) && e.name) : !1;
let cn = !1;
function cl(e) {
  return typeof e == "boolean" && (cn = e), cn;
}
function La(e) {
  const t = typeof e == "string" ? ur(e, !0, cn) : e;
  if (t) {
    const n = Lt(t.provider, t.prefix), r = t.name;
    return n.icons[r] || (n.missing.has(r) ? null : void 0);
  }
}
function Hp(e, t) {
  const n = ur(e, !0, cn);
  if (!n) return !1;
  const r = Lt(n.provider, n.prefix);
  return t ? Lp(r, n.name, t) : (r.missing.add(n.name), !0);
}
function Up(e, t) {
  if (typeof e != "object") return !1;
  if (typeof t != "string" && (t = e.provider || ""), cn && !t && !e.prefix) {
    let o = !1;
    return sl(e) && (e.prefix = "", ol(e, (s, i) => {
      Hp(s, i) && (o = !0);
    })), o;
  }
  const n = e.prefix;
  if (!Yn({
    prefix: n,
    name: "a"
  })) return !1;
  const r = Lt(t, n);
  return !!il(r, e);
}
const ll = Object.freeze({
  width: null,
  height: null
}), ul = Object.freeze({
  ...ll,
  ...ir
}), qp = /(-?[0-9.]*[0-9]+[0-9.]*)/g, Fp = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function Ha(e, t, n) {
  if (t === 1) return e;
  if (n = n || 100, typeof e == "number") return Math.ceil(e * t * n) / n;
  if (typeof e != "string") return e;
  const r = e.split(qp);
  if (r === null || !r.length) return e;
  const o = [];
  let s = r.shift(), i = Fp.test(s);
  for (; ; ) {
    if (i) {
      const a = parseFloat(s);
      isNaN(a) ? o.push(s) : o.push(Math.ceil(a * t * n) / n);
    } else o.push(s);
    if (s = r.shift(), s === void 0) return o.join("");
    i = !i;
  }
}
function Bp(e, t = "defs") {
  let n = "";
  const r = e.indexOf("<" + t);
  for (; r >= 0; ) {
    const o = e.indexOf(">", r), s = e.indexOf("</" + t);
    if (o === -1 || s === -1) break;
    const i = e.indexOf(">", s);
    if (i === -1) break;
    n += e.slice(o + 1, s).trim(), e = e.slice(0, r).trim() + e.slice(i + 1);
  }
  return {
    defs: n,
    content: e
  };
}
function $p(e, t) {
  return e ? "<defs>" + e + "</defs>" + t : t;
}
function Wp(e, t, n) {
  const r = Bp(e);
  return $p(r.defs, t + r.content + n);
}
const zp = (e) => e === "unset" || e === "undefined" || e === "none";
function Gp(e, t) {
  const n = {
    ...Ss,
    ...e
  }, r = {
    ...ul,
    ...t
  }, o = {
    left: n.left,
    top: n.top,
    width: n.width,
    height: n.height
  };
  let s = n.body;
  [n, r].forEach((R) => {
    const b = [], _ = R.hFlip, k = R.vFlip;
    let S = R.rotate;
    _ ? k ? S += 2 : (b.push("translate(" + (o.width + o.left).toString() + " " + (0 - o.top).toString() + ")"), b.push("scale(-1 1)"), o.top = o.left = 0) : k && (b.push("translate(" + (0 - o.left).toString() + " " + (o.height + o.top).toString() + ")"), b.push("scale(1 -1)"), o.top = o.left = 0);
    let w;
    switch (S < 0 && (S -= Math.floor(S / 4) * 4), S = S % 4, S) {
      case 1:
        w = o.height / 2 + o.top, b.unshift("rotate(90 " + w.toString() + " " + w.toString() + ")");
        break;
      case 2:
        b.unshift("rotate(180 " + (o.width / 2 + o.left).toString() + " " + (o.height / 2 + o.top).toString() + ")");
        break;
      case 3:
        w = o.width / 2 + o.left, b.unshift("rotate(-90 " + w.toString() + " " + w.toString() + ")");
        break;
    }
    S % 2 === 1 && (o.left !== o.top && (w = o.left, o.left = o.top, o.top = w), o.width !== o.height && (w = o.width, o.width = o.height, o.height = w)), b.length && (s = Wp(s, '<g transform="' + b.join(" ") + '">', "</g>"));
  });
  const i = r.width, a = r.height, c = o.width, l = o.height;
  let u, d;
  i === null ? (d = a === null ? "1em" : a === "auto" ? l : a, u = Ha(d, c / l)) : (u = i === "auto" ? c : i, d = a === null ? Ha(u, l / c) : a === "auto" ? l : a);
  const f = {}, p = (R, b) => {
    zp(b) || (f[R] = b.toString());
  };
  p("width", u), p("height", d);
  const m = [
    o.left,
    o.top,
    c,
    l
  ];
  return f.viewBox = m.join(" "), {
    attributes: f,
    viewBox: m,
    body: s
  };
}
const Xp = /\sid="(\S+)"/g, Vp = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
let Kp = 0;
function Yp(e, t = Vp) {
  const n = [];
  let r;
  for (; r = Xp.exec(e); ) n.push(r[1]);
  if (!n.length) return e;
  const o = "suffix" + (Math.random() * 16777216 | Date.now()).toString(16);
  return n.forEach((s) => {
    const i = typeof t == "function" ? t(s) : t + (Kp++).toString(), a = s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    e = e.replace(new RegExp('([#;"])(' + a + ')([")]|\\.[a-z])', "g"), "$1" + i + o + "$3");
  }), e = e.replace(new RegExp(o, "g"), ""), e;
}
const as = /* @__PURE__ */ Object.create(null);
function Jp(e, t) {
  as[e] = t;
}
function cs(e) {
  return as[e] || as[""];
}
function Ts(e) {
  let t;
  if (typeof e.resources == "string") t = [e.resources];
  else if (t = e.resources, !(t instanceof Array) || !t.length) return null;
  return {
    resources: t,
    path: e.path || "/",
    maxURL: e.maxURL || 500,
    rotate: e.rotate || 750,
    timeout: e.timeout || 5e3,
    random: e.random === !0,
    index: e.index || 0,
    dataAfterTimeout: e.dataAfterTimeout !== !1
  };
}
const As = /* @__PURE__ */ Object.create(null), Qt = ["https://api.simplesvg.com", "https://api.unisvg.com"], Jn = [];
for (; Qt.length > 0; ) Qt.length === 1 || Math.random() > 0.5 ? Jn.push(Qt.shift()) : Jn.push(Qt.pop());
As[""] = Ts({ resources: ["https://api.iconify.design"].concat(Jn) });
function Qp(e, t) {
  const n = Ts(t);
  return n === null ? !1 : (As[e] = n, !0);
}
function Cs(e) {
  return As[e];
}
const Zp = () => {
  let e;
  try {
    if (e = fetch, typeof e == "function") return e;
  } catch {
  }
};
let Ua = Zp();
function em(e, t) {
  const n = Cs(e);
  if (!n) return 0;
  let r;
  if (!n.maxURL) r = 0;
  else {
    let o = 0;
    n.resources.forEach((i) => {
      o = Math.max(o, i.length);
    });
    const s = t + ".json?icons=";
    r = n.maxURL - o - n.path.length - s.length;
  }
  return r;
}
function tm(e) {
  return e === 404;
}
const nm = (e, t, n) => {
  const r = [], o = em(e, t), s = "icons";
  let i = {
    type: s,
    provider: e,
    prefix: t,
    icons: []
  }, a = 0;
  return n.forEach((c, l) => {
    a += c.length + 1, a >= o && l > 0 && (r.push(i), i = {
      type: s,
      provider: e,
      prefix: t,
      icons: []
    }, a = c.length), i.icons.push(c);
  }), r.push(i), r;
};
function rm(e) {
  if (typeof e == "string") {
    const t = Cs(e);
    if (t) return t.path;
  }
  return "/";
}
const om = (e, t, n) => {
  if (!Ua) {
    n("abort", 424);
    return;
  }
  let r = rm(t.provider);
  switch (t.type) {
    case "icons": {
      const s = t.prefix, a = t.icons.join(","), c = new URLSearchParams({ icons: a });
      r += s + ".json?" + c.toString();
      break;
    }
    case "custom": {
      const s = t.uri;
      r += s.slice(0, 1) === "/" ? s.slice(1) : s;
      break;
    }
    default:
      n("abort", 400);
      return;
  }
  let o = 503;
  Ua(e + r).then((s) => {
    const i = s.status;
    if (i !== 200) {
      setTimeout(() => {
        n(tm(i) ? "abort" : "next", i);
      });
      return;
    }
    return o = 501, s.json();
  }).then((s) => {
    if (typeof s != "object" || s === null) {
      setTimeout(() => {
        s === 404 ? n("abort", s) : n("next", o);
      });
      return;
    }
    setTimeout(() => {
      n("success", s);
    });
  }).catch(() => {
    n("next", o);
  });
}, sm = {
  prepare: nm,
  send: om
};
function dl(e, t) {
  e.forEach((n) => {
    const r = n.loaderCallbacks;
    r && (n.loaderCallbacks = r.filter((o) => o.id !== t));
  });
}
function im(e) {
  e.pendingCallbacksFlag || (e.pendingCallbacksFlag = !0, setTimeout(() => {
    e.pendingCallbacksFlag = !1;
    const t = e.loaderCallbacks ? e.loaderCallbacks.slice(0) : [];
    if (!t.length) return;
    let n = !1;
    const r = e.provider, o = e.prefix;
    t.forEach((s) => {
      const i = s.icons, a = i.pending.length;
      i.pending = i.pending.filter((c) => {
        if (c.prefix !== o) return !0;
        const l = c.name;
        if (e.icons[l]) i.loaded.push({
          provider: r,
          prefix: o,
          name: l
        });
        else if (e.missing.has(l)) i.missing.push({
          provider: r,
          prefix: o,
          name: l
        });
        else
          return n = !0, !0;
        return !1;
      }), i.pending.length !== a && (n || dl([e], s.id), s.callback(i.loaded.slice(0), i.missing.slice(0), i.pending.slice(0), s.abort));
    });
  }));
}
let am = 0;
function cm(e, t, n) {
  const r = am++, o = dl.bind(null, n, r);
  if (!t.pending.length) return o;
  const s = {
    id: r,
    icons: t,
    callback: e,
    abort: o
  };
  return n.forEach((i) => {
    (i.loaderCallbacks || (i.loaderCallbacks = [])).push(s);
  }), o;
}
function lm(e) {
  const t = {
    loaded: [],
    missing: [],
    pending: []
  }, n = /* @__PURE__ */ Object.create(null);
  e.sort((o, s) => o.provider !== s.provider ? o.provider.localeCompare(s.provider) : o.prefix !== s.prefix ? o.prefix.localeCompare(s.prefix) : o.name.localeCompare(s.name));
  let r = {
    provider: "",
    prefix: "",
    name: ""
  };
  return e.forEach((o) => {
    if (r.name === o.name && r.prefix === o.prefix && r.provider === o.provider) return;
    r = o;
    const s = o.provider, i = o.prefix, a = o.name, c = n[s] || (n[s] = /* @__PURE__ */ Object.create(null)), l = c[i] || (c[i] = Lt(s, i));
    let u;
    a in l.icons ? u = t.loaded : i === "" || l.missing.has(a) ? u = t.missing : u = t.pending;
    const d = {
      provider: s,
      prefix: i,
      name: a
    };
    u.push(d);
  }), t;
}
function um(e, t = !0, n = !1) {
  const r = [];
  return e.forEach((o) => {
    const s = typeof o == "string" ? ur(o, t, n) : o;
    s && r.push(s);
  }), r;
}
const dm = {
  resources: [],
  index: 0,
  timeout: 2e3,
  rotate: 750,
  random: !1,
  dataAfterTimeout: !1
};
function fm(e, t, n, r) {
  const o = e.resources.length, s = e.random ? Math.floor(Math.random() * o) : e.index;
  let i;
  if (e.random) {
    let g = e.resources.slice(0);
    for (i = []; g.length > 1; ) {
      const y = Math.floor(Math.random() * g.length);
      i.push(g[y]), g = g.slice(0, y).concat(g.slice(y + 1));
    }
    i = i.concat(g);
  } else i = e.resources.slice(s).concat(e.resources.slice(0, s));
  const a = Date.now();
  let c = "pending", l = 0, u, d = null, f = [], p = [];
  typeof r == "function" && p.push(r);
  function m() {
    d && (clearTimeout(d), d = null);
  }
  function R() {
    c === "pending" && (c = "aborted"), m(), f.forEach((g) => {
      g.status === "pending" && (g.status = "aborted");
    }), f = [];
  }
  function b(g, y) {
    y && (p = []), typeof g == "function" && p.push(g);
  }
  function _() {
    return {
      startTime: a,
      payload: t,
      status: c,
      queriesSent: l,
      queriesPending: f.length,
      subscribe: b,
      abort: R
    };
  }
  function k() {
    c = "failed", p.forEach((g) => {
      g(void 0, u);
    });
  }
  function S() {
    f.forEach((g) => {
      g.status === "pending" && (g.status = "aborted");
    }), f = [];
  }
  function w(g, y, E) {
    const A = y !== "success";
    switch (f = f.filter((H) => H !== g), c) {
      case "pending":
        break;
      case "failed":
        if (A || !e.dataAfterTimeout) return;
        break;
      default:
        return;
    }
    if (y === "abort") {
      u = E, k();
      return;
    }
    if (A) {
      u = E, f.length || (i.length ? h() : k());
      return;
    }
    if (m(), S(), !e.random) {
      const H = e.resources.indexOf(g.resource);
      H !== -1 && H !== e.index && (e.index = H);
    }
    c = "completed", p.forEach((H) => {
      H(E);
    });
  }
  function h() {
    if (c !== "pending") return;
    m();
    const g = i.shift();
    if (g === void 0) {
      if (f.length) {
        d = setTimeout(() => {
          m(), c === "pending" && (S(), k());
        }, e.timeout);
        return;
      }
      k();
      return;
    }
    const y = {
      status: "pending",
      resource: g,
      callback: (E, A) => {
        w(y, E, A);
      }
    };
    f.push(y), l++, d = setTimeout(h, e.rotate), n(g, t, y.callback);
  }
  return setTimeout(h), _;
}
function fl(e) {
  const t = {
    ...dm,
    ...e
  };
  let n = [];
  function r() {
    n = n.filter((a) => a().status === "pending");
  }
  function o(a, c, l) {
    const u = fm(t, a, c, (d, f) => {
      r(), l && l(d, f);
    });
    return n.push(u), u;
  }
  function s(a) {
    return n.find((c) => a(c)) || null;
  }
  return {
    query: o,
    find: s,
    setIndex: (a) => {
      t.index = a;
    },
    getIndex: () => t.index,
    cleanup: r
  };
}
function qa() {
}
const qo = /* @__PURE__ */ Object.create(null);
function hm(e) {
  if (!qo[e]) {
    const t = Cs(e);
    if (!t) return;
    const n = fl(t), r = {
      config: t,
      redundancy: n
    };
    qo[e] = r;
  }
  return qo[e];
}
function pm(e, t, n) {
  let r, o;
  if (typeof e == "string") {
    const s = cs(e);
    if (!s)
      return n(void 0, 424), qa;
    o = s.send;
    const i = hm(e);
    i && (r = i.redundancy);
  } else {
    const s = Ts(e);
    if (s) {
      r = fl(s);
      const i = e.resources ? e.resources[0] : "", a = cs(i);
      a && (o = a.send);
    }
  }
  return !r || !o ? (n(void 0, 424), qa) : r.query(t, o, n)().abort;
}
function Fa() {
}
function mm(e) {
  e.iconsLoaderFlag || (e.iconsLoaderFlag = !0, setTimeout(() => {
    e.iconsLoaderFlag = !1, im(e);
  }));
}
function gm(e) {
  const t = [], n = [];
  return e.forEach((r) => {
    (r.match(al) ? t : n).push(r);
  }), {
    valid: t,
    invalid: n
  };
}
function Zt(e, t, n) {
  function r() {
    const o = e.pendingIcons;
    t.forEach((s) => {
      o && o.delete(s), e.icons[s] || e.missing.add(s);
    });
  }
  if (n && typeof n == "object") try {
    if (!il(e, n).length) {
      r();
      return;
    }
  } catch (o) {
    console.error(o);
  }
  r(), mm(e);
}
function Ba(e, t) {
  e instanceof Promise ? e.then((n) => {
    t(n);
  }).catch(() => {
    t(null);
  }) : t(e);
}
function ym(e, t) {
  e.iconsToLoad ? e.iconsToLoad = e.iconsToLoad.concat(t).sort() : e.iconsToLoad = t, e.iconsQueueFlag || (e.iconsQueueFlag = !0, setTimeout(() => {
    e.iconsQueueFlag = !1;
    const { provider: n, prefix: r } = e, o = e.iconsToLoad;
    if (delete e.iconsToLoad, !o || !o.length) return;
    const s = e.loadIcon;
    if (e.loadIcons && (o.length > 1 || !s)) {
      Ba(e.loadIcons(o, r, n), (u) => {
        Zt(e, o, u);
      });
      return;
    }
    if (s) {
      o.forEach((u) => {
        const d = s(u, r, n);
        Ba(d, (f) => {
          const p = f ? {
            prefix: r,
            icons: { [u]: f }
          } : null;
          Zt(e, [u], p);
        });
      });
      return;
    }
    const { valid: i, invalid: a } = gm(o);
    if (a.length && Zt(e, a, null), !i.length) return;
    const c = r.match(al) ? cs(n) : null;
    if (!c) {
      Zt(e, i, null);
      return;
    }
    c.prepare(n, r, i).forEach((u) => {
      pm(n, u, (d) => {
        Zt(e, u.icons, d);
      });
    });
  }));
}
const _m = (e, t) => {
  const n = um(e, !0, cl()), r = lm(n);
  if (!r.pending.length) {
    let c = !0;
    return t && setTimeout(() => {
      c && t(r.loaded, r.missing, r.pending, Fa);
    }), () => {
      c = !1;
    };
  }
  const o = /* @__PURE__ */ Object.create(null), s = [];
  let i, a;
  return r.pending.forEach((c) => {
    const { provider: l, prefix: u } = c;
    if (u === a && l === i) return;
    i = l, a = u, s.push(Lt(l, u));
    const d = o[l] || (o[l] = /* @__PURE__ */ Object.create(null));
    d[u] || (d[u] = []);
  }), r.pending.forEach((c) => {
    const { provider: l, prefix: u, name: d } = c, f = Lt(l, u), p = f.pendingIcons || (f.pendingIcons = /* @__PURE__ */ new Set());
    p.has(d) || (p.add(d), o[l][u].push(d));
  }), s.forEach((c) => {
    const l = o[c.provider][c.prefix];
    l.length && ym(c, l);
  }), t ? cm(t, r, s) : Fa;
};
function bm(e, t) {
  const n = { ...e };
  for (const r in t) {
    const o = t[r], s = typeof o;
    r in ll ? (o === null || o && (s === "string" || s === "number")) && (n[r] = o) : s === typeof n[r] && (n[r] = r === "rotate" ? o % 4 : o);
  }
  return n;
}
const Em = /[\s,]+/;
function vm(e, t) {
  t.split(Em).forEach((n) => {
    switch (n.trim()) {
      case "horizontal":
        e.hFlip = !0;
        break;
      case "vertical":
        e.vFlip = !0;
        break;
    }
  });
}
function wm(e, t = 0) {
  const n = e.replace(/^-?[0-9.]*/, "");
  function r(o) {
    for (; o < 0; ) o += 4;
    return o % 4;
  }
  if (n === "") {
    const o = parseInt(e);
    return isNaN(o) ? 0 : r(o);
  } else if (n !== e) {
    let o = 0;
    switch (n) {
      case "%":
        o = 25;
        break;
      case "deg":
        o = 90;
    }
    if (o) {
      let s = parseFloat(e.slice(0, e.length - n.length));
      return isNaN(s) ? 0 : (s = s / o, s % 1 === 0 ? r(s) : 0);
    }
  }
  return t;
}
function Rm(e, t) {
  let n = e.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
  for (const r in t) n += " " + r + '="' + t[r] + '"';
  return '<svg xmlns="http://www.w3.org/2000/svg"' + n + ">" + e + "</svg>";
}
function Sm(e) {
  return e.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function Tm(e) {
  return "data:image/svg+xml," + Sm(e);
}
function Am(e) {
  return 'url("' + Tm(e) + '")';
}
let an;
function Cm() {
  try {
    an = window.trustedTypes.createPolicy("iconify", { createHTML: (e) => e });
  } catch {
    an = null;
  }
}
function Om(e) {
  return an === void 0 && Cm(), an ? an.createHTML(e) : e;
}
const hl = {
  ...ul,
  inline: !1
}, km = {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  "aria-hidden": !0,
  role: "img"
}, Pm = {
  display: "inline-block"
}, ls = {
  backgroundColor: "currentColor"
}, pl = {
  backgroundColor: "transparent"
}, $a = {
  Image: "var(--svg)",
  Repeat: "no-repeat",
  Size: "100% 100%"
}, Wa = {
  WebkitMask: ls,
  mask: ls,
  background: pl
};
for (const e in Wa) {
  const t = Wa[e];
  for (const n in $a)
    t[e + n] = $a[n];
}
const xm = {
  ...hl,
  inline: !0
};
function za(e) {
  return e + (e.match(/^[-0-9.]+$/) ? "px" : "");
}
const Im = (e, t, n) => {
  const r = t.inline ? xm : hl, o = bm(r, t), s = t.mode || "svg", i = {}, a = t.style || {}, c = {
    ...s === "svg" ? km : {}
  };
  if (n) {
    const b = ur(n, !1, !0);
    if (b) {
      const _ = ["iconify"], k = [
        "provider",
        "prefix"
      ];
      for (const S of k)
        b[S] && _.push("iconify--" + b[S]);
      c.className = _.join(" ");
    }
  }
  for (let b in t) {
    const _ = t[b];
    if (_ !== void 0)
      switch (b) {
        // Properties to ignore
        case "icon":
        case "style":
        case "children":
        case "onLoad":
        case "mode":
        case "ssr":
        case "fallback":
          break;
        // Forward ref
        case "_ref":
          c.ref = _;
          break;
        // Merge class names
        case "className":
          c[b] = (c[b] ? c[b] + " " : "") + _;
          break;
        // Boolean attributes
        case "inline":
        case "hFlip":
        case "vFlip":
          o[b] = _ === !0 || _ === "true" || _ === 1;
          break;
        // Flip as string: 'horizontal,vertical'
        case "flip":
          typeof _ == "string" && vm(o, _);
          break;
        // Color: copy to style
        case "color":
          i.color = _;
          break;
        // Rotation as string
        case "rotate":
          typeof _ == "string" ? o[b] = wm(_) : typeof _ == "number" && (o[b] = _);
          break;
        // Remove aria-hidden
        case "ariaHidden":
        case "aria-hidden":
          _ !== !0 && _ !== "true" && delete c["aria-hidden"];
          break;
        // Copy missing property if it does not exist in customisations
        default:
          r[b] === void 0 && (c[b] = _);
      }
  }
  const l = Gp(e, o), u = l.attributes;
  if (o.inline && (i.verticalAlign = "-0.125em"), s === "svg") {
    c.style = {
      ...i,
      ...a
    }, Object.assign(c, u);
    let b = 0, _ = t.id;
    return typeof _ == "string" && (_ = _.replace(/-/g, "_")), c.dangerouslySetInnerHTML = {
      __html: Om(Yp(l.body, _ ? () => _ + "ID" + b++ : "iconifyReact"))
    }, Zn("svg", c);
  }
  const { body: d, width: f, height: p } = e, m = s === "mask" || (s === "bg" ? !1 : d.indexOf("currentColor") !== -1), R = Rm(d, {
    ...u,
    width: f + "",
    height: p + ""
  });
  return c.style = {
    ...i,
    "--svg": Am(R),
    width: za(u.width),
    height: za(u.height),
    ...Pm,
    ...m ? ls : pl,
    ...a
  }, Zn("span", c);
};
cl(!0);
Jp("", sm);
if (typeof document < "u" && typeof window < "u") {
  const e = window;
  if (e.IconifyPreload !== void 0) {
    const t = e.IconifyPreload, n = "Invalid IconifyPreload syntax.";
    typeof t == "object" && t !== null && (t instanceof Array ? t : [t]).forEach((r) => {
      try {
        // Check if item is an object and not null/array
        (typeof r != "object" || r === null || r instanceof Array || // Check for 'icons' and 'prefix'
        typeof r.icons != "object" || typeof r.prefix != "string" || // Add icon set
        !Up(r)) && console.error(n);
      } catch {
        console.error(n);
      }
    });
  }
  if (e.IconifyProviders !== void 0) {
    const t = e.IconifyProviders;
    if (typeof t == "object" && t !== null)
      for (let n in t) {
        const r = "IconifyProviders[" + n + "] is invalid.";
        try {
          const o = t[n];
          if (typeof o != "object" || !o || o.resources === void 0)
            continue;
          Qp(n, o) || console.error(r);
        } catch {
          console.error(r);
        }
      }
  }
}
function ml(e) {
  const [t, n] = pe(!!e.ssr), [r, o] = pe({});
  function s(p) {
    if (p) {
      const m = e.icon;
      if (typeof m == "object")
        return {
          name: "",
          data: m
        };
      const R = La(m);
      if (R)
        return {
          name: m,
          data: R
        };
    }
    return {
      name: ""
    };
  }
  const [i, a] = pe(s(!!e.ssr));
  function c() {
    const p = r.callback;
    p && (p(), o({}));
  }
  function l(p) {
    if (JSON.stringify(i) !== JSON.stringify(p))
      return c(), a(p), !0;
  }
  function u() {
    var p;
    const m = e.icon;
    if (typeof m == "object") {
      l({
        name: "",
        data: m
      });
      return;
    }
    const R = La(m);
    if (l({
      name: m,
      data: R
    }))
      if (R === void 0) {
        const b = _m([m], u);
        o({
          callback: b
        });
      } else R && ((p = e.onLoad) === null || p === void 0 || p.call(e, m));
  }
  le(() => (n(!0), c), []), le(() => {
    t && u();
  }, [e.icon, t]);
  const { name: d, data: f } = i;
  return f ? Im({
    ...Ss,
    ...f
  }, e, d) : e.children ? e.children : e.fallback ? e.fallback : Zn("span", {});
}
const Wn = Xa((e, t) => ml({
  ...e,
  _ref: t
}));
Xa((e, t) => ml({
  inline: !0,
  ...e,
  _ref: t
}));
const Nm = {
  width: 24,
  height: 24,
  body: '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="m4.9 4.9l14.2 14.2"/></g>'
}, Mm = {
  width: 24,
  height: 24,
  body: '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M2 18v3c0 .6.4 1 1 1h4v-3h3v-3h2l1.4-1.4a6.5 6.5 0 1 0-4-4Z"/><circle cx="16.5" cy="7.5" r=".5"/></g>'
}, Dm = {
  width: 24,
  height: 24,
  body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 4h-7m-4 0H3m18 8h-9m-4 0H3m18 8h-5m-4 0H3M14 2v4m-6 4v4m8 4v4"/>'
}, jm = {
  width: 24,
  height: 24,
  body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3a2 2 0 0 0-2 2m16-2a2 2 0 0 1 2 2m0 14a2 2 0 0 1-2 2M5 21a2 2 0 0 1-2-2M9 3h1M9 21h1m4-18h1m-1 18h1M3 9v1m18-1v1M3 14v1m18-1v1M7 8h8m-8 4h10M7 16h6"/>'
}, Lm = "_devFooterAlpha_1hvqd_1", Hm = "_badgeGroup_1hvqd_20", Um = "_badge_1hvqd_20", qm = "_version_1hvqd_43", Fm = "_envDev_1hvqd_51", Bm = "_envStg_1hvqd_58", $m = "_paletteButton_1hvqd_65", Wm = "_paletteMenu_1hvqd_78", zm = "_paletteMenuHidden_1hvqd_93", Gm = "_jwtWrapper_1hvqd_99", Xm = "_settingsWrapper_1hvqd_100", Vm = "_jwtToggle_1hvqd_108", Km = "_settingsToggle_1hvqd_109", Ym = "_jwtPopup_1hvqd_126", Jm = "_settingsPopup_1hvqd_127", Qm = "_jwtPopupHidden_1hvqd_146", Zm = "_settingsPopupHidden_1hvqd_147", eg = "_jwtEmpty_1hvqd_152", tg = "_settingsEmpty_1hvqd_153", ng = "_jwtSectionLabel_1hvqd_160", rg = "_settingsSectionLabel_1hvqd_161", og = "_jwtJson_1hvqd_174", sg = "_settingsJson_1hvqd_175", ig = "_themeToggle_1hvqd_191", ag = "_debugToggle_1hvqd_204", cg = "_debugToggleOff_1hvqd_217", lg = "_selectabilityIndicator_1hvqd_224", ug = "_selectabilityIndicatorActive_1hvqd_237", dg = "_layoutResetToggle_1hvqd_243", fg = "_paletteWrapper_1hvqd_260", hg = "_paletteItem_1hvqd_266", pg = "_paletteItemHighlighted_1hvqd_277", mg = "_paletteItemActive_1hvqd_281", gg = "_densityGroup_1hvqd_290", yg = "_densityButton_1hvqd_297", _g = "_densityButtonActive_1hvqd_312", bg = "_densityIcon_1hvqd_318", Eg = "_densityLabel_1hvqd_323", vg = "_memoryIndicator_1hvqd_331", wg = "_memoryBar_1hvqd_339", Rg = "_memoryFill_1hvqd_348", Sg = "_memoryFillGreen_1hvqd_353", Tg = "_memoryFillOrange_1hvqd_357", Ag = "_memoryFillRed_1hvqd_361", Cg = "_memoryLabel_1hvqd_365", Og = "_memoryPercent_1hvqd_373", kg = "_memoryPercentGreen_1hvqd_381", Pg = "_memoryPercentOrange_1hvqd_385", xg = "_memoryPercentRed_1hvqd_389", X = {
  devFooterAlpha: Lm,
  badgeGroup: Hm,
  badge: Um,
  version: qm,
  envDev: Fm,
  envStg: Bm,
  paletteButton: $m,
  paletteMenu: Wm,
  paletteMenuHidden: zm,
  jwtWrapper: Gm,
  settingsWrapper: Xm,
  jwtToggle: Vm,
  settingsToggle: Km,
  jwtPopup: Ym,
  settingsPopup: Jm,
  jwtPopupHidden: Qm,
  settingsPopupHidden: Zm,
  jwtEmpty: eg,
  settingsEmpty: tg,
  jwtSectionLabel: ng,
  settingsSectionLabel: rg,
  jwtJson: og,
  settingsJson: sg,
  themeToggle: ig,
  debugToggle: ag,
  debugToggleOff: cg,
  selectabilityIndicator: lg,
  selectabilityIndicatorActive: ug,
  layoutResetToggle: dg,
  paletteWrapper: fg,
  paletteItem: hg,
  paletteItemHighlighted: pg,
  paletteItemActive: mg,
  densityGroup: gg,
  densityButton: yg,
  densityButtonActive: _g,
  densityIcon: bg,
  densityLabel: Eg,
  memoryIndicator: vg,
  memoryBar: wg,
  memoryFill: Rg,
  memoryFillGreen: Sg,
  memoryFillOrange: Tg,
  memoryFillRed: Ag,
  memoryLabel: Cg,
  memoryPercent: Og,
  memoryPercentGreen: kg,
  memoryPercentOrange: Pg,
  memoryPercentRed: xg
}, Ig = (e) => {
  try {
    const t = e.split(".");
    return t.length !== 3 ? null : {
      header: JSON.parse(atob(t[0])),
      payload: JSON.parse(atob(t[1]))
    };
  } catch {
    return null;
  }
}, Ng = () => {
  const e = re.c(161), t = Pe.getRuntime(), {
    isDebug: n,
    toggleDebug: r
  } = Xc(), {
    appIsUnselectable: o
  } = gs(), {
    authData: s
  } = vs(), {
    hasCustomLayout: i,
    resetLayout: a
  } = sp(), {
    environment: c,
    version: l
  } = at(), {
    available: u,
    current: d,
    setTheme: f
  } = Zh(), {
    resolvedMode: p,
    toggleMode: m
  } = ap(), {
    density: R,
    setDensity: b
  } = Xh(), {
    snapshot: _
  } = Jh(), {
    snapshot: k
  } = np(), S = t === "electron", [w, h] = ce.useState(!1), [g, y] = ce.useState(-1), E = ce.useRef(null), [A, H] = ce.useState(!1), x = ce.useRef(null), [M, L] = ce.useState(!1), $ = ce.useRef(null);
  let U;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (U = up.use(Mg), e[0] = U) : U = e[0];
  const z = U;
  let V;
  e[1] !== u ? (V = u.map(Dg).sort(jg), e[1] = u, e[2] = V) : V = e[2];
  const D = V;
  let Z;
  e[3] !== D || e[4] !== d ? (Z = D.find((te) => te.key === d)?.displayName ?? d, e[3] = D, e[4] = d, e[5] = Z) : Z = e[5];
  const ie = Z;
  let T;
  if (e[6] !== s?.idToken || e[7] !== A) {
    e: {
      if (!A) {
        T = null;
        break e;
      }
      const te = s?.idToken;
      if (!te) {
        let be;
        e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (be = {
          kind: "missing"
        }, e[9] = be) : be = e[9], T = be;
        break e;
      }
      const de = Ig(te);
      if (!de) {
        let be;
        e[10] !== te ? (be = {
          kind: "invalid",
          token: te
        }, e[10] = te, e[11] = be) : be = e[11], T = be;
        break e;
      }
      T = {
        kind: "ok",
        headerJson: JSON.stringify(de.header, null, 2),
        payloadJson: JSON.stringify(de.payload, null, 2),
        token: te
      };
    }
    e[6] = s?.idToken, e[7] = A, e[8] = T;
  } else
    T = e[8];
  const q = T;
  let I;
  e: {
    if (!M) {
      I = null;
      break e;
    }
    if (!z) {
      let de;
      e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (de = {
        kind: "missing"
      }, e[12] = de) : de = e[12], I = de;
      break e;
    }
    let te;
    e[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (te = {
      kind: "ok",
      json: JSON.stringify(z, null, 2)
    }, e[13] = te) : te = e[13], I = te;
  }
  const j = I;
  let Q;
  e[14] !== g || e[15] !== w || e[16] !== y || e[17] !== f || e[18] !== h || e[19] !== D || e[20] !== d ? (Q = () => {
    if (!w)
      return;
    const te = (Re) => {
      E.current && !E.current.contains(Re.target) && h(!1);
    }, de = (Re) => {
      if (Re.key === "Escape") {
        h(!1);
        return;
      }
      (Re.key === "ArrowDown" || Re.key === "ArrowUp") && (Re.preventDefault(), y((Os) => {
        const ks = Os === -1 ? D.findIndex((_l) => _l.key === d) : Os;
        return Re.key === "ArrowDown" ? Math.min(ks + 1, D.length - 1) : Math.max(ks - 1, 0);
      })), Re.key === "Enter" && g >= 0 && f(D[g].key);
    }, be = () => h(!1);
    return document.addEventListener("mousedown", te, !0), document.addEventListener("keydown", de), window.addEventListener("blur", be), () => {
      document.removeEventListener("mousedown", te, !0), document.removeEventListener("keydown", de), window.removeEventListener("blur", be);
    };
  }, e[14] = g, e[15] = w, e[16] = y, e[17] = f, e[18] = h, e[19] = D, e[20] = d, e[21] = Q) : Q = e[21];
  let K;
  e[22] !== g || e[23] !== w || e[24] !== f || e[25] !== D || e[26] !== d ? (K = [w, D, d, f, g], e[22] = g, e[23] = w, e[24] = f, e[25] = D, e[26] = d, e[27] = K) : K = e[27], ce.useEffect(Q, K);
  let W;
  e[28] !== A || e[29] !== H ? (W = () => {
    if (!A)
      return;
    const te = (Re) => {
      x.current && !x.current.contains(Re.target) && H(!1);
    }, de = (Re) => {
      Re.key === "Escape" && H(!1);
    }, be = () => H(!1);
    return document.addEventListener("mousedown", te, !0), document.addEventListener("keydown", de), window.addEventListener("blur", be), () => {
      document.removeEventListener("mousedown", te, !0), document.removeEventListener("keydown", de), window.removeEventListener("blur", be);
    };
  }, e[28] = A, e[29] = H, e[30] = W) : W = e[30];
  let ae;
  e[31] !== A ? (ae = [A], e[31] = A, e[32] = ae) : ae = e[32], ce.useEffect(W, ae);
  let oe;
  e[33] !== L || e[34] !== M ? (oe = () => {
    if (!M)
      return;
    const te = (Re) => {
      $.current && !$.current.contains(Re.target) && L(!1);
    }, de = (Re) => {
      Re.key === "Escape" && L(!1);
    }, be = () => L(!1);
    return document.addEventListener("mousedown", te, !0), document.addEventListener("keydown", de), window.addEventListener("blur", be), () => {
      document.removeEventListener("mousedown", te, !0), document.removeEventListener("keydown", de), window.removeEventListener("blur", be);
    };
  }, e[33] = L, e[34] = M, e[35] = oe) : oe = e[35];
  let ue;
  e[36] !== M ? (ue = [M], e[36] = M, e[37] = ue) : ue = e[37], ce.useEffect(oe, ue);
  let ve;
  e[38] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ve = [{
    icon: "▤",
    key: "compact",
    label: "Compact"
  }, {
    icon: "▥",
    key: "standard",
    label: "Standard"
  }, {
    icon: "▦",
    key: "spacious",
    label: "Spacious"
  }], e[38] = ve) : ve = e[38];
  const ge = ve, He = c === "dev" || c === "localhost" ? X.envDev : c === "stg" ? X.envStg : void 0;
  let Ce;
  e[39] !== He ? (Ce = [X.devFooterAlpha, He].filter(Boolean), e[39] = He, e[40] = Ce) : Ce = e[40];
  const Fe = Ce.join(" "), Be = Lg, We = X;
  let ze;
  e[41] !== c ? (ze = c.toUpperCase(), e[41] = c, e[42] = ze) : ze = e[42];
  let ye;
  e[43] !== ze ? (ye = /* @__PURE__ */ C.jsx("span", { className: X.badge, children: ze }), e[43] = ze, e[44] = ye) : ye = e[44];
  const Ft = X, ct = t.toUpperCase();
  let Ge;
  e[45] !== Ft.badge || e[46] !== ct ? (Ge = /* @__PURE__ */ C.jsx("span", { className: Ft.badge, children: ct }), e[45] = Ft.badge, e[46] = ct, e[47] = Ge) : Ge = e[47];
  let Xe;
  e[48] !== We.badgeGroup || e[49] !== ye || e[50] !== Ge ? (Xe = /* @__PURE__ */ C.jsxs("span", { className: We.badgeGroup, children: [
    ye,
    Ge
  ] }), e[48] = We.badgeGroup, e[49] = ye, e[50] = Ge, e[51] = Xe) : Xe = e[51];
  let Ve;
  e[52] !== l ? (Ve = /* @__PURE__ */ C.jsxs("span", { className: X.version, children: [
    "v",
    l
  ] }), e[52] = l, e[53] = Ve) : Ve = e[53];
  let v;
  e[54] !== H ? (v = () => H(Hg), e[54] = H, e[55] = v) : v = e[55];
  let P;
  e[56] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (P = /* @__PURE__ */ C.jsx(Wn, { icon: Mm, width: 12, height: 12, "aria-hidden": "true" }), e[56] = P) : P = e[56];
  let O;
  e[57] !== A || e[58] !== v ? (O = /* @__PURE__ */ C.jsx("button", { type: "button", className: X.jwtToggle, onClick: v, title: "Inspect JWT claims", "aria-expanded": A, "aria-haspopup": "dialog", children: P }), e[57] = A, e[58] = v, e[59] = O) : O = e[59];
  const G = !A && X.jwtPopupHidden;
  let J;
  e[60] !== G ? (J = [X.jwtPopup, G].filter(Boolean), e[60] = G, e[61] = J) : J = e[61];
  const ee = J.join(" ");
  let se;
  e[62] !== q?.kind ? (se = q?.kind === "missing" && /* @__PURE__ */ C.jsx("div", { className: X.jwtEmpty, children: "No JWT available" }), e[62] = q?.kind, e[63] = se) : se = e[63];
  let me;
  e[64] !== q ? (me = q?.kind === "invalid" && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    /* @__PURE__ */ C.jsx("div", { className: X.jwtSectionLabel, children: "Raw (invalid JWT — could not decode)" }),
    /* @__PURE__ */ C.jsx("pre", { className: X.jwtJson, children: q.token })
  ] }), e[64] = q, e[65] = me) : me = e[65];
  let ke;
  e[66] !== q ? (ke = q?.kind === "ok" && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    /* @__PURE__ */ C.jsx("div", { className: X.jwtSectionLabel, children: "Header" }),
    /* @__PURE__ */ C.jsx("pre", { className: X.jwtJson, children: q.headerJson }),
    /* @__PURE__ */ C.jsx("div", { className: X.jwtSectionLabel, children: "Payload" }),
    /* @__PURE__ */ C.jsx("pre", { className: X.jwtJson, children: q.payloadJson }),
    /* @__PURE__ */ C.jsx("div", { className: X.jwtSectionLabel, children: "Token" }),
    /* @__PURE__ */ C.jsx("pre", { className: X.jwtJson, children: q.token })
  ] }), e[66] = q, e[67] = ke) : ke = e[67];
  let _e;
  e[68] !== ee || e[69] !== se || e[70] !== me || e[71] !== ke ? (_e = /* @__PURE__ */ C.jsxs("div", { className: ee, role: "dialog", "aria-label": "JWT claims", children: [
    se,
    me,
    ke
  ] }), e[68] = ee, e[69] = se, e[70] = me, e[71] = ke, e[72] = _e) : _e = e[72];
  let we;
  e[73] !== O || e[74] !== _e ? (we = /* @__PURE__ */ C.jsxs("div", { ref: x, className: X.jwtWrapper, children: [
    O,
    _e
  ] }), e[73] = O, e[74] = _e, e[75] = we) : we = e[75];
  let xe;
  e[76] !== L ? (xe = () => L(Ug), e[76] = L, e[77] = xe) : xe = e[77];
  let Ke;
  e[78] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Ke = /* @__PURE__ */ C.jsx(Wn, { icon: Dm, width: 12, height: 12, "aria-hidden": "true" }), e[78] = Ke) : Ke = e[78];
  let gt;
  e[79] !== M || e[80] !== xe ? (gt = /* @__PURE__ */ C.jsx("button", { type: "button", className: X.settingsToggle, onClick: xe, title: "Inspect settings", "aria-expanded": M, "aria-haspopup": "dialog", children: Ke }), e[79] = M, e[80] = xe, e[81] = gt) : gt = e[81];
  const dr = !M && X.settingsPopupHidden;
  let dn;
  e[82] !== dr ? (dn = [X.settingsPopup, dr].filter(Boolean), e[82] = dr, e[83] = dn) : dn = e[83];
  const fr = dn.join(" ");
  let yt;
  e[84] !== j?.kind ? (yt = j?.kind === "missing" && /* @__PURE__ */ C.jsx("div", { className: X.settingsEmpty, children: "No settings available" }), e[84] = j?.kind, e[85] = yt) : yt = e[85];
  let _t;
  e[86] !== j ? (_t = j?.kind === "ok" && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    /* @__PURE__ */ C.jsx("div", { className: X.settingsSectionLabel, children: "Settings" }),
    /* @__PURE__ */ C.jsx("pre", { className: X.settingsJson, children: j.json })
  ] }), e[86] = j, e[87] = _t) : _t = e[87];
  let bt;
  e[88] !== fr || e[89] !== yt || e[90] !== _t ? (bt = /* @__PURE__ */ C.jsxs("div", { className: fr, role: "dialog", "aria-label": "App settings", children: [
    yt,
    _t
  ] }), e[88] = fr, e[89] = yt, e[90] = _t, e[91] = bt) : bt = e[91];
  let Et;
  e[92] !== gt || e[93] !== bt ? (Et = /* @__PURE__ */ C.jsxs("div", { ref: $, className: X.settingsWrapper, children: [
    gt,
    bt
  ] }), e[92] = gt, e[93] = bt, e[94] = Et) : Et = e[94];
  let vt;
  e[95] !== R || e[96] !== ge || e[97] !== b ? (vt = /* @__PURE__ */ C.jsx("div", { className: X.densityGroup, role: "group", "aria-label": "UI density", children: ge.map((te) => /* @__PURE__ */ C.jsxs("button", { type: "button", className: [X.densityButton, te.key === R && X.densityButtonActive].filter(Boolean).join(" "), onClick: () => b(te.key), title: `${te.label} density`, "aria-pressed": te.key === R, children: [
    /* @__PURE__ */ C.jsx("span", { className: X.densityIcon, "aria-hidden": "true", children: te.icon }),
    /* @__PURE__ */ C.jsx("span", { className: X.densityLabel, children: te.label })
  ] }, te.key)) }), e[95] = R, e[96] = ge, e[97] = b, e[98] = vt) : vt = e[98];
  let wt;
  e[99] !== y || e[100] !== h ? (wt = () => {
    h(qg), y(-1);
  }, e[99] = y, e[100] = h, e[101] = wt) : wt = e[101];
  let Rt;
  e[102] !== ie || e[103] !== wt ? (Rt = /* @__PURE__ */ C.jsx("button", { type: "button", className: X.paletteButton, onClick: wt, children: ie }), e[102] = ie, e[103] = wt, e[104] = Rt) : Rt = e[104];
  const hr = !w && X.paletteMenuHidden;
  let fn;
  e[105] !== hr ? (fn = [X.paletteMenu, hr].filter(Boolean), e[105] = hr, e[106] = fn) : fn = e[106];
  const pr = fn.join(" ");
  let St;
  if (e[107] !== g || e[108] !== f || e[109] !== D || e[110] !== d) {
    let te;
    e[112] !== g || e[113] !== f || e[114] !== d ? (te = (de, be) => /* @__PURE__ */ C.jsx("div", { role: "option", "aria-selected": de.key === d, tabIndex: -1, className: [X.paletteItem, de.key === d && X.paletteItemActive, be === g && X.paletteItemHighlighted].filter(Boolean).join(" "), onClick: () => f(de.key), onKeyDown: (Re) => {
      (Re.key === "Enter" || Re.key === " ") && f(de.key);
    }, children: de.displayName }, de.key), e[112] = g, e[113] = f, e[114] = d, e[115] = te) : te = e[115], St = D.map(te), e[107] = g, e[108] = f, e[109] = D, e[110] = d, e[111] = St;
  } else
    St = e[111];
  let Tt;
  e[116] !== pr || e[117] !== St ? (Tt = /* @__PURE__ */ C.jsx("div", { className: pr, children: St }), e[116] = pr, e[117] = St, e[118] = Tt) : Tt = e[118];
  let At;
  e[119] !== Rt || e[120] !== Tt ? (At = /* @__PURE__ */ C.jsxs("div", { ref: E, className: X.paletteWrapper, children: [
    Rt,
    Tt
  ] }), e[119] = Rt, e[120] = Tt, e[121] = At) : At = e[121];
  const mr = p === "dark" ? "Switch to light mode" : "Switch to dark mode", gr = p === "dark" ? "☼" : "☀";
  let Ct;
  e[122] !== mr || e[123] !== gr || e[124] !== m ? (Ct = /* @__PURE__ */ C.jsx("button", { type: "button", className: X.themeToggle, onClick: m, title: mr, children: gr }), e[122] = mr, e[123] = gr, e[124] = m, e[125] = Ct) : Ct = e[125];
  let Ot;
  e[126] !== i || e[127] !== a ? (Ot = a && /* @__PURE__ */ C.jsx("button", { type: "button", className: X.layoutResetToggle, onClick: a, disabled: !i, title: "Reset layout", children: /* @__PURE__ */ C.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", children: [
    /* @__PURE__ */ C.jsx("rect", { width: "18", height: "7", x: "3", y: "3", rx: "1" }),
    /* @__PURE__ */ C.jsx("rect", { width: "9", height: "7", x: "3", y: "14", rx: "1" }),
    /* @__PURE__ */ C.jsx("rect", { width: "5", height: "7", x: "16", y: "14", rx: "1" })
  ] }) }), e[126] = i, e[127] = a, e[128] = Ot) : Ot = e[128];
  const yr = !n && X.debugToggleOff;
  let hn;
  e[129] !== yr ? (hn = [X.debugToggle, yr].filter(Boolean), e[129] = yr, e[130] = hn) : hn = e[130];
  const _r = hn.join(" "), br = n ? "Disable debug mode" : "Enable debug mode", Er = n ? "◉" : "◎";
  let kt;
  e[131] !== _r || e[132] !== br || e[133] !== Er || e[134] !== r ? (kt = /* @__PURE__ */ C.jsx("button", { type: "button", className: _r, onClick: r, title: br, children: Er }), e[131] = _r, e[132] = br, e[133] = Er, e[134] = r, e[135] = kt) : kt = e[135];
  const vr = o && X.selectabilityIndicatorActive;
  let pn;
  e[136] !== vr ? (pn = [X.selectabilityIndicator, vr].filter(Boolean), e[136] = vr, e[137] = pn) : pn = e[137];
  const wr = pn.join(" "), Rr = o ? "App is unselectable (drag in progress)" : "App is selectable";
  let Pt;
  e[138] !== o ? (Pt = o ? /* @__PURE__ */ C.jsx(Wn, { icon: Nm, width: 12, height: 12, "aria-hidden": "true" }) : /* @__PURE__ */ C.jsx(Wn, { icon: jm, width: 12, height: 12, "aria-hidden": "true" }), e[138] = o, e[139] = Pt) : Pt = e[139];
  let xt;
  e[140] !== wr || e[141] !== Rr || e[142] !== Pt ? (xt = /* @__PURE__ */ C.jsx("span", { className: wr, title: Rr, "aria-live": "polite", children: Pt }), e[140] = wr, e[141] = Rr, e[142] = Pt, e[143] = xt) : xt = e[143];
  let It;
  e[144] !== _ || e[145] !== Be || e[146] !== k ? (It = S && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    Be("M", "Main", _),
    Be("R", "Renderer", k)
  ] }), e[144] = _, e[145] = Be, e[146] = k, e[147] = It) : It = e[147];
  let mn;
  return e[148] !== Fe || e[149] !== Xe || e[150] !== Ve || e[151] !== we || e[152] !== Et || e[153] !== vt || e[154] !== At || e[155] !== Ct || e[156] !== Ot || e[157] !== kt || e[158] !== xt || e[159] !== It ? (mn = /* @__PURE__ */ C.jsxs("div", { className: Fe, children: [
    Xe,
    Ve,
    we,
    Et,
    vt,
    At,
    Ct,
    Ot,
    kt,
    xt,
    It
  ] }), e[148] = Fe, e[149] = Xe, e[150] = Ve, e[151] = we, e[152] = Et, e[153] = vt, e[154] = At, e[155] = Ct, e[156] = Ot, e[157] = kt, e[158] = xt, e[159] = It, e[160] = mn) : mn = e[160], mn;
};
function Mg(e) {
  return e.snapshot;
}
function Dg(e) {
  return {
    displayName: e.displayName,
    key: e.name
  };
}
function jg(e, t) {
  return e.displayName.localeCompare(t.displayName);
}
function Lg(e, t, n) {
  if (!n)
    return null;
  const {
    heapLimit: r,
    heapUsed: o,
    usagePercent: s
  } = n, i = s < 50 ? X.memoryFillGreen : s < 75 ? X.memoryFillOrange : X.memoryFillRed, a = s < 50 ? X.memoryPercentGreen : s < 75 ? X.memoryPercentOrange : X.memoryPercentRed, c = Math.round(o / 1024 / 1024), l = Math.round(r / 1024 / 1024), u = `${t}: ${s.toFixed(2)}% (${c} / ${l} MB)`, d = `${Math.min(100, Math.max(0, s))}%`;
  return /* @__PURE__ */ C.jsxs("div", { className: X.memoryIndicator, title: u, children: [
    /* @__PURE__ */ C.jsx("span", { className: X.memoryLabel, children: e }),
    /* @__PURE__ */ C.jsx("div", { className: X.memoryBar, children: /* @__PURE__ */ C.jsx("div", { className: [X.memoryFill, i].join(" "), style: {
      width: d
    } }) }),
    /* @__PURE__ */ C.jsxs("span", { className: [X.memoryPercent, a].join(" "), children: [
      Math.round(s),
      "%"
    ] })
  ] });
}
function Hg(e) {
  return !e;
}
function Ug(e) {
  return !e;
}
function qg(e) {
  return !e;
}
const Fg = (e) => {
  const {
    children: t,
    initializingComponent: n,
    loginComponent: r
  } = e, {
    globalMouseClick: o,
    globalMouseDown: s,
    globalMouseEnter: i,
    globalMouseLeave: a,
    globalMouseMove: c,
    globalMouseUp: l
  } = Ec(), {
    appIsUnselectable: u,
    setAppIsUnselectable: d
  } = gs(), {
    isAuthenticated: f,
    isAuthInitialized: p,
    hydrateAuthToken: m
  } = vs();
  tp();
  const {
    isDebug: R
  } = Xc(), {
    environment: b
  } = at(), {
    logError: _
  } = mt("AppContainer"), k = Pe.isElectron(), S = b !== "prod";
  wc({
    /** Re-hydrates the auth token when the computer wakes from sleep. */
    onWakeFromSleep: () => {
      m().catch((h) => _("[onWakeFromSleep] Failed to hydrate auth token on wake.", h));
    },
    sleepThresholdMs: 3e4
    // 30 seconds
  }), le(() => {
    m().catch((h) => _("[mount] Failed to hydrate auth token.", h));
  }, []);
  const w = (h) => {
    l(h), d(!1);
  };
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    /* @__PURE__ */ C.jsxs("div", { className: _c(qe.appContainerInnerAlpha, u && qe.unselectable), role: "application", onClick: (h) => o(h), onMouseDown: (h) => s(h), onMouseEnter: (h) => i(h), onMouseLeave: (h) => a(h), onMouseMove: (h) => c(h), onMouseUp: w, children: [
      k && !f && /* @__PURE__ */ C.jsx("div", { className: `${qe.electronDragBar}${R ? ` ${qe.debug}` : ""}` }),
      !p && /* @__PURE__ */ C.jsx("div", { className: `${qe.content}${S ? ` ${qe.hasDevFooter}` : ""}`, children: n }),
      p && !f && /* @__PURE__ */ C.jsx("div", { className: `${qe.content}${S ? ` ${qe.hasDevFooter}` : ""}`, children: r }),
      p && f && /* @__PURE__ */ C.jsx("div", { className: `${qe.content}${S ? ` ${qe.hasDevFooter}` : ""}`, children: t }),
      S && /* @__PURE__ */ C.jsx(Rc, { children: /* @__PURE__ */ C.jsx(Ng, {}) })
    ] })
  );
}, gl = ({
  children: e,
  errorClassName: t,
  viteMetaEnv: n
}) => {
  const [r, o] = pe(null), [s, i] = pe(!0), [a, c] = pe(null);
  return le(() => {
    (async () => {
      try {
        if (n.DEV && !window.__BLUFIN_CONFIG__) {
          const u = await fetch("/config.json", {
            cache: "no-cache",
            headers: {
              Accept: "application/json"
            }
          });
          if (!u.ok) throw new Error(`Failed to load config: ${u.status} ${u.statusText}`);
          window.__BLUFIN_CONFIG__ = await u.json();
        }
        if (!window.__BLUFIN_CONFIG__) throw new Error("Runtime config is not available");
        o(window.__BLUFIN_CONFIG__);
      } catch (u) {
        const d = u instanceof Error ? u.message : "Unknown error loading config";
        console.error("[ConfigLoaderAlpha] Failed to load config:", d), c(d);
      } finally {
        i(!1);
      }
    })().then();
  }, [n.DEV]), s ? /* @__PURE__ */ C.jsx("div", {}) : a || !r ? /* @__PURE__ */ C.jsxs("div", { className: t, style: {
    color: "var(--feedback-danger-fg)"
  }, children: [
    "Failed to load configuration: ",
    a || "Config is null"
  ] }) : /* @__PURE__ */ C.jsx(C.Fragment, { children: e(r) });
}, Xy = (e) => {
  const t = re.c(17), {
    appName: n,
    children: r,
    initialDensity: o,
    initialMode: s,
    initialTheme: i,
    loginComponent: a,
    themes: c,
    viteMetaEnv: l
  } = e;
  let u;
  t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = [], t[0] = u) : u = t[0], ce.useEffect(Bg, u);
  let d;
  t[1] !== r || t[2] !== a || t[3] !== l ? (d = (R) => /* @__PURE__ */ C.jsx(oc, { viteMetaEnv: l, runtimeConfig: R, children: /* @__PURE__ */ C.jsx(nl, { children: /* @__PURE__ */ C.jsx(ds, { children: /* @__PURE__ */ C.jsx(Fg, { loginComponent: a, children: r }) }) }) }), t[1] = r, t[2] = a, t[3] = l, t[4] = d) : d = t[4];
  let f;
  t[5] !== d || t[6] !== l ? (f = /* @__PURE__ */ C.jsx(gl, { viteMetaEnv: l, children: d }), t[5] = d, t[6] = l, t[7] = f) : f = t[7];
  let p;
  t[8] !== o || t[9] !== s || t[10] !== i || t[11] !== f || t[12] !== c ? (p = /* @__PURE__ */ C.jsx(Oc, { themes: c, initialDensity: o, initialMode: s, initialTheme: i, children: f }), t[8] = o, t[9] = s, t[10] = i, t[11] = f, t[12] = c, t[13] = p) : p = t[13];
  let m;
  return t[14] !== n || t[15] !== p ? (m = /* @__PURE__ */ C.jsx(nc, { children: /* @__PURE__ */ C.jsx(mf, { appName: n, children: p }) }), t[14] = n, t[15] = p, t[16] = m) : m = t[16], m;
};
function Bg() {
  Pe.getElectronApi()?.invoke("renderer:ready");
}
const $g = ht({
  accent: "#a855f7",
  brand: "#3b82f6",
  defaultMode: "system",
  diverging: {
    negative: "#ef4444",
    positive: "#22c55e"
  },
  feedback: {
    danger: "#ef4444",
    info: "#06b6d4",
    success: "#22c55e",
    warning: "#f59e0b"
  },
  fonts: {
    mono: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
    sans: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif",
    serif: "ui-serif, Georgia, Cambria, 'Times New Roman', Times, serif"
  },
  gray: "cool",
  name: "blufin-default",
  radius: "md"
}), Wg = ht({
  accent: "#ffcc00",
  brand: "#002c69",
  defaultMode: "system",
  diverging: {
    negative: "#ef4444",
    positive: "#22c55e"
  },
  feedback: {
    danger: "#ef4444",
    info: "#06b6d4",
    success: "#22c55e",
    warning: "#f97316"
  },
  fonts: {
    mono: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
    sans: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif",
    serif: "ui-serif, Georgia, Cambria, 'Times New Roman', Times, serif"
  },
  gray: "slate",
  name: "buff-and-blue",
  radius: "md"
}), zg = ht({
  accent: "#00c2ff",
  brand: "#ff6a00",
  defaultMode: "system",
  feedback: {
    danger: "#ef4444",
    info: "#06b6d4",
    success: "#22c55e",
    warning: "#f59e0b"
  },
  fonts: {
    mono: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
    sans: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif",
    serif: "ui-serif, Georgia, Cambria, 'Times New Roman', Times, serif"
  },
  gray: "warm",
  intensity: "vivid",
  name: "ember",
  radius: "md"
}), Gg = ht({
  accent: "#00d4ff",
  brand: "#e10600",
  defaultMode: "system",
  feedback: {
    danger: "#ef4444",
    info: "#06b6d4",
    success: "#22c55e",
    warning: "#f59e0b"
  },
  fonts: {
    mono: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
    sans: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif",
    serif: "ui-serif, Georgia, Cambria, 'Times New Roman', Times, serif"
  },
  gray: "warm",
  name: "inferno",
  radius: "md"
}), Xg = ht({
  accent: "#ff00c8",
  brand: "#39ff14",
  defaultMode: "system",
  feedback: {
    danger: "#ef4444",
    info: "#06b6d4",
    success: "#22c55e",
    warning: "#f59e0b"
  },
  fonts: {
    mono: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
    sans: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif",
    serif: "ui-serif, Georgia, Cambria, 'Times New Roman', Times, serif"
  },
  gray: "cool",
  intensity: "vivid",
  name: "radium",
  radius: "md"
}), Vg = ht({
  accent: "#ff2fb3",
  brand: "#00e5ff",
  defaultMode: "system",
  feedback: {
    danger: "#ef4444",
    info: "#06b6d4",
    success: "#22c55e",
    warning: "#f59e0b"
  },
  fonts: {
    mono: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
    sans: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif",
    serif: "ui-serif, Georgia, Cambria, 'Times New Roman', Times, serif"
  },
  gray: "slate",
  intensity: "vivid",
  name: "riptide",
  radius: "md"
}), Kg = ht({
  accent: "#7c3aed",
  brand: "#ffd400",
  defaultMode: "system",
  feedback: {
    danger: "#ef4444",
    info: "#06b6d4",
    success: "#22c55e",
    warning: "#f59e0b"
  },
  fonts: {
    mono: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
    sans: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif",
    serif: "ui-serif, Georgia, Cambria, 'Times New Roman', Times, serif"
  },
  gray: "warm",
  intensity: "vivid",
  name: "solaris",
  radius: "md"
}), Yg = [$g, Wg, Xg, Gg, Kg, zg, Vg], Jg = "blufin-default", Qg = "window:get-props", Zg = "window:host-ready", Ga = "window:assign", ey = "renderer:ready", Vy = (e) => {
  const t = re.c(6), {
    providers: n,
    routes: r
  } = e, o = n;
  let s;
  t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = sy(), t[0] = s) : s = t[0];
  const i = s;
  let a;
  t[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = oy(), t[1] = a) : a = t[1];
  const c = a;
  let l;
  t[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = tl.getImportMetaEnv(), t[2] = l) : l = t[2];
  const u = l;
  let d;
  return t[3] !== o || t[4] !== r ? (d = /* @__PURE__ */ C.jsx(nc, { children: /* @__PURE__ */ C.jsx(Oc, { themes: Yg, initialDensity: c?.density, initialMode: c?.mode ?? "system", initialTheme: c?.themeName ?? Jg, children: /* @__PURE__ */ C.jsx(gl, { viteMetaEnv: u, children: (f) => /* @__PURE__ */ C.jsx(oc, { viteMetaEnv: u, runtimeConfig: f, children: /* @__PURE__ */ C.jsx(nl, { children: /* @__PURE__ */ C.jsx(ds, { children: /* @__PURE__ */ C.jsx(o, { children: /* @__PURE__ */ C.jsx(ty, { wid: i, routes: r }) }) }) }) }) }) }) }), t[3] = o, t[4] = r, t[5] = d) : d = t[5], d;
}, ty = (e) => {
  const t = re.c(5), {
    routes: n,
    wid: r
  } = e;
  if (r) {
    let s;
    return t[0] !== n || t[1] !== r ? (s = /* @__PURE__ */ C.jsx(ny, { wid: r, routes: n }), t[0] = n, t[1] = r, t[2] = s) : s = t[2], s;
  }
  let o;
  return t[3] !== n ? (o = /* @__PURE__ */ C.jsx(ry, { routes: n }), t[3] = n, t[4] = o) : o = t[4], o;
}, ny = ({
  routes: e,
  wid: t
}) => {
  const [n, r] = pe(null), [o, s] = pe(!1), i = mt("SecondaryWindow"), a = he(i);
  return a.current = i, le(() => {
    let c = !1;
    const l = Pe.getElectronApi();
    if (l)
      return l.invoke(Qg, {
        wid: t
      }).then((u) => {
        if (c) return;
        const d = u;
        r({
          input: d.input,
          kind: d.kind,
          wid: t
        }), s(!0);
      }).catch((u) => {
        c || (a.current.logError("[ColdWindowContent] window:get-props failed.", u), s(!0));
      }), () => {
        c = !0;
      };
  }, [t]), /* @__PURE__ */ C.jsx(yl, { assignment: n, ready: o, routes: e });
}, ry = (e) => {
  const t = re.c(6), {
    routes: n
  } = e, [r, o] = pe(null), s = he(!1);
  let i, a;
  t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = () => {
    const u = Pe.getElectronApi();
    if (!u)
      return;
    const d = (...f) => {
      const m = f[0];
      o({
        input: m.input,
        kind: m.kind,
        wid: m.wid
      });
    };
    return u.on(Ga, d), s.current || (s.current = !0, u.invoke(Zg)), () => {
      u.off(Ga, d);
    };
  }, a = [], t[0] = i, t[1] = a) : (i = t[0], a = t[1]), le(i, a);
  const c = r !== null;
  let l;
  return t[2] !== r || t[3] !== n || t[4] !== c ? (l = /* @__PURE__ */ C.jsx(yl, { assignment: r, ready: c, routes: n }), t[2] = r, t[3] = n, t[4] = c, t[5] = l) : l = t[5], l;
}, yl = (e) => {
  const t = re.c(11), {
    assignment: n,
    ready: r,
    routes: o
  } = e, {
    logError: s
  } = mt("SecondaryWindow");
  let i, a;
  if (t[0] !== r ? (i = () => {
    r && Pe.getElectronApi()?.invoke(ey);
  }, a = [r], t[0] = r, t[1] = i, t[2] = a) : (i = t[1], a = t[2]), le(i, a), !n)
    return null;
  const c = o[n.kind];
  if (!c)
    return s(`[SecondaryWindowView] no route registered for kind '${n.kind}'.`), null;
  const l = c;
  let u;
  t[3] !== n.input || t[4] !== n.wid ? (u = {
    input: n.input,
    wid: n.wid
  }, t[3] = n.input, t[4] = n.wid, t[5] = u) : u = t[5];
  let d;
  t[6] !== l ? (d = /* @__PURE__ */ C.jsx(l, {}), t[6] = l, t[7] = d) : d = t[7];
  let f;
  return t[8] !== u || t[9] !== d ? (f = /* @__PURE__ */ C.jsx(ws.Provider, { value: u, children: d }), t[8] = u, t[9] = d, t[10] = f) : f = t[10], f;
}, oy = () => {
  const e = Pe.getElectronApi()?.getInitialState?.();
  return e ? {
    density: e.density,
    mode: e.mode,
    themeName: e.themeName
  } : null;
}, sy = () => {
  if (typeof window > "u") return "";
  const e = window.location.hash, t = e.indexOf("?");
  return t === -1 ? "" : new URLSearchParams(e.slice(t + 1)).get("wid") ?? "";
};
export {
  Ae as ActionRegistry,
  uy as ActionRootBase,
  pt as ActionRootContext,
  Xy as AppContainerAlpha,
  Gy as AppLocalStorage,
  Sc as AppNameContext,
  mf as AppNameProvider,
  Pe as AppRuntime,
  Jy as AppRuntimeType,
  Yo as AppSelectabilityStore,
  je as AuthStoreAlpha,
  dy as ContextScope,
  gn as EpochUtils,
  nc as ErrorBoundaryAlpha,
  id as ErrorBoundaryAlphaFallback,
  sd as ErrorBoundaryAlphaInternals,
  df as EventBusEvent,
  bc as HttpClientPublicAlpha,
  Ze as HttpClientStoreAlpha,
  Ca as ImagePreloader,
  ql as InFlightStore,
  zy as IndexedDbServiceAlpha,
  jt as KeyParser,
  yf as LOCAL_STORAGE_DEFAULT_CONFIG,
  Sl as NavigationUtils,
  of as NextJsEnvironmentProviderAlpha,
  Oa as ProfileLoader,
  No as ProfileSnapshotStorage,
  ft as ProfileStoreAlpha,
  Ny as ReactHttpTransport,
  Dh as SESSION_STORAGE_DEFAULT_CONFIG,
  tt as ScopeResolver,
  Vy as SecondaryWindowRoot,
  up as SettingsDebugStoreAlpha,
  Py as SiteContainerAlpha,
  cf as SiteHttpProviderAlpha,
  My as SiteTelemetryProvider,
  op as SplitLayoutStore,
  Oe as SystemLocalStorage,
  Tc as TelemetryContextAlpha,
  Iy as TelemetryProviderAlpha,
  un as ThemeContext,
  Cc as ThemeGuards,
  Oc as ThemeProvider,
  xy as ThemeScope,
  Ac as TypedLocalStorage,
  jh as TypedSessionStorage,
  rd as reportUnhandledError,
  Gl as scopeWrapperFactory,
  fy as useAction,
  hy as useActions,
  gs as useAppSelectability,
  vs as useAuthAlpha,
  Dy as useClientConfig,
  py as useConfirm,
  $c as useCoreServiceAlpha,
  qy as useCurrentUserAlpha,
  Xc as useDebug,
  Xh as useDensity,
  at as useEnvironmentAlpha,
  Ec as useEventAlpha,
  vc as useHttpClientBeta,
  jy as useIsFullscreen,
  Ly as useIsMobile,
  zc as useLocalStorageBeta,
  mt as useLoggerAlpha,
  Hy as useMainEnvironmentAlpha,
  Jh as useMemoryAlpha,
  Uy as useMetricsAlpha,
  Zh as usePaletteSelector,
  Bs as usePayloadStability,
  tp as useProfileHydrationAlpha,
  np as useRendererMemoryAlpha,
  Wc as useResolvedTelemetryAgent,
  Vl as useScopeChain,
  Fy as useSecondaryWindowProps,
  By as useSecondaryWindowResult,
  Hh as useSessionStorageBeta,
  wc as useSleepDetectionAlpha,
  sp as useSplitLayout,
  _h as useTelemetryAgent,
  gf as useTelemetryAlpha,
  ap as useTheme,
  $y as useThemeName,
  Wy as useWindowManager
};
